/* ============================================================
   TurnOrder — i18n (internaționalizare)
   Dicționar separat RO/EN + funcția t() + comutator de limbă.
   Lotul 1: shell (meniu, login, înregistrare, hub, butoane principale).
   Următoarele loturi adaugă chei pentru zonele dinamice.
   ============================================================ */
(function () {
    const I18N = {
        ro: {
            'lang.name': 'Română',
            'lang.other': 'EN',
            'copy.done': 'Copiat!',
            'core.loadErrorDemo': 'Eroare la încărcarea datelor. Se folosesc date demo.',
            'core.setNewPass': 'Setează o parolă nouă mai jos.',
            'core.demoOn': 'Mod demo activat! Datele sunt resetate la ieșire.',
            'core.enterEmail': 'Introdu email-ul!',
            'core.sendingReset': 'Se trimite linkul de resetare...',
            'core.errorColon': 'Eroare: ',
            'core.resetSentMaybe': 'Dacă adresa există, vei primi un email cu instrucțiuni de resetare a parolei.',
            'core.resetLinkExpired': 'Linkul de resetare nu mai este activ. Cere unul nou din „Am uitat parola" și deschide-l imediat.',
            'core.resetOpenLinkSuffix': ' (deschide linkul de resetare primit pe email).',
            'core.passUpdated': 'Parola a fost actualizată cu succes! Acum te poți autentifica.',
            'core.loggedOut': 'Ai fost deconectat!',
            'core.noGamesForVote': 'Niciun joc potrivit pentru vot. Adaugă jocuri sau schimbă numărul.',
            'core.appInstalled': 'Aplicația a fost instalată!',
            'core.installHint': 'Pentru instalare folosește meniul browserului → „Adaugă la ecranul principal".',
            'm1.onlyAdminScoresheet': 'Doar adminii pot edita scoresheet-uri.',
            'm1.selectGameFirst': 'Selectează întâi un joc.',
            'm1.saveErrorColon': 'Eroare la salvare: ',
            'm1.scoresheetSaved': 'Scoresheet salvat pentru „{game}".',
            'm1.onlyAdminRoles': 'Doar adminii pot edita rolurile.',
            'm1.rolesSaved': 'Roluri salvate pentru „{game}".',
            'm1.timerStopped': 'Cronometru oprit. Durata sesiunii: {mins} min.',
            'm1.enterGuestName': 'Introdu numele invitatului!',
            'm1.guestEmailRequired': 'Emailul invitatului este obligatoriu (evită dublarea profilurilor).',
            'm1.guestEmailInvalid': 'Introdu un email valid pentru invitat.',
            'm1.guestEmailAskTitle': 'Emailul invitatului',
            'm1.guestEmailAskMsg': 'Emailul lui „{name}" nu se află pe acest dispozitiv (nu circulă prin sesiunea live, ca să rămână privat). Scrie-l din nou ca să putem salva sesiunea.',
            'm1.guestEmailDupSession': 'Există deja un invitat cu acest email în sesiune.',
            'm1.guestEmailIsMember': 'Acest email aparține unui membru al clubului — adaugă-l ca membru, nu ca invitat.',
            'sb.emptySession': 'Sesiunea trebuie să aibă cel puțin un jucător.',
            'm1.guestAlready': 'Invitatul este deja adăugat!',
            'm1.guestAdded': 'Invitat {name} adăugat!',
            'm1.guestRemoved': 'Invitat {name} eliminat!',
            'm1.enterPlayerName': 'Introdu numele jucătorului!',
            'm1.playerExists': 'Jucătorul există deja!',
            'm1.playerAdded': 'Jucător {name} adăugat!',
            'm1.onlyAdminEditPlayers': 'Doar adminii pot edita jucători!',
            'm1.invalidScore': 'Scor invalid!',
            'm1.playerEdited': 'Jucător {name} editat!',
            'm1.playerDeleted': 'Jucător {name} șters!',
            'm1.noPlayersExport': 'Nu există jucători de exportat!',
            'm1.playersExported': 'Jucători exportați cu succes!',
            'm1.noPlayersEntered': 'Nu ai introdus niciun jucător!',
            'm1.importDone': 'Import reușit! {added} jucători adăugați ({skipped} existau deja/eroare).',
            'm1.onlyAdminBulkDelete': 'Doar adminii pot șterge în masă!',
            'm1.noPlayersDelete': 'Nu există jucători de șters!',
            'm1.noPlayerSelected': 'Nu ai selectat niciun jucător!',
            'm1.gameRemovedFromList': 'Joc "{game}" eliminat din lista ta!',
            'm1.fillNamePlayers': 'Completează numele și numărul de jucători!',
            'm1.gameInCatalog': 'Jocul există deja în catalog!',
            'm1.gameAddedCatalog': 'Joc {name} adăugat în catalog!',
            'm1.bggInvalid': 'Username BGG invalid sau colecție privată.',
            'm1.collectionEmpty': 'Colecția este goală sau nu a putut fi citită.',
            'm1.catalogExported': 'Catalog exportat cu succes!',
            'm1.invalidRating': 'Rating invalid! (1–10)',
            'm1.invalidWeight': 'Weight invalid! (1–5)',
            'm1.onlyAdminDeleteGames': 'Doar adminii pot șterge jocuri!',
            'm1.gameDeleted': 'Joc {name} șters!',
            'm1.catalogEmpty': 'Catalogul este gol!',
            'm1.noGameSelected': 'Nu ai selectat niciun joc!',
            'm1.editMore': 'Vrei să editezi și alte detalii?',
            'm1.confirmDeletePlayer': 'Sigur vrei să ștergi jucătorul {name}? Această acțiune este permanentă!',
            'm1.confirmBulkRemovePlayers': 'Sigur vrei să scoți {n} jucători din club?\n\nProfilurile și conturile rămân; se elimină doar apartenența la clubul curent.',
            'm1.confirmDeleteGame': 'Sigur vrei să ștergi jocul {game} din catalog?',
            'm1.confirmBulkDeleteGames': 'Sigur vrei să ștergi {n} jocuri din catalog?',
            'm2.noGamesCriteria': 'Nu s-au găsit jocuri care să îndeplinească criteriile!',
            'm2.gameNotInCatalog': 'Jocul {game} nu este în catalog!',
            'm2.gameSet': 'Joc setat: {game}.',
            'm2.orderCopied': 'Ordine copiată în clipboard!',
            'm2.teamsCopied': 'Echipe copiate în clipboard!',
            'm2.copyError': 'Eroare la copiere!',
            'm2.enterPollQuestion': 'Introdu întrebarea poll-ului!',
            'm2.atLeast2Options': 'Adaugă cel puțin 2 opțiuni!',
            'm2.duplicateOptions': 'Opțiunile trebuie să fie diferite între ele — „{opt}” apare de două ori.',
            'm2.pollCreated': 'Poll creat cu succes!',
            'm2.pollMissing': 'Poll inexistent',
            'm2.pollNotFound': 'Poll-ul nu a fost găsit!',
            'm2.pollInactive': 'Poll-ul nu este activ!',
            'm2.pollExpired': 'Poll-ul a expirat!',
            'm2.optionNotFound': 'Opțiunea nu a fost găsită!',
            'm2.voteWithdrawn': 'Vot retras!',
            'm2.alreadyVotedSingle': 'Ai votat deja și voturile multiple nu sunt permise!',
            'm2.voteRecorded': 'Vot înregistrat!',
            'm2.onlyAdminCreatorClose': 'Doar adminii sau creatorul poll-ului pot să-l închidă!',
            'm2.pollClosed': 'Poll închis!',
            'm2.noClosedPolls': 'Nu există poll-uri închise!',
            'm2.editErrorColon': 'Eroare la editare: ',
            'm2.deleteErrorColon': 'Eroare la ștergere: ',
            'm2.deletingChat': 'Se șterge chat-ul...',
            'm2.chatDeleteErrorColon': 'Eroare la ștergerea chat-ului: ',
            'm2.chatDeleted': 'Chat șters complet!',
            'm2.fillTitleDateTime': 'Completează titlul, data și ora!',
            'm2.eventCreated': 'Eveniment creat!',
            'm2.noEventsExport': 'Nu există evenimente de exportat!',
            'm2.calendarExported': 'Calendar exportat ({count} evenimente)! Importă fișierul .ics în Google/Apple/Outlook Calendar.',
            'm2.confirmClosePoll': 'Închizi poll-ul "{q}"?',
            'm2.confirmDeleteAllChat': 'Sigur ștergi TOATE mesajele din chat?\n\nAcțiunea este permanentă și se aplică tuturor membrilor.',
            'm3.nameCampaign': 'Pune un nume campaniei.',
            'm3.campaignSaved': 'Campanie salvată.',
            'm3.nameScenario': 'Pune un nume scenariului.',
            'm3.scenarioAdded': 'Scenariu adăugat.',
            'm3.campaignDeleted': 'Campanie ștearsă.',
            'm3.allowPopups': 'Permite ferestrele pop-up pentru a printa!',
            'm3.openingPrint': 'Se deschide dialogul de printare...',
            'm3.printRegError': 'Eroare la printarea regulamentului!',
            'm3.regExportedPdf': 'Regulament exportat în PDF!',
            'm3.pdfGenError': 'Eroare la generarea PDF-ului!',
            'm3.onlyAdminEditReg': 'Doar adminii pot edita regulamentul!',
            'm3.fillTitleContent': 'Completează titlul și conținutul articolului!',
            'm3.articleExists': 'Articolul {num} există deja!',
            'm3.articleAdded': 'Articol nou adăugat în regulament!',
            'm3.regReset': 'Regulament resetat la versiunea originală!',
            'm3.contentEmpty': 'Conținutul nu poate fi gol!',
            'm3.articleUpdated': 'Articol actualizat!',
            'm3.adminAccessOn': 'Acces admin activat!',
            'm3.notAdmin': 'Contul tău nu are rol de administrator!',
            'm3.adminAccessOff': 'Acces admin dezactivat!',
            'm3.userMadeAdmin': 'Utilizator făcut admin!',
            'm3.userDemoted': 'Utilizator degradat!',
            'm3.cantDeleteSelf': 'Nu te poți șterge pe tine însuți!',
            'm3.userDeleted': 'Utilizator șters!',
            'm3.scoreUpdatedFor': 'Scor actualizat pentru {name}!',
            'm3.restoreImporting': 'Se importă datele în baza de date…',
            'm3.restoreImportError': 'Eroare la import: ',
            'm3.games': 'Jocuri',
            'm3.sessions': 'Sesiuni',
            'm3.restoreDone': 'Backup restaurat. Se reîncarcă…',
            'm3.backupExported': 'Backup exportat cu succes!',
            'm3.onlyAdminRestore': 'Doar adminii pot restaura backup-uri!',
            'm3.restoreLoggedOut': 'Restaurarea a deconectat utilizatorul curent.',
            'm3.restoreError': 'Eroare la restaurarea backup-ului! Fișierul poate fi corupt.',
            'm3.noBackupHistory': 'Nu există istoric de backup-uri!',
            /* Backup de club — creare, istoric, descarcare (tabela club_backups) */
            'bkp.historyTitle': 'Istoric backup-uri',
            'bkp.retentionNote': 'Se păstrează ultimele 10 backup-uri manuale și cele automate din ultimele 7 zile plus 4 săptămâni. Vizibile doar administratorilor clubului.',
            'bkp.colDate': 'Data',
            'bkp.colKind': 'Tip',
            'bkp.colBy': 'Creat de',
            'bkp.kindManual': 'Manual',
            'bkp.kindAuto': 'Automat',
            'bkp.bySystem': 'Sistem',
            'bkp.download': 'Descarcă',
            'bkp.lastCheck': 'verificat automat: {date}',
            'bkp.coverageNote': 'Backup-ul conține toate datele clubului din baza de date. Fotografiile de sesiune NU sunt incluse ca fișiere — dar nici nu se pierd: ele rămân în stocare, iar restaurarea le reconectează automat.',
            'bkp.restore': 'Restaurează',
            'bkp.fileInvalid': 'Fișierul nu pare a fi un backup de club TurnOrder.',
            'bkp.fileOtherClub': 'Acest backup aparține clubului „{from}” și nu poate fi restaurat în „{to}”.',
            'bkp.restoreWarn': 'Vei restaura backup-ul din {date} peste clubul „{club}”.\n\nCe se întâmplă: datele din backup se scriu peste cele actuale, rând cu rând. Nimic nu se șterge — ce ai adăugat după acel backup rămâne pe loc. Se creează automat o copie a stării curente, ca să te poți întoarce.\n\nCe NU se recuperează: conturile de utilizator șterse între timp (sesiunile și punctele lor rămân, dar apar ca „Profil șters”), abonamentul și datele de plată.\n\nContinui?',
            'bkp.restoring': 'Se restaurează… nu închide fereastra.',
            'bkp.restoreDone': 'Restaurare finalizată: {n} rânduri scrise. Copia dinaintea restaurării are id-ul {snap}.',
            'bkp.restoreSkipped': '{n} rânduri sărite (conturi inexistente).',
            'bkp.restoreNulled': '{n} referințe golite (conturi șterse).',
            'bkp.creating': 'Se creează backup-ul clubului…',
            'bkp.created': 'Backup creat și descărcat.',
            'bkp.unchanged': 'Nimic nu s-a schimbat de la ultimul backup — ți-am descărcat copia existentă.',
            'bkp.noClub': 'Selectează un club înainte de backup.',
            'bkp.error': 'Backup eșuat: {msg}',
            'm3.onlyAdminSeasons': 'Doar adminii pot gestiona sezoanele!',
            'm3.archivingSeason': 'Se arhivează sezonul...',
            'm3.newSeasonDone': 'Sezon nou! Clasamentul a fost arhivat, punctele resetate. ELO și istoricul rămân neatinse.',
            'm3.onlyAdminPeriod': 'Doar adminii pot regla perioada!',
            'm3.periodSaveError': 'Eroare la salvarea perioadei.',
            'm3.periodSet': 'Perioadă setată: luna {m}, {y}',
            'm3.onlyAdminLabel': 'Doar adminii pot seta eticheta sezonului!',
            'm3.labelSaveError': 'Eroare la salvarea etichetei.',
            'm3.onlyAdminArchiveDel': 'Doar adminii pot șterge din arhivă!',
            'm3.seasonDeletedArchive': 'Sezon șters din arhivă.',
            'm3.onlyAdminSeasonReport': 'Doar adminii pot exporta rapoarte de sezon!',
            'm3.seasonReportPdf': 'Raport sezon exportat în PDF!',
            'm3.onlyAdminThisReset': 'Doar adminii pot face acest reset!',
            'm3.sessionsErrorColon': 'Eroare sesiuni: ',
            'm3.eventsErrorColon': 'Eroare evenimente: ',
            'm3.chatErrorColon': 'Eroare chat: ',
            'm3.resetErrorColon': 'Eroare la resetare: ',
            'm3.noHistoryExport': 'Nu există istoric de exportat!',
            'm3.historyExported': 'Istoric exportat cu succes!',
            'm3.historyPdf': 'Istoric exportat în PDF!',
            'm3.sessionNotFound': 'Sesiunea nu a fost găsită!',
            'm3.sessionGone': 'Sesiunea nu mai există!',
            'm3.sessionUpdated': 'Sesiune actualizată!',
            'm3.onlyAdminDeleteSessions': 'Doar adminii pot șterge sesiuni!',
            'm3.sessionDeleted': 'Sesiune ștearsă!',
            'm3.saveDataError': 'Eroare la salvarea datelor!',
            'm3.confirmDeleteScenario': 'Ștergi acest scenariu?',
            'm3.confirmDeleteCampaign': 'Ștergi campania „{name}" și toate scenariile ei?',
            'm3.confirmResetReg': 'Sigur vrei să resetezi regulamentul la versiunea originală? Toate modificările vor fi pierdute!',
            'm3.confirmDeleteUser': 'Sigur vrei să ștergi utilizatorul {email}?',
            'm3.confirmRestore': 'Vei restaura un backup mai vechi (format clasic). Datele din fișier se scriu peste cele actuale, rând cu rând — nimic nu se șterge, iar ce ai adăugat după acel backup rămâne pe loc. Se acoperă doar catalogul de jocuri, sesiunile, regulamentul și sezoanele. Continui?',
            'm3.confirmNewSeason': 'Începi un sezon nou?\n\nClasamentul și punctajele actuale se ARHIVEAZĂ, apoi punctele se resetează la 0.\nIstoricul sesiunilor și ELO-ul rămân NEATINSE.',
            'm3.confirmDeleteSeasonArchive': 'Ștergi acest sezon din arhivă?\n\nAcțiunea este permanentă.',
            'm3.confirmSureIrreversible': 'ESTI SIGUR? Această acțiune este permanentă și ireversibilă!',
            'm3.confirmDeleteSession': 'Sigur vrei să ștergi această sesiune?',
            'sb.switchingClub': 'Comut clubul…',
            'sb.activeClubColon': 'Club activ: ',
            'sb.creatingClub': 'Creez clubul…',
            'sb.createClubErrorColon': 'Eroare la creare club: ',
            'sb.unknown': 'necunoscut',
            'sb.thisMember': 'acest membru',
            'sb.clubCreatedNotAdminColon': 'Club creat, dar nu te-am putut adăuga ca admin: ',
            'sb.clubCreatedColon': 'Club creat: ',
            'sb.errorColon': 'Eroare: ',
            'sb.clubStatusNoChanges': 'Clubul „{name}" este {status} — modificările nu sunt permise.',
            'sb.viewOnlyMuted': 'Ești în mod vizualizare (mut) în acest club. Poți vedea tot, dar nu poți face modificări până când un admin te dezmuțează.',
            'sb.onlyAdminsThis': 'Doar adminii pot face asta.',
            'sb.cantApplySelf': 'Nu te poți aplica ție însuți această acțiune.',
            'sb.muteErrorColon': 'Eroare la mute: ',
            'sb.unmuteErrorColon': 'Eroare la unmute: ',
            'sb.banErrorColon': 'Eroare la ban: ',
            'sb.unbanErrorColon': 'Eroare la unban: ',
            'sb.memberExcluded': '{name} a fost exclus din club.',
            'sb.unbannedCanRejoin': '{name} a fost deblocat. Poate cere din nou intrarea în club.',
            'sb.bannedFromClub': 'Ai fost exclus din acest club și nu poți reintra.',
            'sb.onlyPrincipalClose': 'Doar adminul principal poate închide clubul.',
            'sb.cantCloseOnlyClub': 'Nu poți închide singurul tău club. Creează altul mai întâi.',
            'sb.closeErrorColon': 'Eroare la închidere: ',
            'sb.clubClosed': 'Clubul „{name}" a fost închis (arhivat).',
            'sb.onlyPrincipalReopen': 'Doar adminul principal poate reactiva clubul.',
            'sb.clubAlreadyActive': 'Clubul este deja activ.',
            'sb.reopenErrorColon': 'Eroare la reactivare: ',
            'sb.clubReopened': 'Clubul „{name}" a fost reactivat.',
            'sb.joinErrorColon': 'Nu te-am putut alătura: ',
            'sb.joinedClub': 'Te-ai alăturat clubului!',
            'sb.requestErrorColon': 'Nu am putut trimite cererea: ',
            'sb.onlyAdminsClubSettings': 'Doar adminii pot schimba setările clubului.',
            'sb.clubNameEmpty': 'Numele clubului nu poate fi gol.',
            'sb.rlsRejected': 'Salvarea a fost respinsă de baza de date (permisiuni RLS pe „clubs"): rândul nu a fost actualizat.',
            'sb.clubSettingsSaved': 'Setările clubului au fost salvate.',
            'sb.onlyAdminsRequests': 'Doar adminii pot vedea cererile.',
            'sb.approveErrorColon': 'Eroare la aprobare: ',
            'sb.requestApproved': 'Cerere aprobată — membru adăugat.',
            'sb.requestRejected': 'Cerere respinsă.',
            'sb.onlyAdminsInvites': 'Doar adminii pot crea invitații.',
            'sb.inviteCreateErrorColon': 'Eroare la crearea invitației: ',
            'sb.linkCopied': 'Link copiat!',
            'sb.inviteInvalid': 'Invitație invalidă sau expirată.',
            'sb.clubFull': 'Clubul a atins numărul maxim de membri. Roagă-l pe administrator să facă upgrade și încearcă din nou — linkul tău rămâne valabil.',
            'pact.success': 'Bine ai venit! Profilul tău a fost activat în ',
            'pact.alreadyLinked': 'Profilul tău era deja legat de acest cont în ',
            'pact.error': 'Nu am putut activa profilul acum. Încearcă din nou peste câteva momente.',
            'pact.fail.invalid': 'Linkul de activare nu mai este valid.',
            'pact.fail.used': 'Linkul de activare a fost deja folosit.',
            'pact.fail.expired': 'Linkul de activare a expirat. Cere-i administratorului clubului unul nou.',
            'pact.fail.revoked': 'Linkul de activare a fost anulat de administratorul clubului.',
            'pact.fail.already_activated': 'Acest profil este deja legat de un cont.',
            'pact.fail.already_member': 'Ești deja membru al acestui club cu contul curent, așa că nu mai e nimic de activat.',
            'pact.fail.not_authenticated': 'Trebuie să fii conectat pentru a activa profilul.',
            'pact.admin.noAccount': 'Fără cont',
            'pact.admin.noAccountTip': 'Jucătorul nu și-a creat încă un cont. Trimite-i un link de activare ca să-și preia profilul, cu tot istoricul.',
            'pact.admin.linkSent': 'Link trimis',
            'pact.admin.expiresOn': 'Valabil până pe',
            'pact.admin.sendLink': 'Trimite link de activare',
            'pact.admin.newLink': 'Generează alt link (îl anulează pe cel vechi)',
            'pact.admin.revoke': 'Anulează linkul de activare',
            'pact.admin.confirmRevoke': 'Anulezi linkul de activare pentru {name}? Linkul deja trimis nu va mai funcționa.',
            'pact.admin.revoked': 'Linkul de activare a fost anulat.',
            'pact.admin.modalTitle': 'Link de activare pentru',
            'pact.admin.modalNote': 'Trimite-i acest link DOAR persoanei în cauză. Îl poate folosi o singură dată, ca să-și lege profilul existent (cu tot istoricul) de un cont nou. Poate folosi orice adresă de email dorește. Nu confunda cu invitația de club: aceea adaugă un membru nou, fără istoric.',
            'pact.admin.alreadyActivated': 'Jucătorul are deja un cont, deci nu are nevoie de activare.',
            'pact.admin.notMember': 'Jucătorul nu este membru activ al acestui club.',
            'pact.admin.rateLimit': 'S-au generat prea multe linkuri astăzi în acest club. Încearcă mâine.',
            'pact.admin.hasAccount': '{name} are deja un cont TurnOrder. Nu poate fi adăugat direct — trebuie să accepte o invitație. Trimite-i linkul de mai jos.',
            'pact.admin.error': 'Nu am putut face asta acum. Încearcă din nou peste câteva momente.',
            'audit.paIssue': 'Link de activare generat',
            'audit.paRevoke': 'Link de activare anulat',
            'audit.paRedeem': 'Profil activat',
            'sb.joinedViaInvite': 'Te-ai alăturat clubului prin invitație!',
            'players.clubFullAdd': 'Clubul a atins numărul maxim de membri. Fă upgrade ca să mai poți adăuga jucători.',
            'sb.inviteErrorColon': 'Eroare la invitație: ',
            'sb.unavailableDemo': 'Indisponibil în demo.',
            'sb.friendRequestSent': 'Cerere de prietenie trimisă!',
            'sb.friendNoAccount': 'Această persoană nu are încă un cont, deci nu poate primi cereri de prietenie.',
            'sb.friendsNeedSql': 'Pentru prietenii rulează „turnorder_friends.sql". ({msg})',
            'sb.nowFriends': 'Sunteți acum prieteni!',
            'sb.friendRemoved': 'Prietenie eliminată.',
            'sb.eventNotFoundDot': 'Evenimentul nu a fost găsit.',
            'sb.onlyDeleteOwnEvents': 'Poți șterge doar evenimentele tale (sau ca admin).',
            'sb.eventDeleted': 'Eveniment șters!',
            'sb.nothingToShare': 'Nimic de partajat.',
            'sb.generatingImage': 'Se generează imaginea…',
            'sb.imageBusy': 'Imaginea se generează deja — mai durează câteva secunde.',
            'sb.imageGenError': 'Eroare la generarea imaginii.',
            'sb.imageDownloaded': 'Imaginea a fost descărcată — o poți trimite pe WhatsApp.',
            'sb.imageGenFail': 'Nu am putut genera imaginea.',
            'sb.copiedPasteWhatsApp': 'Copiat! Lipește în WhatsApp.',
            'sb.chooseImageFile': 'Alege un fișier imagine.',
            'sb.unavailableDemoMode': 'Indisponibil în modul demo.',
            'sb.accountDeactivated': 'Cont dezactivat. Te poți reconecta în 30 de zile pentru a-l reactiva.',
            'sb.deleteNeedSql': 'Pentru programarea ștergerii rulează „turnorder_account.sql". Te-am deconectat oricum.',
            'sb.accountScheduledDelete': 'Acest cont era programat pentru ștergere. Contactează un administrator dacă mai ai nevoie de date.',
            'sb.accountReactivated': 'Cont reactivat. Bine ai revenit!',
            'sb.onlyAdminsCompetitive': 'Doar adminii pot schimba modul competitiv!',
            'sb.settingSaveErrorSql': 'Eroare la salvarea setării: {msg} (ai rulat scriptul SQL?)',
            'sb.voteSaveErrorSql': 'Eroare la salvarea votului: {msg} (ai rulat scriptul SQL?)',
            'sb.catalogEmptyAddFirst': 'Catalogul e gol — adaugă jocuri întâi.',
            'sb.voteStarted': 'Vot pornit! Toți membrii pot vota acum.',
            'sb.gameAlreadyInList': 'Jocul e deja în listă.',
            'sb.addAtLeastOneGame': 'Adaugă cel puțin un joc în listă.',
            'sb.invalidFileColon': 'Fișier invalid sau format neașteptat: ',
            'sb.nothingNewImport': 'Nimic nou de importat (totul există deja).',
            'sb.demoImportNoSave': 'În modul demo importul nu se salvează în Supabase.',
            'sb.importingGS': 'Se importă {g} jocuri și {s} sesiuni...',
            'sb.importCatalogErrorColon': 'Eroare import catalog: ',
            'sb.importSessionsErrorColon': 'Eroare import sesiuni: ',
            'sb.importDoneGS': 'Import gata: {g} jocuri, {s} sesiuni adăugate.',
            'sb.bggLinkInvalid': 'Link BGG invalid. Ex: https://boardgamegeek.com/boardgame/169786/scythe',
            'sb.playerNotFoundDot': 'Jucătorul nu a fost găsit.',
            'sb.nameEmpty': 'Numele nu poate fi gol.',
            'sb.newPassMismatch': 'Parolele noi nu coincid.',
            'sb.demoNoSaveChanges': 'În modul demo, modificările nu se salvează.',
            'sb.userTagColon': 'User Tag: ',
            'sb.nameAvatarSavedSql': 'Numele și avatarul s-au salvat. Pentru restul câmpurilor rulează scriptul „profile_fields.sql".',
            'sb.emailColon': 'Email: ',
            'sb.emailChangeLinks': 'Ți-am trimis linkuri de confirmare pe adresa VECHE și pe cea NOUĂ. Confirmă-le pe ambele ca să se schimbe emailul.',
            'sb.passwordColon': 'Parolă: ',
            'sb.passwordChanged': 'Parola a fost schimbată.',
            'sb.movingHistory': 'Se mută istoricul pe noul nume...',
            'sb.profileUpdated': 'Profil actualizat!',
            'sb.historyMoved': 'Istoric mutat pe „{name}": {m} sesiuni și {e} evenimente actualizate.',
            'sb.welcomeName': 'Bun venit, {name}!',
            'sb.fillAllFields': 'Completează toate câmpurile!',
            'sb.weakPassword': 'Parola nu e suficient de puternică: minim 8 caractere, literă mare, literă mică, cifră și un caracter special.',
            'sb.passMismatch': 'Parolele nu coincid!',
            'sb.acceptTerms': 'Trebuie să accepți termenii și condițiile!',
            'sb.consentSaveError': 'Nu am putut salva consimțământul. Încearcă din nou.',
            'sb.creatingAccount': 'Se creează contul...',
            'sb.registerErrorColon': 'Eroare la înregistrare: ',
            'sb.accountCreatedWelcome': 'Cont creat cu succes! Bun venit, {name}!',
            'sb.accountCreatedVerify': 'Cont creat! Verifică-ți emailul pentru confirmare.',
            'sb.unknownAddress': 'Adresă necunoscută. Reia înregistrarea.',
            'sb.connUnavailable': 'Conexiune indisponibilă. Reîncearcă.',
            'sb.resendErrorColon': 'Nu am putut retrimite: ',
            'sb.confirmResent': 'Email de confirmare retrimis. Verifică inbox-ul (și Spam).',
            'sb.resendError': 'Eroare la retrimitere.',
            'sb.redirectGoogle': 'Redirecționare către Google...',
            'sb.googleErrorColon': 'Eroare Google: ',
            'sb.googleConnError': 'Eroare la conectarea cu Google.',
            'sb.loggedOut': 'Ai fost deconectat!',
            'sb.demoModeData': 'Mod demo cu date fictive!',
            'sb.sendMsgErrorColon': 'Eroare la trimiterea mesajului: ',
            'sb.fillDateGame': 'Completează data și jocul!',
            'sb.addParticipant': 'Adaugă cel puțin un participant!',
            'sb.savingSession': 'Se salvează sesiunea...',
            'sb.saveSessionErrorColon': 'Eroare la salvarea sesiunii: ',
            'sb.sessionSavedRecordedBySql': 'Sesiune salvată. Pentru „înregistrat de" rulează scriptul „matches_recorded_by.sql".',
            'sb.sessionSaved': 'Sesiune salvată cu succes!',
            'sb.saveChangesErrorColon': 'Eroare la salvarea modificărilor: ',
            'sb.gameUpdated': 'Joc {name} actualizat!',
            'sb.addGameErrorColon': 'Eroare la adăugarea jocului: ',
            'sb.removeFromClubErrorColon': 'Eroare la scoaterea din club: ',
            'sb.userMadeAdminClub': 'Utilizator făcut admin în acest club!',
            'sb.userDemotedClub': 'Utilizator degradat în acest club!',
            'sb.profileDeleted': 'Profil șters! (Contul de autentificare se șterge separat din panoul Supabase.)',
            'sb.createEventErrorColon': 'Eroare la crearea evenimentului: ',
            'sb.eventNotFoundExcl': 'Evenimentul nu a fost găsit!',
            'sb.updateErrorColon': 'Eroare la actualizare: ',
            'sb.supabaseLoadError': 'Nu s-a putut încărca librăria Supabase. Verifică conexiunea la internet.',
            'sb.confirmBan': 'Excluzi (ban) „{name}" din club?\n\nVa fi eliminat din club imediat și nu va putea reintra până când un admin îl deblochează. Datele lui istorice rămân.',
            'sb.confirmCloseClub': 'Închizi clubul „{name}"?\n\nDatele NU se șterg — clubul devine arhivat (doar citire) și poate fi redeschis ulterior.',
            'sb.confirmDeleteEvent': 'Ștergi evenimentul „{title}"?\n\nAcțiunea este permanentă.',
            'sb.confirmReactivate': 'Contul tău este programat pentru ștergere (mai sunt ~{days} zile).\n\nVrei să-l REACTIVEZI acum?',
            'sb.confirmCloseVote': 'Închizi votul curent? Rezultatul se mută în istoric.',
            'sb.confirmRemovePlayerClub': 'Scoți jucătorul {name} din acest club?\n\nProfilul și contul persoanei rămân; se elimină doar apartenența la clubul curent.',
            'sb.confirmDeleteProfile': 'Sigur vrei să ștergi profilul {email}?',
            'audit.logout': 'Logout',
            'audit.playerAdded': 'Jucător adăugat',
            'audit.playerEdited': 'Jucător editat',
            'audit.playerDeleted': 'Jucător șters',
            'audit.exportPlayersCsv': 'Export jucători CSV',
            'audit.importPlayers': 'Import jucători',
            'audit.bulkRemovePlayers': 'Scoatere jucători în masă',
            'audit.gameRemovedFromList': 'Joc eliminat din listă',
            'audit.gameAddedCatalog': 'Joc adăugat în catalog',
            'audit.importBggCollection': 'Import colecție BGG',
            'audit.exportCatalogJson': 'Export catalog JSON',
            'audit.gameDeletedCatalog': 'Joc șters din catalog',
            'audit.bulkDeleteGames': 'Ștergere jocuri în masă',
            'audit.randomGameSelected': 'Joc random selectat',
            'audit.playerOrderRandomized': 'Ordine jucători randomizată',
            'audit.teamsGenerated': 'Echipe generate',
            'audit.pollCreated': 'Poll creat',
            'audit.pollEdited': 'Poll editat',
            'audit.pollDeleted': 'Poll șters',
            'audit.pollVote': 'Vot în poll',
            'audit.pollVoteWithdrawn': 'Vot retras din poll',
            'audit.pollClosed': 'Poll închis',
            'audit.chatMessageSent': 'Mesaj chat trimis',
            'audit.chatCleared': 'Chat șters',
            'audit.eventCreated': 'Eveniment creat',
            'audit.eventUpdated': 'Eveniment modificat',
            'audit.exportCalendarIcs': 'Export calendar (.ics)',
            'audit.printRegulation': 'Printare regulament',
            'audit.exportRegulationPdf': 'Export regulament PDF',
            'audit.regulationArticleAdded': 'Articol nou adăugat în regulament',
            'audit.regulationReset': 'Regulament resetat la original',
            'audit.regulationEdited': 'Regulament editat',
            'audit.adminLogin': 'Admin login',
            'audit.adminStatusChanged': 'Status admin modificat',
            'audit.userDeleted': 'Utilizator șters',
            'audit.playerScoreManual': 'Scor jucător modificat manual',
            'audit.fullBackupExported': 'Backup complet exportat',
            'auditd.backupRestoredDetail': 'backup #{id}, {n} rânduri',
            'audit.backupRestored': 'Backup restaurat',
            'audit.newSeasonStarted': 'Sezon nou început',
            'audit.seasonReportPdf': 'Raport sezon PDF',
            'audit.clubDataReset': 'Reset date club',
            'audit.exportHistoryCsv': 'Export istoric CSV',
            'audit.exportHistoryPdf': 'Export istoric PDF',
            'audit.sessionEdited': 'Editare sesiune',
            'audit.sessionDeleted': 'Sesiune ștearsă',
            'audit.autoSave': 'Auto-save',
            'audit.memberMuted': 'Membru pus pe mute',
            'audit.memberUnmuted': 'Membru scos de pe mute',
            'audit.memberBanned': 'Membru exclus (ban)',
            'audit.memberUnbanned': 'Membru reactivat (unban)',
            'audit.eventDeleted': 'Eveniment șters',
            'audit.competitiveModeElo': 'Mod competitiv ELO',
            'audit.scoringConfig': 'Configurare uniformizare scoruri',
            'audit.gameVoteStarted': 'Vot „Ce jucăm” pornit',
            'audit.gameVoteClosed': 'Vot „Ce jucăm” închis',
            'audit.importData': 'Import date',
            'audit.userRenamed': 'Redenumire utilizator',
            'audit.sessionSaved': 'Sesiune salvată',
            'audit.gameEditedCatalog': 'Joc editat în catalog',
            'audit.clubRoleChanged': 'Rol club modificat',
            'audit.roleChangedInClub': 'Rol modificat în club',
            'auditd.roleArrow': '{name} → {role}',
            'audit.userProfileDeleted': 'Profil utilizator șters',
            'audit.scoreManual': 'Scor modificat manual',
            'audit.playerRemovedFromClub': 'Jucător scos din club',
            'auditd.gamesAddedByUser': '{user}: +{n} jocuri',
            'auditd.gamesCount': '{n} jocuri',
            'auditd.allChatDeleted': 'toate mesajele șterse din Supabase',
            'auditd.roleVerifiedDb': 'Rol verificat din baza de date',
            'auditd.activated': 'activat',
            'auditd.deactivated': 'dezactivat',
            'auditd.importGS': '{g} jocuri, {s} sesiuni',
            'auditd.renameDetails': '„{old}” → „{new}” · {m} sesiuni, {e} evenimente',
            'auditd.sessionParticipants': '{game} - {n} participanți',
            'auditd.playerScoreArrow': '{name}: scor → {score}',
            'auditd.roleArrowSecondary': '{name} → Admin Secundar',
            'auditd.roleArrowMember': '{name} → Membru',
            'auditd.roleSecondaryAdmin': 'admin secundar',
            'auditd.roleMember': 'membru',
            'cm.title': 'Confirmare',
            'cm.confirm': 'Confirmă',
            'cm.cancel': 'Anulează',
            'cm.input': 'Introdu o valoare',
            'cm.ok': 'OK',
            /* RO: dialogul cu TREI optiuni, pentru iesirea dintr-un formular cu modificari
               nesalvate. Cel cu doua butoane (`cm.*`) nu poate deosebi „ies fara sa salvez"
               de „ma razgandesc", fiindca Escape, clicul pe fundal si Anuleaza dau toate
               acelasi raspuns. EN: three-way unsaved-changes dialog. */
            'cm3.title': 'Modificări nesalvate',
            'cm3.message': 'Ai modificări nesalvate. Ce vrei să faci?',
            'cm3.save': 'Salvează',
            'cm3.discard': 'Nu salva',
            'cm3.stay': 'Rămâi',
            'm1.newScorePrompt': 'Scor nou pentru {name}:',
            'sb.confirmDeleteAccount1': '⚠️ AVERTISMENT 1 din 2\n\nVrei să-ți ștergi contul?\n\nContul va fi DEZACTIVAT imediat, iar după 30 de zile datele tale individuale vor fi șterse DEFINITIV.',
            'sb.confirmDeleteAccount2': '⚠️ AVERTISMENT 2 din 2 — ultima confirmare\n\nÎn cele 30 de zile te poți reconecta pentru a reactiva contul. După aceea, ștergerea este ireversibilă.\n\nConfirmi dezactivarea contului acum?',
            'demo.descCatan': 'Joc clasic de construire și negociere pe insula Catan.',
            'demo.descAzul': 'Joc abstract de placări ceramice inspirat din arta azulejo portugheză.',
            'demo.descGloomhaven': 'RPG tactic cooperativ cu campanie epică și sistem de legacy.',
            'demo.descTtr': 'Joc de construire a rețelei feroviare prin America de Nord.',
            'demo.chat1': 'Salutare! Cine vrea să jucăm Catan mâine?',
            'demo.chat2': 'Eu sunt disponibil după ora 19:00!',
            'demo.chat3': 'Am adus și expansionul pentru Catan!',
            'demo.pollQuestion': 'Ce joc vrem să jucăm vineri?',
            'demo.eventTitle': 'Sesiune Catan Tournament',
            'demo.eventDesc': 'Turneu de Catan cu premii!',
            'demo.eventLocation': 'Cafeneaua Centrală',
            'demo.achFirstWin': '🏆 Prima Victorie',
            'demo.ach10Games': '🎮 10 Jocuri',
            'demo.ach50Points': '💯 50 de Puncte',
            'demo.achHatTrick': '🔥 Hat Trick',

            // Meniu (nav)
            /* ---- NAVIGARE NOUĂ (nav.js, Etapa 1a) ---- */
            'nav2.search': 'Caută',
            'nav2.side.collapse': 'Pliază meniul',
            'nav2.side.expand': 'Desfășoară meniul',
            'nav2.pending': 'în așteptare',
            'nav2.r.joinReq': 'Cereri de aderare',
            'nav2.s.joinReq': 'Aprobă sau respinge membri noi',
            'nav2.d.memberOne': '1 membru',
            'nav2.d.memberFew': '{n} membri',
            'nav2.d.memberMany': '{n} de membri',
            'nav2.d.requestOne': '1 cerere',
            'nav2.d.requestFew': '{n} cereri',
            'nav2.d.requestMany': '{n} de cereri',
            'nav2.d.unreadOne': '1 mesaj necitit',
            'nav2.d.unreadFew': '{n} mesaje necitite',
            'nav2.d.unreadMany': '{n} de mesaje necitite',
            'nav2.d.openPollOne': '1 vot deschis',
            'nav2.d.openPollFew': '{n} voturi deschise',
            'nav2.d.openPollMany': '{n} de voturi deschise',
            'nav2.d.noPoll': 'niciun vot deschis',
            'nav2.d.gameOne': '1 joc',
            'nav2.d.gameFew': '{n} jocuri',
            'nav2.d.gameMany': '{n} de jocuri',
            'nav2.d.articleOne': '1 articol',
            'nav2.d.articleFew': '{n} articole',
            'nav2.d.articleMany': '{n} de articole',
            'nav2.d.sessionOne': '1 sesiune',
            'nav2.d.sessionFew': '{n} sesiuni',
            'nav2.d.sessionMany': '{n} de sesiuni',
            'nav2.d.activeCampaignOne': '1 campanie activă',
            'nav2.d.activeCampaignFew': '{n} campanii active',
            'nav2.d.activeCampaignMany': '{n} de campanii active',
            'nav2.d.onlineOne': '1 membru activ',
            'nav2.d.onlineFew': '{n} membri activi',
            'nav2.d.onlineMany': '{n} de membri activi',
            'nav2.d.today': 'azi',
            'nav2.d.yesterday': 'ieri',
            'nav2.d.daysAgo': 'acum {n} zile',
            'nav2.d.lastMsg': 'ultimul mesaj {when}',
            'nav2.d.lastOne': 'ultima {when}',
            'nav2.d.updated': 'actualizat {when}',
            'nav2.d.planNow': 'planul {p}',
            'nav2.q.placeholder': 'Caută în club…',
            'nav2.q.nav': 'Secțiuni',
            'nav2.q.members': 'Membri',
            'nav2.q.games': 'Jocuri',
            'nav2.q.sessions': 'Sesiuni',
            'nav2.q.events': 'Evenimente',
            'nav2.q.hint': 'Scrie cel puțin 2 litere.',
            'nav2.q.empty': 'Niciun rezultat pentru „{q}".',
            'nav2.q.more': '+{n} încă',
            'nav2.home': 'Acasă',
            'nav2.club': 'Club',
            'nav2.agenda': 'Agendă',
            'nav2.more': 'Mai multe',
            'nav2.profile': 'Profil',
            'nav2.hub.club': 'Club',
            'nav2.hub.more': 'Mai multe',
            'nav2.hub.profile': 'Profil',
            'nav2.g.people': 'Oameni',
            'nav2.g.library': 'Bibliotecă',
            'nav2.g.record': 'Palmares',
            'nav2.g.admin': 'Administrare',
            'nav2.g.community': 'Comunitate',
            'nav2.g.competition': 'Competiție',
            'nav2.g.tools': 'Unelte',
            'nav2.g.account': 'Cont',
            'nav2.g.presence': 'Prezență',
            'nav2.g.app': 'Aplicație',
            'nav2.r.clubSettings': 'Setări club',
            'nav2.r.moderation': 'Moderare',
            'nav2.r.ownerPanel': 'Panou proprietar',
            'nav2.r.discoverClubs': 'Descoperă cluburi',
            'nav2.r.discoverPlayers': 'Descoperă jucători',
            'nav2.r.myStats': 'Statisticile mele',
            'nav2.r.plans': 'Planuri',
            'nav2.s.players': 'Membri, roluri și cereri',
            'nav2.s.chat': 'Discuția clubului',
            'nav2.s.polls': 'Voturi și sondaje',
            'nav2.s.catalog': 'Jocurile clubului',
            'nav2.s.regulation': 'Regulamentul intern',
            'nav2.s.stats': 'Clasamente și evoluție',
            'nav2.s.history': 'Sesiunile jucate',
            'nav2.s.admin': 'Gestiunea clubului',
            'nav2.s.clubSettings': 'Nume, plan și opțiuni',
            'nav2.s.moderation': 'Rapoarte și sancțiuni',
            'nav2.s.ownerPanel': 'Administrarea platformei',
            'nav2.s.discoverClubs': 'Găsește cluburi noi',
            'nav2.s.discoverPlayers': 'Găsește jucători',
            'nav2.s.tournaments': 'Competiții cu etape',
            'nav2.s.campaigns': 'Campanii și legacy',
            'nav2.s.randomizers': 'Ordine, echipe, jocuri',
            'nav2.s.myProfile': 'Datele și preferințele tale',
            'nav2.s.myStats': 'Rezultatele tale din toate cluburile',
            'nav2.s.online': 'Cine e activ acum',
            'nav2.s.settings': 'Limbă, notificări, cont',
            'nav2.s.plans': 'Abonamentul clubului',
            'nav2.s.feedback': 'Spune-ne ce nu merge',
            'nav2.s.logout': 'Ieși din contul tău',
            'nav2.create.title': 'Ce vrei să creezi?',
            'nav2.create.session': 'Sesiune nouă',
            'nav2.newSession.confirm': 'Ai o sesiune în lucru. Vrei să o abandonezi și să începi una nouă?',
            'nav2.create.event': 'Eveniment nou',
            'nav2.create.poll': 'Vot nou',
            'nav2.create.ann': 'Anunț nou',
            'nav2.create.open': 'Creează',
            'nav2.create.close': 'Închide',
            'nav2.create.none': 'Nu ai drepturi de creare în acest club.',
            'nav2.empty': 'Nimic disponibil aici.',
            'nav.dashboard': 'Dashboard',
            'nav.session': 'Sesiune',
            'nav.players': 'Jucători',
            'nav.catalog': 'Catalog',
            'nav.randomizers': 'Randomizers',
            'nav.history': 'Istoric',
            'nav.campaigns': 'Campanii',
            'nav.polls': 'Poll-uri',
            'nav.chat': 'Chat',
            'nav.calendar': 'Calendar',
            'nav.stats': 'Statistici',
            'nav.regulation': 'Regulament',
            'nav.admin': 'Admin',
            'nav.profile': 'Profilul meu',
            'nav.logout': 'Logout',
            'nav.memberSince': 'Membru din {date}',   /* {date} = luna + anul, interpolat in nav.js */

            // Login
            'login.title': 'Autentificare',
            'login.email': 'Email / User Tag',
            'login.emailPh': 'exemplu@email.com sau @usertag',
            'login.emailOnlyPh': 'exemplu@email.com',
            'login.password': 'Parolă',
            'login.passwordPh': 'Introdu parola',
            'login.forgot': 'Ai uitat parola?',
            'login.remember': 'Ține-mă minte și rămâi conectat',
            'login.rememberHint': 'Rămâi autentificat chiar și după ce închizi complet browserul, pe acest dispozitiv.',
            'login.signin': 'Conectare',
            'login.register': 'Înregistrare',
            'login.demo': 'Demo Rapid',
            'login.or': 'sau',
            'login.google': 'Continuă cu Google',
            'login.fillFields': 'Completează Email-ul / User Tag-ul și parola!',
            'login.connecting': 'Se conectează...',
            'login.failed': 'Email/parolă greșite sau emailul nu e confirmat.',
            'login.captchaFailed': 'Verificarea de securitate a eșuat. Reîncearcă.',
            'login.captchaPending': 'Bifează caseta de verificare de mai jos, apoi apasă din nou Conectare.',
            'login.captchaChecking': 'Verificarea de securitate rulează... te conectăm imediat.',
            'login.tagNotFound': 'Nu am găsit niciun cont cu acest User Tag.',
            'login.showPw': 'Arată parola',
            'login.hidePw': 'Ascunde parola',
            'welcome.title': 'Bun venit în TurnOrder',
            'welcome.subtitle': 'Contul tău e gata. Hai să-ți pui clubul în mișcare!',
            'welcome.createClubTitle': 'Înființează un club',
            'welcome.createClubDesc': 'Creează-ți propriul club, invită membri și începe să înregistrezi sesiuni.',
            'welcome.discoverTitle': 'Descoperă',
            'welcome.discoverDesc': 'Găsește cluburi publice și alți jucători cu care să te conectezi.',
            'welcome.btnCreateClub': 'Înființează un club',
            'welcome.btnDiscover': 'Discover',
            'welcome.btnLater': 'Mai târziu',
            'welcome.btnProfile': 'Completează-ți profilul',

            // Înregistrare
            'register.title': 'Înregistrare Cont Nou',
            'register.fullname': 'Nume complet',
            'register.fullnamePh': 'Numele tău în club',
            'register.email': 'Email',
            'register.password': 'Parolă',
            'register.passwordPh': 'Minimum 8 caractere',
            'register.confirm': 'Confirmă parola',
            'register.confirmPh': 'Reintrodu parola',
            'register.termsPre': 'Sunt de acord cu',
            'register.termsLink': 'Termenii și Condițiile',
            'register.submit': 'Înregistrare',
            'register.back': 'Înapoi',
            'register.age16': 'Am peste 16 ani',
            'register.consentError': 'Bifează vârsta și consimțământul pentru a continua.',
            'consent.title': 'Un pas rapid',
            'consent.intro': 'Înainte de a continua, te rugăm să confirmi:',
            'consent.accept': 'Accept și continui',
            'consent.cancel': 'Renunț',
            // ===== Legal (footer, checkbox, documente, istoric) =====
            'footer.about': 'Despre TurnOrder',
            'footer.aboutUrl': 'https://turnorder.org/ro/',
            'footer.terms': 'Termeni și Condiții',
            'footer.privacy': 'Politică de Confidențialitate',
            'footer.cookies': 'Politică de Cookie-uri',
            'footer.rights': '© TurnOrder. Toate drepturile rezervate.',
            'cookieNotice.text': 'TurnOrder folosește doar cookie-uri esențiale, necesare funcționării.',
            'cookieNotice.link': 'Politica de Cookie-uri',
            'register.termsAnd': 'și',
            'register.privacyLink': 'Politica de Confidențialitate',
            'legal.effective': 'Data intrării în vigoare',
            'legal.history': 'Istoric actualizări',
            'legal.initialVersion': 'Versiune inițială',
            'legal.current': 'curentă',
            'legal.viewThis': 'Vezi această versiune',
            'legal.historyHint': 'Nu există versiuni anterioare.',
            'legal.terms.body': `<p>TurnOrder („Platforma", „Serviciul", „aplicația") este o platformă de tip software-as-a-service (SaaS) sub formă de aplicație web progresivă (PWA), dedicată organizării cluburilor de board games, operată de <strong>[DENUMIRE_COMPANIE]</strong>, cu sediul în [ADRESA_SEDIU], înregistrată la Registrul Comerțului sub nr. [NR_REG_COM], CUI [CUI] („noi", „Compania").</p>
<p>Vă rugăm să citiți cu atenție acești Termeni înainte de a utiliza Platforma.</p>
<h3>1. Acceptarea Termenilor</h3>
<p>Prin crearea unui cont, accesarea sau utilizarea Platformei, confirmați că ați citit, ați înțeles și sunteți de acord să respectați acești Termeni și Condiții, precum și Politica de Confidențialitate și Politica de Cookie-uri, care fac parte integrantă din prezentul acord. Dacă nu sunteți de acord, vă rugăm să nu utilizați Platforma.</p>
<h3>2. Definiții</h3>
<ul>
<li><strong>Club</strong> — spațiu de lucru izolat în Platformă, dedicat unei comunități de board games (sesiuni, jucători, scoruri, clasamente, calendar, chat etc.).</li>
<li><strong>Admin Principal</strong> — utilizatorul care deține un abonament activ și este proprietarul juridic al unui Club, cu drepturi depline de administrare și de transfer al proprietății.</li>
<li><strong>Admin Secundar</strong> — utilizator desemnat de Admin Principal cu drepturi extinse de administrare, fără dreptul de transfer al proprietății Clubului.</li>
<li><strong>Moderator</strong> — utilizator cu drepturi limitate de moderare a conținutului și a membrilor.</li>
<li><strong>Membru</strong> — utilizator care participă într-un Club fără drepturi de administrare.</li>
<li><strong>Guest (Invitat)</strong> — persoană introdusă într-un Club de către un administrator (de regulă prin nume și/sau email), fără cont propriu, ale cărei date de joc pot fi ulterior unificate cu un cont real.</li>
<li><strong>Conținut generat de utilizatori (CGU)</strong> — orice conținut încărcat de utilizatori: fotografii de sesiune, avatare, mesaje, denumiri, descrieri, scoruri, recenzii.</li>
</ul>
<h3>3. Eligibilitate</h3>
<p>Pentru a crea un cont și a utiliza Platforma trebuie să aveți vârsta de cel puțin <strong>16 ani</strong>. Persoanele sub 16 ani nu au dreptul să își creeze cont și nici să acceseze sau să utilizeze Platforma, indiferent de existența unui acord al reprezentantului legal. Prin crearea contului confirmați că aveți cel puțin 16 ani. Conturile despre care aflăm că aparțin unor persoane sub această vârstă vor fi închise, iar datele asociate șterse conform Politicii de Confidențialitate.</p>
<h3>4. Conturi de utilizator</h3>
<p>Pentru a accesa anumite funcționalități trebuie să creați un cont. Sunteți de acord să:
- furnizați informații corecte și actuale (inclusiv un nume afișat și un identificator unic public „user tag");
- păstrați confidențialitatea datelor de autentificare;
- fiți responsabil pentru toate activitățile desfășurate prin contul dumneavoastră.</p>
<p>Compania își rezervă dreptul de a suspenda sau închide contul în cazul încălcării acestor Termeni.</p>
<h3>5. Structura Cluburilor, roluri și proprietatea datelor</h3>
<p>Platforma este multi-tenant: un utilizator poate deține sau participa în mai multe Cluburi, iar Cluburile sunt izolate între ele.</p>
<p><strong>Distincția fundamentală privind proprietatea datelor:</strong>
- <strong>Datele Clubului</strong> (sesiuni, scoruri, clasamente, catalog, calendar, conținutul clubului) <strong>aparțin Clubului ca entitate, NU utilizatorului individual care le-a introdus.</strong> La plecarea unui membru, la transferul sau la preluarea (Claim) Clubului, aceste date rămân asociate Clubului.
- <strong>Datele personale de profil</strong> (nume afișat, user tag, avatar, biografie, preferințe și statistici globale) <strong>rămân, în orice situație, proprietatea exclusivă a utilizatorului.</strong> Ele aparțin contului dumneavoastră, vă urmează indiferent de Cluburile în care intrați sau pe care le părăsiți și le puteți edita ori șterge oricând din contul propriu.</p>
<p>Drepturile de administrare sunt ierarhizate: Admin Principal &gt; Admin Secundar &gt; Moderator &gt; Membru. Doar Adminul Principal poate transfera proprietatea Clubului sau gestiona abonamentul aferent.</p>
<h3>5.1 Competiții, turnee, campanii și pagini publice de turneu</h3>
<p>Platforma include funcționalități competitive și comunitare: <strong>turnee</strong> (eliminatorii sau pe grupe), <strong>campanii</strong> (serii de sesiuni legate între ele), <strong>sesiuni cooperative</strong> și <strong>clasamente</strong> (inclusiv ELO și scoruri normalizate între jocuri diferite). Clasamentele și punctajele sunt reprezentări calculate automat pe baza rezultatelor introduse în Club, pot fi corectate de administratori, <strong>nu au valoare monetară</strong> și nu constituie jocuri de noroc.</p>
<p><strong>Pagina publică de turneu:</strong> administratorii unui Club pot alege să publice pagina publică a unui turneu. Pe această pagină, <strong>numele afișate ale participanților, rezultatele și clasamentul turneului devin vizibile oricărei persoane care deține linkul, fără autentificare.</strong> Participând la un turneu marcat ca public, luați la cunoștință această vizibilitate. Administratorii pot retrage publicarea oricând, iar în privința datelor vă puteți exercita drepturile conform Politicii de Confidențialitate.</p>
<h3>6. Conduita utilizatorului</h3>
<p>Vă angajați să nu:
- utilizați Platforma în scopuri ilegale sau neautorizate;
- publicați conținut ilegal, jignitor, amenințător, defăimător sau care încalcă drepturile altora;
- perturbați funcționarea Platformei (viruși, spam, accesări automate/bot);
- vă dați drept altă persoană sau să accesați conturi care nu vă aparțin.</p>
<p>Sunteți singurul responsabil pentru interacțiunile cu ceilalți membri și pentru conținutul pe care îl publicați.</p>
<p><strong>Raportarea conținutului.</strong> Puteți raporta direct din aplicație conținutul sau utilizatorii care încalcă acești Termeni ori legea. Analizăm sesizările într-un termen rezonabil și putem elimina conținutul, restricționa funcționalități sau suspenda conturi, cu respectarea legislației aplicabile privind serviciile digitale.</p>
<h3>7. Conținut generat de utilizatori și licență</h3>
<p>Prin încărcarea de conținut (în special fotografii de sesiune și avatare, stocate în infrastructura noastră) declarați și garantați că <strong>dețineți toate drepturile necesare</strong> asupra acestuia și că aveți consimțământul persoanelor identificabile din fotografii.</p>
<p>Acordați Companiei o licență mondială, neexclusivă, gratuită și transferabilă de a stoca, afișa și reproduce acest conținut <strong>exclusiv în scopul funcționării Platformei</strong> (afișarea în Clubul respectiv, în istoric, galerii și profiluri). Această licență încetează când ștergeți conținutul, cu excepția copiilor tehnice reziduale și a cazurilor în care conținutul a fost deja distribuit altor membri ai Clubului.</p>
<p>Compania poate elimina sau modera, la propria apreciere, conținutul care încalcă acești Termeni.</p>
<h3>8. Abonamente, plăți și facturare</h3>
<p>Profilul personal este gratuit. Accesul la funcționalitățile avansate ale Cluburilor se face pe bază de <strong>abonament asociat contului</strong> (nu Clubului), disponibil în mai multe planuri (lunar sau anual). Tipul de plan determină numărul de Cluburi pe care le puteți crea și numărul de membri per Club.</p>
<p><strong>Valute și prețuri.</strong> Prețurile sunt afișate și încasate în <strong>lei (RON), dolari americani (USD) sau euro (EUR)</strong>. Fiecare plan are un preț propriu, fix, în fiecare valută — nu sunt conversii, iar suma afișată este exact suma care vi se va încasa. Valuta contului dumneavoastră de plată se stabilește la prima plată și rămâne aceeași pentru plățile ulterioare.</p>
<p><strong>Perioadă de probă (trial):</strong> putem oferi o perioadă de probă gratuită de <strong>30 de zile, fără card</strong>, care deblochează funcționalitățile unui plan plătit. Perioada de probă se acordă <strong>o singură dată per cont</strong>, eligibilitatea fiind verificată de sistemele noastre. La expirare, dacă nu activați un abonament plătit, Clubul aferent parcurge etapele descrise la secțiunea 9 (regim „doar citire", apoi arhivare). Ne rezervăm dreptul de a refuza sau revoca perioadele de probă obținute prin conturi multiple sau alte forme de abuz.</p>
<ul>
<li><strong>Procesarea plăților și gestionarea taxelor</strong> sunt asigurate prin <strong>Stripe Managed Payments</strong>, furnizate de <strong>Sold through Link, LLC</strong> („Link SMP"), un afiliat Stripe. Pentru tranzacțiile efectuate prin Platformă, Link SMP acționează ca <strong>vânzător oficial din punct de vedere fiscal (merchant of record)</strong>: colectează și virează taxele aplicabile (TVA și echivalente), procesează plata și emite documentația fiscală a tranzacției. Pe chitanță și pe extrasul de card apare „Sold through Link, LLC". Nu stocăm datele complete ale cardului dumneavoastră.</li>
<li><strong>TurnOrder (operat de [DENUMIRE_COMPANIE]) rămâne furnizorul serviciului</strong> și răspunde pentru produs, calitatea acestuia, conformitatea legală și politica proprie de rambursare. Rambursările pot fi emise prin Stripe/Link în termen de până la 60 de zile, în condițiile politicii noastre de rambursare și ale termenilor Stripe/Link.</li>
<li><strong>Reînnoire automată:</strong> abonamentele se reînnoiesc automat la finalul fiecărei perioade. Puteți opri oricând reînnoirea din <strong>portalul de facturare</strong>, accesibil din aplicație („Gestionează abonamentul"), de unde vă puteți actualiza și metoda de plată sau descărca facturile.</li>
<li><strong>Upgrade/Downgrade:</strong> puteți schimba planul oricând din <strong>portalul de facturare</strong>. Planul nou îl înlocuiește pe cel curent, iar diferența de preț se calculează proporțional cu perioada rămasă, conform regulilor procesatorului de plăți.</li>
</ul>
<h3>9. Neplata, ciclul de viață al Clubului și mecanismul „Claim Club"</h3>
<p>În cazul în care abonamentul Adminului Principal nu mai este activ, Clubul aferent parcurge următoarele etape:
1. <strong>Perioadă de grație (zilele 1–30):</strong> Clubul trece în regim <strong>„doar citire"</strong> — datele rămân accesibile, dar nu mai pot fi adăugate sau modificate.
2. <strong>Arhivare (din ziua 31):</strong> Clubul devine inaccesibil membrilor și ascuns din zonele publice, însă datele se păstrează.
3. <strong>Ștergere definitivă (din ziua 90):</strong> datele Clubului se șterg ireversibil. Datele de profil personal și statisticile globale ale membrilor rămân neafectate.</p>
<p><strong>Mecanismul „Claim Club" (Preluarea Clubului):</strong> orice membru activ al unui Club aflat în grație sau arhivat poate prelua Clubul activându-și un abonament corespunzător (sau, dacă deține deja unul cu un slot disponibil, direct). În urma preluării, <strong>proprietatea juridică a Clubului trece la membrul care preia</strong>, Adminul Principal anterior devenind membru obișnuit. <strong>Prin acceptarea acestor Termeni, recunoașteți și sunteți de acord că neplata abonamentului poate duce la pierderea dreptului de proprietate asupra Clubului în favoarea altui membru care preia abonamentul,</strong> precum și la ștergerea definitivă a datelor Clubului conform termenelor de mai sus.</p>
<p><strong>Transferul proprietății:</strong> Adminul Principal poate transfera voluntar proprietatea Clubului către alt membru care deține un abonament activ și un slot disponibil.</p>
<h3>10. Dreptul de retragere și politica de rambursare (consumatori)</h3>
<p>Platforma furnizează conținut digital și servicii cu acces imediat. În conformitate cu legislația UE și cu OUG nr. 34/2014, prin inițierea abonamentului și solicitarea accesului imediat la funcționalitățile premium, <strong>vă exprimați acordul expres pentru începerea prestării serviciului înainte de expirarea termenului de retragere de 14 zile și luați la cunoștință că vă pierdeți dreptul de retragere</strong> odată ce serviciul a fost prestat integral. Acest aspect vă este reconfirmat la momentul plății (checkout).</p>
<p><strong>Politica de rambursare.</strong> Întrucât oferim un serviciu digital cu acces imediat, plățile efectuate nu sunt, de regulă, rambursabile după ce ați început să utilizați funcționalitățile premium (conform paragrafului de mai sus). Totuși, putem acorda rambursări, la aprecierea noastră rezonabilă, în situații precum:</p>
<ul>
<li>plăți duble sau erori de facturare;</li>
<li>o problemă tehnică ce vă împiedică să folosiți serviciul și pe care nu o putem remedia într-un termen rezonabil;</li>
<li>alte cazuri în care rambursarea este cerută de legislația aplicabilă privind protecția consumatorilor.</li>
</ul>
<p>Rambursările aprobate se procesează prin <strong>Stripe / Sold through Link, LLC</strong>, către metoda de plată originală, în termen de până la 60 de zile. Pentru a solicita o rambursare, ne contactați la <strong>contact@turnorder.org</strong>, indicând contul și tranzacția vizată.</p>
<p><strong>Anularea reînnoirii automate.</strong> Puteți opri oricând reînnoirea automată din <strong>portalul de facturare</strong>, accesibil din aplicație („Gestionează abonamentul"). Anularea oprește plățile viitoare, dar nu generează automat o rambursare pentru perioada curentă — accesul rămâne activ până la finalul perioadei deja plătite.</p>
<p>Nicio prevedere din această secțiune nu limitează drepturile imperative pe care le aveți în calitate de consumator conform legislației aplicabile.</p>
<h3>11. Proprietate intelectuală</h3>
<p>Toate drepturile de proprietate intelectuală asupra Platformei (design, cod sursă, mărci, funcționalități) aparțin Companiei. Nu aveți dreptul să copiați, modificați, decompilați sau să utilizați Platforma într-un mod care încalcă aceste drepturi sau drepturile terților.</p>
<h3>12. Modificări ale Serviciului</h3>
<p>Compania își rezervă dreptul de a modifica, actualiza sau întrerupe Platforma sau părți ale acesteia, în orice moment. Vom depune eforturi rezonabile pentru a anunța modificările semnificative.</p>
<h3>13. Suspendarea și încetarea accesului</h3>
<p>Compania poate suspenda sau închide accesul la cont în caz de încălcare a Termenilor sau de activitate ilegală. Vă puteți închide contul oricând. La încetare, accesul la cont și la conținutul asociat încetează, sub rezerva obligațiilor legale de retenție.</p>
<h3>14. Limitarea răspunderii și dispute între membri</h3>
<p>Platforma este furnizată „ca atare" și „în funcție de disponibilitate", fără garanții de niciun fel. Nu garantăm disponibilitatea neîntreruptă sau lipsa erorilor.</p>
<p><strong>TurnOrder este un instrument de organizare; nu suntem parte și nu ne asumăm răspunderea pentru disputele dintre membrii unui Club</strong> (privind scoruri, clasamente, organizare, comportament sau orice altă chestiune internă). În limita maximă permisă de lege, Compania nu răspunde pentru daune indirecte, incidentale sau consecvente rezultate din utilizarea Platformei. Aceste limitări nu afectează drepturile imperative ale consumatorilor.</p>
<h3>15. Despăgubire</h3>
<p>Sunteți de acord să despăgubiți Compania pentru orice pretenții, daune sau cheltuieli (inclusiv onorarii) rezultate din utilizarea Platformei de către dumneavoastră, din încălcarea acestor Termeni sau a drepturilor unui terț.</p>
<h3>16. Linkuri și servicii terțe</h3>
<p>Platforma poate conține integrări sau linkuri către servicii terțe (de ex. BoardGameGeek, Stripe). Nu răspundem pentru conținutul sau practicile acestora; utilizarea lor este pe propriul risc și este guvernată de termenii respectivilor furnizori.</p>
<h3>17. Legea aplicabilă și soluționarea litigiilor</h3>
<p>Acești Termeni sunt guvernați de legea română. Litigiile se soluționează de instanțele competente din România.</p>
<p>Pentru consumatori: aveți dreptul de a vă adresa <strong>Autorității Naționale pentru Protecția Consumatorilor (ANPC)</strong> — <a href="https://anpc.ro">www.anpc.ro</a> — inclusiv prin procedura de <strong>Soluționare Alternativă a Litigiilor (SAL)</strong> — <a href="https://anpc.ro/ce-este-sal/">anpc.ro/ce-este-sal</a>. Platforma europeană de Soluționare Online a Litigiilor (SOL/ODR) a fost desființată de Uniunea Europeană în iulie 2025 și nu mai este disponibilă.</p>
<h3>18. Modificări ale Termenilor</h3>
<p>Putem modifica acești Termeni. Modificările vor fi publicate în Platformă, iar utilizarea în continuare a Platformei constituie acceptarea Termenilor actualizați.</p>
<h3>19. Contact</h3>
<p>Pentru întrebări legate de acești Termeni: <strong>contact@turnorder.org</strong>.</p>
<hr />`,
            'legal.privacy.body': `<p>[DENUMIRE_COMPANIE] (CUI [CUI], [ADRESA_SEDIU]) este operatorul de date cu caracter personal pentru platforma TurnOrder și se angajează să vă protejeze confidențialitatea. Această politică explică ce date colectăm, de ce, unde le stocăm, cu cine le partajăm și ce drepturi aveți conform Regulamentului (UE) 2016/679 (GDPR).</p>
<h3>1. Operatorul de date</h3>
<p>Operator: <strong>[DENUMIRE_COMPANIE]</strong>, [ADRESA_SEDIU], CUI [CUI], înregistrată la Registrul Comerțului sub nr. [NR_REG_COM].
Contact confidențialitate: <strong>contact@turnorder.org</strong>.</p>
<h3>2. Ce date colectăm</h3>
<p>Colectăm doar datele necesare funcționării serviciului:</p>
<p><strong>a) Date de cont și profil</strong>
- Adresă de email;
- Nume afișat (display name) și identificator public unic (user tag);
- Opțional: biografie, nivel de experiență, jocuri preferate, avatar, nume de utilizator BoardGameGeek, gen, status, disponibilitate, țară/oraș;
- Setările tale de comunicare: persoanele blocate, conversațiile private șterse doar pentru tine, persoanele de la care ai oprit notificările, notificările pe care le primești din fiecare club și cine vede când ești online;
- Preferințele tale de aspect ale chatului (culoarea bulelor, fundalul, mărimea textului), precum și emoji-urile folosite recent și nuanța pielii aleasă pentru ele, vizibile doar ție și păstrate în cont ca să fie la fel pe toate dispozitivele.</p>
<p><strong>b) Conținut generat de utilizator</strong>
- Fotografii de sesiune, fotografii din anunțurile clubului și avatare (stocate în spațiul nostru de stocare securizat; fotografiile noi de sesiune și din anunțuri au și o copie mică, pentru afișare rapidă, ștearsă odată cu fotografia);
- Mesaje în chat-ul clubului și mesaje directe (DM), inclusiv reacțiile tale la mesaje (le văd cei care văd și mesajul) și pozele trimise în ele (fiecare cu o copie mică, pentru afișare rapidă, ștearsă odată cu poza);
- Previzualizarea linkurilor pe care le scrii într-un mesaj: titlul, descrierea și o imagine mică a paginii, preluate de serverul nostru de pe site-ul respectiv chiar când scrii linkul (site-ul vede doar serverul nostru, nu adresa ta). Previzualizarea face parte din mesaj (o văd doar cei care văd și mesajul), iar linkul nu se păstrează nicăieri altundeva; imaginea se șterge odată cu mesajul. Un videoclip YouTube se încarcă de la YouTube (Google) doar după ce apeși ▶ și accepți; din acel moment YouTube primește adresa ta IP și informațiile tehnice ale dispozitivului;
- Scoruri, istoric de sesiuni, clasamente (inclusiv ELO).</p>
<p><strong>c) Date tehnice și de securitate</strong>
- Adresă IP și informații tehnice minime necesare securității și prevenirii abuzului;
- Jurnale de audit ale acțiunilor administrative din cluburi;
- Dacă activați notificările push: abonamentul push al browserului (token tehnic), folosit exclusiv pentru livrarea notificărilor solicitate de dumneavoastră (temei: consimțământ); îl puteți revoca oricând din aplicație sau din browser;
- Tokeni de sesiune (autentificare).</p>
<p><strong>d) Date de facturare și fiscale</strong> (la achiziționarea unui abonament)
- Sunt colectate direct de <strong>Sold through Link, LLC / Stripe</strong> la momentul plății (nume/denumire și, pentru persoane juridice, datele fiscale, inclusiv codul de TVA), pentru emiterea documentației fiscale a tranzacției. Noi nu colectăm aceste date în aplicație.</p>
<p><strong>e) Date opționale</strong>
- Locație (oraș/țară), furnizată voluntar de dumneavoastră.</p>
<p>Nu colectăm și <strong>nu stocăm niciodată parola dumneavoastră</strong> — autentificarea și criptarea parolelor (hashing) sunt gestionate securizat de furnizorul nostru de infrastructură.</p>
<h3>3. De ce prelucrăm datele (temeiuri legale)</h3>
<div class="legal-table-wrap"><table>
<thead>
<tr>
<th>Scop</th>
<th>Temei legal (GDPR)</th>
</tr>
</thead>
<tbody>
<tr>
<td>Crearea contului și furnizarea serviciului (cluburi, sesiuni, scoruri, chat)</td>
<td>Executarea contractului (art. 6(1)(b))</td>
</tr>
<tr>
<td>Afișarea profilului public (user tag, nume afișat) ca rețea socială</td>
<td>Executarea contractului / consimțământ (art. 6(1)(b)/(a))</td>
</tr>
<tr>
<td>Procesarea plăților și gestionarea abonamentelor</td>
<td>Executarea contractului (art. 6(1)(b))</td>
</tr>
<tr>
<td>Securitate, prevenirea fraudei și a abuzului (IP, CAPTCHA, audit)</td>
<td>Interes legitim (art. 6(1)(f))</td>
</tr>
<tr>
<td>Date opționale de profil și locație</td>
<td>Consimțământ (art. 6(1)(a))</td>
</tr>
</tbody>
</table></div>
<h3>4. Unde stocăm datele</h3>
<p>Baza de date și sistemul de autentificare sunt găzduite pe <strong>Supabase</strong>, în regiunea <strong>Uniunea Europeană – Irlanda (eu-west-1)</strong>. Datele dumneavoastră de bază sunt astfel stocate <strong>fizic în UE</strong>.</p>
<p>Aplicația este găzduită pe <strong>Netlify</strong>, iar codul sursă pe GitHub. Procesarea plăților implică <strong>Stripe / Sold through Link, LLC</strong> (entitate din SUA), care pot prelucra anumite date în afara UE — acest transfer este protejat prin <strong>Clauzele Contractuale Standard (SCC)</strong> aprobate de Comisia Europeană și prin angajamentele de conformitate GDPR ale Stripe.</p>
<p>Rapoartele automate de eroare tehnică sunt procesate de <strong>Sentry</strong>, în regiunea <strong>Uniunea Europeană – Frankfurt, Germania</strong>. Emailurile tranzacționale sunt livrate prin <strong>Resend</strong>.</p>
<h3>5. Cu cine partajăm datele (persoane împuternicite)</h3>
<p>Nu vindem datele dumneavoastră și nu le partajăm în scopuri publicitare. Le partajăm exclusiv cu furnizorii necesari funcționării serviciului, care acționează ca persoane împuternicite:</p>
<ul>
<li><strong>Supabase</strong> — găzduire bază de date, autentificare și stocare fișiere (UE/Irlanda);</li>
<li><strong>Stripe / Sold through Link, LLC</strong> — procesare plăți, prevenirea fraudei, gestionarea disputelor și conformitate fiscală (merchant of record pentru tranzacții, prin Stripe Managed Payments);</li>
<li><strong>Netlify</strong> — găzduire aplicație;</li>
<li><strong>Cloudflare (Turnstile)</strong> — protecție anti-bot la autentificare;</li>
<li><strong>Sentry</strong> — monitorizarea automată a erorilor tehnice ale aplicației (UE/Frankfurt). Se transmit exclusiv informații tehnice despre eroare: tipul erorii, locul din codul aplicației unde a apărut, pagina și versiunea aplicației. <strong>Nu se transmit adresa dumneavoastră de email, numele, conținutul mesajelor, adresa IP sau localizarea</strong> — acestea sunt eliminate automat înainte de trimitere;</li>
<li><strong>Resend</strong> — livrarea emailurilor tranzacționale (confirmări, export de date, notificări privind contul și securitatea). Primește adresa de email a destinatarului și conținutul mesajului trimis.</li>
</ul>
<p><strong>Autentificarea cu Google.</strong> Dacă alegeți „Continuă cu Google", Google acționează ca <strong>operator independent</strong> pentru procesul de autentificare, conform propriei sale politici de confidențialitate. Noi primim de la Google doar adresa de email și numele afișat, strict necesare creării contului.</p>
<p><strong>Rețele de distribuție de conținut (CDN).</strong> Anumite componente tehnice ale aplicației (biblioteci de cod, elemente audio) sunt livrate prin rețelele publice <strong>cdnjs (Cloudflare)</strong> și <strong>jsDelivr</strong>. La încărcarea acestor fișiere, adresa IP a dispozitivului dumneavoastră devine vizibilă furnizorului respectiv — la fel ca la orice cerere pe internet. Nu le transmitem niciun fel de date de cont.</p>
<p>Putem divulga date și atunci când legea ne obligă (autorități, instanțe).</p>
<h3>6. Vizibilitatea profilului public</h3>
<p>TurnOrder include o componentă socială, iar <strong>vizibilitatea profilului dumneavoastră este controlată integral de dumneavoastră, din setările contului:</strong>
- <strong>Numele afișat și user tag-ul</strong> sunt elementele de identificare publică și sunt vizibile altor utilizatori (similar unei rețele sociale).
- <strong>Fotografia de profil (avatar)</strong> este opțională: dacă alegeți să încărcați o fotografie, aceasta este afișată ca parte a profilului dumneavoastră și vizibilă altor utilizatori. Alternativ, puteți folosi un avatar presetat, iar fotografia poate fi eliminată oricând.
- <strong>Toate celelalte informații de profil</strong> (avatar, nivel de experiență, vârstă, gen, locație, jocuri preferate, status, disponibilitate etc.) devin vizibile altor utilizatori <strong>doar în măsura în care alegeți dumneavoastră să le faceți publice</strong> — fiecare câmp are propriul comutator de vizibilitate. Dumneavoastră decideți, câmp cu câmp, ce se afișează.
- Printr-un comutator separat puteți controla dacă profilul este <strong>„descoperibil"</strong> (apare pentru alți utilizatori în secțiunea „Descoperă jucători") sau ascuns.
- <strong>Adresa de email</strong> nu este afișată public.
- <strong>Statusul online</strong> („Online”): cât folosiți aplicația, membrii cluburilor dumneavoastră, prietenii și persoanele cu care aveți conversații private pot vedea că sunteți online. Din setările profilului puteți alege „Nimeni”: atunci nu mai apăreți online și nici nu vedeți statusul celorlalți. Statusul nu este salvat — nu păstrăm un istoric al momentelor în care ați fost online.</p>
<p>Datele dumneavoastră de profil vă aparțin în orice situație: le puteți edita, ascunde sau șterge oricând din cont. (Spre deosebire de acestea, datele introduse în cadrul unui Club aparțin Clubului — vezi Termenii și Condiții.)</p>
<p><strong>Pagini publice de turneu:</strong> dacă administratorii clubului publică un turneu, numele dumneavoastră afișat și rezultatele din acel turneu apar pe o pagină publică, accesibilă fără autentificare, cât timp turneul rămâne publicat. Detalii în Termeni și Condiții (secțiunea 5.1).</p>
<h3>7. Fluxul Guest → Cont real (consimțământ hibrid)</h3>
<p>Un administrator de club poate adăuga un „Guest" (invitat) introducând numele și, opțional, emailul acestuia, pentru a-i înregistra participarea la sesiuni — pe baza interesului legitim de organizare a clubului. Dacă persoana respectivă își creează ulterior un cont real cu același email, datele de joc anterioare pot fi <strong>unificate</strong> cu noul cont, cu acordul utilizatorului, astfel încât istoricul să îi aparțină. Dacă nu doriți unificarea, ne puteți contacta pentru ștergerea datelor de Guest.</p>
<h3>8. Cât timp păstrăm datele (retenție)</h3>
<ul>
<li><strong>Date de cont și profil:</strong> cât timp contul este activ. La ștergerea contului, datele personale sunt eliminate, cu excepția celor pe care suntem obligați legal să le păstrăm.</li>
<li><strong>Date ale unui Club neplătit:</strong> păstrate pe durata abonamentului și a perioadei de grație ulterioare; <strong>datele Clubului se șterg definitiv la 90 de zile</strong> de la încetarea abonamentului. (Etapele complete ale ciclului de viață al Clubului sunt descrise în Termeni și Condiții.)</li>
<li><strong>Documente fiscale ale tranzacțiilor:</strong> emise și păstrate de <strong>Sold through Link, LLC / Stripe</strong> conform obligațiilor lor. Evidențele noastre contabile proprii (privind încasările) se păstrează conform legislației contabile române (în general 10 ani).</li>
<li><strong>Jurnale de securitate/audit:</strong> păstrate pe o perioadă limitată, necesară securității.</li>
<li><strong>Rapoarte de eroare tehnică:</strong> păstrate de Sentry maximum <strong>90 de zile</strong>, apoi șterse automat.</li>
<li><strong>Copii de siguranță (backup) ale Clubului:</strong> pentru a putea recupera datele unui Club în caz de ștergere accidentală sau incident tehnic, realizăm automat copii zilnice ale datelor fiecărui Club. Acestea sunt accesibile <strong>exclusiv administratorilor Clubului respectiv</strong> și se păstrează maximum <strong>5 săptămâni</strong> (ultimele 7 zile, plus câte o copie săptămânală din ultimele 4 săptămâni). Copiile <strong>nu conțin</strong> adrese de email, date de plată sau mesaje private (DM). Conțin însă numele afișate ale membrilor, acolo unde acestea sunt necesare pentru a păstra inteligibil istoricul (de exemplu autorul unui mesaj din chat-ul Clubului sau al unei acțiuni din jurnalul de audit). În consecință, la ștergerea contului, numele dumneavoastră afișat poate persista în aceste copii de siguranță <strong>până la 5 săptămâni</strong>, după care dispare automat. Administratorii pot descărca oricând o copie manuală; acestea se păstrează în limita ultimelor 10.</li>
</ul>
<h3>9. Drepturile dumneavoastră (GDPR)</h3>
<p>Aveți dreptul la:
- <strong>Acces</strong> — să aflați ce date deținem despre dumneavoastră;
- <strong>Rectificare</strong> — corectarea datelor inexacte;
- <strong>Ștergere („dreptul de a fi uitat")</strong> — eliminarea datelor, în limitele obligațiilor legale;
- <strong>Portabilitate</strong> — primirea datelor într-un format structurat, utilizat în mod curent;
- <strong>Restricționare</strong> și <strong>opoziție</strong> la anumite prelucrări;
- <strong>Retragerea consimțământului</strong> oricând, fără a afecta prelucrările anterioare.</p>
<p><strong>Direct din aplicație</strong> puteți exporta o copie a datelor dumneavoastră (export într-un format structurat) și puteți <strong>șterge definitiv contul</strong>, din secțiunea de profil. Pentru orice alte solicitări privind drepturile de mai sus, ne contactați la <strong>contact@turnorder.org</strong>. Vă vom ghida prin proces conform GDPR și vom răspunde în termenele legale.</p>
<p>Aveți de asemenea dreptul de a depune o plângere la <strong>Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP)</strong> — <a href="https://www.dataprotection.ro">www.dataprotection.ro</a>.</p>
<h3>10. Securitatea datelor</h3>
<p>Aplicăm măsuri tehnice și organizatorice standard în industrie: criptarea parolelor (hashing), transmisie securizată HTTPS, izolarea datelor între cluburi prin politici de securitate la nivel de rând (Row Level Security), controale de acces bazate pe roluri, protecție anti-bot (CAPTCHA) și jurnale de audit. În cazul unei breșe de securitate care vă afectează datele, vă vom notifica și vom notifica autoritatea competentă conform obligațiilor legale.</p>
<h3>11. Cookie-uri</h3>
<p>Folosim doar cookie-uri și tehnologii similare <strong>esențiale</strong> (menținerea sesiunii de autentificare și prevenirea fraudei la plată). Nu folosim cookie-uri de publicitate sau de urmărire. Detalii în <strong>Politica de Cookie-uri</strong>.</p>
<h3>12. Copii</h3>
<p>Platforma nu se adresează persoanelor sub <strong>16 ani</strong> și nu colectăm cu bună știință date ale acestora. Vârsta minimă de 16 ani este confirmată la crearea contului. Dacă aflăm că am colectat date de la o persoană sub 16 ani, vom închide contul și vom șterge datele în cel mai scurt timp.</p>
<h3>13. Modificări ale acestei politici</h3>
<p>Putem actualiza periodic această politică. Vom publica versiunea actualizată în Platformă, iar modificările intră în vigoare la publicare. Vă recomandăm să revizuiți periodic această pagină.</p>
<h3>14. Contact</h3>
<p>Pentru orice întrebare privind această Politică de Confidențialitate sau datele dumneavoastră: <strong>contact@turnorder.org</strong>.</p>
<hr />`,
            'legal.cookies.body': `<p>Această politică explică ce cookie-uri și tehnologii similare folosim în TurnOrder, operat de [DENUMIRE_COMPANIE]. Pe scurt: <strong>folosim doar tehnologii esențiale, necesare funcționării aplicației. Nu folosim cookie-uri de publicitate, de urmărire sau de profilare.</strong> Singura excepție este opțională și o alegi tu: un videoclip YouTube dintr-o conversație se încarcă doar dacă apeși ▶ și accepți (vezi secțiunea 3).</p>
<h3>1. Ce sunt cookie-urile și tehnologiile similare</h3>
<p>Cookie-urile sunt fișiere text mici stocate de browser. „Tehnologiile similare" includ stocarea locală a browserului (localStorage) și stocarea valabilă doar pe durata sesiunii (sessionStorage), pe care TurnOrder le folosește pentru a-și aminti sesiunea și preferințele dumneavoastră. În această politică ne referim la toate acestea, generic, drept „cookie-uri".</p>
<h3>2. Cum folosim noi aceste tehnologii (esențiale)</h3>
<p>TurnOrder <strong>nu plasează cookie-uri proprii de urmărire</strong>. Pentru funcționarea aplicației folosim stocarea locală a browserului (localStorage și, pentru ce trebuie păstrat doar cât e deschisă fila, sessionStorage), în următoarele scopuri:</p>
<div class="legal-table-wrap"><table>
<thead>
<tr>
<th>Scop</th>
<th>Exemple</th>
<th>Tip</th>
</tr>
</thead>
<tbody>
<tr>
<td><strong>Sesiune de autentificare</strong> — vă menține conectat fără să reintroduceți parola la fiecare accesare</td>
<td>tokenul de sesiune furnizat de Supabase</td>
<td>Esențial</td>
</tr>
<tr>
<td><strong>Preferințe</strong> — rețin opțiunile dumneavoastră</td>
<td>limba aleasă, ultima secțiune vizitată, email reținut (dacă bifați „ține-mă minte"), sunet chat, aspectul conversațiilor (culoarea bulelor, fundalul, mărimea textului — o copie a alegerilor salvate în cont, ca să apară imediat la deschidere; ștearsă la ieșirea din cont)</td>
<td>Funcțional</td>
</tr>
<tr>
<td><strong>Starea locală a aplicației</strong> — permite funcționarea fluidă și parțial offline</td>
<td>date de lucru ale clubului curent, marcaje „citit/văzut", textul început și netrimis într-o conversație (ciorna — păstrată doar pe durata sesiunii, în sessionStorage, și ștearsă la ieșirea din cont)</td>
<td>Esențial / Funcțional</td>
</tr>
<tr>
<td><strong>Fluxul de plată</strong> — continuă corect procesul după întoarcerea de la Stripe</td>
<td>indicatori temporari de checkout</td>
<td>Esențial</td>
</tr>
<tr>
<td><strong>Funcționare offline (PWA)</strong> — aplicația păstrează local fișierele proprii, pentru încărcare rapidă și funcționare parțial offline</td>
<td>cache-ul service worker-ului</td>
<td>Esențial</td>
</tr>
<tr>
<td><strong>Notificări push</strong> — doar dacă le activați dumneavoastră</td>
<td>abonamentul push al browserului</td>
<td>Funcțional (opt-in)</td>
</tr>
</tbody>
</table></div>
<p>Aceste tehnologii sunt necesare funcționării aplicației; fără ele, autentificarea și funcțiile de bază nu ar funcționa corect.</p>
<h3>3. Cookie-uri ale terților</h3>
<p>Anumiți furnizori pe care îi folosim pot plasa propriile cookie-uri: pentru securitate și funcționare (Stripe, Cloudflare) sau, numai dacă pornești un videoclip și accepți, pentru redarea lui (YouTube):</p>
<ul>
<li><strong>Stripe</strong> — cookie-uri pentru <strong>prevenirea fraudei</strong> în timpul procesării plăților. Vezi <a href="https://stripe.com/privacy">Politica de confidențialitate Stripe</a>.</li>
<li><strong>Cloudflare Turnstile</strong> — tehnologie <strong>anti-bot (CAPTCHA)</strong> care protejează formularul de autentificare împotriva abuzurilor automate. Vezi <a href="https://www.cloudflare.com/privacypolicy/">Politica de confidențialitate Cloudflare</a>.</li>
<li><strong>Sentry</strong> — monitorizarea erorilor tehnice. <strong>Nu setează cookie-uri</strong> și nu folosește stocare locală persistentă pe dispozitivul dumneavoastră. Vezi <a href="https://sentry.io/privacy/">Politica de confidențialitate Sentry</a>.</li>
<li><strong>YouTube (Google)</strong> — playerul videoclipurilor din conversații, în varianta „fără cookie-uri" (youtube-nocookie.com). <strong>Se încarcă doar după ce apeși ▶ și accepți</strong> (acordul e ținut minte doar până închizi aplicația); după pornire, YouTube poate salva informații în browser. Vezi <a href="https://policies.google.com/privacy">Politica de confidențialitate Google</a>.</li>
</ul>
<p>Nu controlăm aceste cookie-uri ale terților; ele sunt guvernate de politicile furnizorilor respectivi.</p>
<h3>4. Ce NU folosim</h3>
<ul>
<li><strong>Fără</strong> cookie-uri de publicitate;</li>
<li><strong>Fără</strong> urmărire între site-uri (cross-site tracking);</li>
<li><strong>Fără</strong> profilare în scop de marketing;</li>
<li><strong>Nu vindem</strong> și nu partajăm aceste date în scopuri publicitare.</li>
</ul>
<p>Aceste angajamente privesc TurnOrder. Dacă alegi să pornești un videoclip YouTube (după acord), Google își aplică propriile tehnologii și propria politică pentru acel videoclip; dacă nu accepți, YouTube nu se încarcă și nu primește nimic.</p>
<h3>5. Cum gestionați cookie-urile</h3>
<p>Vă puteți gestiona sau șterge cookie-urile și datele stocate local din setările browserului. De asemenea, prin delogare și ștergerea datelor aplicației din browser eliminați tokenul de sesiune și preferințele stocate local. Rețineți că dezactivarea tehnologiilor <strong>esențiale</strong> va împiedica autentificarea și funcționarea corectă a aplicației.</p>
<h3>6. Modificări ale acestei politici</h3>
<p>Putem actualiza această politică pe măsură ce aplicația evoluează. Versiunea actualizată va fi publicată în Platformă, cu efect de la data publicării.</p>
<h3>7. Contact</h3>
<p>Pentru întrebări privind această Politică de Cookie-uri: <strong>contact@turnorder.org</strong>.</p>
<hr />`,
            'pw.len': 'Minim 8 caractere',
            'pw.upper': 'O literă mare',
            'pw.lower': 'O literă mică',
            'pw.digit': 'O cifră',
            'pw.special': 'Un caracter special',
            'pw.match': 'Parolele coincid',
            'pw.weak': 'Parola nu e suficient de puternică: minim 8 caractere, literă mare, literă mică, cifră și un caracter special.',

            // Welcome
            'welcome.tagline': 'Platforma cluburilor tale de jocuri de societate',
            'welcome.register': 'Înregistrare',
            'welcome.demo': 'Demo Rapid',
            'demoBar.text': 'Ești în modul demo: datele sunt fictive și nimic nu se salvează.',
            'demoBar.cta': 'Creează-ți cont gratuit',

            // Hub
            'hub.title': 'Cluburile mele',
            'hub.subtitle': 'Alege un club pentru a intra, sau descoperă altele.',
            'hub.searchPh': 'Caută un club...',
            'hub.noMatch': 'Niciun club nu se potrivește căutării.',
            'hub.noClubs': 'Nu faci parte din niciun club încă.',
            'hub.createClub': 'Creează club',
            'hub.createClubName': 'Numele noului club:',
            'profile.usernameTaken': 'Acest username este deja folosit. Alege altul.',
            'hub.discoverClubs': 'Descoperă cluburi',
            'hub.discoverPlayers': 'Descoperă jucători',
            'hub.plans': 'Planuri de abonament',
            'hub.install': 'Instalează aplicația',
            'hub.ownerPanel': 'Panou proprietar',
            'owner.title': 'Panou proprietar',
            'owner.feedbackTitle': 'Feedback recent',
            'owner.errorsTitle': 'Erori client',
            'owner.errorsFilter': 'Filtrează după context / mesaj…',
            'owner.errorsEmpty': 'Nicio eroare raportată.',
            'common.refresh': 'Reîmprospătează',
            'owner.feedbackLoading': 'Se încarcă feedback-ul...',
            'owner.feedbackEmpty': 'Niciun feedback încă.',
            'owner.feedbackNoAccess': 'Inbox-ul de feedback nu e accesibil (verifică politicile RLS din Supabase).',
            'owner.clubsTitle': 'Cluburile mele',
            'owner.noClubs': 'Niciun club.',
            'owner.infoTitle': 'Info platformă',
            'owner.plan': 'Plan',
            'owner.status': 'Status',
            'owner.role': 'Rol',
            'owner.limit': 'Limită membri',
            'owner.email': 'Email owner',
            'owner.clubCount': 'Total cluburi',
            'owner.pwa': 'PWA',
            'owner.pwaOn': 'activ',
            'owner.pwaOff': 'inactiv',
            'owner.demoNote': 'Ești în demo — feedback-ul real nu este disponibil.',
            'hub.logout': 'Ieși din cont',

            'session.newTitle': 'Sesiune Nouă de Joc',
            'session.type': 'Tip Sesiune',
            'session.standard': 'Sesiune Standard',
            'session.tournament': 'Turneu',
            'session.coop': 'Cooperativ',
            'session.more': 'Mai multe opțiuni',
            'session.friendlyShort': 'Amical',
            'session.photosShort': 'Foto',
            'session.scoresheetShort': 'Scoresheet',
            'session.rolesShort': 'Roluri',
            'session.gameHelp': 'Alegerea jocului încarcă automat scoresheet-ul și rolurile (dacă există).',
            'session.descStandard': 'Joc obișnuit, cu clasament ELO și scoruri individuale.',
            'session.descTournament': 'Eveniment cu mai multe runde, format și premii.',
            'session.descCoop': 'Toți jucați împreună împotriva jocului — fără clasament individual.',
            'session.coopResult': 'Rezultat (echipă)',
            'session.coopWin': 'Victorie (echipa a câștigat)',
            'session.coopLoss': 'Înfrângere (jocul a câștigat)',
            'session.teamScore': 'Scor echipă (opțional)',
            'session.scenario': 'Scenariu (opțional)',
            'coop.difficulty': 'Dificultate (opțional)',
            'coop.diff.none': '— neprecizat',
            'coop.diff.easy': 'Ușor',
            'coop.diff.normal': 'Normal',
            'coop.diff.hard': 'Greu',
            'coop.diff.heroic': 'Eroic',
            'coop.diff.brutal': 'Brutal',
            'coop.diff.custom': 'Personalizat…',
            'coop.difficultyCustom': 'Nume dificultate',
            'coop.detail': 'Detaliu rezultat (opțional)',
            'coop.difficultyShort': 'Dificultate',
            'coop.detailShort': 'Detaliu',
            'coop.ptsEachSuffix': '/ jucător',
            'coop.mvp': 'Jucătorul evidențiat / MVP (opțional)',
            'coop.mvpNone': '— niciunul —',
            'coop.mvpNote': 'Doar o evidențiere simbolică — nu afectează punctele sau clasamentul.',
            'coop.mvpShort': 'MVP',
            'coop.mvpCustom': 'Personalizat (nume liber)…',
            'coop.mvpCustomPh': 'Ex: Andrei (invitat)',
            'history.editSessionTitle': 'Editare sesiune',
            'stats.typeCoop': 'Co-op',
            'coopStats.empty': 'Nu există sesiuni cooperative în această perioadă.',
            'coopStats.sessions': 'Sesiuni coop',
            'coopStats.wins': 'Victorii',
            'coopStats.winRate': 'Rată de victorie',
            'coopStats.streak': 'Serie curentă',
            'coopStats.hardestBeaten': 'Cea mai grea învinsă',
            'coopStats.mostPlayed': 'Cel mai jucat',
            'coopStats.byDifficulty': 'Victorii pe dificultate',
            'coop.scenarioSuggest': 'Scenarii anterioare:',
            'session.coopNote': 'În mod cooperativ nu există clasament individual: toți participanții împart rezultatul, iar sesiunea nu afectează ELO-ul.',
            'session.coopNoPoints': 'Uniformizarea e dezactivată pe acest club. La victorie, Scorul de echipă (dacă îl completezi) se adaugă egal tuturor jucătorilor; la înfrângere se înregistrează în istoric, fără a modifica punctele.',
            'session.tName': 'Nume Turneu',
            'session.prize': 'Premiu',
            'session.format': 'Format',
            'session.fmtChoose': '— Alege formatul —',
            'session.fmtRR': 'Toți contra toți (Round Robin)',
            'session.fmtKO': 'Eliminare directă',
            'session.fmtSwiss': 'Sistem elvețian (Swiss)',
            'session.fmtPoints': 'Puncte cumulate',
            'session.fmtOther': 'Altul',
            'session.rounds': 'Număr de runde',
            'session.fee': 'Taxă de participare',
            'session.date': 'Data',
            'session.startTime': 'Ora început',
            'session.duration': 'Durată estimată (min)',
            'session.game': 'Joc',
            'session.chooseGame': '-- Selectează joc --',
            'session.searchGame': 'Caută jocul (titlu / categorie / autor)…',
            'session.noGames': 'Niciun joc găsit în catalog.',
            'session.editScoresheet': 'Editează scoresheet (Pro)',
            'session.editRoles': 'Editează roluri (Pro)',
            'session.location': 'Locație',
            'session.notes': 'Notițe & Reguli speciale',
            'session.notesPh': 'Reguli speciale, observații, etc.',
            'session.friendly': 'Sesiune Amicală (fără ELO)',
            'session.friendlyNote': 'Scorurile se salvează doar ca istoric. Nu se modifică punctajele ELO și clasamentul clubului.',
            'session.scoreModeLabel': 'Tip scorare sesiune',
            'calc.title': 'Calculator',
            'calc.done': 'Gata',
            'session.scoreDirLabel': 'Direcția scorului',
            'session.scoreDirInherited': 'Moștenit de la joc: {dir}. Poți schimba doar pentru această sesiune.',
            'session.scoreDirOverride': 'Suprascris pentru această sesiune (diferit de setarea jocului).',
            'session.scoreModeRawNote': 'Brut: punctele de pe cutie intră direct în clasament, ca până acum.',
            'session.scoreModeUniformNote': 'Uniformizat: punctele se transformă în „Puncte de Club" după loc, conform șablonului din Admin.',
            'session.tieBreakTitle': 'Departajare la egalitate',
            'session.tieBreakHint': 'Apasă pe jucătorul care a câștigat departajarea conform regulamentului jocului — primește locul superior.',
            'session.tieAt': 'Egalitate la',
            'session.scoreKindLabel': 'Tip punctaj',
            'session.kindCompetitive': 'Competitiv (după loc)',
            'session.kindCampaign': 'Campanie (participare)',
            'session.bonusLabel': 'Bonus',
            'session.campaignNote': 'Fiecare jucător primește punctele de participare; câmpul de mai jos e un bonus individual opțional.',
            'session.friendlyLocked': 'Poți introduce scoruri — se salvează în istoric, dar nu afectează clasamentul sau statisticile jucătorilor.',
            'session.addPlayers': 'Adaugă jucători',
            'session.searchPlayersPh': 'Caută după nume sau @user_tag...',
            'session.noPlayersSelected': 'Niciun jucător selectat încă. Caută și adaugă participanții de mai sus.',
            'session.removePlayer': 'Scoate jucătorul',
            'session.noPlayerMatch': 'Niciun jucător găsit.',
            'session.photos': 'Fotografii de la joc',
            'session.addPhotos': 'Adaugă fotografii',
            'session.uploadingPhotos': 'Se încarcă fotografiile...',
            'photo.preparing': 'Se pregătesc {n} fotografii…',
            'photo.stillPreparing': 'Fotografiile încă se pregătesc — mai durează câteva secunde.',
            'photo.uploadRejected': 'Fotografii neîncărcate: {n} — format neacceptat sau fișier prea mare. Restul a fost salvat.',
            'common.remove': 'Elimină',
            'session.participants': 'Participanți',
            'session.addGuest': 'Adaugă Invitat',
            'session.guestNamePh': 'Nume invitat',
            'session.guestEmailPh': 'Email (obligatoriu)',
            'session.add': 'Adaugă',
            'session.save': 'Salvează Sesiune',
            'session.reset': 'Resetează',
            'session.guestTag': 'Invitat',
            'session.absent': 'Absent',
            'session.turn': 'La rând',
            'session.turnActive': 'La rând…',
            'session.scoreLabel': 'Scor',
            'session.role': '— rol/facțiune —',
            'session.timerReset': 'Reset',

            'players.title': 'Gestionare Jucători',
            'players.editScoreTitle': 'Editează scorul',
            'players.currentScore': 'Scor curent',
            'players.newScore': 'Scor nou',
            'players.scoreUpdated': 'Scor actualizat!',
            'players.banned': 'Membri excluși',
            'players.unban': 'Unban',
            'common.edit': 'Edit',
            'common.delete': 'Șterge',
            'common.mute': 'Mute',
            'common.unmute': 'Unmute',
            'common.ban': 'Ban',
            'common.share': 'Distribuie',
            'common.close': 'Închide',
            'lb.prev': 'Poza anterioară',
            'lb.next': 'Poza următoare',
            'common.deletedProfile': 'Profil șters',

            'history.title': 'Istoric Sesiuni',
            'history.empty': 'Nicio sesiune înregistrată încă.',
            'history.recordedBy': 'Înregistrat de',
            'history.edit': 'Editează',

            'catalog.title': 'Catalog Jocuri',
            'catalog.search': 'Caută joc',
            'catalog.searchPh': 'Nume, categorie, mecanici...',
            'catalog.filters': 'Filtre',
            'catalog.allCats': 'Toate categoriile',
            'catalog.sortBy': 'Sortează după',
            'catalog.sortAz': 'Alfabetic (A–Z)',
            'catalog.sortAdded': 'Data adăugării (recente)',
            'catalog.sortRating': 'Rating (mare → mic)',
            'catalog.sortWeight': 'Weight (mare → mic)',
            'catalog.sortPlays': 'Cele mai jucate',
            'catalog.sortRecent': 'Jucate recent',
            'catalog.catEuro': '🏛️ Eurogame',
            'catalog.catAmeri': '🎲 Ameritrash',
            'catalog.catParty': '🎉 Party',
            'catalog.catCoop': '🤝 Cooperativ',
            'catalog.catStrategy': '🧠 Strategie',
            'catalog.catRpg': '🐉 RPG',
            'catalog.catFiller': '⚡ Filler',
            'catalog.catLegacy': '📖 Legacy',
            'catalog.catDeck': '🎴 Deck Building',
            'catalog.catWorker': '👷 Worker Placement',
            'catalog.addGame': 'Adaugă Joc',
            'catalog.importBgg': 'Import BGG',
            'catalog.exportJson': 'Export JSON',
            'catalog.bulkDelete': 'Ștergere în masă',
            'catalog.statsTitle': 'Statistici Catalog',
            'catalog.totalGames': 'Total Jocuri',
            'catalog.mostPlayed': 'Cel mai jucat',
            'catalog.avgRating': 'Rating mediu',
            'catalog.tools': 'Unelte',
            'catalog.playTime': 'Timp total de joc',
            'catalog.totalPlays': 'Total Jucări',

            'stats.title': 'Statistici Detaliate',
            'stats.crossClub': 'Statistici inter-club',
            'stats.period': 'Perioadă',
            'stats.filters': 'Filtre',
            'stats.type': 'Tip statistică',
            'stats.periodAll': 'Tot timpul',
            'stats.changeNew': 'nou',
            'stats.periodYear': 'Anul curent',
            'stats.periodMonth': 'Luna aceasta',
            'stats.periodWeek': 'Săptămâna aceasta',
            'stats.periodQuarter': 'Trimestrul acesta',
            'stats.typeOverview': 'Prezentare generală',
            'stats.typePlayers': 'Jucători',
            'stats.typeGames': 'Jocuri',
            'stats.typeTrends': 'Tendințe',
            'stats.typeHindex': 'H-Index',
            'stats.typeRolewinrate': 'Win rate per rol/facțiune',
            'stats.tabHindex': 'H-Index',
            'stats.tabRolewinrate': 'Win rate / rol',
            'stats.sessions': 'Sesiuni',
            'stats.pointsAccrued': 'Scoruri acumulate',
            'stats.totalDuration': 'Durată Totală',
            'stats.crossClubTitle': 'Statistici inter-club',
            'stats.clubs': 'Cluburi',
            'stats.wins': 'Victorii',
            'stats.totalPoints': 'Puncte totale',
            'stats.totalScores': 'Total scoruri',
            'stats.scoresH': 'Scoruri',
            'stats.totalScoresTip': 'Suma scorurilor brute din meciuri (diferită de punctele de club, acordate de administratori).',
            'stats.distinctGames': 'Jocuri distincte',
            'stats.club': 'Club',
            'stats.points': 'Puncte',
            'stats.winRateH': 'Win rate',
            'stats.topGamesAll': 'Top jocuri (toate cluburile)',
            'stats.game': 'Joc',
            'stats.plays': 'Partide',
            'stats.roleFaction': 'Rol/facțiune',
            'stats.hIndexClub': 'H-Index club',
            'stats.totalPlays': 'Total partide',
            'stats.hIndexNote': 'H-Index = N înseamnă că există cel puțin <strong>N</strong> jocuri diferite, fiecare jucat de cel puțin <strong>N</strong> ori. E o măsură a diversității + constanței, nu doar a numărului de partide.',
            'stats.player': 'Jucător',
            'stats.topGames': 'Top jocuri',
            'stats.games': 'Jocuri',
            'stats.average': 'Medie',
            'stats.attendance': 'Prezență',
            'stats.playerOfMonth': 'Jucătorul Lunii',
            'stats.bestAverage': 'Cea Mai Bună Medie',
            'stats.mostActive': 'Cel Mai Activ',
            'stats.bestAttendance': 'Cea Mai Bună Prezență',
            'stats.pointsDistribution': 'Distribuție Puncte',
            'stats.players': 'Jucători',
            'stats.duration': 'Durată',
            'stats.lastPlayed': 'Ultima dată',
            'stats.rating': 'Rating',
            'stats.mostPlayedStat': 'Cel Mai Jucat',
            'stats.longestAverage': 'Cea Mai Lungă Medie',
            'stats.trendsTitle': 'Trend-uri',
            'stats.avgScore': 'Scor Mediu',
            'stats.playHours': 'Ore de Joc',

            'calendar.title': 'Calendar Evenimente',
            'calendar.addEvent': 'Adaugă Eveniment',
            'calendar.syncGoogle': 'Sincronizează Google',
            'calendar.export': 'Export Calendar',

            'polls.gameVote': 'Vot — Ce jucăm?',
            'polls.active': 'Poll-uri Active',
            'polls.createNew': 'Creează Poll Nou',
            'polls.statsTitle': 'Statistici Poll-uri',
            'polls.statTotalVotes': 'Total Voturi',
            'polls.statAvgPart': 'Participare Medie',
            'polls.statClosed': 'Poll-uri Închise',

            'campaigns.title': 'Campanii & Legacy',
            'campaigns.new': 'Campanie nouă',
            'campaigns.intro': 'Urmărește progresul campaniilor pe mai multe sesiuni (ex: Gloomhaven, Pandemic Legacy): scenarii, rezultate, roster.',

            'common.save': 'Salvează',
            /* RO: eticheta butonului cat timp salvarea e in curs (rotita). Fara ea,
               la conexiuni lente utilizatorul nu are niciun semn ca s-a intamplat ceva
               si apasa din nou. EN: busy label for save buttons while the write runs. */
            'common.saving': 'Se salvează…',
            'common.retry': 'Reîncearcă',
            'common.back': 'Înapoi',
            'confirm.title': 'Confirmă-ți emailul',
            'confirm.body': 'Ți-am trimis un cod de 6 cifre la',
            'confirm.hint': 'Nu găsești emailul? Verifică și folderul Spam.',
            'confirm.codeLabel': 'Codul din email',
            'confirm.digitLabel': 'Cifra {n} din 6',
            'confirm.codeBtn': 'Confirmă',
            'confirm.codeChecking': 'Se verifică...',
            'confirm.codeInvalid': 'Codul nu e corect sau a expirat. Verifică-l sau cere unul nou.',
            'confirm.resend': 'Retrimite codul',
            'confirm.resendWait': 'Poți cere un cod nou peste {n} secunde.',
            'confirm.resendIn': 'Retrimite în',

            'regulation.tabTitle': 'Regulament',
            'rulesack.bannerTitle': 'Nu ai acceptat încă regulamentul clubului',
            'rulesack.bannerSub': 'Până atunci poți citi tot, dar nu poți adăuga sesiuni, mesaje sau propuneri.',
            'regulation.exportPdf': 'Export PDF',
            'regulation.print': 'Printează',

            'admin.accessTitle': 'Acces Administrare',
            'admin.accessNote': 'Accesul în acest panou este permis automat doar conturilor care au rolul admin setat în baza de date.',
            'admin.checkAccess': 'Verifică accesul',
            'admin.panelTitle': 'Panou Administrare',
            'admin.eloMode': 'Mod Competitiv (ELO)',
            'admin.importData': 'Import date',
            'admin.importNote': 'Importă jocuri și sesiuni din BoardGameGeek (CSV de colecție) sau BG Stats (JSON). Vezi o previzualizare înainte; ce există deja se ignoră.',
            'admin.importBggCsv': 'Import BGG (CSV)',
            'admin.importBgStats': 'Import BG Stats (JSON)',
            'admin.importScorePal': 'Import ScorePal (CSV)',
            'admin.backupRestore': 'Backup & Restore',
            'admin.backupFull': 'Backup complet',
            'admin.restore': 'Restore',
            'admin.restoreFromFile': 'Restaurează din fișier',
            'admin.backupHistory': 'Istoric backup',
            'admin.seasonMgmt': 'Gestionare Sezon',
            'admin.seasonCurrent': 'Perioada curentă (afișată pe dashboard)',
            'admin.seasonLabel': 'Eticheta sezonului (an sau text — afișată mare pe dashboard)',
            'admin.seasonLabelPh': 'ex: 2026 sau „Sezon de iarnă"',
            'admin.saveLabel': 'Salvează eticheta',
            'admin.default': 'Implicit',
            'admin.seasonReport': 'Raport sezon',
            'admin.startNewSeason': 'Începe sezon nou',
            'm3.labelSet': 'Eticheta sezonului: „{label}”',
            'm3.labelReset': 'Eticheta a revenit la an.',
            'auditd.seasonStarted': 'Sezonul {season} arhivat; ELO și istoricul sesiunilor păstrate',
            'auditd.seasonStartedAlready': 'Sezonul {season} (deja arhivat); ELO și istoricul sesiunilor păstrate',
            'auditd.seasonArchivedDemo': 'Arhivat sezonul {season} ({n} membri); ELO și istoricul sesiunilor păstrate',
            'admin.seasonNote': '„Începe sezon nou" arhivează clasamentul și resetează punctele. ELO-ul și istoricul sesiunilor rămân neatinse.',
            'admin.viewArchived': 'Vezi sezoane arhivate',
            'admin.userMgmt': 'Gestionare Utilizatori',
            'admin.scoreEdit': 'Editare Manuală Scoruri',
            'admin.auditLog': 'Audit Log',
            'admin.auditSearchPh': 'Caută în audit (acțiune, user, detalii)...',
            'admin.scorePalNote': 'ScorePal a fost retras în 2024, iar backup-ul nativ e un fișier <code>.realm</code> (binar) care nu poate fi citit aici. Dacă ai datele ca <strong>CSV</strong> (export/convertit, cu coloane gen Game, Date, Player, Score, Winner), le poți importa direct. Alternativ, dacă ți-ai trecut datele prin BG Stats, folosește importul „BG Stats (JSON)".',

            'impmap.title': 'Mapează jucătorii din import',
            'impmap.intro': 'Pentru fiecare nume din import, alege membrul corespunzător sau creează un guest. La „Guest nou" poți seta user_tag și email — ambele sunt opționale. Emailul e doar o scurtătură: dacă se potrivește cu un cont existent, îl leagă pe loc. Poți lăsa câmpul gol fără să pierzi nimic: oricând mai târziu îi poți trimite guest-ului o invitație ca să-și conecteze un cont.',
            'impmap.colImport': 'Din import',
            'impmap.colMapTo': 'Mapează la',
            'impmap.choose': '— alege —',
            'impmap.guestNew': '➕ Guest nou',
            'impmap.tagPh': 'user_tag (opțional)',
            'impmap.emailPh': 'email (opțional)',
            'impmap.continue': 'Continuă importul',
            'impmap.needAll': 'Alege o opțiune pentru fiecare jucător.',
            'impmap.tagTaken': 'user_tag deja folosit pentru: ',
            'impmap.creating': 'Se creează profilurile și se importă...',
            'clubset.title': 'Setări club',
            'clubset.name': 'Nume club',
            'clubset.avatar': 'Avatar club',
            'clubset.avatarUpload': 'Încarcă imagine',
            'clubset.avatarRemove': 'Elimină',
            'clubset.avatarNotImage': 'Alege un fișier imagine.',
            'clubset.avatarReady': 'Imagine pregătită. Apasă Salvează.',
            'clubset.plan': 'Plan abonament',
            'clubset.feats': 'Funcții pe planul curent',
            'clubset.public': 'Club public (apare în „Descoperă cluburi")',
            'clubset.joinPolicy': 'Politică de aderare',
            'clubset.rulesAck': 'Cere acceptarea regulamentului',
            'clubset.rulesAckHint': 'Membrii noi — inclusiv cei veniți prin invitație — trebuie să citească și să accepte regulamentul înainte de a putea scrie ceva în club. Se cere din nou la fiecare versiune nouă de regulament. Administratorii sunt exceptați.',
            'rulesack.title': 'Regulamentul clubului',
            'rulesack.intro': 'Înainte de a participa în „{club}”, citește regulamentul și confirmă că ești de acord.',
            'rulesack.checkbox': 'Am citit regulamentul clubului și sunt de acord să îl respect.',
            'rulesack.accept': 'Accept regulamentul',
            'rulesack.done': 'Regulament acceptat. Bine ai venit!',
            'rulesack.blocked': 'Trebuie să accepți regulamentul clubului înainte de această acțiune.',
            'rulesack.readOnlyHint': 'Până accepți, poți naviga și citi, dar nu poți adăuga sesiuni, mesaje sau propuneri.',
            'rulesack.error': 'Acceptarea nu a reușit: {msg}',
            'audit.rulesAckOn': 'Acceptarea regulamentului a fost activată',
            'audit.rulesAckOff': 'Acceptarea regulamentului a fost dezactivată',
            'clubset.joinRequest': 'Cu aprobare (cerere)',
            'clubset.joinOpen': 'Liberă (oricine se poate alătura)',

            'chat.title': 'Chat Club',
            'chat.searchPh': 'Caută în conversație...',
            'chat.unread1': '1 mesaj necitit',
            'chat.unreadN': '{n} mesaje necitite',
            'chat.unreadNde': '{n} de mesaje necitite',
            'chat.toLatest': 'Mergi la ultimele mesaje',
            'chat.new1': '1 mesaj nou',
            'chat.newN': '{n} mesaje noi',
            'chat.newNde': '{n} de mesaje noi',
            'chat.tickSent': 'Trimis',
            'chat.tickSeen': 'Văzut',
            'chat.tickSeenAll': 'Văzut de toți',
            'chat.searchTitle': 'Caută în chat',
            'chat.fullscreen': 'Ecran complet',
            'chat.exitFullscreen': 'Ieși din ecran complet',
            'chat.notifTitle': 'Notificări mesaje',
            'chat.reply': 'Răspunde',
            'chat.replyPrivately': 'Răspunde privat',
            'chat.forward': 'Redirecționează',
            'chat.forwardTo': 'Redirecționează către…',
            'chat.forwardedTo': 'Redirecționat către {name}',
            'chat.forwardNoContacts': 'Niciun contact disponibil (adaugă prieteni sau pornește un mesaj privat).',
            'chat.forwardEmpty': 'Mesajul nu are text de redirecționat.',
            // v9 8.4-b — redirecționarea mai multor mesaje (selecția multiplă)
            'chat.forwardedManyTo': '{n} mesaje redirecționate către {name}',
            'chat.forwardSkipped': '{n} mesaje fără text n-au fost redirecționate (pozele nu se redirecționează).',
            'chat.forwardMax': 'Poți redirecționa cel mult {n} mesaje deodată.',
            // v9 8.4-c — redirecționarea pozelor (club + DM)
            'chat.forwardPreparing': 'Se pregătesc pozele…',
            'chat.forwardPhotoErr': 'Pozele nu s-au putut pregăti. Verifică internetul și încearcă din nou.',
            'chat.cantReplyPrivate': 'Nu pot deschide un mesaj privat cu acest utilizator.',
            'chat.replySelf': 'Nu îți poți trimite un mesaj privat ție însuți.',
            'chat.copy': 'Copiază',
            'chat.edit': 'Editează',
            'chat.delete': 'Șterge',
            'chat.info': 'Info',
            'chat.copied': 'Mesaj copiat!',
            'chat.copyErr': 'Nu am putut copia.',
            'chat.edited': 'Editat',
            'chat.editTitle': 'Editează mesajul',
            'chat.editExpired': 'Editarea e permisă doar în primele 15 minute.',
            'chat.deleteExpired': 'Ștergerea e permisă doar în primele 60 de ore.',
            'chat.deleteConfirm': 'Ștergi mesajul pentru toți? În locul lui va rămâne „Mesaj șters”.',
            'chat.deleteConfirmAdmin': 'Ștergi mesajul pentru toți? În locul lui va rămâne „Mesaj șters de un administrator”.',
            // v9 8.4-d — ștergerea mai multor mesaje (selecția multiplă)
            'chat.deleteManyConfirm': 'Ștergi {n} mesaje pentru toți? În locul lor va rămâne „Mesaj șters”.',
            'chat.deleteManyConfirmAdmin': 'Ștergi {n} mesaje pentru toți? La mesajele altora va rămâne „Mesaj șters de un administrator”.',
            'chat.deleteSomeFailed': '{n} mesaje nu s-au putut șterge.',
            'chat.msgDeleted': 'Mesaj șters',
            'chat.msgDeletedMine': 'Ai șters acest mesaj',
            'chat.msgDeletedAdmin': 'Mesaj șters de un administrator',
            'chat.olderLoading': 'Se încarcă mesajele mai vechi…',
            'chat.quoteGone': 'Mesajul original nu mai există.',
            'chat.quoteFar': 'Mesajul e prea departe pentru salt. Derulează în sus ca să-l găsești.',
            'chat.quoteErr': 'Nu am putut încărca mesajul. Încearcă din nou.',
            'chat.searching': 'Se caută…',
            'chat.photoAlt': 'Poza {i} din {n}',
            'chat.mentionList': 'Menționează un membru',
            'chat.select': 'Selectează',
            'chat.selectedN': 'Selectate: {n}',
            'chat.copiedMany': 'Mesaje copiate!',
            'chat.sending': 'Se trimite…',
            'chat.notSent': 'Nu s-a trimis · Atinge pentru a reîncerca',
            'chat.lpLoading': 'Se încarcă previzualizarea…',
            'chat.lpRemove': 'Elimină previzualizarea',
            'chat.lpPlay': 'Redă videoclipul',
            'chat.lpVideo': 'Videoclip YouTube',
            'chat.lpClose': 'Închide videoclipul',
            'chat.lpVideoNote': 'Redat de pe YouTube (youtube-nocookie.com)',
            'chat.lpConsent': 'Videoclipul se redă de pe YouTube (Google). Când pornește, YouTube primește adresa ta IP și poate salva informații în browser, conform politicii Google.',
            'chat.lpConsentLink': 'Politica de confidențialitate Google',
            'chat.lpOpenYt': 'Deschide pe YouTube',
            'chat.lpNotNow': 'Nu acum',
            'chat.notSentToast': 'Mesajul nu s-a trimis:',
            'chat.retry': 'Reîncearcă',
            'chat.discard': 'Renunță la mesaj',
            'chat.forwarded': 'Redirecționat',
            'chat.emptyErr': 'Mesajul nu poate fi gol.',
            'chat.infoTitle': 'Detalii mesaj',
            'chat.seenByTitle': 'Văzut de',
            'chat.notSeenTitle': 'Încă nu a văzut',
            'chat.system': 'Sistem',
            'chat.welcome': 'Bun venit în chat-ul clubului! Aici poți discuta despre jocuri, organiza sesiuni și socializa.',
            'chat.now': 'Acum',
            'chat.inputPh': 'Mesaj',
            'chat.attach': 'Atașează o poză',
            'chat.attachTitle': 'Atașează',
            'chat.attachGallery': 'Galerie',
            'chat.pickPoll': 'Alege un sondaj',
            'chat.newPoll': 'Sondaj nou',
            'chat.noPolls': 'Clubul nu are încă niciun sondaj.',
            'chat.pollFallback': '📊 Sondaj: {q}',
            'card.open': 'Deschide',
            'card.pollGone': 'Sondajul a fost șters.',
            'card.until': 'până la {d}',
            'card.vote1': '1 vot',
            'chat.attachGv': 'Ce jucăm',
            'chat.pickGv': 'Alege un vot „Ce jucăm”',
            'chat.noGv': 'Clubul nu are încă niciun vot „Ce jucăm”.',
            'chat.gvFallback': '🎲 Ce jucăm: {q}',
            'card.gvGone': 'Votul nu mai e disponibil.',
            'card.gvUp': 'Da (+2)',
            'card.gvOk': 'Merge (+1)',
            'card.gvDown': 'Nu (−1)',
            'chat.attachEvent': 'Eveniment',
            'chat.pickEvent': 'Alege un eveniment',
            'chat.noEvents': 'Clubul nu are niciun eveniment.',
            'chat.eventFallback': '📅 Eveniment: {q}',
            'card.eventGone': 'Evenimentul a fost anulat.',
            'card.eventDone': 'A avut loc',
            'ev.rsvpClosed': 'Evenimentul a început — răspunsurile sunt închise.',
            'chat.attachMatch': 'Sesiune',
            'chat.pickMatch': 'Alege o sesiune jucată',
            'chat.noMatches': 'Clubul nu are încă nicio sesiune în istoric.',
            'chat.matchFallback': '🏁 Sesiune: {q}',
            'card.match': 'Sesiune jucată',
            'card.matchGone': 'Sesiunea nu mai e disponibilă.',
            'card.morePlayers': '+{n} jucători',
            'dm.photoOnly': '📷 Poză',
            'chat.photoUploadFail': 'Pozele nu au putut fi încărcate. Mesajul nu a fost trimis — încearcă din nou.',
            'chat.photoMax': 'Poți atașa cel mult {n} poze la un mesaj.',
            'chat.clear': 'Șterge chat',
            'chat.notifMsgs': 'Notificări mesaje:',
            'common.on': 'pornit',
            'common.off': 'oprit',

            'poll.createTitle': 'Creează Poll Nou',
            'poll.question': 'Întrebare',
            'poll.questionPh': 'Ex: Ce jucăm vineri?',
            'poll.options': 'Opțiuni',
            'poll.optionPh': 'Opțiune',
            'poll.addOption': 'Adaugă opțiune',
            'poll.create': 'Creează',
            'poll.editTitle': 'Editează poll-ul',
            'poll.saveBtn': 'Salvează modificările',
            'poll.questionLabel': 'Întrebarea poll-ului',
            'poll.optionsLabel': 'Opțiuni',
            'poll.allowMultiple': 'Permite voturi multiple',
            'poll.showVoters': 'Arată cine a votat',
            'poll.duration': 'Durată (zile)',
            'event.addTitle': 'Adaugă Eveniment',
            'event.titleLabel': 'Titlu',
            'event.titlePh': 'Ex: Seară de board games',
            'event.date': 'Data',
            'event.time': 'Ora',
            'event.create': 'Adaugă',
            'game.addTitle': 'Adaugă Joc Nou',
            'game.name': 'Nume joc',
            'game.namePh': 'Ex: Catan',
            'game.category': 'Categorie',
            'game.minPlayers': 'Jucători min.',
            'game.maxPlayers': 'Jucători max.',
            'game.add': 'Adaugă Joc',
            'common.cancel': 'Anulează',
            'common.copy': 'Copiază',
            'common.loading': 'Se încarcă…',
            'core.loaderSlow': 'Durează mai mult decât de obicei. Te rugăm să mai aștepți puțin…',
            'core.loaderStuck': 'Conexiunea pare foarte lentă. Poți aștepta în continuare sau reîncărca pagina.',
            'core.loaderOffline': 'Nu ai conexiune la internet. Aplicația pornește singură când revine conexiunea.',
            'core.loaderReload': 'Reîncarcă pagina',
            'err.generic': 'A apărut o eroare. Încearcă din nou.',
            'common.errorPrefix': 'Eroare: ',
            'invite.titlePrefix': 'Invitație —',
            'invite.note': 'Trimite acest link. Cine îl deschide (logat) devine membru al clubului.',
            'invite.copy': 'Copiază linkul',
            'join.title': 'Cereri de aderare',
            'join.none': 'Nicio cerere în așteptare.',
            'archives.title': 'Sezoane arhivate',
            'archives.none': 'Niciun sezon arhivat încă.',
            'archives.seasonWord': 'Sezon',
            'archives.delFromArchive': 'Șterge din arhivă',
            'discover.clubsTitle': 'Descoperă cluburi',
            'discover.noClubs': 'Niciun club public nou disponibil.',
            'discover.join': 'Alătură-te',
            'discover.filters': 'Filtre',
            'discover.visibility': 'Vizibilitate',
            'discover.visAll': 'Toate',
            'discover.visOpen': 'Acces liber',
            'discover.visRequest': 'Pe bază de cerere',
            'discover.any': 'Oricare',
            'discover.reset': 'Resetează filtrele',
            'discover.interests': 'Interese (tipuri de joc)',
            'clubinfo.title': 'Despre club',
            'clubinfo.unavailable': 'Informațiile despre acest club nu sunt disponibile.',
            'clubinfo.needsSql': 'Nu am putut încărca informațiile (rulează turnorder_club_public_info.sql).',
            'clubinfo.since': 'Activ din',
            'clubinfo.members': 'Membri',
            'clubinfo.sessions': 'Sesiuni',
            'clubinfo.games': 'Jocuri',
            'clubinfo.membersList': 'Membrii clubului',
            'discover.requestAccess': 'Cere acces',
            'discover.requestSent': 'Cerere trimisă',
            'discover.requestSentToast': 'Cerere de aderare trimisă. Aștepți aprobarea unui admin.',
            'discover.clubSearchPh': 'Caută cluburi...',
            'discover.playersTitle': 'Descoperă jucători',
            'discover.playerSearchPh': 'Caută după nume sau joc…',
            'discover.noPlayers': 'Niciun jucător descoperibil',
            'discover.for': 'pentru',
            'friend.accept': 'Acceptă',
            'friend.refuse': 'Refuză',
            'friend.declined': 'Cerere refuzată.',
            'friend.declineErr': 'Nu s-a putut refuza cererea. Încearcă din nou.',
            'friend.cancelReq': 'Anulează cererea',
            'friend.cancelled': 'Cerere anulată.',
            'friend.cancelErr': 'Nu s-a putut anula cererea. Încearcă din nou.',
            'friend.reqPush': 'Ți-a trimis o cerere de prietenie',
            'common.unknownUser': 'Utilizator necunoscut',
            'join.viewProfile': 'Vezi profilul',
            'club.addedToClub': 'Ai fost adăugat în clubul {name}.',
            'club.removedFromClub': 'Nu mai faci parte din acest club.',
            /* ★ FREE TRIAL — 30 de zile, fără card */
            'trial.cta': 'Trial gratuit 30 de zile, fără card',
            'trial.badge': 'Perioadă gratuită',
            'trial.offerTitle': 'Ai 30 de zile gratuite, fără card',
            'trial.confirm': 'Pornești perioada gratuită de 30 de zile pe planul {plan}? Nu îți cerem cardul. Poți activa oricând un abonament plătit — asta încheie perioada gratuită. Perioada gratuită poate fi folosită o singură dată.',
            'trial.starting': 'Se pornește perioada gratuită...',
            'trial.started': 'Perioadă gratuită activă: {plan}, 30 de zile, fără card.',
            'trial.failed': 'Nu am putut porni perioada gratuită.',
            'trial.errUsed': 'Ai folosit deja perioada gratuită. Continuarea se face printr-un abonament plătit.',
            'trial.errHasSub': 'Ai deja un abonament activ.',
            'trial.errPaidBefore': 'Contul are deja istoric de plată — perioada gratuită nu mai este disponibilă.',
            'trial.errPlan': 'Planul ales nu este eligibil pentru perioada gratuită.',
            'trial.expiresIn': 'Expiră în {n} zile',
            'trial.remaining': 'Timp rămas',
            'trial.endsOn': 'Se încheie pe',
            'trial.noCardNote': 'fără card',
            'trial.activatePaid': 'Activează prin plată',
            'trial.claimBlocked': 'Preluarea unui club se face doar printr-un abonament plătit — perioada gratuită nu acoperă preluările.',
            'trial.clubExhausted': 'Acest club a folosit deja perioada gratuită. Poate fi reactivat doar printr-un abonament plătit.',
            'trial.transferBlocked': 'Nu poți transfera clubul unui membru aflat în perioada gratuită. Este nevoie de un abonament plătit.',
            'trial.expiredTitle': 'Perioada gratuită a expirat',
            'trial.expiredBody': 'Datele tale sunt în siguranță: clubul rămâne în modul „doar citire" 30 de zile, apoi este arhivat. Poți reactiva accesul oricând printr-un abonament plătit.',
            'plans.title': 'Planuri de abonament',
            'plans.yourPlan': 'PLANUL TĂU',
            'plans.renewsOn': 'Se reînnoiește automat pe',
            'plans.autoRenews': 'Se reînnoiește automat',
            'plans.endsOn': 'Se încheie pe',
            'plans.willEnd': 'Se încheie la finalul perioadei plătite',
            'plans.trialEndsOn': 'Perioada de probă se încheie pe',
            'plans.billedMonthly': 'facturare lunară',
            'plans.billedYearly': 'facturare anuală',
            'plans.needsAttention': 'Abonamentul necesită atenție',
            'plans.manageBilling': 'Gestionează abonamentul',
            'plans.portalLoading': 'Se deschide portalul de facturare…',
            'plans.portalError': 'Nu am putut deschide portalul de facturare. Încearcă din nou peste câteva momente.',
            'plans.portalNoSub': 'Nu am găsit un abonament de gestionat pentru contul tău.',
            'plans.alreadySubscribed': 'Ai deja un abonament activ. Îl schimbi din portalul de facturare — noul plan îl înlocuiește pe cel curent.',
            'plans.mostPopular': 'Cel mai popular',
            'plans.membersWord': 'membri',
            'plans.clubWord': 'club',
            'plans.clubsWord': 'cluburi',
            'plans.subtitle': 'Funcțiile sunt cumulative — fiecare plan include tot ce e mai jos de el. Plata anuală = 2 luni gratis.',
            'plans.monthly': 'Lunar',
            'plans.yearly': 'Anual',
            'plans.seeAll': 'Vezi toate funcțiile',
            'plans.seeLess': 'Mai puțin',
            'plans.perMonth': '/lună',
            'plans.perYear': '/an',
            'plans.ron': 'RON',
            'plans.fromPrefix': 'de la',
            'plans.save2months': '2 luni gratis',
            'plans.perPlayer': '/jucător/lună',
            'plans.estCost': 'Cost estimat',
            'upgrade.title': 'Funcție indisponibilă pe planul tău',
            'upgrade.featureFrom': 'este disponibilă de la planul',
            'upgrade.memberLimit': 'Ai atins limita de membri a planului',
            'upgrade.clubLimit': 'Ai atins limita de cluburi a abonamentului tău',
            'club.needSubscription': 'Alege un abonament ca să-ți creezi clubul.',
            'upgrade.suggestPlan': 'Treci la',
            'upgrade.cta': 'Vezi planurile',
            'upgrade.later': 'Mai târziu',
            'plans.choose': 'Continuă la plată',
            'plans.currencyNote': 'Prețurile în USD/EUR sunt orientative; facturarea se face în RON, la prețul în RON afișat.',
            'checkout.soon': 'Checkout Stripe vine în pasul următor.',
            'billing.title': 'Date facturare companie',
            'billing.note': 'Datele de facturare sunt gestionate de Stripe la momentul plății.',
            'billing.company': 'Denumire companie',
            'billing.cui': 'CUI / CIF (ex: RO12345678)',
            'billing.regCom': 'Nr. Reg. Comerțului (ex: J40/1234/2020)',
            'billing.address': 'Adresă de facturare',
            'billing.save': 'Salvează datele de facturare',
            'billing.requiredBeforePay': 'Completează întâi datele de facturare, apoi poți face plata.',
            'billing.saved': 'Date de facturare salvate.',
            'billing.cuiInvalid': 'CUI invalid. Folosește doar cifre (opțional prefix RO).',
            'billing.companyRequired': 'Denumirea companiei este obligatorie.',
            'billing.addressRequired': 'Adresa de facturare este obligatorie.',
            'billing.requiredFirst': 'Completează mai întâi datele de facturare ale companiei.',
            'billing.typeIndividual': 'Sunt Persoană Fizică',
            'billing.typeCompany': 'Sunt Companie (firmă)',
            'billing.fullName': 'Nume complet',
            'billing.country': 'Țara',
            'billing.countryRO': 'România',
            'billing.countryOther': 'Altă țară (internațional)',
            'billing.fullNameRequired': 'Numele complet este obligatoriu.',
            'billing.countryRequired': 'Selectează țara.',
            'plans.enterprisePrice': 'Contactează-ne pentru ofertă',
            'plans.enterpriseContact': 'Pentru Enterprise, contactează-ne pentru o ofertă personalizată.',
            'checkout.loading': 'Se pregătește plata...',
            'checkout.resuming': 'Date salvate — continuăm spre plată...',
            'checkout.activated': 'Planul tău a fost activat!',
            'checkout.pendingReload': 'Plata a fost primită. Dacă planul nu apare imediat, reîncarcă pagina în câteva momente.',
            'checkout.redirect': 'Te redirecționăm către Stripe...',
            'checkout.netError': 'Eroare de rețea la inițierea plății. Încearcă din nou.',
            'checkout.success': 'Plată inițiată! Abonamentul se activează în câteva momente.',
            'checkout.canceled': 'Plata a fost anulată.',
            'plan.unlimitedMembers': 'membri nelimitați',
            'plan.upTo': 'până la',
            'feat.thisFeature': 'Această funcție',
            'feat.advancedFeature': 'Funcție avansată',
            'feat.availFrom': 'e disponibilă din planul',
            'feat.planSuffix': '.',
            'feat.seeSettings': 'Vezi „Setări club".',
            'feat.availableFromPlan': 'Disponibilă din planul',
            'feat.changePlan': 'Schimbă planul din „Setări club".',
            'feat.askAdmin': 'Cere unui admin upgrade-ul clubului.',
            'feat.fromShort': 'din',
            'dash.title': 'Statistici Generale',
            'dash.nextEvent': 'Următorul eveniment',
            'dash.seeCalendar': 'Vezi calendarul',
            'dash.openEvent': 'Deschide',
            'dash.activePlayers': 'Jucători Activi',
            'dash.sessions30': 'Sesiuni (30 zile)',
            'dash.recentActivityChange': 'activitate recentă',
            'dash.currentSeason': 'Sezon Curent',
            'dash.leaderboard': 'Clasament Actual',
            'dash.loc': 'Loc',
            'dash.trend': 'Trend',
            'dash.clubAchievements': 'Realizări ale Clubului',
            'dash.achievementsIntro': 'Obiective deblocate împreună, din activitatea întregului club.',
            'dash.monthlyPerf': 'Performanță Lunară',
            'dash.gamesPlayed': 'Jocuri jucate',
            'dash.sessions6mo': 'sesiuni (6 luni)',
            'dash.recentTitle': 'Activitate Recentă',
            'dash.recentSearchPh': '🔍 Caută în toate sesiunile (joc, jucător, locație, notițe)...',
            'dash.month': 'Luna',
            'dash.memberOne': 'membru',
            'dash.memberMany': 'membri',
            'dash.online': 'online',
            'dash.you': '(tu)',
            'dash.noActivity': 'Nu există activitate recentă.',
            'dash.noOneOnline': 'Niciun membru online',
            'hist.searchLabel': 'Caută (joc, jucător, locație, notițe)',
            'hist.search': 'Caută',
            'hist.filters': 'Filtre',
            'hist.export': 'Export',
            'hist.seeAllPlayers': 'Vezi toți jucătorii',
            'hist.searchPh': 'Scrie un cuvânt cheie...',
            'hist.filterPlayer': 'Filtrează după jucător',
            'hist.period': 'Perioadă',
            'hist.periodAll': 'Tot timpul',
            'hist.periodWeek': 'Săptămâna aceasta',
            'hist.periodMonth': 'Luna aceasta',
            'hist.periodYear': 'Anul acesta',
            'hist.periodLast30': 'Ultimele 30 zile',
            'hist.game': 'Joc',
            'hist.allGames': 'Toate jocurile',
            'hist.exportCsv': 'Export CSV',
            'hist.exportPdf': 'Export PDF',
            'hist.clearFilters': 'Resetează filtre',
                        'hist.uniform': 'Uniformizat',
            'hist.uniformTip': 'Sesiune cu scorare uniformizată: scorurile brute au fost convertite în Puncte de Club.',
            'hist.uniformWhat': 'Apasă ca să afli ce înseamnă',
            'hist.uniformExplain': 'Ca să poți compara corect jocuri diferite în clasamentul general, scorurile brute sunt convertite în „Puncte de Club”, după locul ocupat.',
            'hist.uniformHow': 'Punctajul clubului tău:',
            'hist.uniformComp': 'Competitiv (după loc)',
            'hist.uniformCoop': 'Cooperativ',
            'hist.uniformCamp': 'Campanii și RPG',
            'hist.uniformPart': 'prezență',
            'hist.clubPts': 'pct. club',
            'hist.tieBreakWon': 'A câștigat departajarea (tie-break)',
'hist.points': 'puncte',
            'hist.turnTime': 'Timp la rând',
            'hist.participants': 'participanți',
            'cal.upcoming': 'Evenimente Viitoare',
            'cal.coming': 'Vin',
            'cal.maybe': 'Poate',
            'cal.notComing': 'Nu vin',
            'cal.deleteEvent': 'Șterge evenimentul',
            'cal.rsvpYes': 'vin',
            'cal.rsvpMaybe': 'poate',
            'cal.rsvpNo': 'nu',
            'camp.inProgress': 'În desfășurare',
            'camp.completed': 'Finalizat',
            'camp.scenarios': 'scenarii',
            'camp.scenario': 'Scenariu',
            'camp.abandoned': 'Abandonată',
            'camp.completedF': 'Finalizată',
            'camp.noScenarios': 'Niciun scenariu încă.',
            'camp.noCampaigns': 'Nicio campanie încă. Apasă „Campanie nouă" pentru a începe (ex: Gloomhaven).',
            'camp.winShort': 'V',
            'camp.lossShort': 'Î',
            'camp.statusLabel': 'Stare',
            'camp.gameLabel': 'Joc (opțional)',
            'camp.gamePh': 'Ex: Gloomhaven',
            'camp.sessionsCount': 'sesiuni',
            'camp.charsActive': 'personaje active',
            'camp.startSession': '+ Sesiune de campanie',
            'camp.noLinkedSessions': 'Nicio sesiune legată încă.',
            'camp.attachLabel': 'Atașează la campanie',
            'camp.attachNone': '— fără campanie —',
            'camp.scenarioLabel': 'Scenariu (opțional)',
            'camp.scenarioPh': 'Ex: Scenariul 3 — Cripta',
            'camp.sessionStarted': 'Sesiune de campanie pornită: {name}',
            'camp.needUniformNote': 'activează scorarea uniformizată în Admin pentru Puncte de Club',
            'camp.saved': 'Campanie salvată.',
            'camp.demoNote': 'Campaniile necesită un cont real (indisponibil în demo).',
            'camp.scenarioObsolete': 'Scenariile se adaugă acum ca sesiuni de campanie.',
            'camp.deleteViaHistory': 'Șterge sesiunea din Istoric.',
            'camp.err.forbidden': 'Nu ai permisiunea pentru această acțiune.',
            'camp.err.plan': 'Campaniile necesită planul Pro sau superior.',
            'camp.err.name': 'Dă un nume campaniei.',
            'camp.err.badGame': 'Jocul selectat nu e valid pentru acest club.',
            'camp.err.badStatus': 'Stare invalidă.',
            'camp.err.badPatch': 'Date invalide pentru World State.',
            'camp.err.notMember': 'Jucătorul nu e membru activ al clubului.',
            'camp.err.charNotFound': 'Personajul nu a fost găsit.',
            'camp.err.notFound': 'Campania nu există.',
            'camp.err.club': 'Clubul nu poate fi modificat acum.',
            'camp.err.generic': 'A apărut o eroare. Încearcă din nou.',
            'camp.back': 'Înapoi',
            'camp.linkedSessions': 'Sesiuni legate',
            'camp.charactersTitle': 'Personaje',
            'camp.noChars': 'Niciun personaj activ încă.',
            'camp.addMyChar': '+ Personajul meu',
            'camp.addCharOther': '+ Personaj (membru)',
            'camp.editChar': 'Editează personaj',
            'camp.newChar': 'Personaj nou',
            'camp.retireCharBtn': 'Retrage',
            'camp.retiredTitle': 'Personaje retrase',
            'camp.charSaved': 'Personaj salvat.',
            'camp.charRetired': 'Personaj retras.',
            'camp.confirmRetireChar': 'Retragi personajul „{name}"? Se poate crea unul nou după.',
            'camp.you': 'tu',
            'camp.lvl': 'Nv.',
            'camp.xpNote': 'XP-ul de campanie e in-ficțiune, separat de XP-ul de profil.',
            'camp.selectMember': '— alege membru —',
            'camp.f.member': 'Membru',
            'camp.f.memberSearchPh': 'Caută membru…',
            'camp.f.name': 'Nume personaj',
            'camp.f.namePh': 'Ex: Brute',
            'camp.f.class': 'Clasă',
            'camp.f.classPh': 'Ex: Inox',
            'camp.f.level': 'Nivel',
            'camp.f.xp': 'XP (in-ficțiune)',
            'camp.f.gold': 'Aur',
            'camp.f.equipment': 'Echipament',
            'camp.f.quest': 'Quest personal',
            'camp.f.notes': 'Notițe',
            'camp.showMore': 'Arată mai multe',
            'camp.showLess': 'Arată mai puține',
            'camp.ws.title': 'Starea lumii',
            'camp.ws.empty': 'Nimic în starea lumii încă.',
            'camp.ws.edit': 'Editează World State',
            'camp.ws.counters': 'Contoare',
            'camp.ws.counterKey': 'Nume',
            'camp.ws.counterVal': 'Valoare',
            'camp.ws.counterHint': 'Contoarele se pot adăuga sau actualiza.',
            'camp.ws.addCounter': '+ Contor',
            'camp.ws.unlocks': 'Deblocări',
            'camp.ws.achievements': 'Realizări',
            'camp.ws.notes': 'Note',
            'camp.ws.linePh': 'câte unul pe linie',
            'camp.ws.saved': 'World State salvat.',
            'camp.err.charNotInCamp': 'Personajul nu aparține acestei campanii.',
            'camp.err.badMatch': 'Sesiune invalidă.',
            'camp.err.badEntries': 'Date de progresie invalide.',
            'camp.prog.title': 'Progresie personaje',
            'camp.prog.btn': 'XP/Aur',
            'camp.prog.has': 'Progresie înregistrată',
            'camp.prog.hint': 'Valori câștigate în această sesiune (in-ficțiune, separat de Puncte de Club).',
            'camp.prog.noChars': 'Niciun personaj activ pentru progresie.',
            'camp.prog.saved': 'Progresie salvată.',
            'camp.finalize': 'Finalizează',
            'camp.reopen': 'Redeschide',
            'camp.final.title': 'Finalizează campania',
            'camp.final.hint': 'Opțional: Puncte de Club acordate la finalizare (reversibile la redeschidere).',
            'camp.final.modOnly': 'Vei marca campania ca finalizată. Distribuția de Puncte de Club necesită un Administrator.',
            'camp.final.noParts': 'Niciun participant cu personaj.',
            'camp.final.done': 'Campanie finalizată.',
            'camp.reopen.confirm': 'Redeschizi campania „{name}"? Punctele finale acordate vor fi reversate.',
            'camp.reopen.done': 'Campanie redeschisă.',
            'camp.err.finalNeedsAdmin': 'Distribuția de Puncte de Club necesită un Administrator.',
            'camp.err.awardTarget': 'Una dintre țintele premiate nu e membru al clubului.',
            'camp.err.badTransition': 'Tranziție de stare invalidă.',
            'camp.err.notActive': 'Campania nu este activă. Redeschide-o pentru a adăuga sesiuni.',
            'camp.notif.new': 'Campanie nouă: {name}',
            'camp.notif.finalized': 'Campanie finalizată: {name}',
            'camp.gold': 'Aur',
            'camp.evo.title': 'Evoluția personajului',
            'camp.evo.retired': 'retras',
            'camp.search': 'Caută',
            'camp.searchPh': 'Caută campanii…',
            'camp.searchEmpty': 'Nicio campanie găsită.',
            'camp.export': 'Export',
            'camp.exportEmpty': 'Nimic de exportat.',
            'camp.exp.name': 'Nume',
            'camp.exp.game': 'Joc',
            'camp.exp.status': 'Stare',
            'camp.exp.created': 'Creată',
            'scoreTpl.title': 'Uniformizare scoruri (Puncte de Club)',
            'scoreTpl.intro': 'Transformă scorurile brute în „Puncte de Club" în funcție de loc, ca să poți compara corect jocuri diferite în clasamentul general. Când e activată, la fiecare sesiune nouă poți alege „Brut" sau „Uniformizat".',
            'scoreTpl.useUniform': 'Folosește uniformizarea în acest club',
            'scoreTpl.defaultMode': 'Mod implicit la sesiuni noi',
            'scoreTpl.modeRaw': 'Brut (ca în regulament)',
            'scoreTpl.modeUniform': 'Uniformizat (Puncte de Club)',
            'scoreTpl.tplA': 'Șablonul A — Competitiv (după loc)',
            'scoreTpl.tplADesc': 'Puncte acordate în funcție de locul în clasament. Ultimul rând se aplică tuturor locurilor inferioare.',
            'scoreTpl.place': 'Locul',
            'scoreTpl.placeAndBelow': '+ (și mai jos)',
            'scoreTpl.pts': 'pct',
            'scoreTpl.addPlace': 'Adaugă loc',
            'scoreTpl.removePlace': 'Șterge ultimul',
            'scoreTpl.tplB': 'Șablonul B — Cooperativ (Victorie/Înfrângere)',
            'scoreTpl.tplBDesc': 'Pentru jocuri co-op: contează doar dacă echipa a bătut jocul.',
            'scoreTpl.win': 'Victorie',
            'scoreTpl.loss': 'Înfrângere',
            'scoreTpl.tplC': 'Șablonul C — Campanie / RPG (Participare)',
            'scoreTpl.tplCDesc': 'Fiecare jucător prezent primește puncte de participare; bonusurile individuale se adaugă manual la sesiune.',
            'scoreTpl.participation': 'Participare (per jucător)',
            'scoreTpl.saved': 'Setări de scorare salvate.',
            'elo.title': 'Clasament ELO',
            'elo.activeNote': 'Mod competitiv activ · K=32, start 1000. Calculat automat din sesiuni.',
            'elo.gamesWord': 'jocuri',
            'elo.statePrefix': 'Stare:',
            'elo.on': 'ACTIVAT',
            'elo.off': 'DEZACTIVAT',
            'elo.descOn': 'Când e activat, apare un clasament ELO (K=32, start 1000) calculat automat din sesiuni, vizibil pentru toți membrii clubului.',
            'elo.disable': 'Dezactivează modul competitiv',
            'elo.enable': 'Activează modul competitiv',
            'role.principal': 'Admin principal',
            'role.secondary': 'Admin secundar',
            'role.moderator': 'Moderator',
            'role.member': 'Membru',
            'rbac.community': 'Gestiune comunitate',
            'rbac.role': 'Rol',
            'rbac.changeRole': 'Schimbă rolul',
            'rbac.roleUpdated': 'Rol actualizat.',
            'rbac.noPermission': 'Nu ai permisiunea pentru această acțiune.',
            'rbac.cantManagePrincipal': 'Rolul de Admin Principal se schimbă doar prin transfer de proprietate.',
            'rbac.cantManageHigher': 'Nu poți modifica un membru cu rol egal sau superior.',
            'rbac.you': '(tu)',
            'menu.myClubs': 'Cluburile mele',
            'menu.switchClub': 'Schimbă club',
            'plans.downgrade': 'Schimbă planul',
            'menu.inviteLink': 'Invită prin link',
            'menu.reactivate': 'Reactivează clubul',
            'menu.closeClub': 'Închide clubul activ (arhivează)',
            'cal.monthNames': 'Ianuarie,Februarie,Martie,Aprilie,Mai,Iunie,Iulie,August,Septembrie,Octombrie,Noiembrie,Decembrie',
            'cal.dayNames': 'D,L,M,M,J,V,S',
            'gv.title': 'Ce jucăm diseară?',
            'gv.howMany': 'Câți jucători sunteți?',
            'gv.recommend': 'Recomandă',
            'gv.random': 'Alege la întâmplare',
            'gv.lastPlayed': 'jucat ultima dată:',
            'poll.startedBy': 'Pornit de',
            'poll.voterOne': 'votant',
            'poll.voterMany': 'votanți',
            'poll.anon': '🔒 anonim',
            'poll.pub': '👁️ public',
            'poll.closeVote': 'Închide votul',
            'poll.score': 'scor',
            'adm.email': 'Email',
            'adm.name': 'Nume',
            'adm.searchMembers': 'Caută după nume sau email...',
            'adm.admin': 'Admin',
            'adm.createdAt': 'Creat la',
            'adm.lastLogin': 'Ultima autentificare',
            'adm.actions': 'Acțiuni',
            'adm.currentScore': 'Scor actual',
            'adm.newScore': 'Nou scor',
            'adm.action': 'Acțiune',
            'adm.auditSynced': 'Jurnal sincronizat cu serverul — persistent pe toate dispozitivele, doar-adăugare (nu poate fi editat sau șters).',
            'adm.auditLocalNote': 'Jurnal local (doar acest dispozitiv). Se sincronizează cu serverul când e disponibil.',
            'common.prev': 'Anterior',
            'adm.noAudit': 'Nu există înregistrări de audit.',
            'adm.fullReset': 'Resetează datele clubului',
            'admin.dangerZone': 'Zonă periculoasă',
            'admin.clubResetNote': 'Șterge sesiunile, istoricul, evenimentele și chat-ul clubului curent. Scorurile acumulate de jucători, membrii și catalogul de jocuri rămân.',
            'admin.clubResetC1': 'ATENȚIE: Ștergi sesiunile, istoricul, evenimentele și chat-ul acestui club? Scorurile jucătorilor, clubul și membrii rămân.',
            'admin.clubResetDone': 'Datele clubului au fost resetate.',
            'reg.internalTitle': 'Regulamentul Intern —',
            /* Regulament implicit pentru cluburile noi (RO) */
            'regdef.a1.title': 'Art. 1 — Sesiunile de joc',
            'regdef.a1.body': '1.1. Propunerea jocurilor. Fiecare membru poate propune până la trei jocuri din catalogul clubului pentru sesiunea următoare. Nu toți membrii sunt obligați să propună, dar e nevoie de cel puțin o propunere ca sesiunea să aibă loc.\n1.2. Termenul de propunere. Propunerile se transmit până cel târziu cu 48 de ore înainte de sesiune. Cele întârziate intră la următoarea rundă.\n1.3. Selecția. Din totalul propunerilor se aleg trei jocuri, iar membrii votează unul singur. Jocul cu cele mai multe voturi devine jocul sesiunii. La egalitate decide organizatorul sesiunii.\n1.4. Diversitate. Jocul jucat în sesiunea anterioară nu poate fi propus din nou imediat, ca lista să rămână variată.\n1.5. Explicarea regulilor. Persoana care aduce jocul selectat îl explică celorlalți. Dacă nimeni nu îl cunoaște, se stabilește dinainte cine învață regulile.',
            'regdef.a2.title': 'Art. 2 — Membri și conduită',
            'regdef.a2.body': '2.1. Respect. Toți membrii se tratează cu respect, indiferent de experiență, vârstă sau nivel de joc. Nu sunt tolerate jignirile, discriminarea sau hărțuirea.\n2.2. Începători. Un jucător nou primește explicațiile de care are nevoie, fără grabă și fără reproșuri. Clubul are ca scop să atragă oameni, nu să îi filtreze.\n2.3. Telefoane și atenție. În timpul unei partide, atenția rămâne la masă. Pauzele lungi se anunță, ca ceilalți să nu aștepte fără să știe.\n2.4. Conflicte. Neînțelegerile legate de reguli se rezolvă pe loc, prin consultarea manualului. Dacă nu există un răspuns clar, decizia se ia prin vot și se aplică până la finalul partidei.\n2.5. Raportare. Orice comportament nepotrivit poate fi semnalat unui administrator, care decide măsurile, până la excluderea din club.',
            'regdef.a3.title': 'Art. 3 — Jocurile clubului',
            'regdef.a3.body': '3.1. Proprietate. Fiecare joc din catalog aparține fie clubului, fie unui membru. Proprietarul e trecut în catalog și decide dacă jocul poate fi împrumutat.\n3.2. Îngrijire. Piesele se manipulează cu grijă, iar jocul se strânge complet la final. Cărțile se pun înapoi în protecții, dacă există.\n3.3. Piese pierdute sau deteriorate. Cine pierde sau strică o piesă anunță proprietarul și se ocupă de înlocuire, dacă e posibil.\n3.4. Mâncare și băutură. Nu se mănâncă și nu se bea direct deasupra componentelor. Paharele stau pe altă suprafață decât masa de joc.\n3.5. Împrumut. Un joc împrumutat se întoarce la următoarea sesiune, complet și în aceeași stare, dacă nu s-a agreat altfel cu proprietarul.',
            'regdef.a4.title': 'Art. 4 — Prezență și programare',
            'regdef.a4.body': '4.1. Confirmare. Prezența la o sesiune se confirmă în aplicație, ca organizatorul să știe pe câți oameni contează și ce jocuri sunt potrivite.\n4.2. Anulare. Cine nu mai poate veni anunță cât mai devreme. O anulare cu câteva ore înainte poate lăsa o partidă fără numărul minim de jucători.\n4.3. Întârzieri. Sesiunea începe la ora anunțată. Cine întârzie se alătură partidei următoare, ca să nu întrerupă una în curs.\n4.4. Locul de desfășurare. Locația se anunță odată cu sesiunea. Dacă e la cineva acasă, gazda stabilește regulile proprii, care se respectă.\n4.5. Invitați. Membrii pot aduce invitați, anunțând dinainte. Invitații respectă același regulament.',
            'regdef.a5.title': 'Art. 5 — Scoruri, clasament și fair play',
            'regdef.a5.body': '5.1. Înregistrarea. Rezultatul fiecărei partide se trece în aplicație la final, de către organizator sau de cel care a explicat jocul.\n5.2. Corectitudine. Scorurile se trec exact așa cum au ieșit. O greșeală observată ulterior se corectează prin editarea sesiunii, nu prin rescrierea istoricului.\n5.3. Clasamentul. Punctele de club se acordă după sistemul ales de club și se pot reseta la începutul unui sezon nou. Istoricul sesiunilor rămâne neatins.\n5.4. Fair play. Nu se acceptă trișatul, înțelegerile ascunse între jucători sau abandonul deliberat pentru a influența rezultatul altcuiva.\n5.5. Jocuri neterminate. O partidă abandonată din motive de timp poate fi înregistrată ca neterminată, fără câștigător, dacă membrii prezenți sunt de acord.',
            'reg.version': 'Versiune',
            'reg.lastModified': 'Ultima modificare:',
            'reg.searchPh': 'Caută în regulament...',
            'reg.noMatch': 'Niciun articol nu se potrivește căutării.',
            'reg.empty': 'Regulamentul nu are încă articole.',
            'reg.articleOne': 'articol',
            'reg.articleMany': 'articole',
            'reg.effectiveFrom': 'Intrare în vigoare:',
            'clubset.membersUsed': 'Membri folosiți:',
            'clubset.planFromSub': 'Planul vine din abonamentul tău.',
            'clubset.archiveHint': 'Închide (arhivează) clubul activ. Clubul devine inaccesibil membrilor până îl reactivezi din sertarul „Cluburile mele”.',
            'clubset.canPlanNote': ' (Ca admin principal poți schimba planul. Plățile reale vin cu modulul de abonament.)',
            'clubset.noPlanNote': ' Planul poate fi schimbat doar de adminul principal al clubului.',
            'ach.unlocked': 'deblocate',
            'ach.unlockedOne': 'Realizare deblocată',
            'ach.detailTitle': 'Detalii realizare',
            'ach.unlockedStatus': 'Deblocată',
            'ach.lockedStatus': 'Încă blocată',
            'ach.doneNote': 'Felicitări — obiectiv atins de tot clubul!',
            'ach.remaining': 'Mai aveți nevoie de {n} pentru a o debloca.',
            'feedback.button': 'Feedback',
            'feedback.title': 'Feedback / Raportează o problemă',
            'feedback.intro': 'Spune-ne ce merge bine sau ce nu. Mesajul ajunge direct la echipă.',
            'feedback.placeholder': 'Scrie aici sugestia sau problema ta...',
            'feedback.send': 'Trimite',
            'feedback.cancel': 'Anulează',
            'feedback.sent': 'Mulțumim! Feedback trimis.',
            'feedback.empty': 'Scrie un mesaj mai întâi.',
            'feedback.error': 'Nu am putut trimite feedback-ul. Încearcă din nou.',
            'feedback.rateLimit': 'Ai trimis prea multe mesaje. Încearcă din nou peste câteva minute.',

            'event.eTitle': 'Titlu eveniment',
            'event.eTitlePh': 'Ex: Turneu Catan',
            'event.location': 'Locație',
            'event.locationPh': 'Ex: Cafeneaua Centrală',
            'event.type': 'Tip eveniment',
            'event.typeSession': '🎮 Sesiune de joc',
            'event.typeTournament': '🏆 Turneu',
            'event.typeMeeting': '🤝 Întâlnire',
            'event.typeOther': '📅 Altele',
            'event.description': 'Descriere',
            'event.descriptionPh': 'Detalii despre eveniment...',
            'event.recurrence': 'Recurență',
            'event.recOnce': 'Eveniment unic',
            'event.recWeekly': 'Săptămânal',
            'event.recBiweekly': 'La 2 săptămâni',
            'event.recMonthly': 'Lunar',
            'event.recCount': 'Câte ocazii',
            'event.save': 'Salvează eveniment',

            'game.addTitleNew': 'Adaugă Joc Nou',
            'game.editTitle': 'Editează jocul',
            'game.nameLockedNote': 'Numele nu poate fi schimbat aici (păstrează legătura cu istoricul).',
            'game.bggSearch': 'Caută pe BoardGameGeek',
            'game.nameLabel': 'Nume Joc',
            'game.players': 'Număr jucători',
            'game.playersPh': 'Ex: 2-4',
            'game.durationLabel': 'Durată (min)',
            'game.difficulty': 'Dificultate (1-5)',
            'game.diff1': '1 – Ușor (Light)',
            'game.diff2': '2 – Mediu-ușor (Medium Light)',
            'game.diff3': '3 – Mediu (Medium)',
            'game.diff4': '4 – Mediu-greu (Medium Heavy)',
            'game.diff5': '5 – Greu (Heavy)',
            'game.rating': 'Rating (1-10)',
            'game.moreDetails': 'Mai multe detalii (opțional)',
            'game.imageUrl': 'Poza jocului (URL)',
            'game.age': 'Vârstă minimă',
            'game.edition': 'Ediție',
            'game.scoreDir': 'Direcția scorului',
            'game.scoreDirHigh': 'Scor mare câștigă',
            'game.scoreDirLow': 'Scor mic câștigă',
            'game.scoreDirHint': 'Cine câștigă la acest joc: cel cu scorul cel mai mare (implicit) sau cel mai mic (golf, jocuri de penalizări). Poți schimba per sesiune.',
            'game.editionPh': 'Ex: ediția pe care o dețineți',
            'game.editionLabel': 'Ediție (din BGG)',
            'game.editionNone': '— Ediție implicită —',
            'game.editionSearch': 'Caută ediția (nume / limbă / an)…',
            'game.editionSet': 'Ediție selectată',
            'catalog.edition': 'Ediție',
            'game.designer': 'Designer',
            'game.artist': 'Artist',
            'game.publisher': 'Editură',
            'game.categories': 'Categorii',
            'game.categoriesPh': 'Sau introdu categorii noi separate prin virgulă',
            'game.description': 'Descriere',
            'rand.maxDiff': 'Dificultate maximă',
            'rand.any': 'Oricare',

            'profile.tabTitle': 'Profilul meu',
            'profile.statsTitle': 'Statistici',
            'profile.points': 'Puncte',
            'profile.totalScores': 'Total scoruri',
            'profile.games': 'Jocuri',
            'profile.winRate': 'Win rate',
            'profile.pointsNote': 'Punctele și scorurile se modifică doar de administratori.',
            'profile.statsScopeClub': 'Acest club',
            'profile.statsScopeGlobal': 'Toate cluburile',
            'profile.statsCalculating': 'Se calculează statisticile globale…',
            'profile.statsLoadError': 'Nu am putut încărca statisticile globale.',
            'profile.statsGlobalNote': 'Statistici agregate din toate cluburile din care faci parte.',
            'profile.statMatches': 'Meciuri totale',
            'profile.statDistinctGames': 'Jocuri diferite',
            'profile.eloPerClub': 'ELO pe fiecare club',
            'profile.noEloClubs': 'Niciun club cu meciuri clasate încă.',
            'profile.xp': 'XP',
            'profile.myFriends': 'Prietenii mei',
            'profile.noFriends': 'Nu ai încă prieteni adăugați. Caută jucători în Descoperă jucători.',
            'profile.myData': 'Datele mele',
            'profile.avatar': 'Avatar',
            'profile.avatarNone': '— fără —',
            'profile.displayName': 'Nume afișat',
            'profile.nameNote': 'Dacă îl schimbi, sesiunile mai vechi păstrează numele anterior.',
            'profile.userTag': 'User Tag (handle unic)',
            'profile.userTagNote': 'Identificator unic pentru login și menționări. Doar litere mici, cifre, punct sau underscore (fără spații). Se afișează cu @ în față.',
            'profile.userTagLocked': 'Permanent',
            'profile.userTagLockedNote': 'Tag-ul tău este permanent și nu mai poate fi schimbat — nici de tine, nici de adminii clubului.',
            'profile.userTagOnceNote': 'Îți poți schimba user tag-ul o singură dată; după aceea devine permanent.',
            'profile.userTagChangeWarn': 'Atenție! Îți poți schimba user tag-ul o singură dată. După această acțiune, tag-ul tău devine permanent și nu va mai putea fi modificat nici de tine, nici de adminii clubului. Ești sigur că ai scris corect {tag}?',
            'profile.userTagEmpty': 'User Tag-ul nu poate fi gol.',
            'profile.userTagInvalid': 'User Tag invalid: 3-30 caractere, doar litere mici, cifre, punct sau underscore.',
            'profile.userTagTaken': 'Acest User Tag este deja folosit. Alege altul.',
            'profile.userTagNeedsSql': 'Numele s-a salvat. Pentru User Tag rulează scriptul „turnorder_user_tag.sql" în Supabase.',
            'profile.about': 'Despre mine',
            'profile.aboutPh': 'Câteva cuvinte despre tine ca jucător...',
            'profile.photo': 'Poză de profil (opțional)',
            'profile.attachPhoto': 'Atașează poză',
            'profile.removePhoto': 'Elimină poza',
            'profile.photoNote': 'Poza are prioritate față de emoji și e redimensionată automat.',
            'profile.editPhoto': 'Editează poza',
            'profile.photoReady': 'Poză pregătită. Apasă „Salvează profilul".',
            'common.done': 'Gata',
            'profile.favGames': 'Jocuri preferate',
            'profile.clubs': 'Cluburi',
            'profile.addFromCatalog': 'Adaugă din catalog',
            'profile.bggLinkPh': 'sau lipește un link BoardGameGeek',
            'profile.addFromBgg': 'Adaugă din BGG',
            'profile.favSearchPh': 'Caută un joc (catalog + BoardGameGeek)…',
            'profile.favNoLocal': 'Niciun joc găsit în catalog. Scrie minim 3 litere pentru BGG sau lipește un link mai jos.',
            'profile.bggUser': 'Utilizator BoardGameGeek',
            'profile.optional': 'opțional',
            'profile.security': 'Securitate cont',
            'block.menu': 'Opțiuni',
            'block.block': 'Blochează',
            'block.unblock': 'Deblochează',
            'block.notNow': 'Nu acum',
            'block.confirmMsg': 'Blochezi utilizatorul {name}?\n\nNu veți mai putea să vă trimiteți mesaje directe, prietenia se șterge, iar profilurile devin invizibile unul pentru celălalt.\n\nNumele rămâne vizibil în istoricul clubului și în clasamente.',
            'block.unblockMsg': 'Deblochezi utilizatorul {name}?\n\nVeți putea din nou să vă trimiteți mesaje și să vă vedeți profilurile. Prietenia NU se restabilește automat.',
            'block.afterReport': 'Raportul a fost trimis. Vrei să blochezi și utilizatorul {name}?',
            'block.done': 'Utilizator blocat.',
            'block.undone': 'Utilizator deblocat.',
            'block.failed': 'Operațiunea nu a reușit. Încearcă din nou.',
            'block.loading': 'Se încarcă…',
            'block.none': 'Nu ai blocat pe nimeni.',
            'block.listTitle': 'Utilizatori blocați',
            'block.listNote': 'Nu vă puteți trimite mesaje directe și nu vă vedeți profilurile. Numele rămâne vizibil în istoricul clubului.',
            'block.hiddenProfile': 'Profilul nu este disponibil.',
            'block.youBlocked': 'Ai blocat acest utilizator.',
            'block.dmBar': 'Nu poți trimite mesaje acestui utilizator.',
            'profile.email': 'Email',
            'profile.emailNote': 'Dacă schimbi email-ul, s-ar putea să primești un mesaj de confirmare.',
            'profile.hideEmail': 'Nu afișa email-ul în profilul public',
            'profile.discoverable': 'Profil descoperibil (apar în „Descoperă jucători" pentru alți utilizatori)',
            'profile.newPassword': 'Parolă nouă',
            'profile.newPasswordPh': 'lasă gol dacă nu schimbi',
            'profile.confirmPassword': 'Confirmă parola nouă',
            'profile.confirmPasswordPh': 'reintrodu parola nouă',
            'profile.setPwNote': 'Lasă gol dacă nu schimbi parola. Dacă te-ai înregistrat cu Google, setează aici o parolă ca să te poți loga și cu email.',
            'profile.save': 'Salvează profilul',
            'profile.deleteAccount': 'Șterge contul meu',
            'profile.memberSince': 'membru din',
            'profile.mySub': 'Abonamentul meu',
            'sub.renewsOn': 'Se reînnoiește pe',
            'sub.expiresOn': 'Expiră pe',
            'sub.daysLeft': 'zile rămase',
            'sub.renewsInDays': 'zile până la reînnoire',
            'sub.autoRenew': 'Auto-reînnoire',
            'sub.on': 'Activă',
            'sub.off': 'Dezactivată',
            'sub.turnOff': 'Dezactivează',
            'sub.turnOn': 'Reactivează',
            'sub.updating': 'Se actualizează abonamentul...',
            'sub.autoRenewError': 'Nu am putut actualiza auto-reînnoirea.',
            'sub.autoRenewOnMsg': 'Auto-reînnoirea a fost reactivată.',
            'sub.autoRenewOffMsg': 'Auto-reînnoirea a fost dezactivată. Abonamentul va expira la finalul perioadei curente.',
            'transfer.title': 'Transferă proprietatea clubului',
            'transfer.button': 'Transferă clubul',
            'transfer.settingsHint': 'Predă rolul de Admin Principal altui membru. Tu vei deveni admin secundar.',
            'transfer.warning': 'Atenție: după transfer, noul membru devine Admin Principal, iar tu devii admin secundar. Acțiunea nu poate fi anulată decât printr-un nou transfer.',
            'transfer.searchPh': 'Caută membru după nume sau @user_tag...',
            'transfer.noMembers': 'Niciun membru găsit.',
            'transfer.confirm': 'Ești sigur că vrei să transferi clubul către {name}? Vei deveni admin secundar.',
            'transfer.working': 'Se transferă clubul...',
            'transfer.success': 'Clubul a fost transferat către {name}.',
            'transfer.failed': 'Transferul a eșuat.',
            'transfer.errNoSub': 'Membrul ales nu are un abonament activ. Clubul depinde de abonamentul proprietarului.',
            'transfer.errNoSlot': 'Membrul ales nu mai are slot liber de club pe planul lui.',
            'transfer.errNotMember': 'Persoana aleasă nu este membru activ al clubului.',
            'transfer.dmBody': '🔑 Proprietatea clubului „{club}" ți-a fost transferată. Ești acum Admin Principal.',
            'profile.noSub': 'Niciun abonament activ',
            'profile.manageSub': 'Gestionează',
            'profile.clubsUsed': 'Cluburi folosite',
            'profile.membersPerClub': 'Membri/club',
            'common.players': 'jucători',
            'common.never': 'Niciodată',
            'common.total': 'Total',
            'common.game': 'Joc',
            'common.date': 'Data',
            'stats.totalGames': 'Total jocuri',
            'session.allGames': 'Toate jocurile',
            'club.noClubs': 'Niciun club.',
            'tabmenu.open': 'Meniu',
            'tabmenu.close': 'Închide',
            'common.unknownF': 'Necunoscută',
            'session.minutesShort': '{n} min',
            'players.createProfileError': 'Profilul nu a putut fi creat.',
            'players.addErrorColon': 'Eroare la adăugare: ',
            'common.selectAll': 'Selectează tot',
            'common.deleteSelected': 'Șterge selectații',
            'common.import': 'Importă',
            'common.viewProfile': 'Vezi profilul',
            'common.description': 'Descriere',
            'common.tryOtherSearch': 'Încearcă alt termen de căutare',
            'common.playsShort': 'jucări',
            'common.ptsShort': 'pct',
            'ra.fallbackName': 'Sesiune',
            'ra.format': 'Format',
            'ra.rounds': 'runde',
            'ra.prize': 'Premiu',
            'ra.fee': 'Taxă',
            'ra.noScore': 'Fără scor',
            'ra.searchEmptyPre': 'Nicio sesiune găsită pentru',
            'ss.help': 'Categorii de scor (ex: „Așezări", „Orașe", „Cărți dezvoltare"). Totalul se calculează automat ca sumă.',
            'ss.addField': 'Adaugă categorie',
            'ss.fieldPh': 'Nume categorie',
            'roles.heading': 'Roluri / facțiuni',
            'roles.help': 'Rolurile/facțiunile jocului (ex: „Marquise", „Eyrie", „Woodland Alliance"). La fiecare sesiune vei putea alege rolul fiecărui jucător, iar statistica „win rate per rol" se calculează automat.',
            'roles.addField': 'Adaugă rol',
            'roles.fieldPh': 'Nume rol/facțiune',
            'session.timerPause': 'Pauză',
            'session.timerStop': 'Stop &amp; setează durata',
            'session.removeGuest': 'Elimină invitatul',
            'players.noneFound': 'Nu s-au găsit jucători',
            'players.addFirst': 'Adaugă primul jucător!',
            'players.actActive': '🔥 Activ',
            'players.actModerate': '📊 Moderat',
            'players.actInactive': '😴 Inactiv',
            'players.emailPromptPre': 'Email pentru',
            'players.emailPromptPost': '(lasă gol pentru niciun email):',
            'import.playersTitle': 'Import Jucători',
            'import.pasteLabel': 'Lipește jucătorii (unul pe linie)',
            'import.formatHint': 'Format: <b>Nume</b> sau <b>Nume, email</b>. Funcționează și cu fișiere CSV.',
            'import.orCsv': '...sau încarcă un fișier CSV',
            'bulk.playersTitle': 'Ștergere Jucători în Masă',
            'bulk.warningPlayers': 'Atenție: ștergerea este permanentă și elimină și scorurile din istoric.',
            'bulk.gamesTitle': 'Ștergere Jocuri în Masă',
            'bulk.warningGames': 'Jocurile șterse dispar din catalog (istoricul sesiunilor rămâne neschimbat).',
            'bulk.gamesLinksNote': 'Turneele și campaniile care folosesc jocurile șterse rămân, dar pierd legătura cu jocul. Istoricul sesiunilor NU e afectat (se leagă prin titlu, nu prin id).',
            'bulk.gamesDeleting': 'Se șterg jocurile…',
            'bulk.gamesDeletePartial': 'Șterse: {ok}. Nu s-au putut șterge: {fail}.',
            'catalog.noneFound': 'Nu s-au găsit jocuri',
            'catalog.addFirst': 'Adaugă primul joc!',
            'catalog.lastShort': 'ultima',
            'catalog.difficulty': 'Dificultate',
            'catalog.weight': 'Greutate',
            'catalog.rating': 'Rating',
            'catalog.age': 'Vârstă',
            'catalog.designer': 'Designer',
            'catalog.artist': 'Artist',
            'catalog.publisher': 'Editură',
            'catalog.diffPrompt': 'Dificultatea (weight) pentru',
            'catalog.playsLabel': 'Jocuri',
            'rate.ratingLabel': 'Nota ta (1–10)',
            'rate.weightLabel': 'Dificultate / Weight (1–5)',
            'rate.save': 'Salvează evaluarea',
            'rate.saved': 'Evaluare salvată!',
            'rate.yourPrev': 'Evaluarea ta anterioară:',
            'catalog.playsShort': 'partide',
            'catalog.realMin': 'min reali',
            'catalog.rate': 'Evaluează',
            'catalog.noListGames': 'Niciun membru nu a adăugat jocuri în listă',
            'catalog.beFirstList': 'Fii primul care adaugă jocuri preferate!',
            'catalog.bggLinkLabel': 'Link sau ID BoardGameGeek',
            'catalog.edit': 'Editează',
            'catalog.saveGame': 'Salvează modificările',
            'catalog.addGameBtn': 'Adaugă Joc',
            'catalog.descPh': 'Descrierea jocului...',
            'catalog.info': 'Informații',
            'catalog.playersColon': 'Jucători',
            'catalog.durationLabel': 'Durata',
            'catalog.realAvg': 'medie reală',
            'catalog.lastPlayedLabel': 'Ultima dată jucat',
            'catalog.categories': 'Categorii',
            'catalog.noCategories': 'Fără categorii',
            'catalog.statistics': 'Statistici',
            'catalog.avgDurationLabel': 'Durata medie reală',
            'catalog.favoriteFor': 'Favorite pentru',
            'catalog.scoreBlendBoth': 'media dintre nota BGG {bgg} și {n} voturi ale membrilor acestui club',
            'catalog.scoreBggOnly': 'nota BGG {bgg}',
            'catalog.scoreClubOnly': 'media a {n} voturi ale membrilor acestui club',
            'common.readMore': 'Citește tot',
            'common.readLess': 'Restrânge',
            'catalog.nobody': 'Nimeni',
            'catalog.viewBgg': 'Vezi pe BGG',
            'catalog.bggUserPrompt': 'Introdu username-ul tău de BoardGameGeek:',
            /* Import colecție BGG — fereastra de progres (import în 4 faze) */
            'bggimp.title': 'Import colecție BoardGameGeek',
            'bggimp.phaseCollection': 'Se citește colecția de pe BGG…',
            'bggimp.phaseDetails': 'Se aduc detaliile jocurilor…',
            'bggimp.phaseSaving': 'Se salvează în catalogul clubului…',
            'bggimp.phaseRefresh': 'Se reîncarcă catalogul…',
            'bggimp.counter': '{done} din {total}',
            'bggimp.cancel': 'Anulează',
            'bggimp.cancelling': 'Se oprește după pachetul curent…',
            'bggimp.done': 'Import finalizat: {ins} jocuri noi, {upd} completate.',
            'bggimp.doneCancelled': 'Import oprit: {ins} jocuri noi, {upd} completate. Ce s-a salvat rămâne salvat.',
            'bggimp.noWeight': 'Pentru {n} jocuri, BGG nu are complexitate.',
            'bggimp.failedDetails': 'Pentru {n} jocuri nu am putut aduce detaliile; s-au salvat cu datele de bază.',
            'bggimp.invalidUser': 'Utilizatorul BGG nu există sau colecția lui e privată.',
            'bggimp.noClub': 'Selectează un club înainte de import.',
            'bggimp.error': 'Importul a eșuat: {msg}',
            'catalog.ratePromptPre': 'Evaluează',
            'catalog.ratePromptPost': 'de la 1 la 10:',
            'csv.name': 'Nume',
            'csv.email': 'Email',
            'csv.points': 'Puncte',
            'csv.plays': 'Jocuri',
            'csv.avg': 'Medie',
            'csv.winRate': 'Win Rate',
            'csv.joinDate': 'Data Înscrierii',
            'session.timerResetTitle': 'Resetează timpii',
            'import.pastePh': 'Nume jucător, email@exemplu.com&#10;Maria Popescu&#10;Andrei Ionescu, andrei@mail.com',
            'common.enabled': 'activate',
            'common.disabled': 'dezactivate',
            'chat.notif': 'Notificări chat',
            'chat.noResults': 'Niciun mesaj găsit.',
            'chat.seenBy': 'Văzut de',
            'rand.useForSession': 'Folosește pentru sesiune',
            'rand.playerOrder': 'Ordinea jucătorilor',
            'rand.copyOrder': 'Copiază ordinea',
            'rand.reroll': 'Încă o dată',
            'rand.chosenGame': 'Jocul ales',
            'rand.teamsGenerated': 'Echipe generate',
            'rand.team': 'Echipa',
            'rand.detailsBtn': 'Detalii',
            'rand.whoPlays': 'Cine intră în tragere',
            'rand.selectAll': 'Toți',
            'rand.selectNone': 'Niciunul',
            'rand.noPlayers': 'Nu există jucători în club.',
            'rand.needTwoSelected': 'Selectează cel puțin 2 jucători!',
            'rand.searchPh': 'Caută după nume sau @tag...',
            'rand.noMatch': 'Niciun jucător găsit.',
            'rand.drawEmpty': 'Niciun jucător adăugat încă — caută mai sus.',
            'rand.inDraw': 'în tragere',
            'rand.addAll': 'Adaugă toți',
            'rand.clear': 'Golește',
            'rand.teamPool': 'Jucători disponibili',
            'rand.teamsNeed': 'Ai nevoie de {need} jucători, dar ai doar {have}!',
            'rand.copyTeams': 'Copiază echipele',
            'polls.noneActive': 'Nu există poll-uri active',
            'polls.createFirst': 'Creează primul poll pentru a colecta opiniile membrilor!',
            'polls.createBtn': 'Creează Poll',
            'polls.votes': 'voturi',
            'polls.expires': 'Expiră',
            'polls.yourVote': '✓ Votul tău',
            'polls.clickToVote': 'Click pe o opțiune pentru a vota',
            'polls.multipleAllowed': '(multiple permise)',
            'polls.canVoteMultiple': 'Poți vota mai multe opțiuni',
            'polls.closePoll': 'Închide poll',
            'polls.statusActive': 'Activ',
            'polls.retract': 'Retrage votul',
            'polls.alreadyVoted': 'Ai votat deja (click pe opțiune pentru a retrage)',
            'polls.deleteConfirm': 'Sigur ștergi acest poll? Acțiunea nu poate fi anulată.',
            'polls.deleted': 'Poll șters',
            'polls.edited': 'Poll actualizat',
            'polls.notifCreated': '{by} a creat un poll: {q}',
            'polls.closedTitle': 'Poll-uri Închise',
            'polls.closed': 'Închis',
            'polls.winner': '🏆 Câștigător',
            'cal.noEventsDay': 'Nu sunt evenimente în această zi.',
            'cal.addEvent': 'Adaugă eveniment',
            'cal.planFirst': 'Planifică primul eveniment!',
            'cal.today': 'Azi',
            'cal.noUpcoming': 'Nu sunt evenimente viitoare',
            'cal.join': 'Participă',
            'cal.googleHelp': 'Adaugă evenimentele în Google Calendar cu un singur click, sau folosește <b>Export Calendar</b> pentru a importa toate evenimentele odată (fișier .ics).',
            'cross.loading': 'Se încarcă din {n} cluburi…',
            'cross.loadError': 'Eroare la încărcare',
            'cross.noSessions': 'Încă nu ai sesiuni înregistrate în cluburile tale.',
            'roleStats.empty': 'Nicio sesiune cu roluri în perioada selectată. Definește rolurile unui joc (linkul „Editează roluri" de la formularul de sesiune) și alege rolul fiecărui jucător când loghezi partida.',
            'stats.noMatchesPeriod': 'Nicio partidă în perioada selectată.',
            'stats.noChartData': 'Nu există date pentru grafic',
            'stats.avgPerPlayer': 'Medie/jucător',
            'stats.gameDistribution': 'Distribuție Jocuri',
            'stats.weekShort': 'Săpt.',
            'stats.ptsWord': 'pct.',
            'stats.uniquePlayers': 'Jucători unici',
            'insights.sessUp': '<strong>Creștere puternică în numărul de sesiuni</strong> (+{n}% față de perioada anterioară). Clubul este mai activ ca niciodată!',
            'insights.sessDown': '<strong>Scădere în activitate</strong> ({n}% față de perioada anterioară). Poate este timpul pentru o sesiune specială?',
            'insights.sessStable': '<strong>Stabilitate în activitate</strong>. Numărul de sesiuni este constant.',
            'insights.players': '<strong>Comunitate în creștere</strong> (+{n}% jucători noi). Clubul atrage membri noi!',
            'insights.scoreUp': '<strong>Competiție mai intensă</strong> (+{n}% în scorul mediu). Jucătorii își îmbunătățesc abilitățile!',
            'insights.scoreDown': '<strong>Atmosferă mai relaxată</strong>. Scorurile sunt mai mici, ceea ce indică jocuri mai prietenoase.',
            'insights.routine': '<strong>Rutină stabilă</strong>. Clubul are o frecvență constantă de sesiuni.',
            'insights.peak': '<strong>Perioada cea mai activă</strong> a fost {label} cu {n} sesiuni.',
            'insights.none': 'Nu există insights semnificative pentru această perioadă.',
            'insights.title': 'Observații',
            'insights.recordSessions': '<strong>Record de activitate.</strong> {n} sesiuni — cea mai bună perioadă de până acum.',
            'insights.comeback': '<strong>Clubul s-a repornit.</strong> După o perioadă fără nicio sesiune, iată {n} la loc pe tablă.',
            'insights.topGame': '<strong>Jocul momentului: {game}.</strong> Jucat de {n} ori în această perioadă.',
            'insights.newGame': '<strong>Titlu nou pe masă: {game}.</strong> Prima oară în istoricul clubului.',
            'insights.newGames': '<strong>{n} jocuri noi încercate</strong>, printre care {game}.',
            'insights.variety': '<strong>Multă varietate.</strong> {n} titluri diferite în {s} sesiuni.',
            'insights.focused': '<strong>V-ați fixat pe {game}.</strong> Ori e foarte bun, ori e campanie în toi.',
            'insights.groupSize': '<strong>Grup de {n} jucători</strong> în medie la masă.',
            'insights.mostPresent': '<strong>{name} nu a lipsit aproape deloc</strong> — {n} din {s} sesiuni.',
            'insights.playersDown': '<strong>Mai puțină lume.</strong> Cu {n}% mai puțini jucători decât perioada trecută.',
            'insights.hoursUp': '<strong>Sesiuni mai lungi.</strong> {n} ore de joc în această perioadă.',
            'insights.hoursDown': '<strong>Partide mai scurte.</strong> {n} ore de joc, sub perioada anterioară.',
            'common.notes': 'Notițe',
            'common.next': 'Următor',
            'common.noData': 'fără date',
            'common.saveChanges': 'Salvează modificările',
            'common.page': 'Pagina',
            'common.of': 'din',
            'camp.editTitle': 'Editează campania',
            'camp.newTitle': 'Campanie nouă',
            'camp.nameLabel': 'Nume campanie',
            'camp.namePh': 'Ex: Gloomhaven — grupul de marți',
            'camp.statusCompleted': 'Finalizată',
            'camp.statusAbandoned': 'Abandonată',
            'camp.roster': 'Roster (participanți)',
            'camp.notesPh': 'Personaje, obiective, observații…',
            'camp.scNameLabel': 'Nume / număr scenariu',
            'camp.scNamePh': 'Ex: Scenariul 3 — Cripta',
            'camp.outcome': 'Rezultat',
            'camp.win': 'Victorie',
            'camp.loss': 'Înfrângere',
            'camp.outcomeOther': 'Altul / narativ',
            'camp.scNotesPh': 'Recompense, deblocări, evenimente…',
            'reg.docTitlePre': 'Regulamentul',
            'reg.noArticles': 'Nu există articole în regulament.',
            'reg.contentLabel': 'Conținut',
            'reg.titleLabel': 'Titlu',
            /* Placeholdere de formular — erau hardcodate în index.html (§53.11) */
            'ph.coopScore': 'Ex: 45',
            'ph.coopDifficulty': 'Ex: Coșmar',
            'ph.coopDetail': 'Ex: 2 orașe rămase, o epidemie evitată',
            'ph.coopScenario': 'Ex: Pandemic — Scenariul 3',
            'ph.tournamentPrize': 'Ex: Trofeu + Joc nou',
            'ph.tournamentRounds': 'Ex: 3',
            'ph.tournamentFee': 'Ex: 20 RON',
            'ph.sessionDuration': 'Ex: 120',
            'ph.randomMaxTime': 'Ex: 120',
            'reg.newTitlePh': 'Ex: Art. 6 — Denumirea articolului',
            'reg.saveChanges': 'Salvează modificări',
            'reg.history': 'Istoric modificări',
            'reg.editTitle': 'Editare regulament',
            'reg.historyCount': 'Istoric modificări ({n})',
            'reg.noHistory': 'Articolul nu a fost modificat de la publicare.',
            'reg.diffRemoved': 'text scos',
            'reg.diffAdded': 'text adăugat',
            'reg.diffNone': 'Textul nu s-a schimbat (salvare fără modificări).',
            'reg.moveUp': 'Mută mai sus',
            'reg.moveDown': 'Mută mai jos',
            'reg.confirmDelete': 'Ștergi articolul „{title}”? Textul dispare din regulament, dar rămâne în istoricul de modificări. Versiunea regulamentului crește, deci membrii vor fi întrebați din nou dacă acceptarea e obligatorie.',
            'reg.share': 'Partajează regulamentul',
            'reg.shareCopied': 'Regulamentul a fost copiat. Îl poți trimite oriunde — se citește fără cont.',
            'reg.shareFailed': 'Partajarea nu a reușit.',
            'm3.articleDeleted': 'Articol șters.',
            'audit.regulationReordered': 'Ordinea articolelor a fost schimbată',
            'audit.regulationArticleDeleted': 'Articol de regulament șters',
            'auditd.regMoved': 'articolul „{title}” a fost mutat',
            'auditd.regDeleted': 'articolul „{title}” a fost șters',
            'auditd.regEdited': 'articolul „{title}” a fost modificat',
            'reg.amendTo': 'În',
            'reg.addArticleNew': 'Adaugă Articol Nou',
            'reg.addArticle': 'Adaugă Articol',
            'reg.newContentPh': 'Introdu conținutul articolului nou...',
            'reg.resetOriginal': 'Resetează la versiunea originală',
            'reg.contentPrompt': 'Conținutul articolului:',
            'admin.revokeAdmin': 'Revocă admin',
            'admin.noProfileDelete': 'Profilul aparține utilizatorului, nu clubului. Folosește „Scoate din club" sau „Ban".',
            'admin.makeAdmin': 'Fă admin',
            'admin.entries': 'intrări',
            'admin.autosaveActive': 'Salvare automată activă',
            'admin.size': 'Mărime',
            'admin.update': 'Actualizează',
            'hist.noSessions': 'Nu există sesiuni în istoric',
            'hist.tryOtherFilters': 'Încearcă alte filtre',
            'hist.startFirst': 'Începe prima sesiune!',
            'hist.allPlayers': 'Toți jucătorii',
            'hist.coop': 'Cooperativ',
            'hist.campaign': 'Campanie',
            'hist.friendly': 'Amical',
            'hist.teamWin': 'Victorie de echipă',
            'hist.teamScore': 'Scor echipă',
            'hist.guests': 'Invitați',
            'hist.sessions': 'sesiuni',
            'hist.durationMin': 'Durată (min)',
            'hist.noScored': 'Această sesiune nu are participanți cu scor.',
            'pdf.historyTitle': 'Istoric sesiuni',
            'pdf.generated': 'Generat',
            'csv.date': 'Data',
            'csv.time': 'Ora',
            'csv.type': 'Tip',
            'csv.duration': 'Durată',
            'csv.participants': 'Participanți',
            'csv.winner': 'Câștigător',
            'csv.typeNormal': 'Normal',
            'csv.winnerScore': 'Scor Câștigător',
            'tip.edit': 'Editează',
            'tip.search': 'Caută',
            'tip.filter': 'Filtrează',
            'tip.download': 'Descarcă',
            'tip.upload': 'Încarcă',
            'tip.print': 'Printează',
            'tip.stats': 'Statistici',
            'tip.games': 'Jocuri',
            'tip.history': 'Istoric',
            'tip.polls': 'Poll-uri',
            'tip.settings': 'Setări',
            'tip.logout': 'Deconectare',
            'tip.profile': 'Profil',
            'tip.time': 'Timp',
            'tip.rankPos': 'Poziția în clasament',
            'tip.playerName': 'Numele jucătorului',
            'tip.pointsAccrued': 'Punctele de club acumulate (acordate prin sistemul clubului, doar de administratori).',
            'tip.scoresSum': 'Suma scorurilor brute din meciuri (diferită de punctele de club).',
            'tip.gamesCount': 'Numărul de jocuri jucate',
            'tip.avgPerGame': 'Puncte medii per joc',
            'tip.winPct': 'Procentul de victorii',
            'tip.recentTrend': 'Evoluția recentă',
            'tip.sessionDate': 'Data sesiunii',
            'tip.startTime': 'Ora începerii',
            'tip.complexity': 'Complexitatea jocului',
            'tip.gameRating': 'Evaluarea jocului',
            'tip.presentPlayers': 'Jucători prezenți',
            'tip.playTime': 'Timpul de joc',
            'tip.scoreObtained': 'Punctajul obținut',
            'notif.eventStarting': '⏰ Evenimentul „{title}" începe în {n} minute{loc}!',
            'notif.atLoc': ' la {l}',
            'banner.muted': '🔇 Ești în mod vizualizare (mut) — poți vedea tot, dar nu poți face modificări.',
            'banner.readonlyPre': 'Clubul',
            'overlimit.bannerOwner': 'Ești peste limita de cluburi a planului. Alege ce cluburi rămân active; restul devin doar-citire.',
            'overlimit.bannerMember': 'Acest club e în pauză temporar (proprietarul e peste limita planului).',
            'overlimit.chooseBtn': 'Alege cluburile',
            'overlimit.modalTitle': 'Păstrează cluburile active',
            'overlimit.modalIntro': 'Planul tău permite {n} cluburi active. Alege care rămân active; restul vor fi doar-citire până faci upgrade.',
            'overlimit.selected': 'selectate',
            'overlimit.tooMany': 'Poți păstra cel mult {n} cluburi active.',
            'overlimit.saved': 'Cluburile active au fost actualizate.',
            'overlimit.locked': 'Selecția e blocată. Fă upgrade pentru a o schimba.',
            'overlimit.lockedToast': 'Ai făcut deja alegerea. Fă upgrade ca s-o schimbi.',
            'claim.button': 'Preia Clubul',
            'claim.redirecting': 'Te redirecționez către plată pentru a prelua clubul...',
            'claim.success': 'Ai preluat clubul! Ești noul Admin Principal, iar clubul e din nou activ.',
            'claim.failed': 'Preluarea clubului a eșuat.',
            'claim.notMember': 'Nu ești membru al acestui club.',
            'claim.phaseGrace': 'în perioadă de grație (doar citire)',
            'claim.phaseArchived': 'arhivat',
            'claim.phaseClosed': 'închis',
            'claim.archivedExplain': 'Acest club este inactiv din cauza neplății și este momentan',
            'claim.archivedCta': 'Pornește un abonament pe numele tău ca să-l reactivezi instant și să devii Admin Principal.',
            'claim.reactivate': 'Reactivează clubul',
            'claim.reactivated': 'Clubul a fost reactivat.',
            'claim.reactivateFailed': 'Reactivarea a eșuat:',
            'claim.onlyOwnerReactivate': 'Doar adminul principal poate reactiva clubul.',
            'claim.closedExplainOwner': 'Acest club este închis. Îl poți reactiva oricând cât timp abonamentul tău este activ — datele sunt intacte. După expirarea abonamentului va trebui să plătești din nou pentru reactivare.',
            'claim.claiming': 'Se preia clubul...',
            'hub.createClubNew': 'Creează club nou',
            'hub.freeJoin': 'Alăturare liberă',
            'hub.needsApproval': 'Necesită aprobare',
            'friends.add': 'Adaugă prieten',
            'friends.friends': 'Prieteni',
            'friends.removeTitle': 'Elimină',
            'friends.requestSent': 'Cerere trimisă',
            'ev.noVotesYet': 'Niciun vot încă.',
            'notif.empty': 'Nicio notificare deocamdată.',
            'notif.title': 'Notificări',
            'toastlog.title': 'Mesaje recente',
            'toastlog.hint': 'Mesajele apărute în colț la acțiunile tale. Se șterg la deconectare.',
            'toastlog.empty': 'Niciun mesaj în această sesiune.',
            'toastlog.clear': 'Golește jurnalul',
            'toastlog.justNow': 'chiar acum',
            'toastlog.minShort': 'min',
            'toastlog.hourShort': 'h',
            'notif.tapToOpen': 'atinge pentru a deschide',
            'camp.unknownMember': 'Membru necunoscut',
            'push.title': 'Notificări push',
            'appsec.title': 'Aplicație',
            'appsec.desc': 'Instalează TurnOrder pe dispozitiv sau verifică dacă există o versiune mai nouă.',
            'appsec.checkUpdate': 'Verifică actualizările',
            'appsec.checking': 'Se verifică…',
            'appsec.upToDate': 'Ai deja cea mai recentă versiune.',
            'appsec.updating': 'Versiune nouă găsită. Se actualizează…',
            'appsec.updateFail': 'Verificarea a eșuat. Încearcă din nou.',
            'appsec.updateUnsupported': 'Browserul acesta nu suportă actualizarea automată.',
            'push.desc': 'Primește notificări în timp real (chat, mesaje private, activitate din club) și când aplicația e închisă.',
            'push.enable': 'Activează notificările',
            'push.disable': 'Dezactivează notificările',
            'push.on': 'Notificările push sunt active pe acest dispozitiv.',
            'push.pending': 'Atinge „Activează" pentru a primi notificări pe acest dispozitiv.',
            'rem.label': 'Remindere',
            'rem.addRule': 'Adaugă reminder',
            'rem.hint': 'Vei trimite o notificare celor care nu au răspuns încă, înainte de termen.',
            'rem.needsDeadline': 'Setează un termen limită pentru a activa reminderele.',
            'rem.defaultsTitle': 'Remindere implicite',
            'rem.defaultsHint': 'Aceste valori pre-completează formularele când creezi un eveniment, sondaj sau vot. Le poți ajusta de fiecare dată.',
            'rem.defEvent': 'Pentru evenimente',
            'rem.defPoll': 'Pentru sondaje',
            'rem.defGameVote': 'Pentru „Ce jucăm?”',
            'rem.min10': 'Cu 10 minute înainte',
            'rem.min30': 'Cu 30 de minute înainte',
            'rem.hour1': 'Cu 1 oră înainte',
            'rem.hour2': 'Cu 2 ore înainte',
            'rem.hour6': 'Cu 6 ore înainte',
            'rem.hour12': 'Cu 12 ore înainte',
            'rem.day1': 'Cu 1 zi înainte',
            'rem.day2': 'Cu 2 zile înainte',
            'rem.week1': 'Cu 1 săptămână înainte',
            'push.off': 'Notificările push sunt dezactivate pe acest dispozitiv.',
            'push.granted': 'Notificările push au fost activate! 🔔',
            'push.disabled': 'Notificările push au fost dezactivate pe acest dispozitiv.',
            'push.denied': 'Notificările sunt blocate. Activează-le din setările browserului pentru acest site.',
            'push.unsupported': 'Acest browser/dispozitiv nu suportă notificări push.',
            'push.iosHint': 'Pe iPhone/iPad: adaugă întâi aplicația pe ecranul principal (Share → Add to Home Screen), apoi deschide-o de acolo pentru a activa notificările.',
            'install.banner': '📲 Descarcă aplicația TurnOrder pentru o experiență mai bună',
            'install.btn': 'Instalează',
            'install.iosHint': 'Apasă Share, apoi „Adaugă pe ecranul principal".',
            'update.banner': '🔄 A apărut o versiune nouă a aplicației',
            'update.btn': 'Actualizează',
            'push.error': 'Nu am putut activa notificările. Încearcă din nou.',
            'notif.markAllRead': 'Marchează tot ca citit',
            'notif.clearAll': 'Șterge toate notificările',
            'elo.empty': 'Încă nu sunt sesiuni cu rezultat pentru clasament.',
            'gv.noActive': 'Niciun vot activ. Pornește unul ca să decideți împreună ce jucați.',
            'gv.start': 'Pornește un vot',
            'gv.shareMenuTitle': 'Distribuie votul',
            'gv.shareMenuHint': 'Apasă „Distribuie" ca să alegi aplicația (inclusiv WhatsApp personal).',
            'gv.shareNative': 'Distribuie',
            'gv.shareWaWeb': 'WhatsApp Web (desktop)',
            'gv.shareCopy': 'Copiază textul',
            'gv.share': 'Distribuie',
            'gv.shareTitle': 'Vot: Ce jucăm?',
            'gv.shareCta': 'Alege ce jucăm data viitoare — votează acum! 👇',
            'gv.shareOpen': 'Deschide TurnOrder și votează:',
            'share.asImage': 'Ca imagine',
            'share.asText': 'Ca text',
            'gv.notifStarted': '{by} a pornit un vot: Ce jucăm?',
            'gv.viewDetails': 'Vezi detalii joc',
            'gv.onlyYourGames': 'Poți elimina doar jocurile adăugate de tine.',
            'gv.onlyInitiator': 'Doar inițiatorul votului sau un admin poate închide votul.',
            'gv.notifWinner': 'Votul „Ce jucăm” s-a încheiat. Câștigător:',
            'gv.notifNoWinner': 'Votul „Ce jucăm” s-a încheiat fără un câștigător clar.',
            'gv.autoClosed': 'Vot încheiat. Câștigător:',
            'gv.autoClosedNoWinner': 'Vot încheiat, fără câștigător clar.',
            'gv.closing': 'Se închide votul...',
            'gv.deadlineLabel': 'Termen limită (opțional)',
            'gv.deadlineHint': 'La acest moment votul se închide automat și toți participanții sunt anunțați.',
            'gv.proposeTitle': 'Propune jocuri pentru vot',
            'gv.setupHint2': 'Caută în catalog și adaugă jocurile pe care vrei să le supui la vot.',
            'gv.searchPh': 'Caută un joc în catalog...',
            'gv.anonLabel': 'Vot anonim (nu se vede cine ce a votat)',
            'gv.selected': 'Selectate',
            'gv.results': 'Rezultate',
            'gv.fromCatalog': 'Din catalog',
            'gv.catalogEmpty': 'Catalogul e gol — adaugă jocuri întâi.',
            'gv.noMatch': 'Niciun joc găsit.',
            'gv.closed': 'Închise',
            'gv.closedTitle': 'Voturi închise — Ce jucăm',
            'gv.noWinner': 'Fără câștigător clar',
            'gv.deletedGame': 'Joc șters din catalog',
            'gv.noClosed': 'Niciun vot închis încă.',
            'gv.removeFromVote': 'Elimină din vot',
            'gv.addToVote': 'Adaugă în vot',
            'gv.setupHint': 'Am pre-completat câteva sugestii. Adaugă sau elimină ce vrei, apoi pornește votul.',
            'gv.startVote': 'Pornește votul',
            'gv.noneSelected': 'Niciun joc selectat încă. Adaugă din catalog mai jos.',
            'gv.allInList': 'Toate jocurile din catalog sunt deja în listă.',
            'import.newGames': 'jocuri noi',
            'import.previewTitle': 'Previzualizare import ({src})',
            'import.catalogLabel': 'Catalog',
            'import.newShort': 'noi',
            'import.sessionsLabel': 'Sesiuni',
            'import.alreadyExist': 'există deja, ignorate',
            'import.alreadyImported': 'deja importate, ignorate',
            'import.note': 'Importul scrie în baza comună a clubului (vizibil pentru toți). Jucătorii din sesiuni sunt păstrați după nume și contribuie la ELO și realizări. Ce există deja se ignoră automat.',
            'profile.noFav': 'Niciun joc preferat adăugat.',
            'profile.playerProfile': 'Profil jucător',
            'bgg.searchUnavailable': 'Căutarea BGG nu e disponibilă încă (proxy/token neconfigurat). Poți completa manual mai jos.',
            'bgg.noDetails': 'Nu am găsit detalii.',
            'bgg.filledFromBgg': 'Câmpurile au fost completate din BGG. Verifică și apasă „Adaugă Joc".',
            'bgg.searching': 'Caut pe BGG…',
            'bgg.noResults': 'Niciun rezultat.',
            'bgg.typeMore': 'Scrie cel puțin 3 litere…',
            'bgg.fetchingDetails': 'Aduc detaliile…',
            'copy.prompt': 'Copiază textul:',
            'rsvp.yes': 'Vin',
            'rsvp.maybe': 'Poate',
            'rsvp.no': 'Nu vin',
            'rsvp.saved': 'Răspuns salvat',
            'rsvp.withdrawn': 'Răspuns retras de la',
            'notif.recByOther': '{by} a înregistrat o sesiune de {game} în care ai jucat',
            'notif.recByMe': 'Ai înregistrat o sesiune de {game}',
            'notif.recIPlayed': 'Sesiune de {game} înregistrată (ai jucat)',
            'notif.recIPlayed2': 'Sesiune de {game} (ai jucat)',
            'notif.recordedVerb': 'a înregistrat',
            'notif.recordedImpersonal': 'S-a înregistrat',
            'notif.sessionOf': 'o sesiune de',
            'share.totalVotes': 'Total voturi',
            'notif.voteSing': 'vot',
            'notif.votePlur': 'voturi',
            'notif.pollWord': 'Sondaj',
            'notif.eventWord': 'Eveniment',
            'notif.gamesPlayed': 'Jocuri jucate',
            'notif.members': 'Membri',
            'notif.topPlayers': 'Top jucători',
            'notif.mostPlayed': 'Cel mai jucat',
            'notif.statsWord': 'Statistici',
            'time.justNow': 'chiar acum',
            'time.minAgo': 'acum {n} min',
            'time.hoursAgo': 'acum {n} h',
            'time.today': 'azi',
            'time.yesterday': 'ieri',
            'time.daysAgo': 'acum {n} zile',
            'time.monthAgo': 'acum o lună',
            'time.monthsAgo': 'acum {n} luni',
            'club.memberOne': 'membru',
            'club.memberMany': 'membri',
            'club.lastSession': 'ultima sesiune',
            'club.noSessionsYet': 'fără sesiuni încă',
            'fab.whatToPlay': 'Ce jucăm diseară?',
            'fab.recordSession': 'Înregistrează o sesiune',
            'pwd.recoverTitle': 'Recuperare Parolă',
            'pwd.emailHint': 'Vei primi un cod de verificare pe email pentru a reseta parola.',
            'pwd.codeLabel': 'Cod de verificare',
            'pwd.codePh': 'Introdu codul din email',
            'pwd.newLabel': 'Noua parolă',
            'pwd.sendCode': 'Trimite cod',
            'pwd.resetBtn': 'Resetează parola',
                        'auth.haveAccount': 'Ai deja cont?',
                        'auth.loginLink': 'Loghează-te',
            'sb.unmutedMsg': '{name} poate face din nou modificări.',
            'sb.memberFallback': 'Membrul',
            'sb.mutedMsg': '{name} nu mai poate face modificări (mod vizualizare).',
            'pf.ownedGames': 'Jocuri deținute',
            'live.nowTitle': 'Sesiuni live acum',
            'live.youPlay': 'Joci',
            'live.editing': 'Editezi sesiunea live. Jucătorii o văd în timp real.',
            'live.turnHint': 'Un singur cronometru curge. Când apeși Turn, ceasul celuilalt se oprește.',
            'live.viewBtn': 'Vezi sesiunea (doar vizualizare)',
            'live.readOnly': 'Doar vizualizare. Poți acționa doar propriul cronometru.',
            'live.endBtn': 'Încheie sesiunea',
            'live.confirmEnd': 'Închizi această sesiune live? Ceilalți nu o vor mai vedea.',
            'live.noneNow': 'Nicio sesiune live în acest moment.',
            'live.startBtn': 'Pornește sesiune live',
            'live.makeLiveBtn': 'Fă sesiunea live',
            'live.started': 'Sesiunea live a pornit. Ceilalți membri o văd acum.',
            'live.sheetTitle': 'Sesiune live',
            'live.untitled': 'Joc nespecificat',
            'live.someone': 'Membru',
            'live.youHost': 'Tu găzduiești',
            'live.noPlayers': 'Niciun jucător adăugat încă.',
            'live.notFound': 'Sesiunea nu mai există.',
            'live.ended': 'Sesiunea s-a încheiat.',
            'live.savedElsewhere': 'Sesiunea a fost salvată de pe alt dispozitiv și se află în Istoric.',
            'live.alreadySavedBlock': 'Partida asta e deja salvată în Istoric (de pe alt dispozitiv). Nu o salvăm a doua oară, ca să nu apară dublat. Datele rămân pe ecran; apasă „Sesiune nouă” dacă vrei să înregistrezi altă partidă.',
            'live.myTimerStart': 'Pornește timpul meu',
            'live.myTimerStop': 'Oprește timpul meu',
            'live.watchingOnly': 'Urmărești sesiunea. Doar jucătorii din sesiune își pot porni timpul.',
            'live.errOpen': 'Nu am putut porni sesiunea live: ',
            'live.errSave': 'Nu am putut actualiza foaia: ',
            'live.errTimer': 'Nu am putut salva timpul: ',
            'live.errClose': 'Nu am putut închide sesiunea: ',
            'gdpr.confirmCancelDelete': 'Anulezi ștergerea programată a contului? Contul și datele tale vor fi păstrate.',
            'gdpr.reauthCancelDelete': 'Confirmă-ți parola pentru a anula ștergerea contului.',
            'sb.cantMuteAdmin': 'Nu poți restricționa un administrator.',
            'sb.notAMember': 'Persoana nu este membru activ al acestui club.',
            'm2.saveErrorColon': 'Eroare la salvare: ',
            'sb.profileExtraSaveSkipped': 'Nu am putut citi profilul din baza de date, așa că NU am salvat datele extinse (ca să nu riscăm ștergerea lor). Restul modificărilor s-au salvat. Reîncearcă.',
            'sb.ownedSaveAborted': 'Nu am putut citi lista ta de jocuri din baza de date, așa că NU am salvat nimic (ca să nu riscăm ștergerea celorlalte jocuri). Reîncearcă.',
            'sb.profileLoadFailed': 'Nu am putut încărca profilul tău. NU te-am conectat, ca să nu riscăm suprascrierea datelor. Reîncearcă; dacă persistă, e posibil ca o migrare de bază de date să nu fie aplicată.',
            'pf.noOwned': 'Niciun joc deținut încă. Caută mai jos și adaugă — sau bifează „Îl am și eu” în catalog.',
            'pf.ownedHint': 'Jocurile deținute rămân în profilul tău chiar dacă părăsești clubul. Poți adăuga jocuri pe care clubul nu le are încă — când cineva le adaugă în catalog, vei fi recunoscut automat ca deținător.',
            'pf.seeAll': 'Vezi toate ({n})',
            'pf.gameNotInClub': '„{game}” nu se află în catalogul clubului activ. Comută pe clubul în care e adăugat ca să-i vezi fișa.',
            'polls.byAuthor': 'de',
            'ev.createFromResult': 'Creează eveniment din rezultat',
            'ev.pollNotFound': 'Poll-ul nu a fost găsit.',
            'ev.noVotesToUse': 'Nu există un rezultat cu voturi din care să creez un eveniment.',
            'ev.prefilledFromPoll': 'Am pre-completat evenimentul din rezultatul votului. Verifică și salvează.',
            'ev.pickDateYourself': 'Nu am putut deduce data din opțiunea câștigătoare — alege-o tu, apoi salvează.',
            'ev.fromPollDesc': 'Creat din poll-ul „{q}”. Opțiunea câștigătoare: „{opt}” ({n} voturi).',
            'ev.fromGameVoteTitle': 'Sesiune: {game}',
            'ev.fromGameVoteDesc': 'Creat din votul de joc. Jocul câștigător: „{game}”.',
            'event.editTitle': 'Editează evenimentul',
            'sb.eventUpdated': 'Eveniment actualizat!',
            'sb.onlyEditOwnEvents': 'Poți edita doar evenimentele proprii (sau trebuie să fii admin).',
            'sb.confirmMute': 'Pui pe mute pe „{name}”?\n\nVa putea în continuare să vadă clubul, dar nu va mai putea face modificări. Acțiunea este reversibilă (îl poți scoate oricând de pe mute).',
            'ev.organizer': 'Organizator',
            'ev.when': 'Când',
            'ev.location': 'Locație',
            'ev.description': 'Descriere',
            'ev.noDescription': 'Fără descriere.',
            'ev.participants': 'Participanți',
            'ev.yourAnswer': 'Răspunsul tău',
            'ev.openDetails': 'Vezi detaliile evenimentului',
            /* v8 — capacitate de eveniment + listă de așteptare.
               RO: un spațiu fizic are un număr finit de locuri; fără limită
                   (cheia lipsă / gol) comportamentul rămâne cel dinainte de v8.
               EN: seat limit + waiting list; empty limit = pre-v8 behaviour. */
            'ev.seatLimit': 'Limită de locuri',
            'ev.seatLimitPh': 'Fără limită',
            'ev.seatLimitHint': 'Lasă gol pentru participare nelimitată.',
            'ev.seatsOf': '{n} / {max} locuri',
            'ev.joinWaitlist': 'Intră pe listă',
            'ev.confirmedTitle': 'Confirmați',
            'ev.waitlistTitle': 'Listă de așteptare',
            'ev.waitlistMine': 'Ești pe lista de așteptare — poziția {n}.',
            'ev.waitlistShort': 'Listă · #{n}',
            'ev.waitlistJoined': 'Ai intrat pe lista de așteptare.',
            'ev.checkingSeat': 'Se verifică locul…',
            'ev.promoted': 'S-a eliberat un loc — ai intrat!',
            'gv.closedFindIn': 'Vot închis. Îl găsești în „Închise".',
            'm1.bulkPlayersRemoved': '{n} jucători scoși din club.',
            'm1.bulkGamesDeleted': '{n} jocuri au fost șterse din catalog.',
            'cross.notEnoughData': 'Nu am date suficiente.',
            'cross.aggregatedFor': 'Date agregate pentru {name} din {n} cluburi.',
            'cross.perClub': 'Pe cluburi',
            'elo.enabledMsg': 'Mod competitiv (ELO) ACTIVAT pentru tot clubul!',
            'elo.disabledMsg': 'Mod competitiv (ELO) dezactivat.',
'auth.loginLink': 'Loghează-te',
            'session.tNamePh': 'Ex: Campionatul de Primăvară 2025',
            'session.locationExPh': 'Ex: Casa lui Alex, Cafeneaua Centrală',
            'session.pastLocations': 'Locații anterioare:',
            'players.addNew': 'Adaugă Jucător Nou',
            'players.namePh': 'Nume jucător',
            'players.emailPh': 'Email (opțional)',
            'players.emailPhReq': 'Email (obligatoriu)',
            'players.tagPh': '@user_tag (opțional)',
            'players.emailRequired': 'Emailul este obligatoriu pentru un jucător nou.',
            'players.emailInvalid': 'Email invalid.',
            'players.tagInvalid': 'user_tag invalid: 3-30 caractere, doar litere mici, cifre, „.” și „_”.',
            'players.tagTaken': 'user_tag deja folosit. Alege altul.',
            'players.adding': 'Se adaugă jucătorul...',
            /* RO: adresa apartine cuiva care e DEJA membru. Functia din baza de date nu
               creeaza si nu modifica nimic (dedublare pe email + `on conflict do nothing`),
               deci un mesaj de reusita ar minti. EN: the email already belongs to a member;
               nothing was created or changed. */
            'players.alreadyMember': '{name} este deja membru al clubului. Nu s-a adăugat nimic.',
            'players.searchLabel': 'Caută jucător',
            'players.addPlayer': 'Adaugă jucător',
            'players.tools': 'Unelte',
            'catalog.view': 'Mod de afișare',
            'catalog.viewExpanded': 'Extins',
            'catalog.viewCompact': 'Compact',
            'catalog.viewGrid': 'Grilă',
            'catalog.viewFullImage': 'Vezi imaginea completă',
            'catalog.ofTotal': 'din {n}',
            'players.showMore': 'Vezi mai mult',
            'players.showLess': 'Vezi mai puțin',
            'players.statGames': 'jocuri',
            'players.statWin': 'win',
            'players.statAvg': 'medie',
            'players.statPts': 'puncte',
            'players.searchPh': 'Caută după nume...',
            'players.bulkDelete': 'Ștergere în masă',
            'pstats.title': 'Statistici Jucători',
            'pstats.activePlayers': 'Jucători Activi',
            'pstats.newThisMonth': 'Noi Această Lună',
            'pstats.avgFrequency': 'Frecvență Medie',
            'pstats.participation': 'Participare',
            'pf.publicTitle': 'Profil public',
            'pf.publicIntro': 'Completează ce vrei să afle ceilalți. Fiecare câmp poate fi public sau privat.',
            'pf.public': 'Public',
            'pf.notPublic': 'Nu e public',
            'pf.visHint': 'Vizibil pe profilul tău public',
            'pf.experience': 'Nivel de experiență',
            'pf.experienceNote': '(calculat automat din XP-ul global)',
            'pf.age': 'Vârstă',
            'pf.gender': 'Gen',
            'pf.gameTypes': 'Tipuri de jocuri preferate',
            'pf.gameTypesChoose': 'Alege tipurile de joc',
            'pf.country': 'Țară',
            'pf.city': 'Oraș',
            'pf.cityPh': 'Selectează sau scrie orașul',
            'pf.location': 'Locație',
            'pf.status': 'Status',
            'pf.statusPh': 'Scrie statusul tău…',
            'pf.availability': 'Disponibilitate',
            'gender.male': 'Masculin',
            'gender.female': 'Feminin',
            'gender.other': 'Altul',
            'gender.na': 'Prefer să nu răspund',
            'pstatus.none': '— Niciunul —',
            'pstatus.seekingClub': 'Caut un club',
            'pstatus.seekingCofounders': 'Caut oameni să pornim un club',
            'pstatus.openInvites': 'Deschis la invitații la joc',
            'pstatus.custom': 'Personalizat…',
            'day.mon': 'Luni',
            'day.tue': 'Marți',
            'day.wed': 'Miercuri',
            'day.thu': 'Joi',
            'day.fri': 'Vineri',
            'day.sat': 'Sâmbătă',
            'day.sun': 'Duminică',
            'slot.morning': 'Dimineață',
            'slot.afternoon': 'După-amiază',
            'slot.evening': 'Seară',
            'exp.novice': 'Novice',
            'exp.intermediate': 'Intermediar',
            'exp.advanced': 'Avansat',
            'exp.expert': 'Expert',
            'country.other': 'Alta',
            'clubset.location': 'Locația clubului',
            'clubset.placePh': 'Locație exactă (opțional): adresă, local, etc.',
            'pf.about': 'Despre',
            'profile.emailHidden': 'Email ascuns',
            'friends.title': 'Prietenii mei',
            'friends.incoming': 'Cereri primite:',
            'friends.requests': 'Cereri de prietenie',
            'friends.noRequests': 'Nu ai cereri în așteptare.',
            'friends.none': 'Încă nu ai prieteni. Trimite o cerere din „Selectează jucători".',
            'friends.search': 'Caută prieteni',
            'friends.searchPh': 'Caută după nume sau @etichetă…',
            'friends.noMatch': 'Niciun prieten nu se potrivește cu căutarea.',
            'dm.someone': 'Cineva',
            'dm.msgNotFound': 'Mesajul original nu mai e încărcat.',
            'dm.you': 'Tu',
            'dm.quoteClub': 'Chatul clubului',   // v9 8.4-b: „Răspunde privat” la un mesaj din chatul clubului
            'dm.seen': 'Văzut',
            'dm.delivered': 'Livrat',
            'dm.received': 'Primit',
            'dm.send': 'Trimite mesaj',
            'dm.inputPh': 'Scrie un mesaj…',
            'dm.empty': 'Niciun mesaj încă. Scrie primul!',
            'dm.search': 'Caută în conversație',
            'dm.clear': 'Șterge conversația',
            'dm.clearConfirm': 'Ștergi conversația cu {name}? Mesajele dispar doar pentru tine; {name} le păstrează. Mesajele noi vor apărea din nou.',
            'dm.cleared': 'Conversația a fost ștearsă pentru tine.',
            'dm.muted': 'Nu mai primești notificări de la {name}.',
            'dm.unmuted': 'Primești din nou notificări de la {name}.',
            'dm.prefsErr': 'Nu s-a putut salva. Încearcă din nou.',
            'dm.demo': 'Indisponibil în modul demo.',
            'dm.sendErr': 'Mesajul nu a putut fi trimis.',
            'dm.policy': 'Cine îmi poate trimite mesaje',
            'dm.policyAll': 'Oricine',
            'dm.policyFriendsOpt': 'Doar prietenii',
            'dm.policyNoneOpt': 'Nimeni',
            'pres.setting': 'Cine vede când sunt online',
            'pres.all': 'Toți',
            'pres.none': 'Nimeni',
            'pres.hint': 'Cu „Nimeni” nu apari online și nici tu nu vezi când sunt alții online.',
            'pres.online': 'Online',
            'dm.policyNone': 'Nu acceptă mesaje',
            'dm.policyFriends': 'Doar prietenii pot scrie',
            'notif.friendReq': 'ți-a trimis o cerere de prietenie',
            'logout.confirm': 'Sigur vrei să te deconectezi?',
            'friends.remove': 'Șterge prieten',
            'friends.removeConfirm': 'Sigur vrei să elimini acest prieten?',
            'pf.availabilityToggle': 'Setează intervalele disponibile',
            'namehist.title': 'Istoric nume',
            'namehist.intro': 'Nume folosite anterior de acest utilizator:',
            'session.timerTitle': 'Cronometru sesiune',
            'notif.joinReq': 'cere acces la',
            'notif.newMember': '{name} s-a alăturat clubului 🎉',
            'report.title': 'Raportează',
            'report.action': 'Raportează',
            'report.intro': 'Spune-ne ce nu e în regulă. Raportul ajunge la echipa de moderare.',
            'report.submit': 'Trimite raportul',
            'report.sent': 'Raport trimis. Mulțumim — echipa de moderare îl va analiza.',
            'report.failed': 'Nu am putut trimite raportul. ',
            'report.pickReason': 'Alege un motiv pentru raport.',
            'report.customPh': 'Detalii (opțional)…',
            'report.dsaNote': 'Crezi că este conținut ilegal? Ne poți contacta și la {email}.',
            'report.loginRequired': 'Trebuie să fii autentificat ca să raportezi.',
            'report.demo': 'Raportarea nu este disponibilă în modul demo.',
            'report.reason.spam': 'Spam',
            'report.reason.harassment': 'Hărțuire sau abuz',
            'report.reason.sexual': 'Conținut sexual sau explicit',
            'report.reason.hate': 'Discurs instigator la ură',
            'report.reason.copyright': 'Încălcare drepturi de autor / conținut care nu-mi aparține',
            'report.reason.misinfo': 'Dezinformare',
            'report.reason.other': 'Altul',
            'mod.title': 'Moderare',
            'mod.none': 'Niciun raport în această categorie.',
            'mod.loadError': 'Nu am putut încărca rapoartele. ',
            'mod.filterOpen': 'Deschise',
            'mod.filterReviewing': 'În analiză',
            'mod.filterResolved': 'Rezolvate',
            'mod.filterDismissed': 'Respinse',
            'mod.filterAll': 'Toate',
            'mod.from': 'Raportat de {name}',
            'mod.targetUser': 'Utilizator',
            'mod.targetChat': 'Mesaj din chat',
            'mod.targetDm': 'Mesaj privat (DM)',
            'mod.targetPhoto': 'Poză de sesiune',
            'mod.view': 'Vezi',
            'mod.mute': 'Mute',
            'mod.ban': 'Exclude',
            'mod.markReviewing': 'În analiză',
            'mod.markResolved': 'Rezolvă',
            'mod.markDismissed': 'Respinge',
            'mod.statusUpdated': 'Status actualizat.',
            'mod.statusOpen': 'Deschis',
            'mod.statusReviewing': 'În analiză',
            'mod.statusResolved': 'Rezolvat',
            'mod.statusDismissed': 'Respins',
            'mod.ownerScope': 'Toate cluburile + DM-uri',
            'mod.dmNote': 'Conținutul DM se poate elimina doar de la nivelul platformei.',
            'mod.targetAnn': 'Anunț',
            'mod.viewFail': 'Anunțul nu a putut fi încărcat: ',
            'mod.annGone': 'Anunțul nu mai există — probabil a fost deja șters.',
            'mod.confirmDelAnn': 'Ștergi acest anunț? Pozele atașate se elimină odată cu el.',
            'mod.delAnn': 'Șterge anunțul',
            'mod.delMsg': 'Șterge mesajul',
            'mod.delDm': 'Șterge DM',
            'mod.managePhotos': 'Gestionează pozele',
            'mod.confirmDelMsg': 'Sigur ștergi acest mesaj din chat? Acțiunea e definitivă.',
            'mod.confirmDelDm': 'Sigur ștergi acest mesaj privat? Acțiunea e definitivă.',
            'mod.confirmDelPhoto': 'Sigur ștergi această poză? Acțiunea e definitivă.',
            'mod.takedownOk': 'Conținutul a fost eliminat.',
            'mod.takedownFail': 'Nu am putut elimina conținutul. ',
            'notif.newReport': 'Raport nou de moderare',
            'reauth.title': 'Confirmă identitatea',
            'reauth.message': 'Din motive de securitate, introdu parola contului ca să continui.',
            'reauth.placeholder': 'Parola contului',
            'reauth.confirm': 'Confirmă',
            'reauth.empty': 'Introdu parola.',
            'reauth.wrong': 'Parolă incorectă. Mai încearcă o dată.',
            'reauth.oauthHint': 'Te-ai conectat cu Google? Setează întâi o parolă în „Securitatea contului".',
            'reauth.changeAuth': 'Confirmă parola actuală pentru a schimba parola sau emailul.',
            'reauth.skipped': 'Schimbarea parolei/emailului a fost anulată. Restul modificărilor au fost salvate.',
            'reauth.actTransfer': 'Confirmă parola pentru a transfera proprietatea clubului.',
            'reauth.actClubClose': 'Confirmă parola pentru a închide clubul.',
            'reauth.actClubLeave': 'Confirmă parola pentru a părăsi clubul.',
            'reauth.actPlayerDelete': 'Confirmă parola pentru a scoate jucătorul din club.',
            'reauth.actBan': 'Confirmă parola pentru a exclude membrul din club.',
            'reauth.actUnban': 'Confirmă parola pentru a reactiva membrul în club.',
            'reauth.actBackupRestore': 'Confirmă parola pentru a restaura acest backup peste club.',
            'reauth.actClubReset': 'Confirmă parola pentru a reseta datele clubului.',
            'reauth.needPassword': 'Pentru această acțiune trebuie să ai o parolă setată. Mergi în Profil → Securitatea contului și setează o parolă mai întâi.',
            'reauth.otpSent': 'Ți-am trimis un cod pe email. Introdu-l ca să setezi parola.',
            'reauth.otpPrompt': 'Introdu codul primit pe email:',
            'reauth.otpPh': 'Cod din email',
            'reauth.otpSendFail': 'Nu am putut trimite codul pe email. ',
            'gdpr.exportBtn': 'Portare date personale',
            'gdpr.exportNote': 'Descarci toate datele tale personale (profil, abonament, prietenii, mesaje, sesiuni) într-o arhivă protejată cu parolă (PDF + Excel).',
            'gdpr.reauthExport': 'Confirmă parola pentru a-ți exporta datele personale.',
            'gdpr.preparing': 'Pregătesc arhiva cu datele tale…',
            'gdpr.libMissing': 'Componentele de export nu s-au încărcat. Reîncarcă pagina și încearcă din nou.',
            'gdpr.exportFail': 'Nu am putut genera exportul. ',
            'gdpr.pdfTitle': 'Export date personale',
            'gdpr.generatedOn': 'Generat la',
            'gdpr.secProfile': 'Profil',
            'gdpr.secSub': 'Abonament',
            'gdpr.secSessions': 'Sesiuni',
            'gdpr.secDms': 'Mesaje private',
            'gdpr.dmCount': 'Număr de mesaje',
            'gdpr.dmHidden': 'Conversații șterse doar pentru tine',
            'gdpr.dmMuted': 'Persoane de la care ai oprit notificările',
            'gdpr.blocked': 'Persoane blocate',
            'gdpr.clubNotif': 'Notificări pe club',
            'gdpr.chatPrefs': 'Preferințe de aspect ale chatului',
            'gdpr.emojiRecents': 'Emoji folosite recent',
            'gdpr.reactions': 'Reacțiile tale la mesaje',
            'cnotif.title': 'Notificări',
            'cnotif.all': 'Toate mesajele',
            'cnotif.mentions': 'Doar când mă menționează cineva',
            'cnotif.none': 'Fără notificări',
            'cnotif.saved': 'Notificările clubului: {level}',
            'cnotif.saveErr': 'Nu s-a putut salva. Verifică conexiunea.',
            'cnotif.unavailable': 'Setarea nu este disponibilă încă.',
            'cnotif.mentioned': 'te-a menționat',
            'typing.one': '{name} scrie…',
            'typing.two': '{a} și {b} scriu…',
            'typing.many': '{n} persoane scriu…',
            'typing.someone': 'Cineva',
            'cpref.title': 'Aspect',
            'cpref.scopeLbl': 'Se aplică la',
            'cpref.scopeAll': 'Toate conversațiile',
            'cpref.scopeClub': 'Doar acest club',
            'cpref.scopeDm': 'Doar această conversație',
            'cpref.preview': 'Previzualizare',
            'cpref.bubbles': 'Bulele mele',
            'cpref.bg': 'Fundal',
            'cpref.size': 'Mărimea textului',
            'cpref.default': 'Implicit',
            'cpref.reset': 'Revino la implicit',
            'cpref.save': 'Salvează',
            'cpref.saved': 'Aspect salvat',
            'cpref.saveErr': 'Nu am putut salva. Încearcă din nou.',
            'cpref.loadErr': 'Nu am putut deschide Aspect. Verifică internetul.',
            'cpref.reload': 'Există o versiune nouă a aplicației. Reîncarci acum?',
            // v9 8.3 — fișierele încărcate la cerere + biblioteca de emoji
            'lazy.reload': 'Există o versiune nouă a aplicației. Reîncarci acum?',
            'lazy.loadErr': 'Nu am putut încărca această parte a aplicației. Verifică internetul.',
            'emoji.title': 'Emoji',
            'emoji.search': 'Caută emoji',
            'emoji.keyboard': 'Tastatură',
            'emoji.del': 'Șterge',
            'emoji.tones': 'Alege nuanța pielii',
            'emoji.none': 'Niciun emoji găsit',
            'emoji.loading': 'Se încarcă…',
            'emoji.offline': 'Căutarea are nevoie de internet prima dată.',
            'emoji.games': 'Jocuri',
            'emoji.flagsCredit': 'Steaguri: Twemoji, licență CC-BY 4.0',
            'emoji.cat.recent': 'Recente',
            'emoji.cat.smileys': 'Fețe și emoții',
            'emoji.cat.people': 'Oameni',
            'emoji.cat.animals': 'Animale și natură',
            'emoji.cat.food': 'Mâncare și băutură',
            'emoji.cat.activities': 'Activități',
            'emoji.cat.travel': 'Călătorii și locuri',
            'emoji.cat.objects': 'Obiecte',
            'emoji.cat.symbols': 'Simboluri',
            'emoji.cat.flags': 'Steaguri',
            // v9 8.4 — reacțiile la mesaje
            'rx.title': 'Reacții',
            'rx.with': 'Reacționează cu {e}',
            'rx.more': 'Alt emoji',
            'rx.hover': 'Reacționează',
            'rx.pill': 'Reacții: {list}',
            'rx.tapRemove': 'atinge ca să retragi',
            'rx.rate': 'Prea multe reacții într-un minut. Încearcă puțin mai târziu.',
            'rx.notAllowed': 'Nu poți reacționa la acest mesaj.',
            'rx.deleted': 'Mesajul a fost șters.',
            'rx.err': 'Reacția nu s-a salvat. Verifică internetul și încearcă din nou.',
            'cpref.b.felt': 'Postav verde',
            'cpref.b.wood': 'Lemn',
            'cpref.b.ocean': 'Ocean',
            'cpref.b.berry': 'Mure',
            'cpref.b.ruby': 'Rubin',
            'cpref.b.slate': 'Ardezie',
            'cpref.b.teal': 'Turcoaz',
            'cpref.b.plum': 'Prună',
            'cpref.b.mint': 'Mentă',
            'cpref.b.sky': 'Cer',
            'cpref.b.sand': 'Nisip',
            'cpref.b.lilac': 'Liliac',
            'cpref.g.felt': 'Postav verde',
            'cpref.g.wood': 'Lemn',
            'cpref.g.dice': 'Zaruri',
            'cpref.g.meeple': 'Meeple',
            'cpref.g.hex': 'Hexagoane',
            'cpref.g.cards': 'Cărți de joc',
            'cpref.g.night': 'Noapte',
            'cpref.g.slate': 'Ardezie',
            'cpref.g.score': 'Foaie de scor',
            'cpref.g.parch': 'Pergament',
            'cpref.g.maple': 'Arțar',
            'cpref.g.mist': 'Ceață',
            'cpref.follow': 'Ca la toate conversațiile',
            'cpref.s.s': 'Mic',
            'cpref.s.m': 'Normal',
            'cpref.s.l': 'Mare',
            'cpref.s.xl': 'Foarte mare',
            'cpref.pv.day': 'Azi',
            'cpref.pv.other1': 'Cine vine diseară la o partidă?',
            'cpref.pv.other2': 'Pot aduce eu zarurile.',
            'cpref.pv.mine': 'Eu! Ajung la 8.',
            'cpref.pv.photo': 'Scorul de data trecută',
            'cpref.pv.link': 'Regulile:',
            'cpref.pv.deleted': 'Acest mesaj a fost șters',
            'cpref.pv.unsent': 'Am plecat spre voi!',
            'cpref.pv.fail': 'Nu s-a trimis — atinge ca să reîncerci',
            'gdpr.pwTitle': 'Parola arhivei',
            'gdpr.pwIntro': 'Arhiva e protejată cu parola de mai jos. O afișăm O SINGURĂ DATĂ — salveaz-o acum.',
            'gdpr.pwCopied': 'Parolă copiată.',
            'gdpr.pwWarn': 'Nu îți putem recupera această parolă. Dacă o pierzi, generează un export nou.',
            'gdpr.confirmDelete': 'Sigur ștergi datele tale personale? Contul va fi programat pentru ștergere în 30 de zile. Poți anula oricând în acest interval.',
            'gdpr.reauthDelete': 'Confirmă parola pentru a programa ștergerea datelor.',
            'gdpr.deleteScheduled': 'Ștergerea a fost programată. Datele tale vor fi șterse în 30 de zile. Poți anula oricând în acest interval.',
            'gdpr.deleteCanceled': 'Ștergerea a fost anulată. Contul tău rămâne activ.',
            'gdpr.deletePending': 'Cont programat pentru ștergere pe {date}. Poți anula până atunci.',
            'gdpr.cancelDelete': 'Anulează ștergerea',
            'gdpr.reqBtn': 'Transmite o solicitare',
            'gdpr.reqTitle': 'Solicitare privind datele',
            'gdpr.reqIntro': 'Pentru alte cereri GDPR (rectificare, acces, restricționare, opoziție). Solicitarea ajunge la operator.',
            'gdpr.reqCategory': 'Tip solicitare',
            'gdpr.reqPh': 'Descrie pe scurt ce soliciți…',
            'gdpr.reqReply': 'Îți vom răspunde la {email}.',
            'gdpr.reqSend': 'Trimite solicitarea',
            'gdpr.reqEmpty': 'Scrie un mesaj pentru solicitare.',
            'gdpr.reqSent': 'Solicitare trimisă. Operatorul o va analiza.',
            'gdpr.reqFail': 'Nu am putut trimite solicitarea. ',
            'gdpr.reqCat.rectification': 'Rectificare date eronate',
            'gdpr.reqCat.access': 'Acces la date',
            'gdpr.reqCat.restriction': 'Restricționarea prelucrării',
            'gdpr.reqCat.objection': 'Opoziție la prelucrare',
            'gdpr.reqCat.other': 'Altă solicitare',
            'modnotif.resolved': 'Raportul tău a fost analizat și rezolvat. Mulțumim că ne-ai semnalat.',
            'modnotif.dismissed': 'Ți-am analizat raportul, dar nu am identificat o încălcare a regulilor.',
            'modnotif.copyright': 'Raportul tău privind drepturile de autor a fost analizat și soluționat.',
            'notif.roleChanged': 'Rolul tău a fost schimbat în: {role}',
            'notif.newPrincipal': '{name} este noul administrator principal',
            'notif.joinApproved': 'Cererea ta de aderare a fost aprobată! 🎉',
            'notif.campaignNew': 'Campanie nouă: {name}',
            'notif.ruleUpdated': 'Regulamentul clubului a fost actualizat',
            'notif.eventCancelled': 'Eveniment anulat: {title}',
            'notif.subExpiring': 'Abonamentul tău expiră curând ({date}). Reactivează reînnoirea automată ca să nu pierzi accesul.',
            'notif.pollCancelled': 'Poll anulat: {q}',
            'notif.eventPrefix': 'Eveniment',
            'notif.joinReqToast': 'Cerere nouă de aderare la club',
            'rand.title': 'Randomizers & Sugestii',
            'rand.randomGameTitle': 'Random Joc din Catalog',
            'rand.randomGameIntro': 'Alege aleatoriu un joc din catalog bazat pe preferințe.',
            'rand.maxDuration': 'Durata maximă (min)',
            'rand.durationHint': 'Se compară cu durata reală medie la voi, dacă există; altfel cu cea de pe cutie.',
            'rand.durationInvalid': 'Durata maximă trebuie să fie cel puțin 1 minut.',
            'rand.pickRandom': 'Alege Joc Random',
            'rand.orderTitle': 'Ordine Random Jucători',
            'rand.orderIntro': 'Generează ordinea de joc aleatorie pentru sesiunea curentă.',
            'rand.method': 'Metoda de randomizare',
            'rand.simpleOpt': '🎲 Random simplu',
            'rand.balancedTeamsOpt': '👥 Pe echipe echilibrate',
            'rand.wheelOpt': '🎡 Roata norocului',
            'rand.genOrder': 'Generează Ordine',
            'rand.teamsTitle': 'Formează Echipe Random',
            'rand.teamsIntro': 'Perfect pentru jocuri în echipă sau cu număr limitat de jucători.',
            'rand.numTeams': 'Număr echipe',
            'rand.playersPerTeam': 'Jucători per echipă',
            'rand.genTeams': 'Generează Echipe',
            'hdr.myClubs': 'Cluburile mele',
            'hdr.switchClub': 'Comută clubul',
            'hdr.myProfile': 'Profilul meu',
            'hdr.settings': 'Setări',
            'settings.title': 'Setări',
            'settings.language': 'Limbă',
            'online.title': 'Membri online',
            'online.empty': 'Nimeni online acum.',
            'terms.title': 'Termeni și Condiții',
            'terms.h1': '1. Acceptarea termenilor',
            'terms.p1': 'Prin utilizarea acestei aplicații, sunteți de acord cu acești termeni și condiții.',
            'terms.h2': '2. Protecția datelor (GDPR)',
            'terms.p2': 'Conform Regulamentului General privind Protecția Datelor (GDPR), prelucrăm datele dumneavoastră personale în mod securizat și transparent.',
            'terms.li1': 'Datele sunt stocate local în browserul dumneavoastră',
            'terms.li2': 'Nu partajăm datele cu terțe părți',
            'terms.li3': 'Aveți dreptul de a solicita ștergerea datelor',
            'terms.li4': 'Datele sunt utilizate exclusiv pentru funcționalitățile clubului',
            'terms.h3': '3. Responsabilități utilizator',
            'terms.p3': 'Utilizatorul este responsabil pentru:',
            'terms.li5': 'Securitatea contului și a parolei',
            'terms.li6': 'Conținutul adăugat în aplicație',
            'terms.li7': 'Respectarea celorlalți membri',
            'terms.h4': '4. Limitarea răspunderii',
            'terms.p4': 'Aplicația este furnizată "așa cum este", fără garanții de niciun fel.',
            'terms.h5': '5. Modificări',
            'terms.p5': 'Ne rezervăm dreptul de a modifica acești termeni. Utilizarea continuă constituie acceptarea modificărilor.',
            'catalog.noFitForN': 'Niciun joc din catalog nu se potrivește pentru {n} jucători. Adaugă jocuri în catalog sau încearcă alt număr.',
            'ann.title': 'Anunțuri',
            'ann.new': 'Anunț nou',
            'ann.newPrompt': 'Scrie anunțul pentru club:',
            'ann.bodyPh': 'Mesajul anunțului…',
            'ann.replyPh': 'Scrie un răspuns…',
            'ann.replyBtn': 'Trimite',
            'ann.viewAll': 'Vezi toate anunțurile',
            'ann.hideAll': 'Ascunde anunțurile',
            'ann.viewReplies': 'Vezi răspunsuri',
            'ann.hideReplies': 'Ascunde răspunsurile',
            'ann.empty': 'Niciun anunț încă.',
            'ann.empty2': 'Anunțul nu poate fi gol.',
            'ann.noRight': 'Nu ai dreptul să postezi anunțuri.',
            'ann.posted': 'Anunț publicat.',
            'ann.editTitle': 'Editează anunțul',
            'ann.updated': 'Anunț actualizat.',
            'ann.saveErr': 'Eroare la salvare: ',
            'ann.delErr': 'Eroare la ștergere: ',
            'ann.delConfirm': 'Ștergi acest anunț?',
            'ann.delReplyConfirm': 'Ștergi acest răspuns?',
            'ann.titleLabel': 'Titlu (opțional)',
            'ann.titlePh': 'Ex: Anulare întâlnire',
            'ann.bodyLabel': 'Mesaj',
            'ann.photosLabel': 'Poze (opțional)',
            'ann.addPhotos': 'Adaugă poze',
            'ann.publish': 'Publică',
            'ann.publishing': 'Se publică…',
            'ann.photoUploadErr': 'Pozele nu au putut fi urcate; anunțul a fost publicat fără ele.',
            'notif.announcement': 'Anunț nou: {text}',
            'space.title': 'Spațiu fizic',
            'space.intro': 'Dacă găzduiești seri de board games, alți jucători te pot descoperi.',
            'space.question': 'Dispui de un spațiu fizic pentru seri de board games?',
            'space.capacity': 'Câți jucători poate primi',
            'space.capacityPh': 'Ex: 8',
            'space.address': 'Adresă',
            'space.addressPh': 'Stradă, oraș…',
            'space.addressNote': 'Adresa e dată sensibilă — vizibilă strict conform alegerii tale de mai jos.',
            'space.visSpaceLabel': 'Cine vede că ai spațiu',
            'space.visAddressLabel': 'Cine vede adresa',
            'space.visPublic': 'Public (toată lumea)',
            'space.visClubs': 'În cluburile mele',
            'space.visFriends': 'Doar prieteni',
            'space.visNone': 'Nu afișa',
            'space.hasSpace': 'Are spațiu fizic',
            'space.upTo': 'până la {n} jucători',
            'space.sectionTitle': 'Spațiu de joc',
            'geo.searching': 'Se caută…',
            'geo.noResults': 'Niciun oraș găsit.',
            'geo.unavailable': 'Căutarea nu e disponibilă acum.',
            'leave.menu': 'Părăsește clubul',
            'leave.confirm': 'Sigur vrei să părăsești clubul „{name}"? Vei pierde accesul la datele lui.',
            'leave.done': 'Ai părăsit clubul „{name}".',
            'leave.errorColon': 'Eroare la părăsire: ',
            'leave.ownerMustTransfer': 'Ești Admin Principal — transferă mai întâi proprietatea, apoi poți părăsi clubul.',
            'notif.memberLeft': '{name} a părăsit clubul.',
            'owners.title': 'Cine deține jocul',
            'owners.addedBy': 'Adăugat de {name}',
            'owners.none': 'Nimeni nu a marcat încă faptul că deține jocul.',
            'owners.iHaveItToo': 'Îl am și eu',
            'owners.iHaveIt': 'Îl am',
            'owners.errColon': 'Eroare: ',
            // ===== Turnee (modul management de turnee) =====
            'tourn.title': 'Turnee',
            'tourn.navTitle': 'Turnee',
            'tourn.intro': 'Creează și administrează turnee complete: înscrieri, bracket, runde și clasament live.',
            'tourn.public.title': 'Pagină publică',
            'tourn.public.makePublic': 'Fă public',
            'tourn.public.makePrivate': 'Fă privat',
            'tourn.public.hint': 'Oricine are acest link poate vedea bracket-ul, clasamentul și campionul — fără cont. Făcându-l privat, linkul devine inactiv.',
            'tourn.public.hintOff': 'Generează un link public read-only (bracket, clasament, campion). Îl poți revoca oricând.',
            'tourn.public.enabled': 'Link public creat.',
            'tourn.public.disabled': 'Link public revocat.',
            'tourn.public.copied': 'Link copiat.',
            'tourn.public.confirmPrivate': 'Faci acest turneu privat? Linkul public nu va mai funcționa.',
            'tourn.viewProfile': 'Vezi profilul',
            'tourn.new': 'Turneu nou',
            'tourn.search': 'Caută',
            'tourn.export': 'Exportă',
            'tourn.searchPh': 'Caută turnee…',
            'tourn.searchNone': 'Niciun turneu nu corespunde căutării.',
            'tourn.exportEmpty': 'Nimic de exportat.',
            'tourn.status': 'Status',
            'tourn.edit': 'Editează turneul',
            'tourn.deleted': 'Turneu șters.',
            'tourn.confirmDelete': 'Ștergi acest turneu? Acțiunea e ireversibilă.',
            'tourn.err.ONLY_DRAFT_DELETABLE': 'Doar turneele în ciornă (draft) pot fi șterse.',
            'tourn.none': 'Niciun turneu încă.',
            'tourn.loading': 'Se încarcă turneele…',
            'tourn.participants': 'Participanți',
            'tourn.deadline': 'Termen înscriere',
            'tourn.fee': 'Taxă de participare',
            'tourn.prizes': 'Premii',
            'tourn.join': 'Înscrie-mă',
            'tourn.leave': 'Retrage-mă',
            'tourn.waitlisted': 'Ești pe lista de așteptare',
            'tourn.joined': 'Te-ai înscris cu succes!',
            'tourn.left': 'Te-ai retras din turneu.',
            'tourn.promoted': 'Ai fost promovat de pe lista de așteptare!',
            'tourn.created': 'Turneu creat.',
            'tourn.updated': 'Turneu actualizat.',
            'tourn.statusChanged': 'Statusul turneului a fost schimbat.',
            'tourn.bracketGenerated': 'Bracket generat.',
            // format
            'tourn.format.round_robin': 'Round Robin',
            'tourn.format.single_elim': 'Eliminare directă',
            'tourn.format.swiss': 'Sistem elvețian',
            'tourn.format.tables': 'Mese multiplayer',
            // status
            'tourn.status.draft': 'Ciornă',
            'tourn.status.registration': 'Înscrieri deschise',
            'tourn.status.live': 'În desfășurare',
            'tourn.status.completed': 'Finalizat',
            'tourn.status.archived': 'Arhivat',
            // hint în formularul de sesiune (legătura quick-log ↔ turneu complet)
            'tourn.hint.quick': 'Notezi rapid un rezultat? Rămâi aici.',
            'tourn.hint.full': 'Vrei înscrieri și bracket?',
            'tourn.hint.link': 'Deschide Turnee',
            // formular creare
            'tourn.f.name': 'Nume',
            'tourn.f.namePh': 'Ex: Cupa de Primăvară 2026',
            'tourn.f.game': 'Joc',
            'tourn.f.pickGame': 'alege un joc',
            'tourn.f.addGame': 'Adaugă joc',
            'tourn.f.noGames': 'Niciun joc găsit. Folosește + pentru a adăuga.',
            'tourn.f.addGameHint': 'Adaugă jocul din Catalogul de Jocuri, apoi caută-l aici.',
            'tourn.f.format': 'Format',
            'tourn.f.seats': 'Jucători per masă',
            'tourn.f.seatsHint': 'Setează mărimea mesei după jocul tău (2 = 1v1 clasic).',
            'tourn.f.topx': 'Câți avansează per masă',
            'tourn.f.topxPh': 'Ex: 2',
            'tourn.f.legs': 'Câte tururi contra fiecărui adversar',
            'tourn.f.legs1': 'Simplu (o dată)',
            'tourn.f.legs2': 'Dublu (tur-retur)',
            'tourn.f.minP': 'Minim participanți',
            'tourn.f.maxP': 'Maxim participanți',
            'tourn.f.unlimited': 'nelimitat',
            'tourn.f.waitlist': 'Activează lista de așteptare când e plin',
            'tourn.f.prizesPh': 'Ex: Trofeu + joc nou',
            'tourn.f.finalPts': 'Acordă Puncte de Club după clasamentul final',
            'tourn.f.finalPtsHint': 'Implicit oprit — sesiunile per rundă acordă deja puncte.',
            'tourn.f.finalPrizes': 'Premii în puncte per loc final (1, 2, 3 …)',
            'tourn.f.finalPrizesHint': 'Separate prin virgulă. Locurile din afara listei primesc 0.',
            // pagina de turneu
            'tourn.you': 'tu',
            'tourn.noParticipants': 'Niciun participant încă.',
            'tourn.waitlist': 'Listă de așteptare',
            'tourn.bracketSoon': 'Bracket și rezultate — în curând.',
            'tourn.act.openReg': 'Deschide înscrierile',
            'tourn.act.backDraft': 'Înapoi la ciornă',
            'tourn.act.start': 'Pornește turneul',
            'tourn.act.finish': 'Finalizează',
            'tourn.act.reopen': 'Redeschide',
            'tourn.finalized': 'Turneu finalizat.',
            'tourn.reopened': 'Turneu redeschis.',
            'tourn.finalizeTitle': 'Finalizează turneul',
            'tourn.champion': 'Campion',
            'tourn.noWinner': 'Fără câștigător',
            'tourn.tieForFirst': 'Egalitate pe locul 1 — alege campionul conform regulamentului jocului',
            'tourn.finalizeWarnPending': 'Unele mese nu sunt raportate încă. Vor conta ca 0 puncte.',
            'tourn.awardFinalPoints': 'Acordă bonusul final de Puncte de Club (după clasamentul final)',
            'tourn.bonusAdminOnly': 'Bonusul final de puncte poate fi acordat doar de un administrator.',
            'tourn.reopenConfirm': 'Redeschizi acest turneu? Bonusul final de puncte (dacă există) va fi anulat.',
            'tourn.bracket': 'Bracket',
            'tourn.genBracket': 'Generează bracket',
            'tourn.regenBracket': 'Regenerează bracket',
            'tourn.noBracket': 'Niciun bracket generat încă.',
            'tourn.confirmRegen': 'Aceasta va înlocui bracket-ul existent. Continui?',
            'tourn.round': 'Runda',
            'tourn.leg.first': 'tur',
            'tourn.leg.second': 'retur',
            'tourn.table': 'Masa',
            'tourn.bye': 'liber',
            'tourn.reportResult': 'Introdu rezultat',
            'tourn.editResult': 'Editează rezultat',
            'tourn.reportHint': 'Setează locul fiecărui jucător. Scorul e opțional.',
            'tourn.reportHint2': 'Introdu scorul fiecărui jucător. Egalitățile se departajează mai jos, conform regulamentului jocului.',
            'tourn.reported': 'Rezultat salvat.',
            'tourn.place': 'Loc',
            'tourn.score': 'Scor',
            'tourn.scoreMode': 'Tip de punctare a sesiunii',
            'tourn.mode.uniform': 'Uniformizat (Puncte de Club după plasament)',
            'tourn.mode.raw': 'După scor',
            'tourn.mode.hint': 'Uniformizat: Punctele de Club se acordă după plasament, conform șablonului din Admin.',
            'tourn.tstatus.pending': 'în așteptare',
            'tourn.tstatus.live': 'în joc',
            'tourn.tstatus.reported': 'raportat',
            'tourn.tstatus.confirmed': 'confirmat',
            'tourn.standings': 'Clasament',
            'tourn.stats.title': 'Turnee',
            'tourn.stats.played': 'Jucate',
            'tourn.stats.won': 'Câștigate',
            'tourn.stats.podium': 'Podiumuri',
            'tourn.noResults': 'Niciun rezultat încă.',
            'tourn.stand.points': 'Puncte turneu',
            'tourn.stand.raw': 'Scor brut',
            'tourn.stand.rank': 'Loc',
            'tourn.stand.player': 'Jucător',
            'tourn.stand.pts': 'Pct',
            'tourn.stand.wins': 'V',
            'tourn.stand.played': 'Mese',
            'tourn.stand.tie': 'egalitate',
            'tourn.err.formatNoAutogen': 'Acest format se generează rundă cu rundă.',
            // erori (mapate din codurile RPC)
            'tourn.err.generic': 'A apărut o eroare. Încearcă din nou.',
            'tourn.err.pairingInvalid': 'Structura generată e invalidă (un jucător apare de două ori într-o rundă). Regenerează.',
            'tourn.err.NOT_AUTHENTICATED': 'Trebuie să fii autentificat.',
            'tourn.err.FORBIDDEN': 'Nu ai permisiunea necesară (minim Moderator).',
            'tourn.err.PLAN_REQUIRED': 'Turneele sunt disponibile din planul Elite.',
            'tourn.err.CLUB_NOT_WRITABLE': 'Clubul nu permite momentan modificări.',
            'tourn.err.CLUB_NOT_FOUND': 'Clubul nu a fost găsit.',
            'tourn.err.NAME_REQUIRED': 'Numele turneului e obligatoriu.',
            'tourn.err.BAD_FORMAT': 'Format de turneu invalid.',
            'tourn.err.BAD_GAME': 'Jocul selectat nu e valid pentru acest club.',
            'tourn.err.LOCKED_AFTER_START': 'Turneul nu mai poate fi editat după start.',
            'tourn.err.BAD_STATUS': 'Status invalid.',
            'tourn.err.BAD_TRANSITION': 'Tranziție de status nepermisă.',
            'tourn.err.GAME_REQUIRED': 'Alege un joc înainte de a deschide înscrierile.',
            'tourn.err.BAD_ADVANCE_CONFIG': 'Configurație invalidă: câți avansează per masă.',
            'tourn.err.NOT_ENOUGH_PARTICIPANTS': 'Nu sunt destui participanți pentru a începe.',
            'tourn.err.TOURNAMENT_NOT_FOUND': 'Turneul nu a fost găsit.',
            'tourn.err.NOT_MEMBER': 'Trebuie să fii membru al clubului.',
            'tourn.err.BANNED': 'Ai fost exclus din acest club.',
            'tourn.err.REGISTRATION_CLOSED': 'Înscrierile nu sunt deschise.',
            'tourn.err.DEADLINE_PASSED': 'Termenul de înscriere a trecut.',
            'tourn.err.TOURNAMENT_FULL': 'Turneul e complet.',
            'tourn.err.NOT_REGISTERED': 'Nu ești înscris în acest turneu.',
            'tourn.err.BAD_STATE_FOR_PAIRING': 'Bracketul se poate genera doar la înscrieri sau în desfășurare.',
            'tourn.err.EMPTY_PAIRING': 'Structura de generare e goală.',
            'tourn.err.NO_ACTIVE_PARTICIPANTS': 'Nu există participanți activi.',
            'tourn.err.PLAYER_NOT_PARTICIPANT': 'Un jucător din structură nu e participant înscris.',
            'tourn.err.TABLE_NOT_FOUND': 'Masa nu a fost găsită.',
            'tourn.err.TOURNAMENT_NOT_LIVE': 'Turneul nu e în desfășurare.',
            'tourn.err.EMPTY_RESULTS': 'Nu ai introdus niciun rezultat.',
            'tourn.err.NO_PLAYERS_AT_TABLE': 'Masa nu are jucători.',
            'tourn.err.BAD_SEAT_RESULT': 'Locuri invalide (fiecare jucător are nevoie de un loc valid).',
            'tourn.err.PLAYER_NOT_AT_TABLE': 'Un jucător raportat nu e la această masă.',
            'tourn.nextRound': 'Generează runda următoare',
            'tourn.elimNextRound': 'Runda următoare generată.',
            'tourn.elimReadyFinal': 'Runda finală s-a jucat — gata de finalizare.',
            'tourn.swissNextRound': 'Runda următoare generată.',
            'tourn.swissReadyFinal': 'Toate rundele s-au jucat — gata de finalizare.',
            'tourn.noShow': 'Absent',
            'tourn.noShowHint': 'Jucătorul nu s-a prezentat',
            'tourn.walkoverHint': 'A rămas un singur jucător — masa se câștigă prin walkover (fără sesiune de joc).',
            'tourn.walkoverNone': 'Niciun jucător rămas la această masă.',
            'tourn.f.rounds': 'Număr de runde',
            'tourn.f.series': 'Contează pentru seria anuală',
            'tourn.f.seriesHint': 'Clasamentul final contribuie la ierarhia anuală de campion de club.',
            'tourn.series.title': 'Campion de club (anual)',
            'tourn.series.viewSeries': 'Puncte de serie',
            'tourn.notif.registration': 'Înscrieri deschise: {name}',
            'tourn.notif.live': 'Turneu început: {name}',
            'tourn.notif.round': 'Rundă nouă gata: {name}',
            'tourn.notif.finalized': '{name} — campion: {champion}',
            'tourn.abbr.played': 'J',
            'tourn.abbr.won': 'C',
            'tourn.abbr.podium': '🏅',
            'tourn.series.year': 'An',
            'tourn.series.player': 'Jucător',
            'tourn.series.points': 'Puncte',
            'tourn.series.empty': 'Niciun turneu de serie finalizat anul acesta.',
            'tourn.series.editScale': 'Editează scala',
            'tourn.series.scaleLabel': 'Puncte pe loc:',
            'tourn.series.scaleInput': 'Puncte pe loc (1°, 2°, 3° …)',
            'tourn.series.scaleHint': 'Separate prin virgulă. Locurile dincolo de listă primesc 0.',
            'tourn.series.scaleBad': 'Introdu cel puțin un număr.',
            'tourn.series.scaleSaved': 'Scală salvată.',
            'tourn.f.roundsHint': 'Toți joacă acest număr de runde; împerecherile urmează clasamentul.',
            'tourn.f.seeding': 'Împerechere în prima rundă',
            'tourn.f.seedRandom': 'Aleatoriu (amestecă)',
            'tourn.f.seedSeed': 'După seed (1 vs ultimul, …)',
            'tourn.err.ROUND_NOT_COMPLETE': 'Nu toate mesele rundei curente sunt raportate.',
            'tourn.err.NO_ADVANCERS': 'Nu există jucători care avansează.',
            'tourn.err.BAD_FORMAT_FOR_ADVANCE': 'Avansarea e disponibilă doar la eliminare directă.',
            'tourn.err.NO_ROUNDS': 'Nu există runde generate.',
            'tourn.err.WINNER_NOT_PARTICIPANT': 'Câștigătorul ales nu e participant la turneu.',
            'tourn.err.FINAL_POINTS_NEEDS_ADMIN': 'Bonusul final de puncte poate fi acordat doar de un administrator.',
            'tourn.err.FINAL_POINTS_BAD_TARGET': 'Bonusul final vizează un jucător care nu e participant.',
            'tourn.err.BAD_STATUS_TRANSITION': 'Tranziție de status invalidă.',
        },
        en: {
            'lang.name': 'English',
            'lang.other': 'RO',
            'copy.done': 'Copied!',
            'core.loadErrorDemo': 'Error loading data. Using demo data.',
            'core.setNewPass': 'Set a new password below.',
            'core.demoOn': 'Demo mode enabled! Data resets on exit.',
            'core.enterEmail': 'Enter your email!',
            'core.sendingReset': 'Sending reset link...',
            'core.errorColon': 'Error: ',
            'core.resetSentMaybe': 'If the address exists, you will receive a password reset email.',
            'core.resetLinkExpired': 'The reset link is no longer active. Request a new one from "Forgot password" and open it immediately.',
            'core.resetOpenLinkSuffix': ' (open the reset link from your email).',
            'core.passUpdated': 'Password updated successfully! You can now log in.',
            'core.loggedOut': 'You have been logged out!',
            'core.noGamesForVote': 'No suitable games for the vote. Add games or change the count.',
            'core.appInstalled': 'App installed!',
            'core.installHint': 'To install, use the browser menu → "Add to Home Screen".',
            'm1.onlyAdminScoresheet': 'Only admins can edit scoresheets.',
            'm1.selectGameFirst': 'Select a game first.',
            'm1.saveErrorColon': 'Save error: ',
            'm1.scoresheetSaved': 'Scoresheet saved for "{game}".',
            'm1.onlyAdminRoles': 'Only admins can edit roles.',
            'm1.rolesSaved': 'Roles saved for "{game}".',
            'm1.timerStopped': 'Timer stopped. Session length: {mins} min.',
            'm1.enterGuestName': 'Enter the guest name!',
            'm1.guestEmailRequired': 'Guest email is required (prevents duplicate profiles).',
            'm1.guestEmailInvalid': 'Enter a valid guest email.',
            'm1.guestEmailAskTitle': 'Guest email',
            'm1.guestEmailAskMsg': 'The email for "{name}" is not on this device (it is never shared through the live session, to keep it private). Please enter it again so the session can be saved.',
            'm1.guestEmailDupSession': 'A guest with this email is already in the session.',
            'm1.guestEmailIsMember': 'This email belongs to a club member — add them as a member, not a guest.',
            'sb.emptySession': 'A session must have at least one player.',
            'm1.guestAlready': 'Guest already added!',
            'm1.guestAdded': 'Guest {name} added!',
            'm1.guestRemoved': 'Guest {name} removed!',
            'm1.enterPlayerName': 'Enter the player name!',
            'm1.playerExists': 'Player already exists!',
            'm1.playerAdded': 'Player {name} added!',
            'm1.onlyAdminEditPlayers': 'Only admins can edit players!',
            'm1.invalidScore': 'Invalid score!',
            'm1.playerEdited': 'Player {name} edited!',
            'm1.playerDeleted': 'Player {name} deleted!',
            'm1.noPlayersExport': 'No players to export!',
            'm1.playersExported': 'Players exported successfully!',
            'm1.noPlayersEntered': 'You did not enter any players!',
            'm1.importDone': 'Import done! {added} players added ({skipped} already existed/error).',
            'm1.onlyAdminBulkDelete': 'Only admins can bulk delete!',
            'm1.noPlayersDelete': 'No players to delete!',
            'm1.noPlayerSelected': 'No player selected!',
            'm1.gameRemovedFromList': 'Game "{game}" removed from your list!',
            'm1.fillNamePlayers': 'Fill in the name and number of players!',
            'm1.gameInCatalog': 'Game already in catalog!',
            'm1.gameAddedCatalog': 'Game {name} added to catalog!',
            'm1.bggInvalid': 'Invalid BGG username or private collection.',
            'm1.collectionEmpty': 'Collection is empty or could not be read.',
            'm1.catalogExported': 'Catalog exported successfully!',
            'm1.invalidRating': 'Invalid rating! (1–10)',
            'm1.invalidWeight': 'Invalid weight! (1–5)',
            'm1.onlyAdminDeleteGames': 'Only admins can delete games!',
            'm1.gameDeleted': 'Game {name} deleted!',
            'm1.catalogEmpty': 'The catalog is empty!',
            'm1.noGameSelected': 'No game selected!',
            'm1.editMore': 'Do you want to edit more details?',
            'm1.confirmDeletePlayer': 'Are you sure you want to delete player {name}? This action is permanent!',
            'm1.confirmBulkRemovePlayers': 'Are you sure you want to remove {n} players from the club?\n\nProfiles and accounts remain; only club membership is removed.',
            'm1.confirmDeleteGame': 'Are you sure you want to delete game {game} from the catalog?',
            'm1.confirmBulkDeleteGames': 'Are you sure you want to delete {n} games from the catalog?',
            'm2.noGamesCriteria': 'No games match the criteria!',
            'm2.gameNotInCatalog': 'Game {game} is not in the catalog!',
            'm2.gameSet': 'Game set: {game}.',
            'm2.orderCopied': 'Order copied to clipboard!',
            'm2.teamsCopied': 'Teams copied to clipboard!',
            'm2.copyError': 'Copy error!',
            'm2.enterPollQuestion': 'Enter the poll question!',
            'm2.atLeast2Options': 'Add at least 2 options!',
            'm2.duplicateOptions': 'Options must be different from each other — "{opt}" appears twice.',
            'm2.pollCreated': 'Poll created successfully!',
            'm2.pollMissing': 'Poll not found',
            'm2.pollNotFound': 'Poll not found!',
            'm2.pollInactive': 'Poll is not active!',
            'm2.pollExpired': 'Poll has expired!',
            'm2.optionNotFound': 'Option not found!',
            'm2.voteWithdrawn': 'Vote withdrawn!',
            'm2.alreadyVotedSingle': 'You already voted and multiple votes are not allowed!',
            'm2.voteRecorded': 'Vote recorded!',
            'm2.onlyAdminCreatorClose': 'Only admins or the poll creator can close it!',
            'm2.pollClosed': 'Poll closed!',
            'm2.noClosedPolls': 'No closed polls!',
            'm2.editErrorColon': 'Edit error: ',
            'm2.deleteErrorColon': 'Delete error: ',
            'm2.deletingChat': 'Deleting chat...',
            'm2.chatDeleteErrorColon': 'Error deleting chat: ',
            'm2.chatDeleted': 'Chat fully deleted!',
            'm2.fillTitleDateTime': 'Fill in the title, date and time!',
            'm2.eventCreated': 'Event created!',
            'm2.noEventsExport': 'No events to export!',
            'm2.calendarExported': 'Calendar exported ({count} events)! Import the .ics file into Google/Apple/Outlook Calendar.',
            'm2.confirmClosePoll': 'Close the poll "{q}"?',
            'm2.confirmDeleteAllChat': 'Are you sure you want to delete ALL chat messages?\n\nThis action is permanent and applies to all members.',
            'm3.nameCampaign': 'Name the campaign.',
            'm3.campaignSaved': 'Campaign saved.',
            'm3.nameScenario': 'Name the scenario.',
            'm3.scenarioAdded': 'Scenario added.',
            'm3.campaignDeleted': 'Campaign deleted.',
            'm3.allowPopups': 'Allow pop-ups to print!',
            'm3.openingPrint': 'Opening the print dialog...',
            'm3.printRegError': 'Error printing the regulation!',
            'm3.regExportedPdf': 'Regulation exported to PDF!',
            'm3.pdfGenError': 'Error generating the PDF!',
            'm3.onlyAdminEditReg': 'Only admins can edit the regulation!',
            'm3.fillTitleContent': 'Fill in the article title and content!',
            'm3.articleExists': 'Article {num} already exists!',
            'm3.articleAdded': 'New article added to the regulation!',
            'm3.regReset': 'Regulation reset to the original version!',
            'm3.contentEmpty': 'Content cannot be empty!',
            'm3.articleUpdated': 'Article updated!',
            'm3.adminAccessOn': 'Admin access enabled!',
            'm3.notAdmin': 'Your account does not have an admin role!',
            'm3.adminAccessOff': 'Admin access disabled!',
            'm3.userMadeAdmin': 'User made admin!',
            'm3.userDemoted': 'User demoted!',
            'm3.cantDeleteSelf': 'You cannot delete yourself!',
            'm3.userDeleted': 'User deleted!',
            'm3.scoreUpdatedFor': 'Score updated for {name}!',
            'm3.restoreImporting': 'Importing data into the database…',
            'm3.restoreImportError': 'Import error: ',
            'm3.games': 'Games',
            'm3.sessions': 'Sessions',
            'm3.restoreDone': 'Backup restored. Reloading…',
            'm3.backupExported': 'Backup exported successfully!',
            'm3.onlyAdminRestore': 'Only admins can restore backups!',
            'm3.restoreLoggedOut': 'The restore logged out the current user.',
            'm3.restoreError': 'Error restoring the backup! The file may be corrupt.',
            'm3.noBackupHistory': 'No backup history!',
            /* Club backup — creation, history, download (club_backups table) */
            'bkp.historyTitle': 'Backup history',
            'bkp.retentionNote': 'The last 10 manual backups are kept, plus automatic ones from the past 7 days and 4 weeks. Visible to club admins only.',
            'bkp.colDate': 'Date',
            'bkp.colKind': 'Type',
            'bkp.colBy': 'Created by',
            'bkp.kindManual': 'Manual',
            'bkp.kindAuto': 'Automatic',
            'bkp.bySystem': 'System',
            'bkp.download': 'Download',
            'bkp.lastCheck': 'checked automatically: {date}',
            'bkp.coverageNote': 'The backup contains all of the club data held in the database. Session photos are NOT included as files — but they are not lost either: they stay in storage, and restoring reconnects them automatically.',
            'bkp.restore': 'Restore',
            'bkp.fileInvalid': 'The file does not look like a TurnOrder club backup.',
            'bkp.fileOtherClub': 'This backup belongs to the club “{from}” and cannot be restored into “{to}”.',
            'bkp.restoreWarn': 'You are about to restore the backup from {date} over the club “{club}”.\n\nWhat happens: the backup data is written over the current data, row by row. Nothing is deleted — anything added after that backup stays. A copy of the current state is created automatically so you can go back.\n\nWhat is NOT recovered: user accounts deleted in the meantime (their sessions and points remain, but show as “Deleted profile”), the subscription and payment data.\n\nContinue?',
            'bkp.restoring': 'Restoring… do not close this window.',
            'bkp.restoreDone': 'Restore complete: {n} rows written. The pre-restore copy has id {snap}.',
            'bkp.restoreSkipped': '{n} rows skipped (accounts no longer exist).',
            'bkp.restoreNulled': '{n} references cleared (deleted accounts).',
            'bkp.creating': 'Creating the club backup…',
            'bkp.created': 'Backup created and downloaded.',
            'bkp.unchanged': 'Nothing changed since the last backup — downloaded the existing copy.',
            'bkp.noClub': 'Select a club before backing up.',
            'bkp.error': 'Backup failed: {msg}',
            'm3.onlyAdminSeasons': 'Only admins can manage seasons!',
            'm3.archivingSeason': 'Archiving the season...',
            'm3.newSeasonDone': 'New season! The leaderboard was archived, points reset. ELO and history remain untouched.',
            'm3.onlyAdminPeriod': 'Only admins can adjust the period!',
            'm3.periodSaveError': 'Error saving the period.',
            'm3.periodSet': 'Period set: month {m}, {y}',
            'm3.onlyAdminLabel': 'Only admins can set the season label!',
            'm3.labelSaveError': 'Error saving the label.',
            'm3.onlyAdminArchiveDel': 'Only admins can delete from the archive!',
            'm3.seasonDeletedArchive': 'Season deleted from the archive.',
            'm3.onlyAdminSeasonReport': 'Only admins can export season reports!',
            'm3.seasonReportPdf': 'Season report exported to PDF!',
            'm3.onlyAdminThisReset': 'Only admins can perform this reset!',
            'm3.sessionsErrorColon': 'Sessions error: ',
            'm3.eventsErrorColon': 'Events error: ',
            'm3.chatErrorColon': 'Chat error: ',
            'm3.resetErrorColon': 'Reset error: ',
            'm3.noHistoryExport': 'No history to export!',
            'm3.historyExported': 'History exported successfully!',
            'm3.historyPdf': 'History exported to PDF!',
            'm3.sessionNotFound': 'Session not found!',
            'm3.sessionGone': 'Session no longer exists!',
            'm3.sessionUpdated': 'Session updated!',
            'm3.onlyAdminDeleteSessions': 'Only admins can delete sessions!',
            'm3.sessionDeleted': 'Session deleted!',
            'm3.saveDataError': 'Error saving data!',
            'm3.confirmDeleteScenario': 'Delete this scenario?',
            'm3.confirmDeleteCampaign': 'Delete campaign "{name}" and all its scenarios?',
            'm3.confirmResetReg': 'Are you sure you want to reset the regulation to the original version? All changes will be lost!',
            'm3.confirmDeleteUser': 'Are you sure you want to delete user {email}?',
            'm3.confirmRestore': 'You are about to restore an older backup (classic format). The data in the file is written over the current data, row by row — nothing is deleted, and anything added after that backup stays. Only the game catalog, sessions, regulation and seasons are covered. Continue?',
            'm3.confirmNewSeason': 'Start a new season?\n\nThe current leaderboard and points are ARCHIVED, then points reset to 0.\nSession history and ELO remain UNTOUCHED.',
            'm3.confirmDeleteSeasonArchive': 'Delete this season from the archive?\n\nThis action is permanent.',
            'm3.confirmSureIrreversible': 'ARE YOU SURE? This action is permanent and irreversible!',
            'm3.confirmDeleteSession': 'Are you sure you want to delete this session?',
            'sb.switchingClub': 'Switching club…',
            'sb.activeClubColon': 'Active club: ',
            'sb.creatingClub': 'Creating club…',
            'sb.createClubErrorColon': 'Error creating club: ',
            'sb.unknown': 'unknown',
            'sb.thisMember': 'this member',
            'sb.clubCreatedNotAdminColon': 'Club created, but we could not add you as admin: ',
            'sb.clubCreatedColon': 'Club created: ',
            'sb.errorColon': 'Error: ',
            'sb.clubStatusNoChanges': 'Club "{name}" is {status} — changes are not allowed.',
            'sb.viewOnlyMuted': 'You are in view-only (muted) mode in this club. You can see everything, but cannot make changes until an admin unmutes you.',
            'sb.onlyAdminsThis': 'Only admins can do this.',
            'sb.cantApplySelf': 'You cannot apply this action to yourself.',
            'sb.muteErrorColon': 'Mute error: ',
            'sb.unmuteErrorColon': 'Unmute error: ',
            'sb.banErrorColon': 'Ban error: ',
            'sb.unbanErrorColon': 'Unban error: ',
            'sb.memberExcluded': '{name} has been removed from the club.',
            'sb.unbannedCanRejoin': '{name} has been unbanned and can request to rejoin the club.',
            'sb.bannedFromClub': 'You have been banned from this club and cannot rejoin.',
            'sb.onlyPrincipalClose': 'Only the principal admin can close the club.',
            'sb.cantCloseOnlyClub': 'You cannot close your only club. Create another one first.',
            'sb.closeErrorColon': 'Close error: ',
            'sb.clubClosed': 'Club "{name}" was closed (archived).',
            'sb.onlyPrincipalReopen': 'Only the principal admin can reopen the club.',
            'sb.clubAlreadyActive': 'The club is already active.',
            'sb.reopenErrorColon': 'Reopen error: ',
            'sb.clubReopened': 'Club "{name}" was reactivated.',
            'sb.joinErrorColon': 'Could not join: ',
            'sb.joinedClub': 'You joined the club!',
            'sb.requestErrorColon': 'Could not send the request: ',
            'sb.onlyAdminsClubSettings': 'Only admins can change club settings.',
            'sb.clubNameEmpty': 'The club name cannot be empty.',
            'sb.rlsRejected': 'The save was rejected by the database (RLS permissions on "clubs"): the row was not updated.',
            'sb.clubSettingsSaved': 'Club settings have been saved.',
            'sb.onlyAdminsRequests': 'Only admins can view requests.',
            'sb.approveErrorColon': 'Approval error: ',
            'sb.requestApproved': 'Request approved — member added.',
            'sb.requestRejected': 'Request rejected.',
            'sb.onlyAdminsInvites': 'Only admins can create invites.',
            'sb.inviteCreateErrorColon': 'Error creating the invite: ',
            'sb.linkCopied': 'Link copied!',
            'sb.inviteInvalid': 'Invalid or expired invite.',
            'sb.clubFull': 'This club has reached its member limit. Ask an admin to upgrade, then try again — your link stays valid.',
            'pact.success': 'Welcome! Your profile has been activated in ',
            'pact.alreadyLinked': 'Your profile was already linked to this account in ',
            'pact.error': 'We could not activate your profile right now. Please try again in a moment.',
            'pact.fail.invalid': 'This activation link is no longer valid.',
            'pact.fail.used': 'This activation link has already been used.',
            'pact.fail.expired': 'This activation link has expired. Ask a club admin for a new one.',
            'pact.fail.revoked': 'This activation link was cancelled by a club admin.',
            'pact.fail.already_activated': 'This profile is already linked to an account.',
            'pact.fail.already_member': "You're already a member of this club with your current account, so there's nothing left to activate.",
            'pact.fail.not_authenticated': 'You need to be signed in to activate your profile.',
            'pact.admin.noAccount': 'No account',
            'pact.admin.noAccountTip': "This player hasn't created an account yet. Send them an activation link so they can claim their profile, history included.",
            'pact.admin.linkSent': 'Link sent',
            'pact.admin.expiresOn': 'Valid until',
            'pact.admin.sendLink': 'Send activation link',
            'pact.admin.newLink': 'Generate a new link (cancels the old one)',
            'pact.admin.revoke': 'Cancel the activation link',
            'pact.admin.confirmRevoke': 'Cancel the activation link for {name}? The link you already sent will stop working.',
            'pact.admin.revoked': 'The activation link has been cancelled.',
            'pact.admin.modalTitle': 'Activation link for',
            'pact.admin.modalNote': 'Send this link ONLY to that person. It works once, and links their existing profile — history included — to a new account. They may use any email address they like. Not the same as a club invite: that one adds a brand new member, with no history.',
            'pact.admin.alreadyActivated': 'This player already has an account, so no activation is needed.',
            'pact.admin.notMember': 'This player is not an active member of this club.',
            'pact.admin.rateLimit': 'Too many links have been generated in this club today. Please try tomorrow.',
            'pact.admin.hasAccount': '{name} already has a TurnOrder account. They cannot be added directly — they need to accept an invite. Send them the link below.',
            'pact.admin.error': 'We could not do that right now. Please try again in a moment.',
            'audit.paIssue': 'Activation link generated',
            'audit.paRevoke': 'Activation link cancelled',
            'audit.paRedeem': 'Profile activated',
            'sb.joinedViaInvite': 'You joined the club via invite!',
            'players.clubFullAdd': 'This club has reached its member limit. Upgrade the plan to add more players.',
            'sb.inviteErrorColon': 'Invite error: ',
            'sb.unavailableDemo': 'Unavailable in demo.',
            'sb.friendRequestSent': 'Friend request sent!',
            'sb.friendNoAccount': "This person doesn't have an account yet, so they can't receive friend requests.",
            'sb.friendsNeedSql': 'For friends, run "turnorder_friends.sql". ({msg})',
            'sb.nowFriends': 'You are now friends!',
            'sb.friendRemoved': 'Friendship removed.',
            'sb.eventNotFoundDot': 'Event not found.',
            'sb.onlyDeleteOwnEvents': 'You can only delete your own events (or as admin).',
            'sb.eventDeleted': 'Event deleted!',
            'sb.nothingToShare': 'Nothing to share.',
            'sb.generatingImage': 'Generating the image…',
            'sb.imageBusy': 'The image is already being generated — a few more seconds.',
            'sb.imageGenError': 'Error generating the image.',
            'sb.imageDownloaded': 'The image was downloaded — you can send it on WhatsApp.',
            'sb.imageGenFail': 'Could not generate the image.',
            'sb.copiedPasteWhatsApp': 'Copied! Paste into WhatsApp.',
            'sb.chooseImageFile': 'Choose an image file.',
            'sb.unavailableDemoMode': 'Unavailable in demo mode.',
            'sb.accountDeactivated': 'Account deactivated. You can log back in within 30 days to reactivate it.',
            'sb.deleteNeedSql': 'For scheduled deletion, run "turnorder_account.sql". You have been logged out anyway.',
            'sb.accountScheduledDelete': 'This account was scheduled for deletion. Contact an administrator if you still need the data.',
            'sb.accountReactivated': 'Account reactivated. Welcome back!',
            'sb.onlyAdminsCompetitive': 'Only admins can change competitive mode!',
            'sb.settingSaveErrorSql': 'Error saving the setting: {msg} (did you run the SQL script?)',
            'sb.voteSaveErrorSql': 'Error saving the vote: {msg} (did you run the SQL script?)',
            'sb.catalogEmptyAddFirst': 'The catalog is empty — add games first.',
            'sb.voteStarted': 'Vote started! All members can vote now.',
            'sb.gameAlreadyInList': 'The game is already in the list.',
            'sb.addAtLeastOneGame': 'Add at least one game to the list.',
            'sb.invalidFileColon': 'Invalid file or unexpected format: ',
            'sb.nothingNewImport': 'Nothing new to import (everything already exists).',
            'sb.demoImportNoSave': 'In demo mode the import is not saved to Supabase.',
            'sb.importingGS': 'Importing {g} games and {s} sessions...',
            'sb.importCatalogErrorColon': 'Catalog import error: ',
            'sb.importSessionsErrorColon': 'Sessions import error: ',
            'sb.importDoneGS': 'Import done: {g} games, {s} sessions added.',
            'sb.bggLinkInvalid': 'Invalid BGG link. E.g.: https://boardgamegeek.com/boardgame/169786/scythe',
            'sb.playerNotFoundDot': 'Player not found.',
            'sb.nameEmpty': 'The name cannot be empty.',
            'sb.newPassMismatch': 'The new passwords do not match.',
            'sb.demoNoSaveChanges': 'In demo mode, changes are not saved.',
            'sb.userTagColon': 'User Tag: ',
            'sb.nameAvatarSavedSql': 'Name and avatar were saved. For the rest of the fields, run the "profile_fields.sql" script.',
            'sb.emailColon': 'Email: ',
            'sb.emailChangeLinks': 'We sent confirmation links to the OLD and the NEW address. Confirm both to change the email.',
            'sb.passwordColon': 'Password: ',
            'sb.passwordChanged': 'The password has been changed.',
            'sb.movingHistory': 'Moving history to the new name...',
            'sb.profileUpdated': 'Profile updated!',
            'sb.historyMoved': 'History moved to "{name}": {m} sessions and {e} events updated.',
            'sb.welcomeName': 'Welcome, {name}!',
            'sb.fillAllFields': 'Fill in all fields!',
            'sb.weakPassword': 'The password is not strong enough: at least 8 characters, an uppercase letter, a lowercase letter, a digit and a special character.',
            'sb.passMismatch': 'The passwords do not match!',
            'sb.acceptTerms': 'You must accept the terms and conditions!',
            'sb.consentSaveError': 'We couldn\'t save your consent. Please try again.',
            'sb.creatingAccount': 'Creating the account...',
            'sb.registerErrorColon': 'Registration error: ',
            'sb.accountCreatedWelcome': 'Account created successfully! Welcome, {name}!',
            'sb.accountCreatedVerify': 'Account created! Check your email to confirm.',
            'sb.unknownAddress': 'Unknown address. Restart the registration.',
            'sb.connUnavailable': 'Connection unavailable. Try again.',
            'sb.resendErrorColon': 'Could not resend: ',
            'sb.confirmResent': 'Confirmation email resent. Check your inbox (and Spam).',
            'sb.resendError': 'Resend error.',
            'sb.redirectGoogle': 'Redirecting to Google...',
            'sb.googleErrorColon': 'Google error: ',
            'sb.googleConnError': 'Error connecting with Google.',
            'sb.loggedOut': 'You have been logged out!',
            'sb.demoModeData': 'Demo mode with sample data!',
            'sb.sendMsgErrorColon': 'Error sending the message: ',
            'sb.fillDateGame': 'Fill in the date and the game!',
            'sb.addParticipant': 'Add at least one participant!',
            'sb.savingSession': 'Saving the session...',
            'sb.saveSessionErrorColon': 'Error saving the session: ',
            'sb.sessionSavedRecordedBySql': 'Session saved. For "recorded by", run the "matches_recorded_by.sql" script.',
            'sb.sessionSaved': 'Session saved successfully!',
            'sb.saveChangesErrorColon': 'Error saving the changes: ',
            'sb.gameUpdated': 'Game {name} updated!',
            'sb.addGameErrorColon': 'Error adding the game: ',
            'sb.removeFromClubErrorColon': 'Error removing from the club: ',
            'sb.userMadeAdminClub': 'User made admin in this club!',
            'sb.userDemotedClub': 'User demoted in this club!',
            'sb.profileDeleted': 'Profile deleted! (The auth account is deleted separately from the Supabase panel.)',
            'sb.createEventErrorColon': 'Error creating the event: ',
            'sb.eventNotFoundExcl': 'Event not found!',
            'sb.updateErrorColon': 'Update error: ',
            'sb.supabaseLoadError': 'Could not load the Supabase library. Check your internet connection.',
            'sb.confirmBan': 'Ban "{name}" from the club?\n\nThey will be removed from the club immediately and cannot rejoin until an admin unbans them. Their historical data remains.',
            'sb.confirmCloseClub': 'Close club "{name}"?\n\nData is NOT deleted — the club becomes archived (read-only) and can be reopened later.',
            'sb.confirmDeleteEvent': 'Delete event "{title}"?\n\nThis action is permanent.',
            'sb.confirmReactivate': 'Your account is scheduled for deletion (~{days} days left).\n\nDo you want to REACTIVATE it now?',
            'sb.confirmCloseVote': 'Close the current vote? The result moves to history.',
            'sb.confirmRemovePlayerClub': 'Remove player {name} from this club?\n\nThe person\'s profile and account remain; only membership in the current club is removed.',
            'sb.confirmDeleteProfile': 'Are you sure you want to delete profile {email}?',
            'audit.logout': 'Logout',
            'audit.playerAdded': 'Player added',
            'audit.playerEdited': 'Player edited',
            'audit.playerDeleted': 'Player deleted',
            'audit.exportPlayersCsv': 'Players CSV export',
            'audit.importPlayers': 'Players import',
            'audit.bulkRemovePlayers': 'Bulk player removal',
            'audit.gameRemovedFromList': 'Game removed from list',
            'audit.gameAddedCatalog': 'Game added to catalog',
            'audit.importBggCollection': 'BGG collection import',
            'audit.exportCatalogJson': 'Catalog JSON export',
            'audit.gameDeletedCatalog': 'Game deleted from catalog',
            'audit.bulkDeleteGames': 'Bulk game deletion',
            'audit.randomGameSelected': 'Random game selected',
            'audit.playerOrderRandomized': 'Player order randomized',
            'audit.teamsGenerated': 'Teams generated',
            'audit.pollCreated': 'Poll created',
            'audit.pollEdited': 'Poll edited',
            'audit.pollDeleted': 'Poll deleted',
            'audit.pollVote': 'Poll vote',
            'audit.pollVoteWithdrawn': 'Poll vote withdrawn',
            'audit.pollClosed': 'Poll closed',
            'audit.chatMessageSent': 'Chat message sent',
            'audit.chatCleared': 'Chat cleared',
            'audit.eventCreated': 'Event created',
            'audit.eventUpdated': 'Event updated',
            'audit.exportCalendarIcs': 'Calendar export (.ics)',
            'audit.printRegulation': 'Regulation printed',
            'audit.exportRegulationPdf': 'Regulation PDF export',
            'audit.regulationArticleAdded': 'New regulation article added',
            'audit.regulationReset': 'Regulation reset to original',
            'audit.regulationEdited': 'Regulation edited',
            'audit.adminLogin': 'Admin login',
            'audit.adminStatusChanged': 'Admin status changed',
            'audit.userDeleted': 'User deleted',
            'audit.playerScoreManual': 'Player score manually changed',
            'audit.fullBackupExported': 'Full backup exported',
            'auditd.backupRestoredDetail': 'backup #{id}, {n} rows',
            'audit.backupRestored': 'Backup restored',
            'audit.newSeasonStarted': 'New season started',
            'audit.seasonReportPdf': 'Season PDF report',
            'audit.clubDataReset': 'Club data reset',
            'audit.exportHistoryCsv': 'History CSV export',
            'audit.exportHistoryPdf': 'History PDF export',
            'audit.sessionEdited': 'Session edited',
            'audit.sessionDeleted': 'Session deleted',
            'audit.autoSave': 'Auto-save',
            'audit.memberMuted': 'Member muted',
            'audit.memberUnmuted': 'Member unmuted',
            'audit.memberBanned': 'Member banned',
            'audit.memberUnbanned': 'Member unbanned',
            'audit.eventDeleted': 'Event deleted',
            'audit.competitiveModeElo': 'ELO competitive mode',
            'audit.scoringConfig': 'Score uniformization config',
            'audit.gameVoteStarted': '"What to play" vote started',
            'audit.gameVoteClosed': '"What to play" vote closed',
            'audit.importData': 'Data import',
            'audit.userRenamed': 'User renamed',
            'audit.sessionSaved': 'Session saved',
            'audit.gameEditedCatalog': 'Game edited in catalog',
            'audit.clubRoleChanged': 'Club role changed',
            'audit.roleChangedInClub': 'Role changed in club',
            'audit.userProfileDeleted': 'User profile deleted',
            'audit.scoreManual': 'Score manually changed',
            'audit.playerRemovedFromClub': 'Player removed from club',
            'auditd.gamesAddedByUser': '{user}: +{n} games',
            'auditd.gamesCount': '{n} games',
            'auditd.allChatDeleted': 'all messages deleted from Supabase',
            'auditd.roleVerifiedDb': 'Role verified from the database',
            'auditd.activated': 'activated',
            'auditd.deactivated': 'deactivated',
            'auditd.importGS': '{g} games, {s} sessions',
            'auditd.renameDetails': '"{old}" → "{new}" · {m} sessions, {e} events',
            'auditd.sessionParticipants': '{game} - {n} participants',
            'auditd.playerScoreArrow': '{name}: score → {score}',
            'auditd.roleArrowSecondary': '{name} → Secondary Admin',
            'auditd.roleArrowMember': '{name} → Member',
            'auditd.roleArrow': '{name} → {role}',
            'auditd.roleSecondaryAdmin': 'secondary admin',
            'auditd.roleMember': 'member',
            'cm.title': 'Please confirm',
            'cm.confirm': 'Confirm',
            'cm.cancel': 'Cancel',
            'cm.input': 'Enter a value',
            'cm.ok': 'OK',
            'cm3.title': 'Unsaved changes',
            'cm3.message': 'You have unsaved changes. What would you like to do?',
            'cm3.save': 'Save',
            'cm3.discard': "Don't save",
            'cm3.stay': 'Stay',
            'm1.newScorePrompt': 'New score for {name}:',
            'sb.confirmDeleteAccount1': '⚠️ WARNING 1 of 2\n\nDo you want to delete your account?\n\nThe account will be DEACTIVATED immediately, and after 30 days your individual data will be PERMANENTLY deleted.',
            'sb.confirmDeleteAccount2': '⚠️ WARNING 2 of 2 — final confirmation\n\nWithin 30 days you can log back in to reactivate the account. After that, deletion is irreversible.\n\nDo you confirm deactivating the account now?',
            'demo.descCatan': 'A classic game of building and trading on Catan island.',
            'demo.descAzul': 'An abstract tile-laying game inspired by Portuguese azulejo art.',
            'demo.descGloomhaven': 'A cooperative tactical RPG with an epic campaign and a legacy system.',
            'demo.descTtr': 'A game of building a railway network across North America.',
            'demo.chat1': 'Hi! Who wants to play Catan tomorrow?',
            'demo.chat2': 'I\'m available after 7:00 PM!',
            'demo.chat3': 'I also brought the Catan expansion!',
            'demo.pollQuestion': 'What game do we want to play on Friday?',
            'demo.eventTitle': 'Catan Tournament Session',
            'demo.eventDesc': 'Catan tournament with prizes!',
            'demo.eventLocation': 'Central Café',
            'demo.achFirstWin': '🏆 First Win',
            'demo.ach10Games': '🎮 10 Games',
            'demo.ach50Points': '💯 50 Points',
            'demo.achHatTrick': '🔥 Hat Trick',

            /* ---- NEW NAVIGATION (nav.js, Stage 1a) ---- */
            'nav2.search': 'Search',
            'nav2.side.collapse': 'Collapse menu',
            'nav2.side.expand': 'Expand menu',
            'nav2.pending': 'pending',
            'nav2.r.joinReq': 'Join requests',
            'nav2.s.joinReq': 'Approve or reject new members',
            'nav2.d.memberOne': '1 member',
            'nav2.d.memberFew': '{n} members',
            'nav2.d.memberMany': '{n} members',
            'nav2.d.requestOne': '1 request',
            'nav2.d.requestFew': '{n} requests',
            'nav2.d.requestMany': '{n} requests',
            'nav2.d.unreadOne': '1 unread message',
            'nav2.d.unreadFew': '{n} unread messages',
            'nav2.d.unreadMany': '{n} unread messages',
            'nav2.d.openPollOne': '1 open vote',
            'nav2.d.openPollFew': '{n} open votes',
            'nav2.d.openPollMany': '{n} open votes',
            'nav2.d.noPoll': 'no open votes',
            'nav2.d.gameOne': '1 game',
            'nav2.d.gameFew': '{n} games',
            'nav2.d.gameMany': '{n} games',
            'nav2.d.articleOne': '1 article',
            'nav2.d.articleFew': '{n} articles',
            'nav2.d.articleMany': '{n} articles',
            'nav2.d.sessionOne': '1 session',
            'nav2.d.sessionFew': '{n} sessions',
            'nav2.d.sessionMany': '{n} sessions',
            'nav2.d.activeCampaignOne': '1 active campaign',
            'nav2.d.activeCampaignFew': '{n} active campaigns',
            'nav2.d.activeCampaignMany': '{n} active campaigns',
            'nav2.d.onlineOne': '1 member online',
            'nav2.d.onlineFew': '{n} members online',
            'nav2.d.onlineMany': '{n} members online',
            'nav2.d.today': 'today',
            'nav2.d.yesterday': 'yesterday',
            'nav2.d.daysAgo': '{n} days ago',
            'nav2.d.lastMsg': 'last message {when}',
            'nav2.d.lastOne': 'last one {when}',
            'nav2.d.updated': 'updated {when}',
            'nav2.d.planNow': '{p} plan',
            'nav2.q.placeholder': 'Search this club…',
            'nav2.q.nav': 'Sections',
            'nav2.q.members': 'Members',
            'nav2.q.games': 'Games',
            'nav2.q.sessions': 'Sessions',
            'nav2.q.events': 'Events',
            'nav2.q.hint': 'Type at least 2 letters.',
            'nav2.q.empty': 'No results for “{q}”.',
            'nav2.q.more': '+{n} more',
            'nav2.home': 'Home',
            'nav2.club': 'Club',
            'nav2.agenda': 'Agenda',
            'nav2.more': 'More',
            'nav2.profile': 'Profile',
            'nav2.hub.club': 'Club',
            'nav2.hub.more': 'More',
            'nav2.hub.profile': 'Profile',
            'nav2.g.people': 'People',
            'nav2.g.library': 'Library',
            'nav2.g.record': 'Track record',
            'nav2.g.admin': 'Administration',
            'nav2.g.community': 'Community',
            'nav2.g.competition': 'Competition',
            'nav2.g.tools': 'Tools',
            'nav2.g.account': 'Account',
            'nav2.g.presence': 'Presence',
            'nav2.g.app': 'App',
            'nav2.r.clubSettings': 'Club settings',
            'nav2.r.moderation': 'Moderation',
            'nav2.r.ownerPanel': 'Owner panel',
            'nav2.r.discoverClubs': 'Discover clubs',
            'nav2.r.discoverPlayers': 'Discover players',
            'nav2.r.myStats': 'My stats',
            'nav2.r.plans': 'Plans',
            'nav2.s.players': 'Members, roles and requests',
            'nav2.s.chat': 'The club conversation',
            'nav2.s.polls': 'Votes and polls',
            'nav2.s.catalog': 'The club\u2019s games',
            'nav2.s.regulation': 'Internal rules',
            'nav2.s.stats': 'Rankings and trends',
            'nav2.s.history': 'Sessions played',
            'nav2.s.admin': 'Club management',
            'nav2.s.clubSettings': 'Name, plan and options',
            'nav2.s.moderation': 'Reports and sanctions',
            'nav2.s.ownerPanel': 'Platform administration',
            'nav2.s.discoverClubs': 'Find new clubs',
            'nav2.s.discoverPlayers': 'Find players',
            'nav2.s.tournaments': 'Staged competitions',
            'nav2.s.campaigns': 'Campaigns and legacy',
            'nav2.s.randomizers': 'Order, teams, games',
            'nav2.s.myProfile': 'Your details and preferences',
            'nav2.s.myStats': 'Your results across all clubs',
            'nav2.s.online': 'Who is active right now',
            'nav2.s.settings': 'Language, notifications, account',
            'nav2.s.plans': 'The club subscription',
            'nav2.s.feedback': 'Tell us what is not working',
            'nav2.s.logout': 'Sign out of your account',
            'nav2.create.title': 'What do you want to create?',
            'nav2.create.session': 'New session',
            'nav2.newSession.confirm': 'You have a session in progress. Discard it and start a new one?',
            'nav2.create.event': 'New event',
            'nav2.create.poll': 'New vote',
            'nav2.create.ann': 'New announcement',
            'nav2.create.open': 'Create',
            'nav2.create.close': 'Close',
            'nav2.create.none': 'You have no create permissions in this club.',
            'nav2.empty': 'Nothing available here.',
            'nav.dashboard': 'Dashboard',
            'nav.session': 'Session',
            'nav.players': 'Players',
            'nav.catalog': 'Catalog',
            'nav.randomizers': 'Randomizers',
            'nav.history': 'History',
            'nav.campaigns': 'Campaigns',
            'nav.polls': 'Polls',
            'nav.chat': 'Chat',
            'nav.calendar': 'Calendar',
            'nav.stats': 'Statistics',
            'nav.regulation': 'Rulebook',
            'nav.admin': 'Admin',
            'nav.profile': 'My profile',
            'nav.logout': 'Logout',
            'nav.memberSince': 'Member since {date}',   /* {date} = month + year, interpolated in nav.js */

            'login.title': 'Sign in',
            'login.email': 'Email / User Tag',
            'login.emailPh': 'example@email.com or @usertag',
            'login.emailOnlyPh': 'example@email.com',
            'login.password': 'Password',
            'login.passwordPh': 'Enter your password',
            'login.forgot': 'Forgot password?',
            'login.remember': 'Remember me & keep me signed in',
            'login.rememberHint': 'Stay signed in even after fully closing the browser, on this device.',
            'login.signin': 'Sign in',
            'login.register': 'Sign up',
            'login.demo': 'Quick Demo',
            'login.or': 'or',
            'login.google': 'Continue with Google',
            'login.fillFields': 'Enter your Email / User Tag and password!',
            'login.connecting': 'Signing in...',
            'login.failed': 'Wrong email/password, or email not confirmed.',
            'login.captchaFailed': 'Security check failed. Please try again.',
            'login.captchaPending': 'Tick the security checkbox below, then press Sign in again.',
            'login.captchaChecking': 'Running the security check... you will be signed in shortly.',
            'login.tagNotFound': 'No account found with that User Tag.',
            'login.showPw': 'Show password',
            'login.hidePw': 'Hide password',
            'welcome.title': 'Welcome to TurnOrder',
            'welcome.subtitle': 'Your account is ready. Let\'s get your club rolling!',
            'welcome.createClubTitle': 'Create a club',
            'welcome.createClubDesc': 'Start your own club, invite members and begin logging sessions.',
            'welcome.discoverTitle': 'Discover',
            'welcome.discoverDesc': 'Find public clubs and other players to connect with.',
            'welcome.btnCreateClub': 'Create a club',
            'welcome.btnDiscover': 'Discover',
            'welcome.btnLater': 'Later',
            'welcome.btnProfile': 'Complete your profile',

            'register.title': 'Create New Account',
            'register.fullname': 'Full name',
            'register.fullnamePh': 'Your name in the club',
            'register.email': 'Email',
            'register.password': 'Password',
            'register.passwordPh': 'At least 8 characters',
            'register.confirm': 'Confirm password',
            'register.confirmPh': 'Re-enter password',
            'register.termsPre': 'I agree to the',
            'register.termsLink': 'Terms & Conditions',
            'register.submit': 'Sign up',
            'register.back': 'Back',
            'register.age16': 'I am over 16',
            'register.consentError': 'Please check the age and consent boxes to continue.',
            'consent.title': 'One quick step',
            'consent.intro': 'Before you continue, please confirm:',
            'consent.accept': 'Accept and continue',
            'consent.cancel': 'Cancel',
            // ===== Legal (footer, checkbox, documente, istoric) =====
            'footer.about': 'About TurnOrder',
            'footer.aboutUrl': 'https://turnorder.org/',
            'footer.terms': 'Terms of Service',
            'footer.privacy': 'Privacy Policy',
            'footer.cookies': 'Cookie Policy',
            'footer.rights': '© TurnOrder. All rights reserved.',
            'cookieNotice.text': 'TurnOrder uses only essential cookies, necessary for it to work.',
            'cookieNotice.link': 'Cookie Policy',
            'register.termsAnd': 'and',
            'register.privacyLink': 'Privacy Policy',
            'legal.effective': 'Effective date',
            'legal.history': 'Update history',
            'legal.initialVersion': 'Initial version',
            'legal.current': 'current',
            'legal.viewThis': 'View this version',
            'legal.historyHint': 'No previous versions yet.',
            'legal.terms.body': `<p>TurnOrder (the "Platform", the "Service", the "app") is a software-as-a-service (SaaS) progressive web application (PWA) for organizing board game clubs, operated by <strong>[DENUMIRE_COMPANIE]</strong>, with its registered office at [ADRESA_SEDIU], registered with the Trade Register under no. [NR_REG_COM], Tax ID [CUI] (the "Company", "we").</p>
<p>Please read these Terms carefully before using the Platform.</p>
<h3>1. Acceptance of Terms</h3>
<p>By creating an account, accessing or using the Platform, you confirm that you have read, understood and agree to be bound by these Terms of Service, as well as our Privacy Policy and Cookie Policy, which form an integral part of this agreement. If you do not agree, please do not use the Platform.</p>
<h3>2. Definitions</h3>
<ul>
<li><strong>Club</strong> — an isolated workspace within the Platform dedicated to a board game community (sessions, players, scores, leaderboards, calendar, chat, etc.).</li>
<li><strong>Principal Admin</strong> — the user who holds an active subscription and is the legal owner of a Club, with full administration and ownership-transfer rights.</li>
<li><strong>Secondary Admin</strong> — a user designated by the Principal Admin with extended administration rights, but no right to transfer Club ownership.</li>
<li><strong>Moderator</strong> — a user with limited rights to moderate content and members.</li>
<li><strong>Member</strong> — a user participating in a Club without administration rights.</li>
<li><strong>Guest</strong> — a person added to a Club by an administrator (typically by name and/or email), without their own account, whose gameplay data may later be merged with a real account.</li>
<li><strong>User-Generated Content (UGC)</strong> — any content uploaded by users: session photos, avatars, messages, names, descriptions, scores, reviews.</li>
</ul>
<h3>3. Eligibility</h3>
<p>You must be at least <strong>16 years old</strong> to create an account and use the Platform. Persons under 16 may not create an account or access or use the Platform, regardless of any consent from a legal guardian. By creating an account, you confirm that you are at least 16 years old. Accounts found to belong to persons under this age will be closed and the associated data deleted in accordance with the Privacy Policy.</p>
<h3>4. User Accounts</h3>
<p>To access certain features you must create an account. You agree to:
- provide accurate and current information (including a display name and a unique public "user tag");
- maintain the confidentiality of your credentials;
- be responsible for all activity under your account.</p>
<p>The Company reserves the right to suspend or terminate your account for any violation of these Terms.</p>
<h3>5. Club Structure, Roles and Data Ownership</h3>
<p>The Platform is multi-tenant: a user may own or participate in multiple Clubs, and Clubs are isolated from one another.</p>
<p><strong>The fundamental data ownership distinction:</strong>
- <strong>Club data</strong> (sessions, scores, leaderboards, catalog, calendar, club content) <strong>belongs to the Club as an entity, NOT to the individual user who entered it.</strong> When a member leaves, or upon transfer or Claim of the Club, this data remains associated with the Club.
- <strong>Personal profile data</strong> (display name, user tag, avatar, bio, preferences and global statistics) <strong>remains, in all cases, the exclusive property of the user.</strong> It belongs to your account, follows you regardless of which Clubs you join or leave, and you may edit or delete it at any time from your own account.</p>
<p>Administration rights are hierarchical: Principal Admin &gt; Secondary Admin &gt; Moderator &gt; Member. Only the Principal Admin may transfer Club ownership or manage the associated subscription.</p>
<h3>5.1 Competitions, Tournaments, Campaigns and Public Tournament Pages</h3>
<p>The Platform includes competitive and community features: <strong>tournaments</strong> (elimination or group formats), <strong>campaigns</strong> (linked series of sessions), <strong>co-operative sessions</strong> and <strong>leaderboards</strong> (including ELO and scores normalized across different games). Leaderboards and points are automatically computed representations of the results entered in the Club, may be corrected by administrators, <strong>have no monetary value</strong> and do not constitute gambling.</p>
<p><strong>Public tournament page:</strong> Club administrators may choose to publish a public page for a tournament. On that page, <strong>participants' display names, results and the tournament standings become visible to anyone with the link, without authentication.</strong> By participating in a tournament marked as public, you acknowledge this visibility. Administrators may unpublish the page at any time, and you may exercise your data rights as described in the Privacy Policy.</p>
<h3>6. User Conduct</h3>
<p>You agree not to:
- use the Platform for any illegal or unauthorized purpose;
- post unlawful, offensive, threatening, defamatory content or content that infringes others' rights;
- disrupt the Platform's operation (viruses, spam, automated/bot access);
- impersonate another person or access accounts that are not yours.</p>
<p>You are solely responsible for your interactions with other members and for the content you post.</p>
<p><strong>Content reporting.</strong> You may report content or users that violate these Terms or the law directly from within the app. We review reports within a reasonable time and may remove content, restrict features or suspend accounts, in accordance with applicable digital services legislation.</p>
<h3>7. User-Generated Content and License</h3>
<p>By uploading content (in particular session photos and avatars, stored in our infrastructure), you represent and warrant that <strong>you hold all necessary rights</strong> to it and that you have the consent of any identifiable persons appearing in photos.</p>
<p>You grant the Company a worldwide, non-exclusive, royalty-free, transferable license to store, display and reproduce this content <strong>solely for the purpose of operating the Platform</strong> (display within the relevant Club, history, galleries and profiles). This license ends when you delete the content, except for residual technical copies and cases where the content has already been shared with other Club members.</p>
<p>The Company may remove or moderate, at its discretion, content that violates these Terms.</p>
<h3>8. Subscriptions, Payments and Billing</h3>
<p>Personal profiles are free. Access to advanced Club features requires a <strong>subscription tied to your account</strong> (not to the Club), available in several plans (monthly or annual). The plan tier determines how many Clubs you may create and the number of members per Club.</p>
<p><strong>Currencies and prices.</strong> Prices are displayed and charged in <strong>Romanian lei (RON), US dollars (USD) or euros (EUR)</strong>. Each plan has its own fixed price in each currency — these are not conversions, and the amount shown is exactly the amount you will be charged. Your billing currency is set at your first payment and stays the same for subsequent payments.</p>
<p><strong>Free trial:</strong> we may offer a free <strong>30-day trial, no card required</strong>, unlocking the features of a paid plan. The trial is granted <strong>once per account</strong>, with eligibility verified by our systems. Upon expiry, if you do not activate a paid subscription, the associated Club goes through the stages described in Section 9 (read-only mode, then archiving). We reserve the right to refuse or revoke trials obtained through multiple accounts or other forms of abuse.</p>
<ul>
<li><strong>Payment processing and tax handling</strong> are provided through <strong>Stripe Managed Payments</strong>, supplied by <strong>Sold through Link, LLC</strong> ("Link SMP"), a Stripe affiliate. For transactions made through the Platform, Link SMP acts as the <strong>merchant of record for tax purposes</strong>: it collects and remits applicable taxes (VAT and equivalents), processes the payment, and issues the tax documentation for the transaction. "Sold through Link, LLC" appears on your receipt and card statement. We do not store your full card details.</li>
<li><strong>TurnOrder (operated by [DENUMIRE_COMPANIE]) remains the provider of the service</strong> and is responsible for the product, its quality, legal compliance, and its own refund policy. Refunds may be issued through Stripe/Link within up to 60 days, subject to our refund policy and Stripe/Link's terms.</li>
<li><strong>Auto-renewal:</strong> subscriptions renew automatically at the end of each period. You can stop renewal at any time from the <strong>billing portal</strong>, reachable from the app ("Manage subscription"), where you can also update your payment method or download invoices.</li>
<li><strong>Upgrade/Downgrade:</strong> you may change plans at any time from the <strong>billing portal</strong>. The new plan replaces the current one, and the price difference is prorated for the remaining period, according to the payment processor's rules.</li>
</ul>
<h3>9. Non-Payment, Club Lifecycle and the "Claim Club" Mechanism</h3>
<p>If the Principal Admin's subscription is no longer active, the associated Club goes through the following stages:
1. <strong>Grace period (days 1–30):</strong> the Club enters <strong>read-only</strong> mode — data remains accessible but cannot be added or modified.
2. <strong>Archiving (from day 31):</strong> the Club becomes inaccessible to members and hidden from public areas, but data is retained.
3. <strong>Permanent deletion (from day 90):</strong> the Club's data is irreversibly deleted. Members' personal profile data and global statistics remain unaffected.</p>
<p><strong>The "Claim Club" Mechanism:</strong> any active member of a Club in grace or archived status may claim the Club by activating an appropriate subscription (or directly, if they already hold one with an available slot). Upon claiming, <strong>legal ownership of the Club transfers to the claiming member</strong>, and the previous Principal Admin becomes a regular member. <strong>By accepting these Terms, you acknowledge and agree that non-payment of the subscription may result in the loss of your ownership rights over the Club in favor of another member who takes over the subscription,</strong> as well as in the permanent deletion of the Club's data under the timelines above.</p>
<p><strong>Ownership transfer:</strong> the Principal Admin may voluntarily transfer Club ownership to another member who holds an active subscription and an available slot.</p>
<h3>10. Right of Withdrawal and Refund Policy (Consumers)</h3>
<p>The Platform provides digital content and services with immediate access. In accordance with EU law and Romanian Government Emergency Ordinance no. 34/2014, by initiating a subscription and requesting immediate access to premium features, <strong>you expressly consent to the commencement of the service before the 14-day withdrawal period expires and acknowledge that you lose your right of withdrawal</strong> once the service has been fully provided. This is reconfirmed at checkout.</p>
<p><strong>Refund policy.</strong> Because we provide a digital service with immediate access, payments are generally non-refundable once you have started using the premium features (as per the paragraph above). However, we may grant refunds, at our reasonable discretion, in situations such as:</p>
<ul>
<li>duplicate charges or billing errors;</li>
<li>a technical issue that prevents you from using the service and that we cannot resolve within a reasonable time;</li>
<li>other cases where a refund is required by applicable consumer-protection law.</li>
</ul>
<p>Approved refunds are processed through <strong>Stripe / Sold through Link, LLC</strong>, to the original payment method, within up to 60 days. To request a refund, contact us at <strong>contact@turnorder.org</strong>, indicating your account and the relevant transaction.</p>
<p><strong>Cancelling auto-renewal.</strong> You can stop auto-renewal at any time from the <strong>billing portal</strong>, reachable from the app ("Manage subscription"). Cancellation stops future charges but does not automatically trigger a refund for the current period — access remains active until the end of the period already paid for.</p>
<p>Nothing in this section limits the mandatory rights you have as a consumer under applicable law.</p>
<h3>11. Intellectual Property</h3>
<p>All intellectual property rights in the Platform (design, source code, trademarks, features) belong to the Company. You may not copy, modify, decompile or use the Platform in any manner that infringes these or third-party rights.</p>
<h3>12. Modifications to the Service</h3>
<p>The Company reserves the right to modify, update or discontinue the Platform or parts of it at any time. We will make reasonable efforts to announce material changes.</p>
<h3>13. Suspension and Termination</h3>
<p>The Company may suspend or terminate account access for violations of these Terms or unlawful activity. You may close your account at any time. Upon termination, access to your account and associated content ceases, subject to legal retention obligations.</p>
<h3>14. Limitation of Liability and Disputes Between Members</h3>
<p>The Platform is provided "as is" and "as available", without warranties of any kind. We do not guarantee uninterrupted availability or freedom from errors.</p>
<p><strong>TurnOrder is an organizational tool; we are not a party to, and assume no liability for, disputes between members of a Club</strong> (regarding scores, leaderboards, organization, behavior or any other internal matter). To the fullest extent permitted by law, the Company is not liable for indirect, incidental or consequential damages arising from use of the Platform. These limitations do not affect consumers' mandatory statutory rights.</p>
<h3>15. Indemnification</h3>
<p>You agree to indemnify the Company against any claims, damages or expenses (including legal fees) arising from your use of the Platform, your violation of these Terms, or your infringement of a third party's rights.</p>
<h3>16. Third-Party Links and Services</h3>
<p>The Platform may contain integrations or links to third-party services (e.g. BoardGameGeek, Stripe). We are not responsible for their content or practices; use is at your own risk and governed by those providers' terms.</p>
<h3>17. Governing Law and Dispute Resolution</h3>
<p>These Terms are governed by Romanian law. Disputes shall be resolved by the competent courts of Romania.</p>
<p>For consumers: you have the right to contact the <strong>Romanian National Authority for Consumer Protection (ANPC)</strong> — <a href="https://anpc.ro">www.anpc.ro</a> — including through the <strong>Alternative Dispute Resolution (SAL/ADR)</strong> procedure — <a href="https://anpc.ro/ce-este-sal/">anpc.ro/ce-este-sal</a>. The European Online Dispute Resolution (ODR) platform was discontinued by the European Union in July 2025 and is no longer available.</p>
<h3>18. Changes to These Terms</h3>
<p>We may modify these Terms. Changes will be posted within the Platform, and your continued use constitutes acceptance of the updated Terms.</p>
<h3>19. Contact</h3>
<p>For questions about these Terms: <strong>contact@turnorder.org</strong>.</p>`,
            'legal.privacy.body': `<p>[DENUMIRE_COMPANIE] (Tax ID [CUI], [ADRESA_SEDIU]) is the data controller for the TurnOrder platform and is committed to protecting your privacy. This policy explains what data we collect, why, where we store it, with whom we share it, and your rights under Regulation (EU) 2016/679 (GDPR).</p>
<h3>1. Data Controller</h3>
<p>Controller: <strong>[DENUMIRE_COMPANIE]</strong>, [ADRESA_SEDIU], Tax ID [CUI], registered with the Trade Register under no. [NR_REG_COM].
Privacy contact: <strong>contact@turnorder.org</strong>.</p>
<h3>2. What Data We Collect</h3>
<p>We collect only the data necessary to operate the service:</p>
<p><strong>a) Account and profile data</strong>
- Email address;
- Display name and unique public identifier (user tag);
- Optional: bio, experience level, preferred games, avatar, BoardGameGeek username, gender, status, availability, country/city;
- Your communication settings: people you blocked, direct conversations deleted only for you, people you muted, the notifications you receive from each club, and who can see when you are online;
- Your chat appearance preferences (bubble colour, background, text size), as well as your recently used emoji and the skin tone you chose for them, visible only to you and kept in your account so they are the same on all your devices.</p>
<p><strong>b) User-generated content</strong>
- Session photos, club announcement photos and avatars (stored in our secure storage; new session and announcement photos also have a small copy for fast display, deleted together with the photo);
- Club chat messages and direct messages (DMs), including your reactions to messages (seen by those who can see the message) and the photos sent in them (each with a small copy for fast display, deleted together with the photo);
- Previews of the links you write in a message: the title, description and a small image of the page, fetched by our server from that website while you write the link (the website only sees our server, not your address). The preview is part of the message (only those who can see the message see it), and the link is not kept anywhere else; the image is deleted together with the message. A YouTube video is loaded from YouTube (Google) only after you press ▶ and accept; from then on YouTube receives your IP address and your device's technical information;
- Scores, session history, leaderboards (including ELO).</p>
<p><strong>c) Technical and security data</strong>
- IP address and minimal technical information necessary for security and abuse prevention;
- Audit logs of administrative actions within clubs;
- If you enable push notifications: your browser's push subscription (a technical token), used solely to deliver the notifications you requested (legal basis: consent); you may revoke it at any time from the app or your browser;
- Session tokens (authentication).</p>
<p><strong>d) Billing and tax data</strong> (when purchasing a subscription)
- Collected directly by <strong>Sold through Link, LLC / Stripe</strong> at the time of payment (name, and for legal entities, tax details including VAT ID), to issue the transaction's tax documentation. We do not collect this data within the application.</p>
<p><strong>e) Optional data</strong>
- Location (city/country), provided voluntarily by you.</p>
<p>We do not collect and <strong>never store your password</strong> — authentication and password encryption (hashing) are securely handled by our infrastructure provider.</p>
<h3>3. Why We Process Data (Legal Bases)</h3>
<div class="legal-table-wrap"><table>
<thead>
<tr>
<th>Purpose</th>
<th>Legal basis (GDPR)</th>
</tr>
</thead>
<tbody>
<tr>
<td>Creating your account and providing the service (clubs, sessions, scores, chat)</td>
<td>Performance of contract (Art. 6(1)(b))</td>
</tr>
<tr>
<td>Displaying your public profile (user tag, display name) as a social network</td>
<td>Performance of contract / consent (Art. 6(1)(b)/(a))</td>
</tr>
<tr>
<td>Processing payments and managing subscriptions</td>
<td>Performance of contract (Art. 6(1)(b))</td>
</tr>
<tr>
<td>Security, fraud and abuse prevention (IP, CAPTCHA, audit)</td>
<td>Legitimate interest (Art. 6(1)(f))</td>
</tr>
<tr>
<td>Optional profile and location data</td>
<td>Consent (Art. 6(1)(a))</td>
</tr>
</tbody>
</table></div>
<h3>4. Where We Store Data</h3>
<p>The database and authentication system are hosted on <strong>Supabase</strong>, in the <strong>European Union – Ireland (eu-west-1)</strong> region. Your core data is therefore stored <strong>physically within the EU</strong>.</p>
<p>The application is hosted on <strong>Netlify</strong>, and the source code on GitHub. Payment processing involves <strong>Stripe / Sold through Link, LLC</strong> (a US entity), which may process certain data outside the EU — this transfer is protected by the European Commission's <strong>Standard Contractual Clauses (SCCs)</strong> and Stripe's GDPR compliance commitments.</p>
<p>Automated technical error reports are processed by <strong>Sentry</strong>, in the <strong>European Union – Frankfurt, Germany</strong> region. Transactional emails are delivered through <strong>Resend</strong>.</p>
<h3>5. With Whom We Share Data (Processors)</h3>
<p>We do not sell your data and do not share it for advertising purposes. We share it only with the providers necessary to operate the service, acting as processors:</p>
<ul>
<li><strong>Supabase</strong> — database hosting, authentication and file storage (EU/Ireland);</li>
<li><strong>Stripe / Sold through Link, LLC</strong> — payment processing, fraud prevention, dispute management and tax compliance (merchant of record for transactions, via Stripe Managed Payments);</li>
<li><strong>Netlify</strong> — application hosting;</li>
<li><strong>Cloudflare (Turnstile)</strong> — anti-bot protection at login;</li>
<li><strong>Sentry</strong> — automated monitoring of the application's technical errors (EU/Frankfurt). Only technical information about the error is transmitted: the error type, the location in the application code where it occurred, the page and the application version. <strong>Your email address, name, message content, IP address and location are not transmitted</strong> — these are automatically removed before sending;</li>
<li><strong>Resend</strong> — delivery of transactional emails (confirmations, data exports, account and security notifications). It receives the recipient's email address and the content of the message sent.</li>
</ul>
<p><strong>Signing in with Google.</strong> If you choose "Continue with Google", Google acts as an <strong>independent controller</strong> for the authentication process, under its own privacy policy. From Google we receive only your email address and display name, strictly necessary to create the account.</p>
<p><strong>Content delivery networks (CDN).</strong> Certain technical components of the application (code libraries, audio assets) are delivered through the public <strong>cdnjs (Cloudflare)</strong> and <strong>jsDelivr</strong> networks. When these files load, your device's IP address becomes visible to that provider — as with any request on the internet. We do not transmit any account data to them.</p>
<p>We may also disclose data where required by law (authorities, courts).</p>
<h3>6. Public Profile Visibility</h3>
<p>TurnOrder includes a social component, and <strong>the visibility of your profile is entirely controlled by you, from your account settings:</strong>
- <strong>Your display name and user tag</strong> are the public identifiers and are visible to other users (similar to a social network).
- <strong>Your profile photo (avatar)</strong> is optional: if you choose to upload a photo, it is displayed as part of your profile and visible to other users. Alternatively, you may use a preset avatar, and the photo can be removed at any time.
- <strong>All other profile information</strong> (avatar, experience level, age, gender, location, preferred games, status, availability, etc.) becomes visible to other users <strong>only to the extent you choose to make it public</strong> — each field has its own visibility toggle. You decide, field by field, what is shown.
- A separate toggle lets you control whether your profile is <strong>"discoverable"</strong> (appears to other users in the "Discover players" section) or hidden.
- <strong>Your email address</strong> is not displayed publicly.
- <strong>Online status</strong> (“Online”): while you use the app, members of your clubs, your friends and the people you have private conversations with can see that you are online. In your profile settings you can choose “Nobody”: you then no longer appear online, and you cannot see other people's status either. The status is not stored — we keep no history of when you were online.</p>
<p>Your profile data belongs to you in all cases: you may edit, hide or delete it at any time from your account. (By contrast, data entered within a Club belongs to the Club — see the Terms of Service.)</p>
<p><strong>Public tournament pages:</strong> if club administrators publish a tournament, your display name and your results in that tournament appear on a public page, accessible without authentication, for as long as the tournament remains published. See the Terms of Service (Section 5.1) for details.</p>
<h3>7. Guest → Real Account Flow (Hybrid Consent)</h3>
<p>A club administrator may add a "Guest" by entering their name and, optionally, their email, in order to record their participation in sessions — based on the legitimate interest of organizing the club. If that person later creates a real account with the same email, their previous gameplay data may be <strong>merged</strong> with the new account, with the user's consent, so the history belongs to them. If you do not want the merge, you may contact us to delete the Guest data.</p>
<h3>8. How Long We Keep Data (Retention)</h3>
<ul>
<li><strong>Account and profile data:</strong> for as long as the account is active. Upon account deletion, personal data is removed, except for data we are legally required to retain.</li>
<li><strong>Data of an unpaid Club:</strong> retained for the duration of the subscription and the subsequent grace period; the <strong>Club's data is permanently deleted 90 days</strong> after the subscription lapses. (The full Club lifecycle stages are described in the Terms of Service.)</li>
<li><strong>Transaction tax documents:</strong> issued and retained by <strong>Sold through Link, LLC / Stripe</strong> under their obligations. Our own accounting records (of received payouts) are retained under Romanian accounting law (generally 10 years).</li>
<li><strong>Security/audit logs:</strong> retained for a limited period necessary for security.</li>
<li><strong>Technical error reports:</strong> retained by Sentry for a maximum of <strong>90 days</strong>, then automatically deleted.</li>
<li><strong>Club backups:</strong> so that a Club's data can be recovered after accidental deletion or a technical incident, we automatically create daily copies of each Club's data. These are accessible <strong>only to the administrators of that Club</strong> and are retained for a maximum of <strong>5 weeks</strong> (the last 7 days, plus one weekly copy from each of the last 4 weeks). The copies <strong>do not contain</strong> email addresses, payment data or private messages (DMs). They do contain members' display names where these are needed to keep the history intelligible (for example the author of a Club chat message or of an audit log entry). Consequently, after you delete your account, your display name may persist in these backups for <strong>up to 5 weeks</strong>, after which it disappears automatically. Administrators may download a manual copy at any time; up to the last 10 of these are retained.</li>
</ul>
<h3>9. Your Rights (GDPR)</h3>
<p>You have the right to:
- <strong>Access</strong> — learn what data we hold about you;
- <strong>Rectification</strong> — correct inaccurate data;
- <strong>Erasure ("right to be forgotten")</strong> — have your data deleted, within the limits of legal obligations;
- <strong>Portability</strong> — receive your data in a structured, commonly used format;
- <strong>Restriction</strong> and <strong>objection</strong> to certain processing;
- <strong>Withdraw consent</strong> at any time, without affecting prior processing.</p>
<p><strong>Directly in the app</strong> you can export a copy of your data (in a structured format) and <strong>permanently delete your account</strong>, from the profile section. For any other requests regarding the rights above, contact us at <strong>contact@turnorder.org</strong>. We will guide you through the process in accordance with GDPR and respond within the legal deadlines.</p>
<p>You also have the right to lodge a complaint with the <strong>Romanian National Supervisory Authority for Personal Data Processing (ANSPDCP)</strong> — <a href="https://www.dataprotection.ro">www.dataprotection.ro</a>.</p>
<h3>10. Data Security</h3>
<p>We apply industry-standard technical and organizational measures: password hashing, secure HTTPS transmission, data isolation between clubs via Row Level Security, role-based access controls, anti-bot protection (CAPTCHA) and audit logs. In the event of a security breach affecting your data, we will notify you and the competent authority in accordance with our legal obligations.</p>
<h3>11. Cookies</h3>
<p>We use only <strong>essential</strong> cookies and similar technologies (maintaining the authentication session and preventing payment fraud). We do not use advertising or tracking cookies. Details in our <strong>Cookie Policy</strong>.</p>
<h3>12. Children</h3>
<p>The Platform is not directed at persons under <strong>16</strong>, and we do not knowingly collect their data. The minimum age of 16 is confirmed at account creation. If we learn that we have collected data from a person under 16, we will close the account and delete the data as soon as possible.</p>
<h3>13. Changes to This Policy</h3>
<p>We may update this policy from time to time. We will post the updated version within the Platform, and changes take effect upon posting. We recommend reviewing this page periodically.</p>
<h3>14. Contact</h3>
<p>For any questions regarding this Privacy Policy or your data: <strong>contact@turnorder.org</strong>.</p>`,
            'legal.cookies.body': `<p>This policy explains what cookies and similar technologies we use in TurnOrder, operated by [DENUMIRE_COMPANIE]. In short: <strong>we use only essential technologies necessary for the app to function. We do not use advertising, tracking or profiling cookies.</strong> The only exception is optional and your choice: a YouTube video in a conversation loads only if you press ▶ and accept (see section 3).</p>
<h3>1. What Cookies and Similar Technologies Are</h3>
<p>Cookies are small text files stored by your browser. "Similar technologies" include the browser's local storage (localStorage) and storage that lasts only for the session (sessionStorage), which TurnOrder uses to remember your session and preferences. In this policy we refer to all of these, generically, as "cookies".</p>
<h3>2. How We Use These Technologies (Essential)</h3>
<p>TurnOrder <strong>does not place its own tracking cookies</strong>. To make the app work, we use the browser's local storage (localStorage and, for what should be kept only while the tab is open, sessionStorage) for the following purposes:</p>
<div class="legal-table-wrap"><table>
<thead>
<tr>
<th>Purpose</th>
<th>Examples</th>
<th>Type</th>
</tr>
</thead>
<tbody>
<tr>
<td><strong>Authentication session</strong> — keeps you logged in without re-entering your password every time</td>
<td>the session token provided by Supabase</td>
<td>Essential</td>
</tr>
<tr>
<td><strong>Preferences</strong> — remembers your choices</td>
<td>chosen language, last section visited, remembered email (if you tick "remember me"), chat sound, conversation appearance (bubble colour, background, text size — a copy of the choices saved in your account, so they show up immediately on opening; deleted when you sign out)</td>
<td>Functional</td>
</tr>
<tr>
<td><strong>Local app state</strong> — enables smooth and partly offline operation</td>
<td>working data of your current club, "read/seen" markers, text you started but did not send in a conversation (the draft — kept only for the session, in sessionStorage, and deleted when you sign out)</td>
<td>Essential / Functional</td>
</tr>
<tr>
<td><strong>Payment flow</strong> — correctly continues the process after returning from Stripe</td>
<td>temporary checkout indicators</td>
<td>Essential</td>
</tr>
<tr>
<td><strong>Offline operation (PWA)</strong> — the app keeps its own files locally for fast loading and partial offline use</td>
<td>service worker cache</td>
<td>Essential</td>
</tr>
<tr>
<td><strong>Push notifications</strong> — only if you enable them</td>
<td>your browser's push subscription</td>
<td>Functional (opt-in)</td>
</tr>
</tbody>
</table></div>
<p>These technologies are necessary for the app to function; without them, authentication and core features would not work correctly.</p>
<h3>3. Third-Party Cookies</h3>
<p>Certain providers we use may set their own cookies: for security and functionality (Stripe, Cloudflare) or, only if you start a video and accept, to play it (YouTube):</p>
<ul>
<li><strong>Stripe</strong> — cookies for <strong>fraud prevention</strong> during payment processing. See <a href="https://stripe.com/privacy">Stripe's Privacy Policy</a>.</li>
<li><strong>Cloudflare Turnstile</strong> — <strong>anti-bot (CAPTCHA)</strong> technology that protects the login form against automated abuse. See <a href="https://www.cloudflare.com/privacypolicy/">Cloudflare's Privacy Policy</a>.</li>
<li><strong>Sentry</strong> — technical error monitoring. It <strong>does not set cookies</strong> and does not use persistent local storage on your device. See <a href="https://sentry.io/privacy/">Sentry's Privacy Policy</a>.</li>
<li><strong>YouTube (Google)</strong> — the video player in conversations, in its "no-cookie" variant (youtube-nocookie.com). <strong>It loads only after you press ▶ and accept</strong> (the consent is remembered only until you close the app); once playing, YouTube may store information in your browser. See <a href="https://policies.google.com/privacy">Google's Privacy Policy</a>.</li>
</ul>
<p>We do not control these third-party cookies; they are governed by the respective providers' policies.</p>
<h3>4. What We Do NOT Use</h3>
<ul>
<li><strong>No</strong> advertising cookies;</li>
<li><strong>No</strong> cross-site tracking;</li>
<li><strong>No</strong> marketing profiling;</li>
<li>We <strong>do not sell</strong> or share this data for advertising purposes.</li>
</ul>
<p>These commitments concern TurnOrder. If you choose to start a YouTube video (after consent), Google applies its own technologies and its own policy to that video; if you do not accept, YouTube is not loaded and receives nothing.</p>
<h3>5. Managing Cookies</h3>
<p>You can manage or delete cookies and locally stored data from your browser settings. Logging out and clearing the app's data in your browser also removes the session token and locally stored preferences. Please note that disabling <strong>essential</strong> technologies will prevent login and the correct operation of the app.</p>
<h3>6. Changes to This Policy</h3>
<p>We may update this policy as the app evolves. The updated version will be posted within the Platform, effective from the date of posting.</p>
<h3>7. Contact</h3>
<p>For questions regarding this Cookie Policy: <strong>contact@turnorder.org</strong>.</p>`,
            'pw.len': 'At least 8 characters',
            'pw.upper': 'An uppercase letter',
            'pw.lower': 'A lowercase letter',
            'pw.digit': 'A digit',
            'pw.special': 'A special character',
            'pw.match': 'Passwords match',
            'pw.weak': 'Password is not strong enough: at least 8 characters, an uppercase letter, a lowercase letter, a digit, and a special character.',

            'welcome.tagline': 'The platform for your board game clubs',
            'welcome.register': 'Sign up',
            'welcome.demo': 'Quick Demo',
            'demoBar.text': 'You\'re in demo mode: the data is fictional and nothing is saved.',
            'demoBar.cta': 'Create a free account',

            'hub.title': 'My clubs',
            'hub.subtitle': 'Pick a club to enter, or discover others.',
            'hub.searchPh': 'Search a club...',
            'hub.noMatch': 'No club matches your search.',
            'hub.noClubs': 'You are not part of any club yet.',
            'hub.createClub': 'Create club',
            'hub.createClubName': 'Name of the new club:',
            'profile.usernameTaken': 'This username is already taken. Please choose another.',
            'hub.discoverClubs': 'Discover clubs',
            'hub.discoverPlayers': 'Discover players',
            'hub.plans': 'Subscription plans',
            'hub.install': 'Install the app',
            'hub.ownerPanel': 'Owner panel',
            'owner.title': 'Owner panel',
            'owner.feedbackTitle': 'Recent feedback',
            'owner.errorsTitle': 'Client errors',
            'owner.errorsFilter': 'Filter by context / message…',
            'owner.errorsEmpty': 'No errors reported.',
            'common.refresh': 'Refresh',
            'owner.feedbackLoading': 'Loading feedback...',
            'owner.feedbackEmpty': 'No feedback yet.',
            'owner.feedbackNoAccess': 'Feedback inbox is not accessible (check Supabase RLS policies).',
            'owner.clubsTitle': 'My clubs',
            'owner.noClubs': 'No clubs.',
            'owner.infoTitle': 'Platform info',
            'owner.plan': 'Plan',
            'owner.status': 'Status',
            'owner.role': 'Role',
            'owner.limit': 'Member limit',
            'owner.email': 'Owner email',
            'owner.clubCount': 'Total clubs',
            'owner.pwa': 'PWA',
            'owner.pwaOn': 'active',
            'owner.pwaOff': 'inactive',
            'owner.demoNote': 'You are in demo — real feedback is unavailable.',
            'hub.logout': 'Sign out',

            'session.newTitle': 'New Game Session',
            'session.type': 'Session Type',
            'session.standard': 'Standard Session',
            'session.tournament': 'Tournament',
            'session.coop': 'Cooperative',
            'session.more': 'More options',
            'session.friendlyShort': 'Friendly',
            'session.photosShort': 'Photos',
            'session.scoresheetShort': 'Scoresheet',
            'session.rolesShort': 'Roles',
            'session.gameHelp': 'Picking the game auto-loads its scoresheet and roles (if any).',
            'session.descStandard': 'Regular game with ELO ranking and individual scores.',
            'session.descTournament': 'Multi-round event with a format and prizes.',
            'session.descCoop': 'Everyone plays together against the game — no individual ranking.',
            'session.coopResult': 'Result (team)',
            'session.coopWin': 'Victory (team won)',
            'session.coopLoss': 'Defeat (game won)',
            'session.teamScore': 'Team score (optional)',
            'session.scenario': 'Scenario (optional)',
            'coop.difficulty': 'Difficulty (optional)',
            'coop.diff.none': '— unspecified',
            'coop.diff.easy': 'Easy',
            'coop.diff.normal': 'Normal',
            'coop.diff.hard': 'Hard',
            'coop.diff.heroic': 'Heroic',
            'coop.diff.brutal': 'Brutal',
            'coop.diff.custom': 'Custom…',
            'coop.difficultyCustom': 'Difficulty name',
            'coop.detail': 'Result detail (optional)',
            'coop.difficultyShort': 'Difficulty',
            'coop.detailShort': 'Detail',
            'coop.ptsEachSuffix': 'each',
            'coop.mvp': 'Standout player / MVP (optional)',
            'coop.mvpNone': '— none —',
            'coop.mvpNote': 'Just a symbolic highlight — it does not affect points or ranking.',
            'coop.mvpShort': 'MVP',
            'coop.mvpCustom': 'Custom (free name)…',
            'coop.mvpCustomPh': 'e.g. Andrew (guest)',
            'history.editSessionTitle': 'Edit session',
            'stats.typeCoop': 'Co-op',
            'coopStats.empty': 'No cooperative sessions in this period.',
            'coopStats.sessions': 'Co-op sessions',
            'coopStats.wins': 'Wins',
            'coopStats.winRate': 'Win rate',
            'coopStats.streak': 'Current streak',
            'coopStats.hardestBeaten': 'Hardest beaten',
            'coopStats.mostPlayed': 'Most played',
            'coopStats.byDifficulty': 'Wins by difficulty',
            'coop.scenarioSuggest': 'Past scenarios:',
            'session.coopNote': 'In co-op mode there is no individual ranking: all participants share the result, and the session does not affect ELO.',
            'session.coopNoPoints': 'Uniform scoring is off on this club. On victory, the Team score (if you enter it) is added equally to all players; on a loss it is recorded in history without changing points.',
            'session.tName': 'Tournament Name',
            'session.prize': 'Prize',
            'session.format': 'Format',
            'session.fmtChoose': '— Choose format —',
            'session.fmtRR': 'Round Robin',
            'session.fmtKO': 'Single Elimination',
            'session.fmtSwiss': 'Swiss System',
            'session.fmtPoints': 'Cumulative Points',
            'session.fmtOther': 'Other',
            'session.rounds': 'Number of rounds',
            'session.fee': 'Entry fee',
            'session.date': 'Date',
            'session.startTime': 'Start time',
            'session.duration': 'Estimated duration (min)',
            'session.game': 'Game',
            'session.chooseGame': '-- Select game --',
            'session.searchGame': 'Search game (title / category / designer)…',
            'session.noGames': 'No games found in catalog.',
            'session.editScoresheet': 'Edit scoresheet (Pro)',
            'session.editRoles': 'Edit roles (Pro)',
            'session.location': 'Location',
            'session.notes': 'Notes & Special rules',
            'session.notesPh': 'Special rules, notes, etc.',
            'session.friendly': 'Friendly Match (no ELO)',
            'session.friendlyNote': 'Scores are saved as history only. ELO ratings and the club leaderboard stay unchanged.',
            'session.scoreModeLabel': 'Session scoring type',
            'calc.title': 'Calculator',
            'calc.done': 'Done',
            'session.scoreDirLabel': 'Score direction',
            'session.scoreDirInherited': 'Inherited from game: {dir}. You can change it for this session only.',
            'session.scoreDirOverride': 'Overridden for this session (differs from the game setting).',
            'session.scoreModeRawNote': 'Raw: box scores go straight into the leaderboard, as before.',
            'session.scoreModeUniformNote': 'Uniformized: scores become "Club Points" by placement, per the Admin template.',
            'session.tieBreakTitle': 'Tie-breaker',
            'session.tieBreakHint': 'Tap the player who won the tie-break per the game rules — they take the higher place.',
            'session.tieAt': 'Tie at',
            'session.scoreKindLabel': 'Scoring type',
            'session.kindCompetitive': 'Competitive (rank-based)',
            'session.kindCampaign': 'Campaign (participation)',
            'session.bonusLabel': 'Bonus',
            'session.campaignNote': 'Each player gets participation points; the field below is an optional individual bonus.',
            'session.friendlyLocked': 'You can enter scores — they are saved to history but do not affect the leaderboard or player stats.',
            'session.addPlayers': 'Add players',
            'session.searchPlayersPh': 'Search by name or @user_tag...',
            'session.noPlayersSelected': 'No players selected yet. Search and add participants above.',
            'session.removePlayer': 'Remove player',
            'session.noPlayerMatch': 'No players found.',
            'session.photos': 'Game photos',
            'session.addPhotos': 'Add photos',
            'session.uploadingPhotos': 'Uploading photos...',
            'photo.preparing': 'Preparing {n} photos…',
            'photo.stillPreparing': 'The photos are still being prepared — just a few more seconds.',
            'photo.uploadRejected': 'Photos not uploaded: {n} — unsupported format or file too large. Everything else was saved.',
            'common.remove': 'Remove',
            'session.participants': 'Participants',
            'session.addGuest': 'Add Guest',
            'session.guestNamePh': 'Guest name',
            'session.guestEmailPh': 'Email (required)',
            'session.add': 'Add',
            'session.save': 'Save Session',
            'session.reset': 'Reset',
            'session.guestTag': 'Guest',
            'session.absent': 'Absent',
            'session.turn': 'Turn',
            'session.turnActive': 'Turn…',
            'session.scoreLabel': 'Score',
            'session.role': '— role/faction —',
            'session.timerReset': 'Reset',

            'players.title': 'Manage Players',
            'players.editScoreTitle': 'Edit score',
            'players.currentScore': 'Current score',
            'players.newScore': 'New score',
            'players.scoreUpdated': 'Score updated!',
            'players.banned': 'Banned members',
            'players.unban': 'Unban',
            'common.edit': 'Edit',
            'common.delete': 'Delete',
            'common.mute': 'Mute',
            'common.unmute': 'Unmute',
            'common.ban': 'Ban',
            'common.share': 'Share',
            'common.close': 'Close',
            'lb.prev': 'Previous photo',
            'lb.next': 'Next photo',
            'common.deletedProfile': 'Deleted profile',

            'history.title': 'Session History',
            'history.empty': 'No sessions recorded yet.',
            'history.recordedBy': 'Recorded by',
            'history.edit': 'Edit',

            'catalog.title': 'Game Catalog',
            'catalog.search': 'Search game',
            'catalog.searchPh': 'Name, category, mechanics...',
            'catalog.filters': 'Filters',
            'catalog.allCats': 'All categories',
            'catalog.sortBy': 'Sort by',
            'catalog.sortAz': 'Alphabetical (A–Z)',
            'catalog.sortAdded': 'Date added (newest)',
            'catalog.sortRating': 'Rating (high → low)',
            'catalog.sortWeight': 'Weight (high → low)',
            'catalog.sortPlays': 'Most played',
            'catalog.sortRecent': 'Recently played',
            'catalog.catEuro': '🏛️ Eurogame',
            'catalog.catAmeri': '🎲 Ameritrash',
            'catalog.catParty': '🎉 Party',
            'catalog.catCoop': '🤝 Cooperative',
            'catalog.catStrategy': '🧠 Strategy',
            'catalog.catRpg': '🐉 RPG',
            'catalog.catFiller': '⚡ Filler',
            'catalog.catLegacy': '📖 Legacy',
            'catalog.catDeck': '🎴 Deck Building',
            'catalog.catWorker': '👷 Worker Placement',
            'catalog.addGame': 'Add Game',
            'catalog.importBgg': 'Import BGG',
            'catalog.exportJson': 'Export JSON',
            'catalog.bulkDelete': 'Bulk delete',
            'catalog.statsTitle': 'Catalog Statistics',
            'catalog.totalGames': 'Total Games',
            'catalog.mostPlayed': 'Most played',
            'catalog.avgRating': 'Average rating',
            'catalog.tools': 'Tools',
            'catalog.playTime': 'Total play time',
            'catalog.totalPlays': 'Total Plays',

            'stats.title': 'Detailed Statistics',
            'stats.crossClub': 'Cross-club statistics',
            'stats.period': 'Period',
            'stats.filters': 'Filters',
            'stats.type': 'Statistic type',
            'stats.periodAll': 'All time',
            'stats.changeNew': 'new',
            'stats.periodYear': 'This year',
            'stats.periodMonth': 'This month',
            'stats.periodWeek': 'This week',
            'stats.periodQuarter': 'This quarter',
            'stats.typeOverview': 'Overview',
            'stats.typePlayers': 'Players',
            'stats.typeGames': 'Games',
            'stats.typeTrends': 'Trends',
            'stats.typeHindex': 'H-Index',
            'stats.typeRolewinrate': 'Win rate per role/faction',
            'stats.tabHindex': 'H-Index',
            'stats.tabRolewinrate': 'Win rate / role',
            'stats.sessions': 'Sessions',
            'stats.pointsAccrued': 'Scores accrued',
            'stats.totalDuration': 'Total Duration',
            'stats.crossClubTitle': 'Cross-club statistics',
            'stats.clubs': 'Clubs',
            'stats.wins': 'Wins',
            'stats.totalPoints': 'Total points',
            'stats.totalScores': 'Total scores',
            'stats.scoresH': 'Scores',
            'stats.totalScoresTip': 'Sum of raw match scores (different from club points, which are awarded by administrators).',
            'stats.distinctGames': 'Distinct games',
            'stats.club': 'Club',
            'stats.points': 'Points',
            'stats.winRateH': 'Win rate',
            'stats.topGamesAll': 'Top games (all clubs)',
            'stats.game': 'Game',
            'stats.plays': 'Plays',
            'stats.roleFaction': 'Role/faction',
            'stats.hIndexClub': 'Club H-Index',
            'stats.totalPlays': 'Total plays',
            'stats.hIndexNote': 'H-Index = N means there are at least <strong>N</strong> different games, each played at least <strong>N</strong> times. It measures diversity + consistency, not just the number of plays.',
            'stats.player': 'Player',
            'stats.topGames': 'Top games',
            'stats.games': 'Games',
            'stats.average': 'Average',
            'stats.attendance': 'Attendance',
            'stats.playerOfMonth': 'Player of the Month',
            'stats.bestAverage': 'Best Average',
            'stats.mostActive': 'Most Active',
            'stats.bestAttendance': 'Best Attendance',
            'stats.pointsDistribution': 'Points Distribution',
            'stats.players': 'Players',
            'stats.duration': 'Duration',
            'stats.lastPlayed': 'Last played',
            'stats.rating': 'Rating',
            'stats.mostPlayedStat': 'Most Played',
            'stats.longestAverage': 'Longest Average',
            'stats.trendsTitle': 'Trends',
            'stats.avgScore': 'Average Score',
            'stats.playHours': 'Play Hours',

            'calendar.title': 'Events Calendar',
            'calendar.addEvent': 'Add Event',
            'calendar.syncGoogle': 'Sync Google',
            'calendar.export': 'Export Calendar',

            'polls.gameVote': 'Vote — What to play?',
            'polls.active': 'Active Polls',
            'polls.createNew': 'Create New Poll',
            'polls.statsTitle': 'Poll Statistics',
            'polls.statTotalVotes': 'Total Votes',
            'polls.statAvgPart': 'Avg Participation',
            'polls.statClosed': 'Closed Polls',

            'campaigns.title': 'Campaigns & Legacy',
            'campaigns.new': 'New campaign',
            'campaigns.intro': 'Track campaign progress across multiple sessions (e.g. Gloomhaven, Pandemic Legacy): scenarios, results, roster.',

            'common.save': 'Save',
            'common.saving': 'Saving…',
            'common.retry': 'Retry',
            'common.back': 'Back',
            'confirm.title': 'Confirm your email',
            'confirm.body': 'We sent a 6-digit code to',
            'confirm.hint': 'Can’t find the email? Check your Spam folder too.',
            'confirm.codeLabel': 'Code from the email',
            'confirm.digitLabel': 'Digit {n} of 6',
            'confirm.codeBtn': 'Confirm',
            'confirm.codeChecking': 'Checking...',
            'confirm.codeInvalid': 'The code is wrong or has expired. Check it, or ask for a new one.',
            'confirm.resend': 'Resend code',
            'confirm.resendWait': 'You can ask for a new code in {n} seconds.',
            'confirm.resendIn': 'Resend in',

            'regulation.tabTitle': 'Regulation',
            'rulesack.bannerTitle': 'You have not accepted the club regulation yet',
            'rulesack.bannerSub': 'Until you do, you can read everything but cannot add sessions, messages or proposals.',
            'regulation.exportPdf': 'Export PDF',
            'regulation.print': 'Print',

            'admin.accessTitle': 'Admin Access',
            'admin.accessNote': 'Access to this panel is granted automatically only to accounts that have the admin role set in the database.',
            'admin.checkAccess': 'Check access',
            'admin.panelTitle': 'Admin Panel',
            'admin.eloMode': 'Competitive Mode (ELO)',
            'admin.importData': 'Import data',
            'admin.importNote': 'Import games and sessions from BoardGameGeek (collection CSV) or BG Stats (JSON). You see a preview first; anything that already exists is skipped.',
            'admin.importBggCsv': 'Import BGG (CSV)',
            'admin.importBgStats': 'Import BG Stats (JSON)',
            'admin.importScorePal': 'Import ScorePal (CSV)',
            'admin.backupRestore': 'Backup & Restore',
            'admin.backupFull': 'Full backup',
            'admin.restore': 'Restore',
            'admin.restoreFromFile': 'Restore from file',
            'admin.backupHistory': 'Backup history',
            'admin.seasonMgmt': 'Season Management',
            'admin.seasonCurrent': 'Current period (shown on dashboard)',
            'admin.seasonLabel': 'Season label (year or text — shown large on the dashboard)',
            'admin.seasonLabelPh': 'e.g. 2026 or "Winter Season"',
            'admin.saveLabel': 'Save label',
            'admin.default': 'Default',
            'admin.seasonReport': 'Season report',
            'admin.startNewSeason': 'Start new season',
            'm3.labelSet': 'Season label: “{label}”',
            'm3.labelReset': 'The label is back to the year.',
            'auditd.seasonStarted': 'Season {season} archived; ELO and session history kept',
            'auditd.seasonStartedAlready': 'Season {season} (already archived); ELO and session history kept',
            'auditd.seasonArchivedDemo': 'Archived season {season} ({n} members); ELO and session history kept',
            'admin.seasonNote': '"Start new season" archives the leaderboard and resets points. ELO and session history stay untouched.',
            'admin.viewArchived': 'View archived seasons',
            'admin.userMgmt': 'User Management',
            'admin.scoreEdit': 'Manual Score Editing',
            'admin.auditLog': 'Audit Log',
            'admin.auditSearchPh': 'Search audit (action, user, details)...',
            'admin.scorePalNote': 'ScorePal was retired in 2024, and its native backup is a <code>.realm</code> (binary) file that can\'t be read here. If you have the data as <strong>CSV</strong> (exported/converted, with columns like Game, Date, Player, Score, Winner), you can import it directly. Alternatively, if you moved your data through BG Stats, use the “BG Stats (JSON)” import.',

            'impmap.title': 'Map imported players',
            'impmap.intro': 'For each imported name, pick the matching member or create a guest. Under “New guest” you can set a user_tag and an email — both are optional. The email is just a shortcut: if it matches an existing account, it links them right away. Leaving it empty costs you nothing — you can send the guest an invitation later so they can connect an account.',
            'impmap.colImport': 'Imported',
            'impmap.colMapTo': 'Map to',
            'impmap.choose': '— choose —',
            'impmap.guestNew': '➕ New guest',
            'impmap.tagPh': 'user_tag (optional)',
            'impmap.emailPh': 'email (optional)',
            'impmap.continue': 'Continue import',
            'impmap.needAll': 'Pick an option for every player.',
            'impmap.tagTaken': 'user_tag already taken for: ',
            'impmap.creating': 'Creating profiles and importing...',
            'clubset.title': 'Club settings',
            'clubset.name': 'Club name',
            'clubset.avatar': 'Club avatar',
            'clubset.avatarUpload': 'Upload image',
            'clubset.avatarRemove': 'Remove',
            'clubset.avatarNotImage': 'Please choose an image file.',
            'clubset.avatarReady': 'Image ready. Press Save.',
            'clubset.plan': 'Subscription plan',
            'clubset.feats': 'Features on the current plan',
            'clubset.public': 'Public club (appears in "Discover clubs")',
            'clubset.joinPolicy': 'Join policy',
            'clubset.rulesAck': 'Require rules acceptance',
            'clubset.rulesAckHint': 'New members — including those arriving via invitation — must read and accept the regulation before they can write anything in the club. It is asked again for every new regulation version. Admins are exempt.',
            'rulesack.title': 'Club regulation',
            'rulesack.intro': 'Before taking part in “{club}”, please read the regulation and confirm that you agree.',
            'rulesack.checkbox': 'I have read the club regulation and agree to follow it.',
            'rulesack.accept': 'Accept the regulation',
            'rulesack.done': 'Regulation accepted. Welcome!',
            'rulesack.blocked': 'You need to accept the club regulation before doing this.',
            'rulesack.readOnlyHint': 'Until you accept, you can browse and read, but not add sessions, messages or proposals.',
            'rulesack.error': 'Acceptance failed: {msg}',
            'audit.rulesAckOn': 'Rules acceptance turned on',
            'audit.rulesAckOff': 'Rules acceptance turned off',
            'clubset.joinRequest': 'With approval (request)',
            'clubset.joinOpen': 'Open (anyone can join)',

            'chat.title': 'Club Chat',
            'chat.searchPh': 'Search the conversation...',
            'chat.unread1': '1 unread message',
            'chat.unreadN': '{n} unread messages',
            'chat.unreadNde': '{n} unread messages',
            'chat.toLatest': 'Go to latest messages',
            'chat.new1': '1 new message',
            'chat.newN': '{n} new messages',
            'chat.newNde': '{n} new messages',
            'chat.tickSent': 'Sent',
            'chat.tickSeen': 'Seen',
            'chat.tickSeenAll': 'Seen by everyone',
            'chat.searchTitle': 'Search chat',
            'chat.fullscreen': 'Fullscreen',
            'chat.exitFullscreen': 'Exit fullscreen',
            'chat.notifTitle': 'Message notifications',
            'chat.reply': 'Reply',
            'chat.replyPrivately': 'Reply privately',
            'chat.forward': 'Forward',
            'chat.forwardTo': 'Forward to…',
            'chat.forwardedTo': 'Forwarded to {name}',
            'chat.forwardNoContacts': 'No contacts available (add friends or start a private message).',
            'chat.forwardEmpty': 'This message has no text to forward.',
            // v9 8.4-b — forwarding several messages (multi-select)
            'chat.forwardedManyTo': '{n} messages forwarded to {name}',
            'chat.forwardSkipped': "{n} messages without text weren't forwarded (photos aren't forwarded).",
            'chat.forwardMax': 'You can forward up to {n} messages at once.',
            // v9 8.4-c — forwarding photos (club + DM)
            'chat.forwardPreparing': 'Preparing the photos…',
            'chat.forwardPhotoErr': "The photos couldn't be prepared. Check your connection and try again.",
            'chat.cantReplyPrivate': 'Cannot open a private message with this user.',
            'chat.replySelf': 'You cannot send a private message to yourself.',
            'chat.copy': 'Copy',
            'chat.edit': 'Edit',
            'chat.delete': 'Delete',
            'chat.info': 'Info',
            'chat.copied': 'Message copied!',
            'chat.copyErr': 'Could not copy.',
            'chat.edited': 'Edited',
            'chat.editTitle': 'Edit message',
            'chat.editExpired': 'Editing is allowed only in the first 15 minutes.',
            'chat.deleteExpired': 'Deleting is allowed only in the first 60 hours.',
            'chat.deleteConfirm': 'Delete this message for everyone? It will be replaced by “This message was deleted”.',
            'chat.deleteConfirmAdmin': 'Delete this message for everyone? It will be replaced by “Deleted by an admin”.',
            // v9 8.4-d — deleting several messages (multi-select)
            'chat.deleteManyConfirm': 'Delete {n} messages for everyone? They will be replaced by “This message was deleted”.',
            'chat.deleteManyConfirmAdmin': 'Delete {n} messages for everyone? Other people’s messages will show “Deleted by an admin”.',
            'chat.deleteSomeFailed': "{n} messages couldn't be deleted.",
            'chat.msgDeleted': 'This message was deleted',
            'chat.msgDeletedMine': 'You deleted this message',
            'chat.msgDeletedAdmin': 'Deleted by an admin',
            'chat.olderLoading': 'Loading older messages…',
            'chat.quoteGone': 'The original message is no longer available.',
            'chat.quoteFar': 'That message is too far back to jump to. Scroll up to find it.',
            'chat.quoteErr': 'Could not load the message. Please try again.',
            'chat.searching': 'Searching…',
            'chat.photoAlt': 'Photo {i} of {n}',
            'chat.mentionList': 'Mention a member',
            'chat.select': 'Select',
            'chat.selectedN': 'Selected: {n}',
            'chat.copiedMany': 'Messages copied!',
            'chat.sending': 'Sending…',
            'chat.notSent': 'Not sent · Tap to retry',
            'chat.lpLoading': 'Loading preview…',
            'chat.lpRemove': 'Remove preview',
            'chat.lpPlay': 'Play the video',
            'chat.lpVideo': 'YouTube video',
            'chat.lpClose': 'Close the video',
            'chat.lpVideoNote': 'Played from YouTube (youtube-nocookie.com)',
            'chat.lpConsent': 'This video plays from YouTube (Google). When it starts, YouTube receives your IP address and may store information in your browser, under Google\'s policy.',
            'chat.lpConsentLink': 'Google privacy policy',
            'chat.lpOpenYt': 'Open on YouTube',
            'chat.lpNotNow': 'Not now',
            'chat.notSentToast': 'Message not sent:',
            'chat.retry': 'Retry',
            'chat.discard': 'Discard message',
            'chat.forwarded': 'Forwarded',
            'chat.emptyErr': 'Message cannot be empty.',
            'chat.infoTitle': 'Message details',
            'chat.seenByTitle': 'Seen by',
            'chat.notSeenTitle': 'Not seen yet',
            'chat.system': 'System',
            'chat.welcome': 'Welcome to the club chat! Here you can talk about games, organize sessions and socialize.',
            'chat.now': 'Now',
            'chat.inputPh': 'Message',
            'chat.attach': 'Attach a photo',
            'chat.attachTitle': 'Attach',
            'chat.attachGallery': 'Gallery',
            'chat.pickPoll': 'Choose a poll',
            'chat.newPoll': 'New poll',
            'chat.noPolls': 'The club has no polls yet.',
            'chat.pollFallback': '📊 Poll: {q}',
            'card.open': 'Open',
            'card.pollGone': 'This poll was deleted.',
            'card.until': 'until {d}',
            'card.vote1': '1 vote',
            'chat.attachGv': 'What to play',
            'chat.pickGv': 'Choose a “What to play” vote',
            'chat.noGv': 'The club has no “What to play” votes yet.',
            'chat.gvFallback': '🎲 What to play: {q}',
            'card.gvGone': 'This vote is no longer available.',
            'card.gvUp': 'Yes (+2)',
            'card.gvOk': 'Fine (+1)',
            'card.gvDown': 'No (−1)',
            'chat.attachEvent': 'Event',
            'chat.pickEvent': 'Choose an event',
            'chat.noEvents': 'The club has no events.',
            'chat.eventFallback': '📅 Event: {q}',
            'card.eventGone': 'This event was cancelled.',
            'card.eventDone': 'Took place',
            'ev.rsvpClosed': 'The event has started — replies are closed.',
            'chat.attachMatch': 'Session',
            'chat.pickMatch': 'Choose a played session',
            'chat.noMatches': 'The club has no sessions in its history yet.',
            'chat.matchFallback': '🏁 Session: {q}',
            'card.match': 'Game played',
            'card.matchGone': 'This session is no longer available.',
            'card.morePlayers': '+{n} players',
            'dm.photoOnly': '📷 Photo',
            'chat.photoUploadFail': "The photos couldn't be uploaded. The message was not sent — please try again.",
            'chat.photoMax': 'You can attach at most {n} photos to a message.',
            'chat.clear': 'Clear chat',
            'chat.notifMsgs': 'Message notifications:',
            'common.on': 'on',
            'common.off': 'off',

            'poll.createTitle': 'Create New Poll',
            'poll.question': 'Question',
            'poll.questionPh': 'e.g. What do we play Friday?',
            'poll.options': 'Options',
            'poll.optionPh': 'Option',
            'poll.addOption': 'Add option',
            'poll.create': 'Create',
            'poll.editTitle': 'Edit poll',
            'poll.saveBtn': 'Save changes',
            'poll.questionLabel': 'Poll question',
            'poll.optionsLabel': 'Options',
            'poll.allowMultiple': 'Allow multiple votes',
            'poll.showVoters': 'Show who voted',
            'poll.duration': 'Duration (days)',
            'event.addTitle': 'Add Event',
            'event.titleLabel': 'Title',
            'event.titlePh': 'e.g. Board games night',
            'event.date': 'Date',
            'event.time': 'Time',
            'event.create': 'Add',
            'game.addTitle': 'Add New Game',
            'game.name': 'Game name',
            'game.namePh': 'e.g. Catan',
            'game.category': 'Category',
            'game.minPlayers': 'Min. players',
            'game.maxPlayers': 'Max. players',
            'game.add': 'Add Game',
            'common.cancel': 'Cancel',
            'common.copy': 'Copy',
            'common.loading': 'Loading…',
            'core.loaderSlow': 'This is taking longer than usual. Please hold on…',
            'core.loaderStuck': 'Your connection seems very slow. You can keep waiting or reload the page.',
            'core.loaderOffline': "You're offline. The app will start on its own when your connection is back.",
            'core.loaderReload': 'Reload the page',
            'err.generic': 'Something went wrong. Please try again.',
            'common.errorPrefix': 'Error: ',
            'invite.titlePrefix': 'Invitation —',
            'invite.note': 'Share this link. Whoever opens it (while signed in) becomes a member of the club.',
            'invite.copy': 'Copy the link',
            'join.title': 'Join requests',
            'join.none': 'No pending requests.',
            'archives.title': 'Archived seasons',
            'archives.none': 'No archived seasons yet.',
            'archives.seasonWord': 'Season',
            'archives.delFromArchive': 'Delete from archive',
            'discover.clubsTitle': 'Discover clubs',
            'discover.noClubs': 'No new public clubs available.',
            'discover.join': 'Join',
            'discover.filters': 'Filters',
            'discover.visibility': 'Visibility',
            'discover.visAll': 'All',
            'discover.visOpen': 'Open join',
            'discover.visRequest': 'Request to join',
            'discover.any': 'Any',
            'discover.reset': 'Reset filters',
            'discover.interests': 'Interests (game types)',
            'clubinfo.title': 'About the club',
            'clubinfo.unavailable': 'Information about this club is not available.',
            'clubinfo.needsSql': 'Could not load the info (run turnorder_club_public_info.sql).',
            'clubinfo.since': 'Active since',
            'clubinfo.members': 'Members',
            'clubinfo.sessions': 'Sessions',
            'clubinfo.games': 'Games',
            'clubinfo.membersList': 'Club members',
            'discover.requestAccess': 'Request access',
            'discover.requestSent': 'Request sent',
            'discover.requestSentToast': 'Join request sent. Awaiting an admin\'s approval.',
            'discover.clubSearchPh': 'Search clubs...',
            'discover.playersTitle': 'Discover players',
            'discover.playerSearchPh': 'Search by name or game…',
            'discover.noPlayers': 'No discoverable players',
            'discover.for': 'for',
            'friend.accept': 'Accept',
            'friend.refuse': 'Refuse',
            'friend.declined': 'Request declined.',
            'friend.declineErr': 'Could not decline the request. Please try again.',
            'friend.cancelReq': 'Cancel request',
            'friend.cancelled': 'Request cancelled.',
            'friend.cancelErr': 'Could not cancel the request. Please try again.',
            'friend.reqPush': 'Sent you a friend request',
            'common.unknownUser': 'Unknown user',
            'join.viewProfile': 'View profile',
            'club.addedToClub': 'You were added to the club {name}.',
            'club.removedFromClub': 'You are no longer a member of this club.',
            /* ★ FREE TRIAL — 30 days, no card */
            'trial.cta': 'Free 30-day trial, no card',
            'trial.badge': 'Free trial',
            'trial.offerTitle': 'You have 30 free days, no card',
            'trial.confirm': 'Start your 30-day free trial on the {plan} plan? No card required. You can activate a paid subscription at any time — that ends the trial. The free trial can be used only once.',
            'trial.starting': 'Starting your free trial...',
            'trial.started': 'Free trial active: {plan}, 30 days, no card.',
            'trial.failed': 'Could not start the free trial.',
            'trial.errUsed': 'You have already used your free trial. To continue, a paid subscription is required.',
            'trial.errHasSub': 'You already have an active subscription.',
            'trial.errPaidBefore': 'This account already has payment history — the free trial is no longer available.',
            'trial.errPlan': 'That plan is not eligible for the free trial.',
            'trial.expiresIn': 'Ends in {n} days',
            'trial.remaining': 'Time left',
            'trial.endsOn': 'Ends on',
            'trial.noCardNote': 'no card',
            'trial.activatePaid': 'Activate with payment',
            'trial.claimBlocked': 'Claiming a club requires a paid subscription — the free trial does not cover claims.',
            'trial.clubExhausted': 'This club has already used its free trial. It can only be reactivated with a paid subscription.',
            'trial.transferBlocked': 'You cannot transfer the club to a member who is on a free trial. A paid subscription is required.',
            'trial.expiredTitle': 'Free trial ended',
            'trial.expiredBody': 'Your data is safe: the club stays read-only for 30 days, then it is archived. You can restore access at any time with a paid subscription.',
            'plans.title': 'Subscription plans',
            'plans.yourPlan': 'YOUR PLAN',
            'plans.renewsOn': 'Renews automatically on',
            'plans.autoRenews': 'Renews automatically',
            'plans.endsOn': 'Ends on',
            'plans.willEnd': 'Ends when the paid period runs out',
            'plans.trialEndsOn': 'Free trial ends on',
            'plans.billedMonthly': 'billed monthly',
            'plans.billedYearly': 'billed yearly',
            'plans.needsAttention': 'Your subscription needs attention',
            'plans.manageBilling': 'Manage subscription',
            'plans.portalLoading': 'Opening the billing portal…',
            'plans.portalError': 'We could not open the billing portal. Please try again in a moment.',
            'plans.portalNoSub': 'We could not find a subscription to manage for your account.',
            'plans.alreadySubscribed': 'You already have an active subscription. Change it from the billing portal — the new plan replaces the current one.',
            'plans.mostPopular': 'Most popular',
            'plans.membersWord': 'members',
            'plans.clubWord': 'club',
            'plans.clubsWord': 'clubs',
            'plans.subtitle': 'Features are cumulative — each plan includes everything below it. Annual billing = 2 months free.',
            'plans.monthly': 'Monthly',
            'plans.yearly': 'Yearly',
            'plans.seeAll': 'See all features',
            'plans.seeLess': 'Show less',
            'plans.perMonth': '/mo',
            'plans.perYear': '/yr',
            'plans.ron': 'RON',
            'plans.fromPrefix': 'from',
            'plans.save2months': '2 months free',
            'plans.perPlayer': '/player/mo',
            'plans.estCost': 'Est. cost',
            'upgrade.title': 'Feature not available on your plan',
            'upgrade.featureFrom': 'is available from the',
            'upgrade.memberLimit': 'You reached your plan member limit',
            'upgrade.clubLimit': 'You\'ve reached your plan\'s club limit',
            'club.needSubscription': 'Choose a subscription to create your club.',
            'upgrade.suggestPlan': 'Upgrade to',
            'upgrade.cta': 'See plans',
            'upgrade.later': 'Later',
            'plans.choose': 'Continue to payment',
            'plans.currencyNote': 'USD/EUR prices are indicative; billing is done in RON, at the displayed RON price.',
            'checkout.soon': 'Stripe checkout is coming in the next step.',
            'billing.title': 'Company billing details',
            'billing.note': 'Billing details are handled by Stripe at the time of payment.',
            'billing.company': 'Company name',
            'billing.cui': 'VAT ID / CUI (e.g. RO12345678)',
            'billing.regCom': 'Trade Register no. (e.g. J40/1234/2020)',
            'billing.address': 'Billing address',
            'billing.save': 'Save billing details',
            'billing.requiredBeforePay': 'Please fill in your billing details first, then you can pay.',
            'billing.saved': 'Billing details saved.',
            'billing.cuiInvalid': 'Invalid VAT ID. Use digits only (optional RO prefix).',
            'billing.companyRequired': 'Company name is required.',
            'billing.addressRequired': 'Billing address is required.',
            'billing.requiredFirst': 'Please complete the company billing details first.',
            'billing.typeIndividual': 'I am an Individual',
            'billing.typeCompany': 'I am a Company',
            'billing.fullName': 'Full name',
            'billing.country': 'Country',
            'billing.countryRO': 'Romania',
            'billing.countryOther': 'Other country (international)',
            'billing.fullNameRequired': 'Full name is required.',
            'billing.countryRequired': 'Please select your country.',
            'plans.enterprisePrice': 'Contact for offer',
            'plans.enterpriseContact': 'For Enterprise, contact us for a custom offer.',
            'checkout.loading': 'Preparing checkout...',
            'checkout.resuming': 'Details saved — continuing to payment...',
            'checkout.activated': 'Your plan is now active!',
            'checkout.pendingReload': 'Payment received. If your plan does not appear right away, reload the page in a few moments.',
            'checkout.redirect': 'Redirecting to Stripe...',
            'checkout.netError': 'Network error starting checkout. Please try again.',
            'checkout.success': 'Payment started! Your subscription will activate shortly.',
            'checkout.canceled': 'Payment was canceled.',
            'plan.unlimitedMembers': 'unlimited members',
            'plan.upTo': 'up to',
            'feat.thisFeature': 'This feature',
            'feat.advancedFeature': 'Advanced feature',
            'feat.availFrom': 'is available from the',
            'feat.planSuffix': ' plan.',
            'feat.seeSettings': 'See "Club settings".',
            'feat.availableFromPlan': 'Available from the',
            'feat.changePlan': 'Change the plan in "Club settings".',
            'feat.askAdmin': 'Ask an admin to upgrade the club.',
            'feat.fromShort': 'from',
            'dash.title': 'General Statistics',
            'dash.nextEvent': 'Next event',
            'dash.seeCalendar': 'View calendar',
            'dash.openEvent': 'Open',
            'dash.activePlayers': 'Active Players',
            'dash.sessions30': 'Sessions (30 days)',
            'dash.recentActivityChange': 'recent activity',
            'dash.currentSeason': 'Current Season',
            'dash.leaderboard': 'Current Leaderboard',
            'dash.loc': 'Rank',
            'dash.trend': 'Trend',
            'dash.clubAchievements': 'Club Achievements',
            'dash.achievementsIntro': "Goals unlocked together, from the whole club's activity.",
            'dash.monthlyPerf': 'Monthly Performance',
            'dash.gamesPlayed': 'Games played',
            'dash.sessions6mo': 'sessions (6 mo)',
            'dash.recentTitle': 'Recent Activity',
            'dash.recentSearchPh': '🔍 Search all sessions (game, player, location, notes)...',
            'dash.month': 'Month',
            'dash.memberOne': 'member',
            'dash.memberMany': 'members',
            'dash.online': 'online',
            'dash.you': '(you)',
            'dash.noActivity': 'No recent activity.',
            'dash.noOneOnline': 'No one online',
            'hist.searchLabel': 'Search (game, player, location, notes)',
            'hist.search': 'Search',
            'hist.filters': 'Filters',
            'hist.export': 'Export',
            'hist.seeAllPlayers': 'See all players',
            'hist.searchPh': 'Type a keyword...',
            'hist.filterPlayer': 'Filter by player',
            'hist.period': 'Period',
            'hist.periodAll': 'All time',
            'hist.periodWeek': 'This week',
            'hist.periodMonth': 'This month',
            'hist.periodYear': 'This year',
            'hist.periodLast30': 'Last 30 days',
            'hist.game': 'Game',
            'hist.allGames': 'All games',
            'hist.exportCsv': 'Export CSV',
            'hist.exportPdf': 'Export PDF',
            'hist.clearFilters': 'Reset filters',
                        'hist.uniform': 'Uniformized',
            'hist.uniformTip': 'Uniformized scoring session: raw scores were converted into Club Points.',
            'hist.uniformWhat': 'Tap to see what this means',
            'hist.uniformExplain': 'So you can fairly compare different games on the overall leaderboard, raw scores are converted into "Club Points" based on placement.',
            'hist.uniformHow': 'Your club\'s scoring:',
            'hist.uniformComp': 'Competitive (by placement)',
            'hist.uniformCoop': 'Co-op',
            'hist.uniformCamp': 'Campaigns and RPGs',
            'hist.uniformPart': 'taking part',
            'hist.clubPts': 'club pts',
            'hist.tieBreakWon': 'Won the tie-break',
'hist.points': 'points',
            'hist.turnTime': 'Turn time',
            'hist.participants': 'participants',
            'cal.upcoming': 'Upcoming Events',
            'cal.coming': 'Coming',
            'cal.maybe': 'Maybe',
            'cal.notComing': 'Not coming',
            'cal.deleteEvent': 'Delete event',
            'cal.rsvpYes': 'coming',
            'cal.rsvpMaybe': 'maybe',
            'cal.rsvpNo': 'no',
            'camp.inProgress': 'In progress',
            'camp.completed': 'Completed',
            'camp.scenarios': 'scenarios',
            'camp.scenario': 'Scenario',
            'camp.abandoned': 'Abandoned',
            'camp.completedF': 'Completed',
            'camp.noScenarios': 'No scenarios yet.',
            'camp.noCampaigns': 'No campaigns yet. Tap "New campaign" to start (e.g. Gloomhaven).',
            'camp.winShort': 'W',
            'camp.lossShort': 'L',
            'camp.statusLabel': 'Status',
            'camp.gameLabel': 'Game (optional)',
            'camp.gamePh': 'e.g. Gloomhaven',
            'camp.sessionsCount': 'sessions',
            'camp.charsActive': 'active characters',
            'camp.startSession': '+ Campaign session',
            'camp.noLinkedSessions': 'No linked sessions yet.',
            'camp.attachLabel': 'Attach to campaign',
            'camp.attachNone': '— no campaign —',
            'camp.scenarioLabel': 'Scenario (optional)',
            'camp.scenarioPh': 'e.g. Scenario 3 — The Crypt',
            'camp.sessionStarted': 'Campaign session started: {name}',
            'camp.needUniformNote': 'enable uniform scoring in Admin for Club Points',
            'camp.saved': 'Campaign saved.',
            'camp.demoNote': 'Campaigns require a real account (unavailable in demo).',
            'camp.scenarioObsolete': 'Scenarios are now added as campaign sessions.',
            'camp.deleteViaHistory': 'Delete the session from History.',
            'camp.err.forbidden': 'You do not have permission for this action.',
            'camp.err.plan': 'Campaigns require the Pro plan or higher.',
            'camp.err.name': 'Give the campaign a name.',
            'camp.err.badGame': 'The selected game is not valid for this club.',
            'camp.err.badStatus': 'Invalid status.',
            'camp.err.badPatch': 'Invalid World State data.',
            'camp.err.notMember': 'That player is not an active club member.',
            'camp.err.charNotFound': 'Character not found.',
            'camp.err.notFound': 'Campaign not found.',
            'camp.err.club': 'The club cannot be modified right now.',
            'camp.err.generic': 'Something went wrong. Please try again.',
            'camp.back': 'Back',
            'camp.linkedSessions': 'Linked sessions',
            'camp.charactersTitle': 'Characters',
            'camp.noChars': 'No active characters yet.',
            'camp.addMyChar': '+ My character',
            'camp.addCharOther': '+ Character (member)',
            'camp.editChar': 'Edit character',
            'camp.newChar': 'New character',
            'camp.retireCharBtn': 'Retire',
            'camp.retiredTitle': 'Retired characters',
            'camp.charSaved': 'Character saved.',
            'camp.charRetired': 'Character retired.',
            'camp.confirmRetireChar': 'Retire character "{name}"? A new one can be created afterwards.',
            'camp.you': 'you',
            'camp.lvl': 'Lv.',
            'camp.xpNote': 'Campaign XP is in-fiction, separate from profile XP.',
            'camp.selectMember': '— choose member —',
            'camp.f.member': 'Member',
            'camp.f.memberSearchPh': 'Search member…',
            'camp.f.name': 'Character name',
            'camp.f.namePh': 'e.g. Brute',
            'camp.f.class': 'Class',
            'camp.f.classPh': 'e.g. Inox',
            'camp.f.level': 'Level',
            'camp.f.xp': 'XP (in-fiction)',
            'camp.f.gold': 'Gold',
            'camp.f.equipment': 'Equipment',
            'camp.f.quest': 'Personal quest',
            'camp.f.notes': 'Notes',
            'camp.showMore': 'Show more',
            'camp.showLess': 'Show less',
            'camp.ws.title': 'World State',
            'camp.ws.empty': 'Nothing in world state yet.',
            'camp.ws.edit': 'Edit World State',
            'camp.ws.counters': 'Counters',
            'camp.ws.counterKey': 'Name',
            'camp.ws.counterVal': 'Value',
            'camp.ws.counterHint': 'Counters can be added or updated.',
            'camp.ws.addCounter': '+ Counter',
            'camp.ws.unlocks': 'Unlocks',
            'camp.ws.achievements': 'Achievements',
            'camp.ws.notes': 'Notes',
            'camp.ws.linePh': 'one per line',
            'camp.ws.saved': 'World State saved.',
            'camp.err.charNotInCamp': 'Character does not belong to this campaign.',
            'camp.err.badMatch': 'Invalid session.',
            'camp.err.badEntries': 'Invalid progression data.',
            'camp.prog.title': 'Character progression',
            'camp.prog.btn': 'XP/Gold',
            'camp.prog.has': 'Progression recorded',
            'camp.prog.hint': 'Values gained in this session (in-fiction, separate from Club Points).',
            'camp.prog.noChars': 'No active characters for progression.',
            'camp.prog.saved': 'Progression saved.',
            'camp.finalize': 'Finalize',
            'camp.reopen': 'Reopen',
            'camp.final.title': 'Finalize campaign',
            'camp.final.hint': 'Optional: Club Points awarded on finalize (reversible on reopen).',
            'camp.final.modOnly': 'You will mark the campaign as finalized. Distributing Club Points requires an Administrator.',
            'camp.final.noParts': 'No participant with a character.',
            'camp.final.done': 'Campaign finalized.',
            'camp.reopen.confirm': 'Reopen campaign "{name}"? Any final points awarded will be reversed.',
            'camp.reopen.done': 'Campaign reopened.',
            'camp.err.finalNeedsAdmin': 'Distributing Club Points requires an Administrator.',
            'camp.err.awardTarget': 'One of the awarded targets is not a club member.',
            'camp.err.badTransition': 'Invalid status transition.',
            'camp.err.notActive': 'Campaign is not active. Reopen it to add sessions.',
            'camp.notif.new': 'New campaign: {name}',
            'camp.notif.finalized': 'Campaign completed: {name}',
            'camp.gold': 'Gold',
            'camp.evo.title': 'Character evolution',
            'camp.evo.retired': 'retired',
            'camp.search': 'Search',
            'camp.searchPh': 'Search campaigns…',
            'camp.searchEmpty': 'No campaigns found.',
            'camp.export': 'Export',
            'camp.exportEmpty': 'Nothing to export.',
            'camp.exp.name': 'Name',
            'camp.exp.game': 'Game',
            'camp.exp.status': 'Status',
            'camp.exp.created': 'Created',
            'scoreTpl.title': 'Score uniformization (Club Points)',
            'scoreTpl.intro': 'Turn raw scores into "Club Points" based on placement, so you can fairly compare different games on the overall leaderboard. When enabled, each new session lets you pick "Raw" or "Uniformized".',
            'scoreTpl.useUniform': 'Use uniformization in this club',
            'scoreTpl.defaultMode': 'Default mode for new sessions',
            'scoreTpl.modeRaw': 'Raw (as in the rulebook)',
            'scoreTpl.modeUniform': 'Uniformized (Club Points)',
            'scoreTpl.tplA': 'Template A — Competitive (rank-based)',
            'scoreTpl.tplADesc': 'Points awarded by finishing place. The last row applies to all lower places.',
            'scoreTpl.place': 'Place',
            'scoreTpl.placeAndBelow': '+ (and below)',
            'scoreTpl.pts': 'pts',
            'scoreTpl.addPlace': 'Add place',
            'scoreTpl.removePlace': 'Remove last',
            'scoreTpl.tplB': 'Template B — Cooperative (Win/Loss)',
            'scoreTpl.tplBDesc': 'For co-op games: only whether the team beat the game matters.',
            'scoreTpl.win': 'Win',
            'scoreTpl.loss': 'Loss',
            'scoreTpl.tplC': 'Template C — Campaign / RPG (Participation)',
            'scoreTpl.tplCDesc': 'Each present player gets participation points; individual bonuses are added manually at the session.',
            'scoreTpl.participation': 'Participation (per player)',
            'scoreTpl.saved': 'Scoring settings saved.',
            'elo.title': 'ELO Leaderboard',
            'elo.activeNote': 'Competitive mode active · K=32, start 1000. Auto-computed from sessions.',
            'elo.gamesWord': 'games',
            'elo.statePrefix': 'Status:',
            'elo.on': 'ENABLED',
            'elo.off': 'DISABLED',
            'elo.descOn': 'When enabled, an ELO leaderboard (K=32, start 1000) appears, auto-computed from sessions and visible to all club members.',
            'elo.disable': 'Disable competitive mode',
            'elo.enable': 'Enable competitive mode',
            'role.principal': 'Principal admin',
            'role.secondary': 'Secondary admin',
            'role.moderator': 'Moderator',
            'role.member': 'Member',
            'rbac.community': 'Community management',
            'rbac.role': 'Role',
            'rbac.changeRole': 'Change role',
            'rbac.roleUpdated': 'Role updated.',
            'rbac.noPermission': 'You do not have permission for this action.',
            'rbac.cantManagePrincipal': 'The Principal Admin role can only change via ownership transfer.',
            'rbac.cantManageHigher': 'You cannot modify a member with an equal or higher role.',
            'rbac.you': '(you)',
            'menu.myClubs': 'My clubs',
            'menu.switchClub': 'Switch club',
            'plans.downgrade': 'Change plan',
            'menu.inviteLink': 'Invite via link',
            'menu.reactivate': 'Reactivate club',
            'menu.closeClub': 'Close active club (archive)',
            'cal.monthNames': 'January,February,March,April,May,June,July,August,September,October,November,December',
            'cal.dayNames': 'S,M,T,W,T,F,S',
            'gv.title': 'What do we play tonight?',
            'gv.howMany': 'How many players?',
            'gv.recommend': 'Recommend',
            'gv.random': 'Pick at random',
            'gv.lastPlayed': 'last played:',
            'poll.startedBy': 'Started by',
            'poll.voterOne': 'voter',
            'poll.voterMany': 'voters',
            'poll.anon': '🔒 anonymous',
            'poll.pub': '👁️ public',
            'poll.closeVote': 'Close vote',
            'poll.score': 'score',
            'adm.email': 'Email',
            'adm.name': 'Name',
            'adm.searchMembers': 'Search by name or email...',
            'adm.admin': 'Admin',
            'adm.createdAt': 'Created at',
            'adm.lastLogin': 'Last login',
            'adm.actions': 'Actions',
            'adm.currentScore': 'Current score',
            'adm.newScore': 'New score',
            'adm.action': 'Action',
            'adm.auditSynced': 'Log synced with the server — persistent across all devices, append-only (cannot be edited or deleted).',
            'adm.auditLocalNote': 'Local log (this device only). Syncs with the server when available.',
            'common.prev': 'Previous',
            'adm.noAudit': 'No audit records.',
            'adm.fullReset': 'Reset club data',
            'admin.dangerZone': 'Danger Zone',
            'admin.clubResetNote': "Deletes the current club's sessions, history, events and chat. Players' accumulated scores, members and the game catalog remain.",
            'admin.clubResetC1': "WARNING: Delete this club's sessions, history, events and chat? Players' scores, the club and members remain.",
            'admin.clubResetDone': 'Club data has been reset.',
            'reg.internalTitle': 'Internal Rulebook —',
            /* Regulament implicit pentru cluburile noi (EN) */
            'regdef.a1.title': 'Art. 1 — Game sessions',
            'regdef.a1.body': '1.1. Proposing games. Each member may propose up to three games from the club catalog for the next session. Not everyone has to propose, but at least one proposal is needed for the session to happen.\n1.2. Deadline. Proposals are submitted no later than 48 hours before the session. Late ones roll over to the next round.\n1.3. Selection. Three games are drawn from all proposals and members vote for one. The game with the most votes becomes the session game. Ties are decided by the session organiser.\n1.4. Variety. The game played in the previous session cannot be proposed again straight away, so the list stays varied.\n1.5. Teaching the rules. Whoever brings the selected game explains it to the others. If nobody knows it, agree in advance who will learn the rules.',
            'regdef.a2.title': 'Art. 2 — Members and conduct',
            'regdef.a2.body': '2.1. Respect. Members treat each other with respect, regardless of experience, age or skill. Insults, discrimination and harassment are not tolerated.\n2.2. Newcomers. A new player gets the explanations they need, without rushing and without blame. The club exists to bring people in, not to filter them out.\n2.3. Phones and attention. During a game, attention stays at the table. Announce long breaks so others are not left waiting.\n2.4. Disputes. Rules disagreements are settled on the spot by checking the rulebook. If there is no clear answer, the group votes and the decision holds until the end of the game.\n2.5. Reporting. Any inappropriate behaviour can be reported to an admin, who decides on the response, up to removal from the club.',
            'regdef.a3.title': 'Art. 3 — The club\'s games',
            'regdef.a3.body': '3.1. Ownership. Every game in the catalog belongs either to the club or to a member. The owner is listed in the catalog and decides whether the game can be borrowed.\n3.2. Care. Handle components carefully and pack the game away completely at the end. Cards go back into their sleeves, where they are used.\n3.3. Lost or damaged parts. Whoever loses or damages a component tells the owner and arranges a replacement where possible.\n3.4. Food and drink. Do not eat or drink directly over components. Glasses go on a surface other than the play area.\n3.5. Borrowing. A borrowed game comes back at the next session, complete and in the same condition, unless agreed otherwise with the owner.',
            'regdef.a4.title': 'Art. 4 — Attendance and scheduling',
            'regdef.a4.body': '4.1. Confirming. Confirm attendance in the app so the organiser knows how many people to count on and which games fit.\n4.2. Cancelling. If you can no longer come, say so as early as possible. A cancellation a few hours ahead can leave a game below its minimum player count.\n4.3. Late arrivals. Sessions start at the announced time. Latecomers join the next game rather than interrupting one in progress.\n4.4. Venue. The location is announced together with the session. If it is at someone\'s home, the host sets their own house rules and those are respected.\n4.5. Guests. Members may bring guests by announcing them in advance. Guests follow the same regulation.',
            'regdef.a5.title': 'Art. 5 — Scores, leaderboard and fair play',
            'regdef.a5.body': '5.1. Recording. The result of every game is entered in the app at the end, by the organiser or by whoever taught the game.\n5.2. Accuracy. Scores are recorded exactly as they happened. A mistake spotted later is fixed by editing the session, not by rewriting history.\n5.3. Leaderboard. Club points follow the system the club has chosen and may be reset at the start of a new season. Session history stays untouched.\n5.4. Fair play. Cheating, hidden agreements between players and deliberately throwing a game to affect someone else\'s result are not accepted.\n5.5. Unfinished games. A game abandoned for time reasons may be recorded as unfinished, with no winner, if the members present agree.',
            'reg.version': 'Version',
            'reg.lastModified': 'Last modified:',
            'reg.searchPh': 'Search the rulebook...',
            'reg.noMatch': 'No article matches your search.',
            'reg.empty': 'The rulebook has no articles yet.',
            'reg.articleOne': 'article',
            'reg.articleMany': 'articles',
            'reg.effectiveFrom': 'Effective from:',
            'clubset.membersUsed': 'Members used:',
            'clubset.planFromSub': 'The plan comes from your subscription.',
            'clubset.archiveHint': 'Closes (archives) the active club. The club becomes inaccessible to members until you reactivate it from the “My clubs” drawer.',
            'clubset.canPlanNote': ' (As principal admin you can change the plan. Real payments come with the subscription module.)',
            'clubset.noPlanNote': ' The plan can only be changed by the club\'s principal admin.',
            'ach.unlocked': 'unlocked',
            'ach.unlockedOne': 'Achievement unlocked',
            'ach.detailTitle': 'Achievement details',
            'ach.unlockedStatus': 'Unlocked',
            'ach.lockedStatus': 'Still locked',
            'ach.doneNote': 'Congrats — the whole club reached this goal!',
            'ach.remaining': '{n} more to go to unlock it.',
            'feedback.button': 'Feedback',
            'feedback.title': 'Feedback / Report a problem',
            'feedback.intro': "Tell us what works well or what doesn't. Your message goes straight to the team.",
            'feedback.placeholder': 'Write your suggestion or issue here...',
            'feedback.send': 'Send',
            'feedback.cancel': 'Cancel',
            'feedback.sent': 'Thanks! Feedback sent.',
            'feedback.empty': 'Write a message first.',
            'feedback.error': "Couldn't send the feedback. Please try again.",
            'feedback.rateLimit': 'You have sent too many messages. Please try again in a few minutes.',

            'event.eTitle': 'Event title',
            'event.eTitlePh': 'e.g. Catan Tournament',
            'event.location': 'Location',
            'event.locationPh': 'e.g. Central Café',
            'event.type': 'Event type',
            'event.typeSession': '🎮 Game session',
            'event.typeTournament': '🏆 Tournament',
            'event.typeMeeting': '🤝 Meeting',
            'event.typeOther': '📅 Other',
            'event.description': 'Description',
            'event.descriptionPh': 'Event details...',
            'event.recurrence': 'Recurrence',
            'event.recOnce': 'One-time event',
            'event.recWeekly': 'Weekly',
            'event.recBiweekly': 'Every 2 weeks',
            'event.recMonthly': 'Monthly',
            'event.recCount': 'How many times',
            'event.save': 'Save event',

            'game.addTitleNew': 'Add New Game',
            'game.editTitle': 'Edit game',
            'game.nameLockedNote': 'The name can\'t be changed here (keeps the history link).',
            'game.bggSearch': 'Search BoardGameGeek',
            'game.nameLabel': 'Game Name',
            'game.players': 'Number of players',
            'game.playersPh': 'e.g. 2-4',
            'game.durationLabel': 'Duration (min)',
            'game.difficulty': 'Difficulty (1-5)',
            'game.diff1': '1 – Light',
            'game.diff2': '2 – Medium Light',
            'game.diff3': '3 – Medium',
            'game.diff4': '4 – Medium Heavy',
            'game.diff5': '5 – Heavy',
            'game.rating': 'Rating (1-10)',
            'game.moreDetails': 'More details (optional)',
            'game.imageUrl': 'Game image (URL)',
            'game.age': 'Minimum age',
            'game.edition': 'Edition',
            'game.scoreDir': 'Score direction',
            'game.scoreDirHigh': 'Highest score wins',
            'game.scoreDirLow': 'Lowest score wins',
            'game.scoreDirHint': 'Who wins this game: highest score (default) or lowest (golf, penalty games). You can override this per session.',
            'game.editionPh': 'e.g. the edition you own',
            'game.editionLabel': 'Edition (from BGG)',
            'game.editionNone': '— Default edition —',
            'game.editionSearch': 'Search edition (name / language / year)…',
            'game.editionSet': 'Edition selected',
            'catalog.edition': 'Edition',
            'game.designer': 'Designer',
            'game.artist': 'Artist',
            'game.publisher': 'Publisher',
            'game.categories': 'Categories',
            'game.categoriesPh': 'Or enter new categories separated by commas',
            'game.description': 'Description',
            'rand.maxDiff': 'Max difficulty',
            'rand.any': 'Any',

            'profile.tabTitle': 'My profile',
            'profile.statsTitle': 'Statistics',
            'profile.points': 'Points',
            'profile.totalScores': 'Total scores',
            'profile.games': 'Games',
            'profile.winRate': 'Win rate',
            'profile.pointsNote': 'Points and scores can only be changed by administrators.',
            'profile.statsScopeClub': 'This club',
            'profile.statsScopeGlobal': 'All clubs',
            'profile.statsCalculating': 'Calculating global stats…',
            'profile.statsLoadError': 'Could not load global stats.',
            'profile.statsGlobalNote': 'Stats aggregated across all clubs you belong to.',
            'profile.statMatches': 'Total matches',
            'profile.statDistinctGames': 'Distinct games',
            'profile.eloPerClub': 'ELO per club',
            'profile.noEloClubs': 'No club with ranked matches yet.',
            'profile.xp': 'XP',
            'profile.myFriends': 'My friends',
            'profile.noFriends': 'You have no friends yet. Find players in Discover players.',
            'profile.myData': 'My data',
            'profile.avatar': 'Avatar',
            'profile.avatarNone': '— none —',
            'profile.displayName': 'Display name',
            'profile.nameNote': 'If you change it, older sessions keep the previous name.',
            'profile.userTag': 'User Tag (unique handle)',
            'profile.userTagNote': 'Unique identifier for login and mentions. Lowercase letters, digits, dot or underscore only (no spaces). Shown with a leading @.',
            'profile.userTagLocked': 'Permanent',
            'profile.userTagLockedNote': 'Your tag is permanent and can no longer be changed — neither by you nor by club admins.',
            'profile.userTagOnceNote': 'You can change your user tag only once; after that it becomes permanent.',
            'profile.userTagChangeWarn': 'Warning! You can change your user tag only once. After this action, your tag becomes permanent and can no longer be modified, neither by you nor by club admins. Are you sure you typed {tag} correctly?',
            'profile.userTagEmpty': 'User Tag cannot be empty.',
            'profile.userTagInvalid': 'Invalid User Tag: 3-30 chars, lowercase letters, digits, dot or underscore only.',
            'profile.userTagTaken': 'This User Tag is already taken. Please choose another.',
            'profile.userTagNeedsSql': 'Your name was saved. For the User Tag, run "turnorder_user_tag.sql" in Supabase.',
            'profile.about': 'About me',
            'profile.aboutPh': 'A few words about you as a player...',
            'profile.photo': 'Profile photo (optional)',
            'profile.attachPhoto': 'Attach photo',
            'profile.removePhoto': 'Remove photo',
            'profile.photoNote': 'The photo takes priority over the emoji and is resized automatically.',
            'profile.editPhoto': 'Edit photo',
            'profile.photoReady': 'Photo ready. Press "Save profile".',
            'common.done': 'Done',
            'profile.favGames': 'Favorite games',
            'profile.clubs': 'Clubs',
            'profile.addFromCatalog': 'Add from catalog',
            'profile.bggLinkPh': 'or paste a BoardGameGeek link',
            'profile.addFromBgg': 'Add from BGG',
            'profile.favSearchPh': 'Search a game (catalog + BoardGameGeek)…',
            'profile.favNoLocal': 'No game found in the catalog. Type at least 3 letters for BGG or paste a link below.',
            'profile.bggUser': 'BoardGameGeek user',
            'profile.optional': 'optional',
            'profile.security': 'Account security',
            'block.menu': 'Options',
            'block.block': 'Block',
            'block.unblock': 'Unblock',
            'block.notNow': 'Not now',
            'block.confirmMsg': 'Block {name}?\n\nYou will no longer be able to send each other direct messages, the friendship is removed, and your profiles become invisible to one another.\n\nThe name stays visible in club history and standings.',
            'block.unblockMsg': 'Unblock {name}?\n\nYou will be able to message each other and see each other\'s profiles again. The friendship is NOT restored automatically.',
            'block.afterReport': 'Your report was sent. Would you also like to block {name}?',
            'block.done': 'User blocked.',
            'block.undone': 'User unblocked.',
            'block.failed': 'That did not work. Please try again.',
            'block.loading': 'Loading…',
            'block.none': 'You have not blocked anyone.',
            'block.listTitle': 'Blocked users',
            'block.listNote': 'You cannot send each other direct messages and cannot see each other\'s profiles. The name stays visible in club history.',
            'block.hiddenProfile': 'This profile is not available.',
            'block.youBlocked': 'You blocked this user.',
            'block.dmBar': 'You cannot send messages to this user.',
            'profile.email': 'Email',
            'profile.emailNote': 'If you change your email, you may receive a confirmation message.',
            'profile.hideEmail': "Don't show email in public profile",
            'profile.discoverable': 'Discoverable profile (appear in "Discover players" for other users)',
            'profile.newPassword': 'New password',
            'profile.newPasswordPh': 'leave empty to keep current',
            'profile.confirmPassword': 'Confirm new password',
            'profile.confirmPasswordPh': 're-enter new password',
            'profile.setPwNote': 'Leave empty to keep your current password. If you signed up with Google, set a password here to also log in with email.',
            'profile.save': 'Save profile',
            'profile.deleteAccount': 'Delete my account',
            'profile.memberSince': 'member since',
            'profile.mySub': 'My subscription',
            'sub.renewsOn': 'Renews on',
            'sub.expiresOn': 'Expires on',
            'sub.daysLeft': 'days left',
            'sub.renewsInDays': 'days until renewal',
            'sub.autoRenew': 'Auto-renewal',
            'sub.on': 'On',
            'sub.off': 'Off',
            'sub.turnOff': 'Turn off',
            'sub.turnOn': 'Turn on',
            'sub.updating': 'Updating subscription...',
            'sub.autoRenewError': 'Could not update auto-renewal.',
            'sub.autoRenewOnMsg': 'Auto-renewal has been turned back on.',
            'sub.autoRenewOffMsg': 'Auto-renewal turned off. Your subscription will expire at the end of the current period.',
            'transfer.title': 'Transfer club ownership',
            'transfer.button': 'Transfer club',
            'transfer.settingsHint': 'Hand over the Principal Admin role to another member. You will become a secondary admin.',
            'transfer.warning': 'Warning: after the transfer, the new member becomes Principal Admin and you become a secondary admin. This can only be undone by a new transfer.',
            'transfer.searchPh': 'Search member by name or @user_tag...',
            'transfer.noMembers': 'No members found.',
            'transfer.confirm': 'Are you sure you want to transfer the club to {name}? You will become a secondary admin.',
            'transfer.working': 'Transferring the club...',
            'transfer.success': 'The club has been transferred to {name}.',
            'transfer.failed': 'The transfer failed.',
            'transfer.errNoSub': 'The selected member has no active subscription. The club depends on the owner\'s subscription.',
            'transfer.errNoSlot': 'The selected member has no free club slot on their plan.',
            'transfer.errNotMember': 'The selected person is not an active member of the club.',
            'transfer.dmBody': '🔑 Ownership of club "{club}" has been transferred to you. You are now Principal Admin.',
            'profile.noSub': 'No active subscription',
            'profile.manageSub': 'Manage',
            'profile.clubsUsed': 'Clubs used',
            'profile.membersPerClub': 'Members/club',
            'common.players': 'players',
            'common.never': 'Never',
            'common.total': 'Total',
            'common.game': 'Game',
            'common.date': 'Date',
            'stats.totalGames': 'Total games',
            'session.allGames': 'All games',
            'club.noClubs': 'No clubs.',
            'tabmenu.open': 'Menu',
            'tabmenu.close': 'Close',
            'common.unknownF': 'Unknown',
            'session.minutesShort': '{n} min',
            'players.createProfileError': 'Could not create the profile.',
            'players.addErrorColon': 'Error while adding: ',
            'common.selectAll': 'Select all',
            'common.deleteSelected': 'Delete selected',
            'common.import': 'Import',
            'common.viewProfile': 'View profile',
            'common.description': 'Description',
            'common.tryOtherSearch': 'Try another search term',
            'common.playsShort': 'plays',
            'common.ptsShort': 'pts',
            'ra.fallbackName': 'Session',
            'ra.format': 'Format',
            'ra.rounds': 'rounds',
            'ra.prize': 'Prize',
            'ra.fee': 'Fee',
            'ra.noScore': 'No score',
            'ra.searchEmptyPre': 'No session found for',
            'ss.help': 'Score categories (e.g. "Settlements", "Cities", "Development cards"). The total is computed automatically as their sum.',
            'ss.addField': 'Add category',
            'ss.fieldPh': 'Category name',
            'roles.heading': 'Roles / factions',
            'roles.help': 'The game roles/factions (e.g. "Marquise", "Eyrie", "Woodland Alliance"). For each session you can pick every player\'s role, and the "win rate per role" stat is computed automatically.',
            'roles.addField': 'Add role',
            'roles.fieldPh': 'Role/faction name',
            'session.timerPause': 'Pause',
            'session.timerStop': 'Stop &amp; set duration',
            'session.removeGuest': 'Remove guest',
            'players.noneFound': 'No players found',
            'players.addFirst': 'Add the first player!',
            'players.actActive': '🔥 Active',
            'players.actModerate': '📊 Moderate',
            'players.actInactive': '😴 Inactive',
            'players.emailPromptPre': 'Email for',
            'players.emailPromptPost': '(leave empty for none):',
            'import.playersTitle': 'Import Players',
            'import.pasteLabel': 'Paste players (one per line)',
            'import.formatHint': 'Format: <b>Name</b> or <b>Name, email</b>. Works with CSV files too.',
            'import.orCsv': '...or upload a CSV file',
            'bulk.playersTitle': 'Bulk Delete Players',
            'bulk.warningPlayers': 'Warning: deletion is permanent and also removes scores from history.',
            'bulk.gamesTitle': 'Bulk Delete Games',
            'bulk.warningGames': 'Deleted games disappear from the catalog (session history stays unchanged).',
            'bulk.gamesLinksNote': 'Tournaments and campaigns using the deleted games remain, but lose their link to the game. Session history is NOT affected (it links by title, not by id).',
            'bulk.gamesDeleting': 'Deleting games…',
            'bulk.gamesDeletePartial': 'Deleted: {ok}. Could not delete: {fail}.',
            'catalog.noneFound': 'No games found',
            'catalog.addFirst': 'Add the first game!',
            'catalog.lastShort': 'last',
            'catalog.difficulty': 'Difficulty',
            'catalog.weight': 'Weight',
            'catalog.rating': 'Rating',
            'catalog.age': 'Age',
            'catalog.designer': 'Designer',
            'catalog.artist': 'Artist',
            'catalog.publisher': 'Publisher',
            'catalog.diffPrompt': 'Difficulty (weight) for',
            'catalog.playsLabel': 'Plays',
            'rate.ratingLabel': 'Your rating (1–10)',
            'rate.weightLabel': 'Difficulty / Weight (1–5)',
            'rate.save': 'Save rating',
            'rate.saved': 'Rating saved!',
            'rate.yourPrev': 'Your previous rating:',
            'catalog.playsShort': 'plays',
            'catalog.realMin': 'real min',
            'catalog.rate': 'Rate',
            'catalog.noListGames': 'No member has added games to a list',
            'catalog.beFirstList': 'Be the first to add favorite games!',
            'catalog.bggLinkLabel': 'BoardGameGeek link or ID',
            'catalog.edit': 'Edit',
            'catalog.saveGame': 'Save changes',
            'catalog.addGameBtn': 'Add Game',
            'catalog.descPh': 'Game description...',
            'catalog.info': 'Information',
            'catalog.playersColon': 'Players',
            'catalog.durationLabel': 'Duration',
            'catalog.realAvg': 'real avg',
            'catalog.lastPlayedLabel': 'Last played',
            'catalog.categories': 'Categories',
            'catalog.noCategories': 'No categories',
            'catalog.statistics': 'Statistics',
            'catalog.avgDurationLabel': 'Real avg duration',
            'catalog.favoriteFor': 'Favorite for',
            'catalog.scoreBlendBoth': 'average of the BGG score {bgg} and {n} vote(s) from this club\'s members',
            'catalog.scoreBggOnly': 'BGG score {bgg}',
            'catalog.scoreClubOnly': 'average of {n} vote(s) from this club\'s members',
            'common.readMore': 'Read more',
            'common.readLess': 'Read less',
            'catalog.nobody': 'Nobody',
            'catalog.viewBgg': 'View on BGG',
            'catalog.bggUserPrompt': 'Enter your BoardGameGeek username:',
            /* BGG collection import — progress window */
            'bggimp.title': 'Import BoardGameGeek collection',
            'bggimp.phaseCollection': 'Reading your BGG collection…',
            'bggimp.phaseDetails': 'Fetching game details…',
            'bggimp.phaseSaving': 'Saving to the club catalog…',
            'bggimp.phaseRefresh': 'Reloading the catalog…',
            'bggimp.counter': '{done} of {total}',
            'bggimp.cancel': 'Cancel',
            'bggimp.cancelling': 'Stopping after the current batch…',
            'bggimp.done': 'Import finished: {ins} new games, {upd} enriched.',
            'bggimp.doneCancelled': 'Import stopped: {ins} new games, {upd} enriched. What was saved stays saved.',
            'bggimp.noWeight': 'BGG has no complexity rating for {n} games.',
            'bggimp.failedDetails': 'Details could not be fetched for {n} games; saved with basic data only.',
            'bggimp.invalidUser': 'That BGG user does not exist, or their collection is private.',
            'bggimp.noClub': 'Select a club before importing.',
            'bggimp.error': 'Import failed: {msg}',
            'catalog.ratePromptPre': 'Rate',
            'catalog.ratePromptPost': 'from 1 to 10:',
            'csv.name': 'Name',
            'csv.email': 'Email',
            'csv.points': 'Points',
            'csv.plays': 'Plays',
            'csv.avg': 'Average',
            'csv.winRate': 'Win Rate',
            'csv.joinDate': 'Join Date',
            'session.timerResetTitle': 'Reset times',
            'import.pastePh': 'Player name, email@example.com&#10;Maria Popescu&#10;Andrei Ionescu, andrei@mail.com',
            'common.enabled': 'enabled',
            'common.disabled': 'disabled',
            'chat.notif': 'Chat notifications',
            'chat.noResults': 'No messages found.',
            'chat.seenBy': 'Seen by',
            'rand.useForSession': 'Use for session',
            'rand.playerOrder': 'Player order',
            'rand.copyOrder': 'Copy order',
            'rand.reroll': 'Roll again',
            'rand.chosenGame': 'Chosen game',
            'rand.teamsGenerated': 'Generated teams',
            'rand.team': 'Team',
            'rand.detailsBtn': 'Details',
            'rand.whoPlays': 'Who is in the draw',
            'rand.selectAll': 'All',
            'rand.selectNone': 'None',
            'rand.noPlayers': 'No players in the club.',
            'rand.needTwoSelected': 'Select at least 2 players!',
            'rand.searchPh': 'Search by name or @tag...',
            'rand.noMatch': 'No player found.',
            'rand.drawEmpty': 'No players added yet — search above.',
            'rand.inDraw': 'in the draw',
            'rand.addAll': 'Add all',
            'rand.clear': 'Clear',
            'rand.teamPool': 'Available players',
            'rand.teamsNeed': 'You need {need} players, but you only have {have}!',
            'rand.copyTeams': 'Copy teams',
            'polls.noneActive': 'No active polls',
            'polls.createFirst': 'Create the first poll to collect members\' opinions!',
            'polls.createBtn': 'Create Poll',
            'polls.votes': 'votes',
            'polls.expires': 'Expires',
            'polls.yourVote': '✓ Your vote',
            'polls.clickToVote': 'Click an option to vote',
            'polls.multipleAllowed': '(multiple allowed)',
            'polls.canVoteMultiple': 'You can vote for multiple options',
            'polls.closePoll': 'Close poll',
            'polls.statusActive': 'Active',
            'polls.retract': 'Retract vote',
            'polls.alreadyVoted': 'You already voted (click an option to retract)',
            'polls.deleteConfirm': 'Delete this poll? This cannot be undone.',
            'polls.deleted': 'Poll deleted',
            'polls.edited': 'Poll updated',
            'polls.notifCreated': '{by} created a poll: {q}',
            'polls.closedTitle': 'Closed Polls',
            'polls.closed': 'Closed',
            'polls.winner': '🏆 Winner',
            'cal.noEventsDay': 'No events on this day.',
            'cal.addEvent': 'Add event',
            'cal.planFirst': 'Plan the first event!',
            'cal.today': 'Today',
            'cal.noUpcoming': 'No upcoming events',
            'cal.join': 'Join',
            'cal.googleHelp': 'Add events to Google Calendar with one click, or use <b>Export Calendar</b> to import all events at once (.ics file).',
            'cross.loading': 'Loading from {n} clubs…',
            'cross.loadError': 'Error loading',
            'cross.noSessions': 'You have no sessions recorded in your clubs yet.',
            'roleStats.empty': 'No sessions with roles in the selected period. Define a game\'s roles (the "Edit roles" link in the session form) and pick each player\'s role when you log the match.',
            'stats.noMatchesPeriod': 'No matches in the selected period.',
            'stats.noChartData': 'No data for the chart',
            'stats.avgPerPlayer': 'Avg/player',
            'stats.gameDistribution': 'Game Distribution',
            'stats.weekShort': 'Wk',
            'stats.ptsWord': 'pts',
            'stats.uniquePlayers': 'Unique players',
            'insights.sessUp': '<strong>Strong growth in number of sessions</strong> (+{n}% vs the previous period). The club is more active than ever!',
            'insights.sessDown': '<strong>Drop in activity</strong> ({n}% vs the previous period). Maybe it is time for a special session?',
            'insights.sessStable': '<strong>Stable activity</strong>. The number of sessions is constant.',
            'insights.players': '<strong>Growing community</strong> (+{n}% new players). The club attracts new members!',
            'insights.scoreUp': '<strong>More intense competition</strong> (+{n}% in average score). Players are improving their skills!',
            'insights.scoreDown': '<strong>More relaxed atmosphere</strong>. Scores are lower, which points to friendlier games.',
            'insights.routine': '<strong>Stable routine</strong>. The club has a steady session frequency.',
            'insights.peak': '<strong>Most active period</strong> was {label} with {n} sessions.',
            'insights.none': 'No significant insights for this period.',
            'insights.title': 'Insights',
            'insights.recordSessions': '<strong>Activity record.</strong> {n} sessions — your best period so far.',
            'insights.comeback': '<strong>The club is back.</strong> After a period with no sessions at all, here are {n} on the table again.',
            'insights.topGame': '<strong>Game of the moment: {game}.</strong> Played {n} times this period.',
            'insights.newGame': '<strong>New title on the table: {game}.</strong> A first in the club history.',
            'insights.newGames': '<strong>{n} new games tried</strong>, including {game}.',
            'insights.variety': '<strong>Plenty of variety.</strong> {n} different titles across {s} sessions.',
            'insights.focused': '<strong>You have settled on {game}.</strong> Either it is that good, or a campaign is under way.',
            'insights.groupSize': '<strong>Groups of {n} players</strong> on average at the table.',
            'insights.mostPresent': '<strong>{name} barely missed a night</strong> — {n} of {s} sessions.',
            'insights.playersDown': '<strong>Fewer people around.</strong> {n}% fewer players than last period.',
            'insights.hoursUp': '<strong>Longer sessions.</strong> {n} hours of play this period.',
            'insights.hoursDown': '<strong>Shorter games.</strong> {n} hours of play, below the previous period.',
            'common.notes': 'Notes',
            'common.next': 'Next',
            'common.noData': 'no data',
            'common.saveChanges': 'Save changes',
            'common.page': 'Page',
            'common.of': 'of',
            'camp.editTitle': 'Edit campaign',
            'camp.newTitle': 'New campaign',
            'camp.nameLabel': 'Campaign name',
            'camp.namePh': 'E.g. Gloomhaven — Tuesday group',
            'camp.statusCompleted': 'Completed',
            'camp.statusAbandoned': 'Abandoned',
            'camp.roster': 'Roster (participants)',
            'camp.notesPh': 'Characters, objectives, notes…',
            'camp.scNameLabel': 'Scenario name / number',
            'camp.scNamePh': 'E.g. Scenario 3 — The Crypt',
            'camp.outcome': 'Outcome',
            'camp.win': 'Win',
            'camp.loss': 'Loss',
            'camp.outcomeOther': 'Other / narrative',
            'camp.scNotesPh': 'Rewards, unlocks, events…',
            'reg.docTitlePre': 'Rules of',
            'reg.noArticles': 'No articles in the regulation.',
            'reg.contentLabel': 'Content',
            'reg.titleLabel': 'Title',
            /* Form placeholders — previously hardcoded in index.html */
            'ph.coopScore': 'e.g. 45',
            'ph.coopDifficulty': 'e.g. Nightmare',
            'ph.coopDetail': 'e.g. 2 cities left, one outbreak avoided',
            'ph.coopScenario': 'e.g. Pandemic — Scenario 3',
            'ph.tournamentPrize': 'e.g. Trophy + a new game',
            'ph.tournamentRounds': 'e.g. 3',
            'ph.tournamentFee': 'e.g. 20 RON',
            'ph.sessionDuration': 'e.g. 120',
            'ph.randomMaxTime': 'e.g. 120',
            'reg.newTitlePh': 'e.g. Art. 6 — Article name',
            'reg.saveChanges': 'Save changes',
            'reg.history': 'Change history',
            'reg.editTitle': 'Edit regulation',
            'reg.historyCount': 'Change history ({n})',
            'reg.noHistory': 'This article has not been changed since it was published.',
            'reg.diffRemoved': 'removed text',
            'reg.diffAdded': 'added text',
            'reg.diffNone': 'The text did not change (saved without edits).',
            'reg.moveUp': 'Move up',
            'reg.moveDown': 'Move down',
            'reg.confirmDelete': 'Delete the article “{title}”? The text disappears from the regulation but stays in the change history. The regulation version goes up, so members will be asked again if acceptance is required.',
            'reg.share': 'Share the regulation',
            'reg.shareCopied': 'The regulation has been copied. Send it anywhere — no account needed to read it.',
            'reg.shareFailed': 'Sharing failed.',
            'm3.articleDeleted': 'Article deleted.',
            'audit.regulationReordered': 'Article order changed',
            'audit.regulationArticleDeleted': 'Regulation article deleted',
            'auditd.regMoved': 'article “{title}” was moved',
            'auditd.regDeleted': 'article “{title}” was deleted',
            'auditd.regEdited': 'article “{title}” was edited',
            'reg.amendTo': 'To',
            'reg.addArticleNew': 'Add New Article',
            'reg.addArticle': 'Add Article',
            'reg.newContentPh': 'Enter the new article content...',
            'reg.resetOriginal': 'Reset to original version',
            'reg.contentPrompt': 'Article content:',
            'admin.revokeAdmin': 'Revoke admin',
            'admin.noProfileDelete': 'A profile belongs to its owner, not to the club. Use “Remove from club” or “Ban”.',
            'admin.makeAdmin': 'Make admin',
            'admin.entries': 'entries',
            'admin.autosaveActive': 'Autosave active',
            'admin.size': 'Size',
            'admin.update': 'Update',
            'hist.noSessions': 'No sessions in history',
            'hist.tryOtherFilters': 'Try other filters',
            'hist.startFirst': 'Start the first session!',
            'hist.allPlayers': 'All players',
            'hist.coop': 'Co-op',
            'hist.campaign': 'Campaign',
            'hist.friendly': 'Friendly',
            'hist.teamWin': 'Team win',
            'hist.teamScore': 'Team score',
            'hist.guests': 'Guests',
            'hist.sessions': 'sessions',
            'hist.durationMin': 'Duration (min)',
            'hist.noScored': 'This session has no scored participants.',
            'pdf.historyTitle': 'Session history',
            'pdf.generated': 'Generated',
            'csv.date': 'Date',
            'csv.time': 'Time',
            'csv.type': 'Type',
            'csv.duration': 'Duration',
            'csv.participants': 'Participants',
            'csv.winner': 'Winner',
            'csv.typeNormal': 'Normal',
            'csv.winnerScore': 'Winner Score',
            'tip.edit': 'Edit',
            'tip.search': 'Search',
            'tip.filter': 'Filter',
            'tip.download': 'Download',
            'tip.upload': 'Upload',
            'tip.print': 'Print',
            'tip.stats': 'Statistics',
            'tip.games': 'Games',
            'tip.history': 'History',
            'tip.polls': 'Polls',
            'tip.settings': 'Settings',
            'tip.logout': 'Log out',
            'tip.profile': 'Profile',
            'tip.time': 'Time',
            'tip.rankPos': 'Ranking position',
            'tip.playerName': 'Player name',
            'tip.pointsAccrued': 'Accumulated club points (awarded via the club system, by administrators only).',
            'tip.scoresSum': 'Sum of raw match scores (different from club points).',
            'tip.gamesCount': 'Number of games played',
            'tip.avgPerGame': 'Average points per game',
            'tip.winPct': 'Win percentage',
            'tip.recentTrend': 'Recent trend',
            'tip.sessionDate': 'Session date',
            'tip.startTime': 'Start time',
            'tip.complexity': 'Game complexity',
            'tip.gameRating': 'Game rating',
            'tip.presentPlayers': 'Players present',
            'tip.playTime': 'Play time',
            'tip.scoreObtained': 'Score obtained',
            'notif.eventStarting': '⏰ Event "{title}" starts in {n} minutes{loc}!',
            'notif.atLoc': ' at {l}',
            'banner.muted': '🔇 You are in view-only (muted) mode — you can see everything but cannot make changes.',
            'banner.readonlyPre': 'Club',
            'overlimit.bannerOwner': 'You are over your plan\u2019s club limit. Choose which clubs stay active; the rest become read-only.',
            'overlimit.bannerMember': 'This club is temporarily paused (the owner is over their plan limit).',
            'overlimit.chooseBtn': 'Choose clubs',
            'overlimit.modalTitle': 'Keep clubs active',
            'overlimit.modalIntro': 'Your plan allows {n} active clubs. Choose which stay active; the rest will be read-only until you upgrade.',
            'overlimit.selected': 'selected',
            'overlimit.tooMany': 'You can keep at most {n} active clubs.',
            'overlimit.saved': 'Active clubs updated.',
            'overlimit.locked': 'Selection locked. Upgrade to change it.',
            'overlimit.lockedToast': 'You already made your choice. Upgrade to change it.',
            'claim.button': 'Claim Club',
            'claim.redirecting': 'Redirecting you to checkout to claim the club...',
            'claim.success': 'You claimed the club! You are the new Principal Admin and the club is active again.',
            'claim.failed': 'Claiming the club failed.',
            'claim.notMember': 'You are not a member of this club.',
            'claim.phaseGrace': 'in grace period (read-only)',
            'claim.phaseArchived': 'archived',
            'claim.phaseClosed': 'closed',
            'claim.archivedExplain': 'This club is inactive due to non-payment and is currently',
            'claim.archivedCta': 'Start a subscription in your name to instantly reactivate it and become Principal Admin.',
            'claim.reactivate': 'Reactivate club',
            'claim.reactivated': 'The club has been reactivated.',
            'claim.reactivateFailed': 'Reactivation failed:',
            'claim.onlyOwnerReactivate': 'Only the principal admin can reactivate the club.',
            'claim.closedExplainOwner': 'This club is closed. You can reactivate it anytime while your subscription is active — the data is intact. Once your subscription expires, you will need to pay again to reactivate it.',
            'claim.claiming': 'Claiming the club...',
            'hub.createClubNew': 'Create new club',
            'hub.freeJoin': 'Open to join',
            'hub.needsApproval': 'Requires approval',
            'friends.add': 'Add friend',
            'friends.friends': 'Friends',
            'friends.removeTitle': 'Remove',
            'friends.requestSent': 'Request sent',
            'ev.noVotesYet': 'No votes yet.',
            'notif.empty': 'No notifications yet.',
            'notif.title': 'Notifications',
            'toastlog.title': 'Recent messages',
            'toastlog.hint': 'Messages shown in the corner after your actions. Cleared when you sign out.',
            'toastlog.empty': 'No messages in this session.',
            'toastlog.clear': 'Clear the log',
            'toastlog.justNow': 'just now',
            'toastlog.minShort': 'min',
            'toastlog.hourShort': 'h',
            'notif.tapToOpen': 'tap to open',
            'camp.unknownMember': 'Unknown member',
            'push.title': 'Push notifications',
            'appsec.title': 'App',
            'appsec.desc': 'Install TurnOrder on your device, or check whether a newer version is available.',
            'appsec.checkUpdate': 'Check for updates',
            'appsec.checking': 'Checking…',
            'appsec.upToDate': "You're already on the latest version.",
            'appsec.updating': 'New version found. Updating…',
            'appsec.updateFail': 'The check failed. Please try again.',
            'appsec.updateUnsupported': "This browser doesn't support automatic updates.",
            'push.desc': 'Get real-time notifications (chat, direct messages, club activity) even when the app is closed.',
            'push.enable': 'Enable notifications',
            'push.disable': 'Disable notifications',
            'push.on': 'Push notifications are on for this device.',
            'push.pending': 'Tap „Enable" to receive notifications on this device.',
            'rem.label': 'Reminders',
            'rem.addRule': 'Add reminder',
            'rem.hint': 'A notification will be sent to those who haven\'t responded yet, before the deadline.',
            'rem.needsDeadline': 'Set a deadline to enable reminders.',
            'rem.defaultsTitle': 'Default reminders',
            'rem.defaultsHint': 'These values pre-fill the forms when you create an event, poll or vote. You can adjust them each time.',
            'rem.defEvent': 'For events',
            'rem.defPoll': 'For polls',
            'rem.defGameVote': 'For "What do we play?"',
            'rem.min10': '10 minutes before',
            'rem.min30': '30 minutes before',
            'rem.hour1': '1 hour before',
            'rem.hour2': '2 hours before',
            'rem.hour6': '6 hours before',
            'rem.hour12': '12 hours before',
            'rem.day1': '1 day before',
            'rem.day2': '2 days before',
            'rem.week1': '1 week before',
            'push.off': 'Push notifications are off for this device.',
            'push.granted': 'Push notifications enabled! 🔔',
            'push.disabled': 'Push notifications disabled on this device.',
            'push.denied': 'Notifications are blocked. Enable them in your browser settings for this site.',
            'push.unsupported': 'This browser/device does not support push notifications.',
            'push.iosHint': 'On iPhone/iPad: first add the app to your Home Screen (Share → Add to Home Screen), then open it from there to enable notifications.',
            'install.banner': '📲 Get the TurnOrder app for a better experience',
            'install.btn': 'Install',
            'install.iosHint': 'Tap Share, then "Add to Home Screen".',
            'update.banner': '🔄 A new version of the app is available',
            'update.btn': 'Update',
            'push.error': 'Could not enable notifications. Please try again.',
            'notif.markAllRead': 'Mark all as read',
            'notif.clearAll': 'Clear all notifications',
            'elo.empty': 'No sessions with results for the ranking yet.',
            'gv.noActive': 'No active vote. Start one to decide together what to play.',
            'gv.start': 'Start a vote',
            'gv.shareMenuTitle': 'Share the vote',
            'gv.shareMenuHint': 'Tap “Share” to pick the app (including your personal WhatsApp).',
            'gv.shareNative': 'Share',
            'gv.shareWaWeb': 'WhatsApp Web (desktop)',
            'gv.shareCopy': 'Copy text',
            'gv.share': 'Share',
            'gv.shareTitle': 'Vote: What to play?',
            'gv.shareCta': 'Pick what we play next — vote now! 👇',
            'gv.shareOpen': 'Open TurnOrder and vote:',
            'share.asImage': 'As image',
            'share.asText': 'As text',
            'gv.notifStarted': '{by} started a vote: What to play?',
            'gv.viewDetails': 'View game details',
            'gv.onlyYourGames': 'You can only remove games you added.',
            'gv.onlyInitiator': 'Only the vote initiator or an admin can close the vote.',
            'gv.notifWinner': 'The “What to play” vote ended. Winner:',
            'gv.notifNoWinner': 'The “What to play” vote ended with no clear winner.',
            'gv.autoClosed': 'Vote ended. Winner:',
            'gv.autoClosedNoWinner': 'Vote ended, no clear winner.',
            'gv.closing': 'Closing the vote...',
            'gv.deadlineLabel': 'Deadline (optional)',
            'gv.deadlineHint': 'At this time the vote auto-closes and everyone involved is notified.',
            'gv.proposeTitle': 'Propose games to vote on',
            'gv.setupHint2': 'Search the catalog and add the games you want to put up for a vote.',
            'gv.searchPh': 'Search a game in the catalog...',
            'gv.anonLabel': 'Anonymous vote (who voted is hidden)',
            'gv.selected': 'Selected',
            'gv.results': 'Results',
            'gv.fromCatalog': 'From catalog',
            'gv.catalogEmpty': 'Catalog is empty — add games first.',
            'gv.noMatch': 'No games found.',
            'gv.closed': 'Closed',
            'gv.closedTitle': 'Closed votes — What to play',
            'gv.noWinner': 'No clear winner',
            'gv.deletedGame': 'Game removed from the catalog',
            'gv.noClosed': 'No closed votes yet.',
            'gv.removeFromVote': 'Remove from vote',
            'gv.addToVote': 'Add to vote',
            'gv.setupHint': 'We pre-filled a few suggestions. Add or remove what you want, then start the vote.',
            'gv.startVote': 'Start the vote',
            'gv.noneSelected': 'No game selected yet. Add from the catalog below.',
            'gv.allInList': 'All catalog games are already in the list.',
            'import.newGames': 'new games',
            'import.previewTitle': 'Import preview ({src})',
            'import.catalogLabel': 'Catalog',
            'import.newShort': 'new',
            'import.sessionsLabel': 'Sessions',
            'import.alreadyExist': 'already exist, ignored',
            'import.alreadyImported': 'already imported, ignored',
            'import.note': 'The import writes to the club\'s shared database (visible to everyone). Players from sessions are kept by name and contribute to ELO and achievements. Anything that already exists is ignored automatically.',
            'profile.noFav': 'No favorite games added.',
            'profile.playerProfile': 'Player profile',
            'bgg.searchUnavailable': 'BGG search is not available yet (proxy/token not configured). You can fill in manually below.',
            'bgg.noDetails': 'No details found.',
            'bgg.filledFromBgg': 'Fields were filled from BGG. Review and press "Add Game".',
            'bgg.searching': 'Searching BGG…',
            'bgg.noResults': 'No results.',
            'bgg.typeMore': 'Type at least 3 letters…',
            'bgg.fetchingDetails': 'Fetching details…',
            'copy.prompt': 'Copy the text:',
            'rsvp.yes': 'Going',
            'rsvp.maybe': 'Maybe',
            'rsvp.no': 'Not going',
            'rsvp.saved': 'Reply saved',
            'rsvp.withdrawn': 'Reply withdrawn from',
            'notif.recByOther': '{by} recorded a {game} session you played in',
            'notif.recByMe': 'You recorded a {game} session',
            'notif.recIPlayed': '{game} session recorded (you played)',
            'notif.recIPlayed2': '{game} session (you played)',
            'notif.recordedVerb': 'recorded',
            'notif.recordedImpersonal': 'Recorded',
            'notif.sessionOf': 'a session of',
            'share.totalVotes': 'Total votes',
            'notif.voteSing': 'vote',
            'notif.votePlur': 'votes',
            'notif.pollWord': 'Poll',
            'notif.eventWord': 'Event',
            'notif.gamesPlayed': 'Games played',
            'notif.members': 'Members',
            'notif.topPlayers': 'Top players',
            'notif.mostPlayed': 'Most played',
            'notif.statsWord': 'Statistics',
            'time.justNow': 'just now',
            'time.minAgo': '{n} min ago',
            'time.hoursAgo': '{n} h ago',
            'time.today': 'today',
            'time.yesterday': 'yesterday',
            'time.daysAgo': '{n} days ago',
            'time.monthAgo': 'a month ago',
            'time.monthsAgo': '{n} months ago',
            'club.memberOne': 'member',
            'club.memberMany': 'members',
            'club.lastSession': 'last session',
            'club.noSessionsYet': 'no sessions yet',
            'fab.whatToPlay': 'What to play tonight?',
            'fab.recordSession': 'Record a session',
            'pwd.recoverTitle': 'Password Recovery',
            'pwd.emailHint': 'You will receive a verification code by email to reset your password.',
            'pwd.codeLabel': 'Verification code',
            'pwd.codePh': 'Enter the code from the email',
            'pwd.newLabel': 'New password',
            'pwd.sendCode': 'Send code',
            'pwd.resetBtn': 'Reset password',
                        'auth.haveAccount': 'Already have an account?',
                        'auth.loginLink': 'Log in',
            'sb.unmutedMsg': '{name} can make changes again.',
            'sb.memberFallback': 'The member',
            'sb.mutedMsg': '{name} can no longer make changes (view-only mode).',
            'pf.ownedGames': 'Owned games',
            'live.nowTitle': 'Live sessions now',
            'live.youPlay': 'Playing',
            'live.editing': 'You are editing the live session. Players see it in real time.',
            'live.turnHint': 'Only one clock runs at a time. Pressing Turn stops the other player\'s clock.',
            'live.viewBtn': 'View session (read-only)',
            'live.readOnly': 'Read-only. You can only control your own clock.',
            'live.endBtn': 'End session',
            'live.confirmEnd': 'Close this live session? Others will no longer see it.',
            'live.noneNow': 'No live session right now.',
            'live.startBtn': 'Start live session',
            'live.makeLiveBtn': 'Make this session live',
            'live.started': 'Live session started. Other members can see it now.',
            'live.sheetTitle': 'Live session',
            'live.untitled': 'Untitled game',
            'live.someone': 'Member',
            'live.youHost': 'You host',
            'live.noPlayers': 'No players added yet.',
            'live.notFound': 'This session no longer exists.',
            'live.ended': 'The session has ended.',
            'live.savedElsewhere': 'The session was saved from another device and is now in History.',
            'live.alreadySavedBlock': 'This game is already saved in History (from another device). We will not save it twice, to avoid a duplicate. Your data stays on screen; press "New session" if you want to record a different game.',
            'live.myTimerStart': 'Start my time',
            'live.myTimerStop': 'Stop my time',
            'live.watchingOnly': 'You are watching. Only players in the session can run their own time.',
            'live.errOpen': 'Could not start the live session: ',
            'live.errSave': 'Could not update the sheet: ',
            'live.errTimer': 'Could not save your time: ',
            'live.errClose': 'Could not close the session: ',
            'gdpr.confirmCancelDelete': 'Cancel the scheduled deletion of your account? Your account and data will be kept.',
            'gdpr.reauthCancelDelete': 'Confirm your password to cancel the account deletion.',
            'sb.cantMuteAdmin': 'You cannot mute an administrator.',
            'sb.notAMember': 'That person is not an active member of this club.',
            'm2.saveErrorColon': 'Save error: ',
            'sb.profileExtraSaveSkipped': 'Could not read your profile from the database, so the extended profile data was NOT saved (to avoid wiping it). Your other changes were saved. Please retry.',
            'sb.ownedSaveAborted': 'Could not read your game list from the database, so nothing was saved (to avoid wiping your other games). Please retry.',
            'sb.profileLoadFailed': 'Could not load your profile. You were not signed in, to avoid overwriting your data. Please retry; if it persists, a database migration may not have been applied.',
            'pf.noOwned': 'No games owned yet. Search below to add one — or tick "I have it too" in the catalog.',
            'pf.ownedHint': 'Owned games stay on your profile even if you leave the club. You can add games the club does not have yet — when someone adds them to the catalog, you will be recognised as an owner automatically.',
            'pf.seeAll': 'See all ({n})',
            'pf.gameNotInClub': '"{game}" is not in the active club\'s catalog. Switch to the club where it was added to see its details.',
            'polls.byAuthor': 'by',
            'ev.createFromResult': 'Create event from result',
            'ev.pollNotFound': 'Poll not found.',
            'ev.noVotesToUse': 'There is no result with votes to create an event from.',
            'ev.prefilledFromPoll': 'The event was pre-filled from the poll result. Review it and save.',
            'ev.pickDateYourself': "Couldn't work out a date from the winning option — pick one, then save.",
            'ev.fromPollDesc': 'Created from the poll "{q}". Winning option: "{opt}" ({n} votes).',
            'ev.fromGameVoteTitle': 'Session: {game}',
            'ev.fromGameVoteDesc': 'Created from the game vote. Winning game: "{game}".',
            'event.editTitle': 'Edit event',
            'sb.eventUpdated': 'Event updated!',
            'sb.onlyEditOwnEvents': 'You can only edit your own events (or you must be an admin).',
            'sb.confirmMute': 'Mute "{name}"?\n\nThey will still be able to see the club, but will no longer be able to make changes. This action is reversible (you can unmute them at any time).',
            'ev.organizer': 'Organizer',
            'ev.when': 'When',
            'ev.location': 'Location',
            'ev.description': 'Description',
            'ev.noDescription': 'No description.',
            'ev.participants': 'Participants',
            'ev.yourAnswer': 'Your answer',
            'ev.openDetails': 'View event details',
            /* v8 — event capacity + waiting list (see RO block for rationale). */
            'ev.seatLimit': 'Seat limit',
            'ev.seatLimitPh': 'No limit',
            'ev.seatLimitHint': 'Leave empty for unlimited attendance.',
            'ev.seatsOf': '{n} / {max} seats',
            'ev.joinWaitlist': 'Join waitlist',
            'ev.confirmedTitle': 'Confirmed',
            'ev.waitlistTitle': 'Waiting list',
            'ev.waitlistMine': "You're on the waiting list — position {n}.",
            'ev.waitlistShort': 'List · #{n}',
            'ev.waitlistJoined': "You've joined the waiting list.",
            'ev.checkingSeat': 'Checking seat…',
            'ev.promoted': "A seat opened up — you're in!",
            'gv.closedFindIn': 'Voting closed. You can find it under "Closed".',
            'm1.bulkPlayersRemoved': '{n} players removed from the club.',
            'm1.bulkGamesDeleted': '{n} games deleted from the catalog.',
            'cross.notEnoughData': 'Not enough data.',
            'cross.aggregatedFor': 'Aggregated data for {name} across {n} clubs.',
            'cross.perClub': 'By club',
            'elo.enabledMsg': 'Competitive mode (ELO) ENABLED for the whole club!',
            'elo.disabledMsg': 'Competitive mode (ELO) disabled.',
'auth.loginLink': 'Log in',
            'session.tNamePh': 'E.g. Spring Championship 2025',
            'session.locationExPh': 'E.g. Alex\'s place, Central Café',
            'session.pastLocations': 'Past locations:',
            'players.addNew': 'Add New Player',
            'players.namePh': 'Player name',
            'players.emailPh': 'Email (optional)',
            'players.emailPhReq': 'Email (required)',
            'players.tagPh': '@user_tag (optional)',
            'players.emailRequired': 'Email is required for a new player.',
            'players.emailInvalid': 'Invalid email.',
            'players.tagInvalid': 'Invalid user_tag: 3-30 chars, only lowercase letters, digits, “.” and “_”.',
            'players.tagTaken': 'user_tag already taken. Choose another.',
            'players.adding': 'Adding player...',
            'players.alreadyMember': '{name} is already a member of this club. Nothing was added.',
            'players.searchLabel': 'Search player',
            'players.addPlayer': 'Add player',
            'players.tools': 'Tools',
            'catalog.view': 'View mode',
            'catalog.viewExpanded': 'Expanded',
            'catalog.viewCompact': 'Compact',
            'catalog.viewGrid': 'Grid',
            'catalog.viewFullImage': 'View full image',
            'catalog.ofTotal': 'of {n}',
            'players.showMore': 'Show more',
            'players.showLess': 'Show less',
            'players.statGames': 'games',
            'players.statWin': 'win',
            'players.statAvg': 'avg',
            'players.statPts': 'pts',
            'players.searchPh': 'Search by name...',
            'players.bulkDelete': 'Bulk delete',
            'pstats.title': 'Player Statistics',
            'pstats.activePlayers': 'Active Players',
            'pstats.newThisMonth': 'New This Month',
            'pstats.avgFrequency': 'Average Frequency',
            'pstats.participation': 'Participation',
            'pf.publicTitle': 'Public profile',
            'pf.publicIntro': 'Fill in what you want others to know. Each field can be public or private.',
            'pf.public': 'Public',
            'pf.notPublic': 'Not public',
            'pf.visHint': 'Visible on your public profile',
            'pf.experience': 'Experience level',
            'pf.experienceNote': '(auto-computed from global XP)',
            'pf.age': 'Age',
            'pf.gender': 'Gender',
            'pf.gameTypes': 'Preferred game types',
            'pf.gameTypesChoose': 'Choose game types',
            'pf.country': 'Country',
            'pf.city': 'City',
            'pf.cityPh': 'Select or type your city',
            'pf.location': 'Location',
            'pf.status': 'Status',
            'pf.statusPh': 'Write your status…',
            'pf.availability': 'Availability',
            'gender.male': 'Male',
            'gender.female': 'Female',
            'gender.other': 'Other',
            'gender.na': 'Prefer not to say',
            'pstatus.none': '— None —',
            'pstatus.seekingClub': 'Looking for a club',
            'pstatus.seekingCofounders': 'Looking for people to start a club',
            'pstatus.openInvites': 'Open to game invites',
            'pstatus.custom': 'Custom…',
            'day.mon': 'Monday',
            'day.tue': 'Tuesday',
            'day.wed': 'Wednesday',
            'day.thu': 'Thursday',
            'day.fri': 'Friday',
            'day.sat': 'Saturday',
            'day.sun': 'Sunday',
            'slot.morning': 'Morning',
            'slot.afternoon': 'Afternoon',
            'slot.evening': 'Evening',
            'exp.novice': 'Novice',
            'exp.intermediate': 'Intermediate',
            'exp.advanced': 'Advanced',
            'exp.expert': 'Expert',
            'country.other': 'Other',
            'clubset.location': 'Club location',
            'clubset.placePh': 'Exact location (optional): address, venue, etc.',
            'pf.about': 'About',
            'profile.emailHidden': 'Email hidden',
            'friends.title': 'My friends',
            'friends.incoming': 'Incoming requests:',
            'friends.requests': 'Friend requests',
            'friends.noRequests': 'No pending requests.',
            'friends.none': 'No friends yet. Send a request from “Select players”.',
            'friends.search': 'Search friends',
            'friends.searchPh': 'Search by name or @tag…',
            'friends.noMatch': 'No friends match your search.',
            'dm.someone': 'Someone',
            'dm.msgNotFound': 'The original message is no longer loaded.',
            'dm.you': 'You',
            'dm.quoteClub': 'Club chat',   // v9 8.4-b: private reply to a club chat message
            'dm.seen': 'Seen',
            'dm.delivered': 'Delivered',
            'dm.received': 'Received',
            'dm.send': 'Send message',
            'dm.inputPh': 'Write a message…',
            'dm.empty': 'No messages yet. Write the first one!',
            'dm.search': 'Search this conversation',
            'dm.clear': 'Delete conversation',
            'dm.clearConfirm': 'Delete the conversation with {name}? Messages disappear only for you; {name} keeps them. New messages will show up again.',
            'dm.cleared': 'Conversation deleted for you.',
            'dm.muted': 'You will no longer get notifications from {name}.',
            'dm.unmuted': 'Notifications from {name} are back on.',
            'dm.prefsErr': 'Could not save. Please try again.',
            'dm.demo': 'Unavailable in demo mode.',
            'dm.sendErr': 'Message could not be sent.',
            'dm.policy': 'Who can message me',
            'dm.policyAll': 'Anyone',
            'dm.policyFriendsOpt': 'Friends only',
            'dm.policyNoneOpt': 'Nobody',
            'pres.setting': 'Who can see when I\'m online',
            'pres.all': 'Everyone',
            'pres.none': 'Nobody',
            'pres.hint': 'With “Nobody” you don\'t appear online, and you can\'t see when others are online either.',
            'pres.online': 'Online',
            'dm.policyNone': 'Not accepting messages',
            'dm.policyFriends': 'Friends only can message',
            'notif.friendReq': 'sent you a friend request',
            'logout.confirm': 'Are you sure you want to log out?',
            'friends.remove': 'Remove friend',
            'friends.removeConfirm': 'Are you sure you want to remove this friend?',
            'pf.availabilityToggle': 'Set available time slots',
            'namehist.title': 'Name history',
            'namehist.intro': 'Names previously used by this user:',
            'session.timerTitle': 'Session timer',
            'notif.joinReq': 'requested to join',
            'notif.newMember': '{name} joined the club 🎉',
            'report.title': 'Report',
            'report.action': 'Report',
            'report.intro': 'Tell us what is wrong. Your report goes to the moderation team.',
            'report.submit': 'Send report',
            'report.sent': 'Report sent. Thank you — the moderation team will review it.',
            'report.failed': 'Could not send the report. ',
            'report.pickReason': 'Please choose a reason for the report.',
            'report.customPh': 'Details (optional)…',
            'report.dsaNote': 'Believe this is illegal content? You can also contact us at {email}.',
            'report.loginRequired': 'You must be signed in to report.',
            'report.demo': 'Reporting is not available in demo mode.',
            'report.reason.spam': 'Spam',
            'report.reason.harassment': 'Harassment or abuse',
            'report.reason.sexual': 'Sexual or explicit content',
            'report.reason.hate': 'Hate speech',
            'report.reason.copyright': 'Copyright infringement / content that is not mine',
            'report.reason.misinfo': 'Misinformation',
            'report.reason.other': 'Other',
            'mod.title': 'Moderation',
            'mod.none': 'No reports in this category.',
            'mod.loadError': 'Could not load reports. ',
            'mod.filterOpen': 'Open',
            'mod.filterReviewing': 'Reviewing',
            'mod.filterResolved': 'Resolved',
            'mod.filterDismissed': 'Dismissed',
            'mod.filterAll': 'All',
            'mod.from': 'Reported by {name}',
            'mod.targetUser': 'User',
            'mod.targetChat': 'Chat message',
            'mod.targetDm': 'Direct message (DM)',
            'mod.targetPhoto': 'Session photo',
            'mod.view': 'View',
            'mod.mute': 'Mute',
            'mod.ban': 'Ban',
            'mod.markReviewing': 'Reviewing',
            'mod.markResolved': 'Resolve',
            'mod.markDismissed': 'Dismiss',
            'mod.statusUpdated': 'Status updated.',
            'mod.statusOpen': 'Open',
            'mod.statusReviewing': 'Reviewing',
            'mod.statusResolved': 'Resolved',
            'mod.statusDismissed': 'Dismissed',
            'mod.ownerScope': 'All clubs + DMs',
            'mod.dmNote': 'DM content can only be removed at platform level.',
            'mod.targetAnn': 'Announcement',
            'mod.viewFail': 'The announcement could not be loaded: ',
            'mod.annGone': 'This announcement no longer exists — it was probably already deleted.',
            'mod.confirmDelAnn': 'Delete this announcement? Attached photos are removed with it.',
            'mod.delAnn': 'Delete announcement',
            'mod.delMsg': 'Delete message',
            'mod.delDm': 'Delete DM',
            'mod.managePhotos': 'Manage photos',
            'mod.confirmDelMsg': 'Delete this chat message? This cannot be undone.',
            'mod.confirmDelDm': 'Delete this direct message? This cannot be undone.',
            'mod.confirmDelPhoto': 'Delete this photo? This cannot be undone.',
            'mod.takedownOk': 'Content removed.',
            'mod.takedownFail': 'Could not remove the content. ',
            'notif.newReport': 'New moderation report',
            'reauth.title': 'Confirm your identity',
            'reauth.message': 'For security, enter your account password to continue.',
            'reauth.placeholder': 'Account password',
            'reauth.confirm': 'Confirm',
            'reauth.empty': 'Please enter your password.',
            'reauth.wrong': 'Incorrect password. Please try again.',
            'reauth.oauthHint': 'Signed in with Google? Set a password first under “Account security”.',
            'reauth.changeAuth': 'Confirm your current password to change your password or email.',
            'reauth.skipped': 'Password/email change was canceled. Your other changes were saved.',
            'reauth.actTransfer': 'Confirm your password to transfer club ownership.',
            'reauth.actClubClose': 'Confirm your password to close the club.',
            'reauth.actClubLeave': 'Confirm your password to leave the club.',
            'reauth.actPlayerDelete': 'Confirm your password to remove the player from the club.',
            'reauth.actBan': 'Confirm your password to ban the member from the club.',
            'reauth.actUnban': 'Confirm your password to reactivate the member in the club.',
            'reauth.actBackupRestore': 'Confirm your password to restore this backup over the club.',
            'reauth.actClubReset': 'Confirm your password to reset the club data.',
            'reauth.needPassword': 'This action requires a password on your account. Go to Profile → Account security and set a password first.',
            'reauth.otpSent': 'We sent a code to your email. Enter it to set your password.',
            'reauth.otpPrompt': 'Enter the code from your email:',
            'reauth.otpPh': 'Email code',
            'reauth.otpSendFail': 'Could not send the email code. ',
            'gdpr.exportBtn': 'Export my personal data',
            'gdpr.exportNote': 'Download all your personal data (profile, subscription, friends, messages, sessions) in a password-protected archive (PDF + Excel).',
            'gdpr.reauthExport': 'Confirm your password to export your personal data.',
            'gdpr.preparing': 'Preparing your data archive…',
            'gdpr.libMissing': 'Export components failed to load. Reload the page and try again.',
            'gdpr.exportFail': 'Could not generate the export. ',
            'gdpr.pdfTitle': 'Personal data export',
            'gdpr.generatedOn': 'Generated on',
            'gdpr.secProfile': 'Profile',
            'gdpr.secSub': 'Subscription',
            'gdpr.secSessions': 'Sessions',
            'gdpr.secDms': 'Direct messages',
            'gdpr.dmCount': 'Message count',
            'gdpr.dmHidden': 'Conversations deleted only for you',
            'gdpr.dmMuted': 'People you muted',
            'gdpr.blocked': 'People you blocked',
            'gdpr.clubNotif': 'Club notification settings',
            'gdpr.chatPrefs': 'Chat appearance preferences',
            'gdpr.emojiRecents': 'Recently used emoji',
            'gdpr.reactions': 'Your reactions to messages',
            'cnotif.title': 'Notifications',
            'cnotif.all': 'All messages',
            'cnotif.mentions': 'Only when someone mentions me',
            'cnotif.none': 'No notifications',
            'cnotif.saved': 'Club notifications: {level}',
            'cnotif.saveErr': 'Could not save. Check your connection.',
            'cnotif.unavailable': 'This setting is not available yet.',
            'cnotif.mentioned': 'mentioned you',
            'typing.one': '{name} is typing…',
            'typing.two': '{a} and {b} are typing…',
            'typing.many': '{n} people are typing…',
            'typing.someone': 'Someone',
            'cpref.title': 'Appearance',
            'cpref.scopeLbl': 'Apply to',
            'cpref.scopeAll': 'All conversations',
            'cpref.scopeClub': 'Only this club',
            'cpref.scopeDm': 'Only this conversation',
            'cpref.preview': 'Preview',
            'cpref.bubbles': 'My bubbles',
            'cpref.bg': 'Background',
            'cpref.size': 'Text size',
            'cpref.default': 'Default',
            'cpref.reset': 'Reset to default',
            'cpref.save': 'Save',
            'cpref.saved': 'Appearance saved',
            'cpref.saveErr': 'Could not save. Please try again.',
            'cpref.loadErr': 'Could not open Appearance. Check your connection.',
            'cpref.reload': 'A new version of the app is available. Reload now?',
            // v9 8.3 — lazy-loaded files + emoji library
            'lazy.reload': 'A new version of the app is available. Reload now?',
            'lazy.loadErr': 'Could not load this part of the app. Check your connection.',
            'emoji.title': 'Emoji',
            'emoji.search': 'Search emoji',
            'emoji.keyboard': 'Keyboard',
            'emoji.del': 'Delete',
            'emoji.tones': 'Choose skin tone',
            'emoji.none': 'No emoji found',
            'emoji.loading': 'Loading…',
            'emoji.offline': 'Search needs an internet connection the first time.',
            'emoji.games': 'Games',
            'emoji.flagsCredit': 'Flags: Twemoji, CC-BY 4.0 licence',
            'emoji.cat.recent': 'Recent',
            'emoji.cat.smileys': 'Smileys & emotion',
            'emoji.cat.people': 'People',
            'emoji.cat.animals': 'Animals & nature',
            'emoji.cat.food': 'Food & drink',
            'emoji.cat.activities': 'Activities',
            'emoji.cat.travel': 'Travel & places',
            'emoji.cat.objects': 'Objects',
            'emoji.cat.symbols': 'Symbols',
            'emoji.cat.flags': 'Flags',
            // v9 8.4 — message reactions
            'rx.title': 'Reactions',
            'rx.with': 'React with {e}',
            'rx.more': 'More emoji',
            'rx.hover': 'React',
            'rx.pill': 'Reactions: {list}',
            'rx.tapRemove': 'tap to remove',
            'rx.rate': 'Too many reactions in a minute. Try again shortly.',
            'rx.notAllowed': "You can't react to this message.",
            'rx.deleted': 'This message was deleted.',
            'rx.err': "Your reaction wasn't saved. Check your connection and try again.",
            'cpref.b.felt': 'Green felt',
            'cpref.b.wood': 'Wood',
            'cpref.b.ocean': 'Ocean',
            'cpref.b.berry': 'Berry',
            'cpref.b.ruby': 'Ruby',
            'cpref.b.slate': 'Slate',
            'cpref.b.teal': 'Teal',
            'cpref.b.plum': 'Plum',
            'cpref.b.mint': 'Mint',
            'cpref.b.sky': 'Sky',
            'cpref.b.sand': 'Sand',
            'cpref.b.lilac': 'Lilac',
            'cpref.g.felt': 'Green felt',
            'cpref.g.wood': 'Wood',
            'cpref.g.dice': 'Dice',
            'cpref.g.meeple': 'Meeple',
            'cpref.g.hex': 'Hexagons',
            'cpref.g.cards': 'Playing cards',
            'cpref.g.night': 'Night',
            'cpref.g.slate': 'Slate',
            'cpref.g.score': 'Score sheet',
            'cpref.g.parch': 'Parchment',
            'cpref.g.maple': 'Maple',
            'cpref.g.mist': 'Mist',
            'cpref.follow': 'Same as all conversations',
            'cpref.s.s': 'Small',
            'cpref.s.m': 'Normal',
            'cpref.s.l': 'Large',
            'cpref.s.xl': 'Extra large',
            'cpref.pv.day': 'Today',
            'cpref.pv.other1': 'Who is up for a game tonight?',
            'cpref.pv.other2': 'I can bring the dice.',
            'cpref.pv.mine': 'Me! See you at 8.',
            'cpref.pv.photo': 'Last time\'s score',
            'cpref.pv.link': 'The rules:',
            'cpref.pv.deleted': 'This message was deleted',
            'cpref.pv.unsent': 'On my way!',
            'cpref.pv.fail': 'Not sent — tap to retry',
            'gdpr.pwTitle': 'Archive password',
            'gdpr.pwIntro': 'The archive is protected with the password below. We show it ONCE — save it now.',
            'gdpr.pwCopied': 'Password copied.',
            'gdpr.pwWarn': 'We cannot recover this password. If you lose it, generate a new export.',
            'gdpr.confirmDelete': 'Delete your personal data? Your account will be scheduled for deletion in 30 days. You can cancel anytime during this window.',
            'gdpr.reauthDelete': 'Confirm your password to schedule data deletion.',
            'gdpr.deleteScheduled': 'Deletion scheduled. Your data will be deleted in 30 days. You can cancel anytime during this window.',
            'gdpr.deleteCanceled': 'Deletion canceled. Your account stays active.',
            'gdpr.deletePending': 'Account scheduled for deletion on {date}. You can cancel until then.',
            'gdpr.cancelDelete': 'Cancel deletion',
            'gdpr.reqBtn': 'Submit a request',
            'gdpr.reqTitle': 'Data request',
            'gdpr.reqIntro': 'For other GDPR requests (rectification, access, restriction, objection). Your request goes to the operator.',
            'gdpr.reqCategory': 'Request type',
            'gdpr.reqPh': 'Briefly describe your request…',
            'gdpr.reqReply': 'We will reply to {email}.',
            'gdpr.reqSend': 'Send request',
            'gdpr.reqEmpty': 'Please write a message for your request.',
            'gdpr.reqSent': 'Request sent. The operator will review it.',
            'gdpr.reqFail': 'Could not send the request. ',
            'gdpr.reqCat.rectification': 'Rectify inaccurate data',
            'gdpr.reqCat.access': 'Access to data',
            'gdpr.reqCat.restriction': 'Restrict processing',
            'gdpr.reqCat.objection': 'Object to processing',
            'gdpr.reqCat.other': 'Other request',
            'modnotif.resolved': 'Your report has been reviewed and resolved. Thank you for flagging it.',
            'modnotif.dismissed': 'We reviewed your report but did not find a rule violation.',
            'modnotif.copyright': 'Your copyright report has been reviewed and resolved.',
            'notif.roleChanged': 'Your role was changed to: {role}',
            'notif.newPrincipal': '{name} is the new principal admin',
            'notif.joinApproved': 'Your join request was approved! 🎉',
            'notif.campaignNew': 'New campaign: {name}',
            'notif.ruleUpdated': 'The club rules were updated',
            'notif.eventCancelled': 'Event cancelled: {title}',
            'notif.subExpiring': 'Your subscription expires soon ({date}). Re-enable auto-renew to keep access.',
            'notif.pollCancelled': 'Poll cancelled: {q}',
            'notif.eventPrefix': 'Event',
            'notif.joinReqToast': 'New club join request',
            'rand.title': 'Randomizers & Suggestions',
            'rand.randomGameTitle': 'Random Game from Catalog',
            'rand.randomGameIntro': 'Pick a random game from the catalog based on preferences.',
            'rand.maxDuration': 'Max duration (min)',
            'rand.durationHint': 'Compared against your real average duration when available, otherwise the box duration.',
            'rand.durationInvalid': 'Max duration must be at least 1 minute.',
            'rand.pickRandom': 'Pick Random Game',
            'rand.orderTitle': 'Random Player Order',
            'rand.orderIntro': 'Generate a random play order for the current session.',
            'rand.method': 'Randomization method',
            'rand.simpleOpt': '🎲 Simple random',
            'rand.balancedTeamsOpt': '👥 Balanced teams',
            'rand.wheelOpt': '🎡 Wheel of fortune',
            'rand.genOrder': 'Generate Order',
            'rand.teamsTitle': 'Form Random Teams',
            'rand.teamsIntro': 'Perfect for team games or those with a limited number of players.',
            'rand.numTeams': 'Number of teams',
            'rand.playersPerTeam': 'Players per team',
            'rand.genTeams': 'Generate Teams',
            'hdr.myClubs': 'My clubs',
            'hdr.switchClub': 'Switch club',
            'hdr.myProfile': 'My profile',
            'hdr.settings': 'Settings',
            'settings.title': 'Settings',
            'settings.language': 'Language',
            'online.title': 'Online members',
            'online.empty': 'No one online right now.',
            'terms.title': 'Terms & Conditions',
            'terms.h1': '1. Acceptance of terms',
            'terms.p1': 'By using this application, you agree to these terms and conditions.',
            'terms.h2': '2. Data protection (GDPR)',
            'terms.p2': 'In accordance with the General Data Protection Regulation (GDPR), we process your personal data securely and transparently.',
            'terms.li1': 'Data is stored locally in your browser',
            'terms.li2': 'We do not share data with third parties',
            'terms.li3': 'You have the right to request data deletion',
            'terms.li4': 'Data is used solely for club functionality',
            'terms.h3': '3. User responsibilities',
            'terms.p3': 'The user is responsible for:',
            'terms.li5': 'The security of the account and password',
            'terms.li6': 'The content added to the application',
            'terms.li7': 'Respecting other members',
            'terms.h4': '4. Limitation of liability',
            'terms.p4': 'The application is provided "as is", without warranties of any kind.',
            'terms.h5': '5. Changes',
            'terms.p5': 'We reserve the right to modify these terms. Continued use constitutes acceptance of the changes.',
            'catalog.noFitForN': 'No catalog game fits {n} players. Add games to the catalog or try another number.',
            'ann.title': 'Announcements',
            'ann.new': 'New announcement',
            'ann.newPrompt': 'Write the announcement for the club:',
            'ann.bodyPh': 'Announcement message…',
            'ann.replyPh': 'Write a reply…',
            'ann.replyBtn': 'Send',
            'ann.viewAll': 'View all announcements',
            'ann.hideAll': 'Hide announcements',
            'ann.viewReplies': 'View replies',
            'ann.hideReplies': 'Hide replies',
            'ann.empty': 'No announcements yet.',
            'ann.empty2': 'The announcement cannot be empty.',
            'ann.noRight': "You don't have permission to post announcements.",
            'ann.posted': 'Announcement posted.',
            'ann.editTitle': 'Edit announcement',
            'ann.updated': 'Announcement updated.',
            'ann.saveErr': 'Save error: ',
            'ann.delErr': 'Delete error: ',
            'ann.delConfirm': 'Delete this announcement?',
            'ann.delReplyConfirm': 'Delete this reply?',
            'ann.titleLabel': 'Title (optional)',
            'ann.titlePh': 'E.g. Meeting cancelled',
            'ann.bodyLabel': 'Message',
            'ann.photosLabel': 'Photos (optional)',
            'ann.addPhotos': 'Add photos',
            'ann.publish': 'Publish',
            'ann.publishing': 'Publishing…',
            'ann.photoUploadErr': 'Photos could not be uploaded; the announcement was posted without them.',
            'notif.announcement': 'New announcement: {text}',
            'space.title': 'Physical space',
            'space.intro': 'If you host board game nights, other players can discover you.',
            'space.question': 'Do you have a physical space for board game nights?',
            'space.capacity': 'How many players it can host',
            'space.capacityPh': 'E.g. 8',
            'space.address': 'Address',
            'space.addressPh': 'Street, city…',
            'space.addressNote': 'The address is sensitive data — shown strictly per your choice below.',
            'space.visSpaceLabel': 'Who can see you have a space',
            'space.visAddressLabel': 'Who can see the address',
            'space.visPublic': 'Public (everyone)',
            'space.visClubs': 'In my clubs',
            'space.visFriends': 'Friends only',
            'space.visNone': "Don't show",
            'space.hasSpace': 'Has a physical space',
            'space.upTo': 'up to {n} players',
            'space.sectionTitle': 'Game space',
            'geo.searching': 'Searching…',
            'geo.noResults': 'No city found.',
            'geo.unavailable': 'Search is unavailable right now.',
            'leave.menu': 'Leave club',
            'leave.confirm': 'Are you sure you want to leave "{name}"? You will lose access to its data.',
            'leave.done': 'You left "{name}".',
            'leave.errorColon': 'Error leaving: ',
            'leave.ownerMustTransfer': "You're the Principal Admin — transfer ownership first, then you can leave the club.",
            'notif.memberLeft': '{name} left the club.',
            'owners.title': 'Who owns this game',
            'owners.addedBy': 'Added by {name}',
            'owners.none': 'Nobody has marked owning this game yet.',
            'owners.iHaveItToo': 'I have it too',
            'owners.iHaveIt': 'I own it',
            'owners.errColon': 'Error: ',
            // ===== Tournaments (tournament management module) =====
            'tourn.title': 'Tournaments',
            'tourn.navTitle': 'Tournaments',
            'tourn.intro': 'Create and run full tournaments: registration, bracket, rounds and live standings.',
            'tourn.public.title': 'Public page',
            'tourn.public.makePublic': 'Make public',
            'tourn.public.makePrivate': 'Make private',
            'tourn.public.hint': 'Anyone with this link can view the bracket, standings and champion — no login. Making it private revokes the link.',
            'tourn.public.hintOff': 'Generates a read-only public link (bracket, standings, champion). You can revoke it anytime.',
            'tourn.public.enabled': 'Public link created.',
            'tourn.public.disabled': 'Public link revoked.',
            'tourn.public.copied': 'Link copied.',
            'tourn.public.confirmPrivate': 'Make this tournament private? The public link will stop working.',
            'tourn.viewProfile': 'View profile',
            'tourn.new': 'New tournament',
            'tourn.search': 'Search',
            'tourn.export': 'Export',
            'tourn.searchPh': 'Search tournaments…',
            'tourn.searchNone': 'No tournaments match your search.',
            'tourn.exportEmpty': 'Nothing to export.',
            'tourn.status': 'Status',
            'tourn.edit': 'Edit tournament',
            'tourn.deleted': 'Tournament deleted.',
            'tourn.confirmDelete': 'Delete this tournament? This cannot be undone.',
            'tourn.err.ONLY_DRAFT_DELETABLE': 'Only draft tournaments can be deleted.',
            'tourn.none': 'No tournaments yet.',
            'tourn.loading': 'Loading tournaments…',
            'tourn.participants': 'Participants',
            'tourn.deadline': 'Registration deadline',
            'tourn.fee': 'Entry fee',
            'tourn.prizes': 'Prizes',
            'tourn.join': 'Join',
            'tourn.leave': 'Withdraw',
            'tourn.waitlisted': "You're on the waitlist",
            'tourn.joined': 'Successfully registered!',
            'tourn.left': 'You withdrew from the tournament.',
            'tourn.promoted': 'You were promoted from the waitlist!',
            'tourn.created': 'Tournament created.',
            'tourn.updated': 'Tournament updated.',
            'tourn.statusChanged': 'Tournament status changed.',
            'tourn.bracketGenerated': 'Bracket generated.',
            // format
            'tourn.format.round_robin': 'Round Robin',
            'tourn.format.single_elim': 'Single elimination',
            'tourn.format.swiss': 'Swiss system',
            'tourn.format.tables': 'Multiplayer tables',
            // status
            'tourn.status.draft': 'Draft',
            'tourn.status.registration': 'Registration open',
            'tourn.status.live': 'Live',
            'tourn.status.completed': 'Completed',
            'tourn.status.archived': 'Archived',
            // hint in the session form (quick-log ↔ full tournament link)
            'tourn.hint.quick': 'Just logging a result? Stay here.',
            'tourn.hint.full': 'Want registration and a bracket?',
            'tourn.hint.link': 'Open Tournaments',
            // creation form
            'tourn.f.name': 'Name',
            'tourn.f.namePh': 'e.g. Spring Cup 2026',
            'tourn.f.game': 'Game',
            'tourn.f.pickGame': 'pick a game',
            'tourn.f.addGame': 'Add game',
            'tourn.f.noGames': 'No games found. Use + to add one.',
            'tourn.f.addGameHint': 'Add the game from the Game Catalog, then search here.',
            'tourn.f.format': 'Format',
            'tourn.f.seats': 'Players per table',
            'tourn.f.seatsHint': 'Set the table size to match your game (2 = classic 1v1).',
            'tourn.f.topx': 'Advance per table',
            'tourn.f.topxPh': 'e.g. 2',
            'tourn.f.legs': 'Rounds against each opponent',
            'tourn.f.legs1': 'Single (once)',
            'tourn.f.legs2': 'Double (home & away)',
            'tourn.f.minP': 'Min participants',
            'tourn.f.maxP': 'Max participants',
            'tourn.f.unlimited': 'unlimited',
            'tourn.f.waitlist': 'Enable waitlist when full',
            'tourn.f.prizesPh': 'e.g. Trophy + new game',
            'tourn.f.finalPts': 'Award Club Points by final placement',
            'tourn.f.finalPtsHint': 'Off by default — per-round sessions already grant points.',
            'tourn.f.finalPrizes': 'Prize points per final place (1st, 2nd, 3rd …)',
            'tourn.f.finalPrizesHint': 'Comma-separated. Places beyond the list get 0.',
            // tournament page
            'tourn.you': 'you',
            'tourn.noParticipants': 'No participants yet.',
            'tourn.waitlist': 'Waitlist',
            'tourn.bracketSoon': 'Bracket & results coming next.',
            'tourn.act.openReg': 'Open registration',
            'tourn.act.backDraft': 'Back to draft',
            'tourn.act.start': 'Start tournament',
            'tourn.act.finish': 'Finish',
            'tourn.act.reopen': 'Reopen',
            'tourn.finalized': 'Tournament finalized.',
            'tourn.reopened': 'Tournament reopened.',
            'tourn.finalizeTitle': 'Finalize tournament',
            'tourn.champion': 'Champion',
            'tourn.noWinner': 'No winner',
            'tourn.tieForFirst': 'Tie for 1st — pick the champion per the game rules',
            'tourn.finalizeWarnPending': 'Some tables are not reported yet. They will count as 0 points.',
            'tourn.awardFinalPoints': 'Award final Club Points bonus (by final standings)',
            'tourn.bonusAdminOnly': 'The final points bonus can only be awarded by an admin.',
            'tourn.reopenConfirm': 'Reopen this tournament? The final points bonus (if any) will be reversed.',
            'tourn.bracket': 'Bracket',
            'tourn.genBracket': 'Generate bracket',
            'tourn.regenBracket': 'Regenerate bracket',
            'tourn.noBracket': 'No bracket generated yet.',
            'tourn.confirmRegen': 'This will replace the existing bracket. Continue?',
            'tourn.round': 'Round',
            'tourn.leg.first': 'first leg',
            'tourn.leg.second': 'return leg',
            'tourn.table': 'Table',
            'tourn.bye': 'bye',
            'tourn.reportResult': 'Enter result',
            'tourn.editResult': 'Edit result',
            'tourn.reportHint': 'Set the finishing place for each player. Score is optional.',
            'tourn.reportHint2': 'Enter each player\'s score. Ties are broken below, per the game rules.',
            'tourn.reported': 'Result saved.',
            'tourn.place': 'Place',
            'tourn.score': 'Score',
            'tourn.scoreMode': 'Session scoring type',
            'tourn.mode.uniform': 'Uniformized (Club Points by placement)',
            'tourn.mode.raw': 'By score',
            'tourn.mode.hint': 'Uniformized: Club Points are awarded by placement, per the Admin template.',
            'tourn.tstatus.pending': 'pending',
            'tourn.tstatus.live': 'in play',
            'tourn.tstatus.reported': 'reported',
            'tourn.tstatus.confirmed': 'confirmed',
            'tourn.standings': 'Standings',
            'tourn.stats.title': 'Tournaments',
            'tourn.stats.played': 'Played',
            'tourn.stats.won': 'Won',
            'tourn.stats.podium': 'Podiums',
            'tourn.noResults': 'No results yet.',
            'tourn.stand.points': 'Tournament points',
            'tourn.stand.raw': 'Raw score',
            'tourn.stand.rank': '#',
            'tourn.stand.player': 'Player',
            'tourn.stand.pts': 'Pts',
            'tourn.stand.wins': 'W',
            'tourn.stand.played': 'Tables',
            'tourn.stand.tie': 'tie',
            'tourn.err.formatNoAutogen': 'This format is generated round by round.',
            // errors (mapped from RPC codes)
            'tourn.err.generic': 'Something went wrong. Please try again.',
            'tourn.err.pairingInvalid': 'The generated structure is invalid (a player appears twice in a round). Regenerate.',
            'tourn.err.NOT_AUTHENTICATED': 'You must be signed in.',
            'tourn.err.FORBIDDEN': "You don't have the required permission (Moderator or above).",
            'tourn.err.PLAN_REQUIRED': 'Tournaments are available from the Elite plan.',
            'tourn.err.CLUB_NOT_WRITABLE': 'The club currently does not allow changes.',
            'tourn.err.CLUB_NOT_FOUND': 'Club not found.',
            'tourn.err.NAME_REQUIRED': 'Tournament name is required.',
            'tourn.err.BAD_FORMAT': 'Invalid tournament format.',
            'tourn.err.BAD_GAME': 'The selected game is not valid for this club.',
            'tourn.err.LOCKED_AFTER_START': 'The tournament can no longer be edited after it starts.',
            'tourn.err.BAD_STATUS': 'Invalid status.',
            'tourn.err.BAD_TRANSITION': 'Status transition not allowed.',
            'tourn.err.GAME_REQUIRED': 'Pick a game before opening registration.',
            'tourn.err.BAD_ADVANCE_CONFIG': 'Invalid configuration: how many advance per table.',
            'tourn.err.NOT_ENOUGH_PARTICIPANTS': 'Not enough participants to start.',
            'tourn.err.TOURNAMENT_NOT_FOUND': 'Tournament not found.',
            'tourn.err.NOT_MEMBER': 'You must be a member of the club.',
            'tourn.err.BANNED': 'You have been excluded from this club.',
            'tourn.err.REGISTRATION_CLOSED': 'Registration is not open.',
            'tourn.err.DEADLINE_PASSED': 'The registration deadline has passed.',
            'tourn.err.TOURNAMENT_FULL': 'The tournament is full.',
            'tourn.err.NOT_REGISTERED': 'You are not registered in this tournament.',
            'tourn.err.BAD_STATE_FOR_PAIRING': 'The bracket can only be generated during registration or while live.',
            'tourn.err.EMPTY_PAIRING': 'The generation structure is empty.',
            'tourn.err.NO_ACTIVE_PARTICIPANTS': 'There are no active participants.',
            'tourn.err.PLAYER_NOT_PARTICIPANT': 'A player in the structure is not a registered participant.',
            'tourn.err.TABLE_NOT_FOUND': 'Table not found.',
            'tourn.err.TOURNAMENT_NOT_LIVE': 'The tournament is not live.',
            'tourn.err.EMPTY_RESULTS': 'You did not enter any result.',
            'tourn.err.NO_PLAYERS_AT_TABLE': 'The table has no players.',
            'tourn.err.BAD_SEAT_RESULT': 'Invalid places (each player needs a valid place).',
            'tourn.err.PLAYER_NOT_AT_TABLE': 'A reported player is not at this table.',
            'tourn.nextRound': 'Generate next round',
            'tourn.elimNextRound': 'Next round generated.',
            'tourn.elimReadyFinal': 'Final round played — ready to finalize.',
            'tourn.swissNextRound': 'Next round generated.',
            'tourn.swissReadyFinal': 'All rounds played — ready to finalize.',
            'tourn.noShow': 'No-show',
            'tourn.noShowHint': 'Player did not show up',
            'tourn.walkoverHint': 'Only one player left — the table will be won by walkover (no game session).',
            'tourn.walkoverNone': 'No players left at this table.',
            'tourn.f.rounds': 'Number of rounds',
            'tourn.f.series': 'Count toward the annual series',
            'tourn.f.seriesHint': 'Its final standings contribute to the yearly club-champion ranking.',
            'tourn.series.title': 'Club champion (annual)',
            'tourn.series.viewSeries': 'Series points',
            'tourn.notif.registration': 'Registration open: {name}',
            'tourn.notif.live': 'Tournament started: {name}',
            'tourn.notif.round': 'New round ready: {name}',
            'tourn.notif.finalized': '{name} — champion: {champion}',
            'tourn.abbr.played': 'P',
            'tourn.abbr.won': 'W',
            'tourn.abbr.podium': '🏅',
            'tourn.series.year': 'Year',
            'tourn.series.player': 'Player',
            'tourn.series.points': 'Points',
            'tourn.series.empty': 'No series tournaments completed this year yet.',
            'tourn.series.editScale': 'Edit scale',
            'tourn.series.scaleLabel': 'Points per place:',
            'tourn.series.scaleInput': 'Points per place (1st, 2nd, 3rd …)',
            'tourn.series.scaleHint': 'Comma-separated. Places beyond the list get 0.',
            'tourn.series.scaleBad': 'Enter at least one number.',
            'tourn.series.scaleSaved': 'Scale saved.',
            'tourn.f.roundsHint': 'Everyone plays this many rounds; pairings follow the standings.',
            'tourn.f.seeding': 'First-round pairing',
            'tourn.f.seedRandom': 'Random shuffle',
            'tourn.f.seedSeed': 'By seed (1 vs last, …)',
            'tourn.err.ROUND_NOT_COMPLETE': 'Not all tables in the current round are reported.',
            'tourn.err.NO_ADVANCERS': 'No advancing players.',
            'tourn.err.BAD_FORMAT_FOR_ADVANCE': 'Advancing is only available for single elimination.',
            'tourn.err.NO_ROUNDS': 'No rounds generated.',
            'tourn.err.WINNER_NOT_PARTICIPANT': 'The chosen winner is not a tournament participant.',
            'tourn.err.FINAL_POINTS_NEEDS_ADMIN': 'The final points bonus can only be awarded by an admin.',
            'tourn.err.FINAL_POINTS_BAD_TARGET': 'The final bonus targets a non-participant.',
            'tourn.err.BAD_STATUS_TRANSITION': 'Invalid status transition.',
        }
    };

    let currentLang = 'en';
    let currentUserId = null;
    try {
        const saved = localStorage.getItem('lang');
        if (saved) currentLang = saved;
    } catch (e) {}
    if (!I18N[currentLang]) currentLang = 'en';

    function userLangKey(uid) { return 'lang:' + uid; }

    function t(key, fallback) {
        const d = I18N[currentLang] || I18N.ro;
        if (d && d[key] != null) return d[key];
        if (I18N.ro && I18N.ro[key] != null) return I18N.ro[key];
        return (fallback != null) ? fallback : key;
    }

    function applyTranslations(root) {
        root = root || document;
        root.querySelectorAll('[data-i18n]').forEach(el => {
            el.textContent = t(el.getAttribute('data-i18n'));
        });
        root.querySelectorAll('[data-i18n-html]').forEach(el => {
            el.innerHTML = t(el.getAttribute('data-i18n-html'));
        });
        root.querySelectorAll('[data-i18n-ph]').forEach(el => {
            el.setAttribute('placeholder', t(el.getAttribute('data-i18n-ph')));
        });
        root.querySelectorAll('[data-i18n-title]').forEach(el => {
            el.setAttribute('title', t(el.getAttribute('data-i18n-title')));
        });
        // RO: adresa unui link, în limba curentă (ex. site-ul de prezentare: / sau /ro/). Doar adrese
        //     https din dicționar; orice altceva e ignorat, ca un text tradus greșit să nu devină link.
        // EN: localized link target; only https URLs from the dictionary are applied.
        root.querySelectorAll('[data-i18n-href]').forEach(el => {
            const url = t(el.getAttribute('data-i18n-href'));
            if (typeof url === 'string' && url.indexOf('https://') === 0) el.setAttribute('href', url);
        });
        updateLangButtons();
    }

    function updateLangButtons() {
        document.querySelectorAll('.lang-toggle').forEach(b => { b.textContent = t('lang.other'); });
        try { document.documentElement.lang = currentLang; } catch (e) {}
    }

    function setLang(lang) {
        if (!I18N[lang]) lang = 'en';
        currentLang = lang;
        try { localStorage.setItem('lang', lang); } catch (e) {}
        // Leagă preferința de utilizatorul curent (dacă e logat)
        try { if (currentUserId) localStorage.setItem(userLangKey(currentUserId), lang); } catch (e) {}
        /* Persistă limba în DB (profiles.lang) ca reminderele push trimise de
           Edge Function să ajungă în limba setată pe dispozitivul userului.
           Fire-and-forget; funcția e definită în supabase-integration.js (poate
           lipsi în demo/offline — de aceea guard cu typeof). */
        try { if (typeof window.persistUserLang === 'function') window.persistUserLang(lang); } catch (e) {}
        applyTranslations(document);
        // În modul demo, re-traduce datele „înghețate" în state ÎNAINTE de render().
        try { if (typeof window.retranslateDemoData === 'function') window.retranslateDemoData(); } catch (e) {}
        // Re-randează zonele dinamice dacă aplicația e încărcată.
        // NB: `state` e declarat cu `let`, deci NU există pe window — îl referim lexical (scope global partajat).
        try { if (typeof window.render === 'function' && typeof state !== 'undefined' && state && state.currentUser) window.render(); } catch (e) {}
        try { if (typeof window.renderClubHub === 'function') window.renderClubHub(); } catch (e) {}
        // Zone dinamice care NU trec prin render() — altfel s-ar traduce doar după refresh.
        // Fiecare funcție face deja bail dacă lipsește containerul/userul, deci e sigur de apelat.
        var _live = ['loadChat', 'renderClubSwitcher', 'renderClubMenu', 'renderNotifPanel', 'renderOnlinePresence', 'refreshOpenDiscover', 'renderAuditLog', 'renderAnnouncements', '_navRetranslate'];
        for (var _i = 0; _i < _live.length; _i++) {
            try { if (typeof window[_live[_i]] === 'function') window[_live[_i]](); } catch (e) {}
        }
    }

    function toggleLang() { setLang(currentLang === 'ro' ? 'en' : 'ro'); }

    // Apelat la autentificare: aplică limba salvată pentru acest utilizator (dacă există)
    function setUserForLang(userId) {
        currentUserId = userId || null;
        if (!currentUserId) return;
        try {
            const saved = localStorage.getItem(userLangKey(currentUserId));
            if (saved && I18N[saved] && saved !== currentLang) setLang(saved);
            /* 7.3 (3 oct. 2026): dacă pe ACEST dispozitiv utilizatorul n-a ales încă o limbă,
               NU mai salvăm aici limba curentă (implicit engleza) ca preferință a lui:
               syncLangOnLogin (supabase-integration.js) preia limba din cont (profiles.lang).
               Altfel, după mutarea pe app.turnorder.org sau pe un dispozitiv nou, un utilizator
               român rămânea în engleză, iar engleza îi suprascria și limba din cont.
               EN: no longer invent a per-user choice here; syncLangOnLogin adopts the account language. */
        } catch (e) {}
    }
    function clearUserForLang() { currentUserId = null; }

    // Expune global
    window.I18N = I18N;
    window.t = t;
    window.applyTranslations = applyTranslations;
    window.setLang = setLang;
    window.toggleLang = toggleLang;
    window.setUserForLang = setUserForLang;
    window.clearUserForLang = clearUserForLang;
    window.updateLangButtons = updateLangButtons;
    Object.defineProperty(window, 'currentLang', { get: () => currentLang });

    // Aplică la încărcarea paginii
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => applyTranslations(document));
    } else {
        applyTranslations(document);
    }
})();

/* ============================================================
   Traducerea mesajelor de notificare (toast) RO -> EN.
   tn(msg): dacă limba e EN, caută potrivire exactă, apoi prefix;
   altfel întoarce textul original. Folosit de showNotification.
   ============================================================ */
window.NOTIF_EXACT = {
  "Acces admin activat!": "Admin access enabled!",
  "Acces admin dezactivat!": "Admin access disabled!",
  "Acest cont era programat pentru ștergere. Contactează un administrator dacă mai ai nevoie de date.": "This account was scheduled for deletion. Contact an administrator if you still need the data.",
  "Adaugă cel puțin 2 jucători!": "Add at least 2 players!",
  "Adaugă cel puțin 2 opțiuni!": "Add at least 2 options!",
  "Adaugă cel puțin un joc în listă.": "Add at least one game to the list.",
  "Adaugă cel puțin un participant!": "Add at least one participant!",
  "Ai adăugat deja acest joc în lista ta!": "You already added this game to your list!",
  "Ai fost deconectat!": "You have been signed out!",
  "Ai votat deja și voturile multiple nu sunt permise!": "You already voted and multiple votes are not allowed!",
  "Alege un fișier imagine.": "Choose an image file.",
  "Aplicația a fost instalată!": "The app has been installed!",
  "Articol actualizat!": "Article updated!",
  "Articol adăugat!": "Article added!",
  "Articol nou adăugat în regulament!": "New article added to the rulebook!",
  "Articol șters!": "Article deleted!",
  "Backup exportat cu succes!": "Backup exported successfully!",
  "Campanie salvată.": "Campaign saved.",
  "Campanie ștearsă.": "Campaign deleted.",
  "Catalog exportat cu succes!": "Catalog exported successfully!",
  "Catalogul e gol — adaugă jocuri întâi.": "The catalog is empty — add games first.",
  "Catalogul este gol!": "The catalog is empty!",
  "Cerere aprobată — membru adăugat.": "Request approved — member added.",
  "Cerere de aderare trimisă. Aștepți aprobarea unui admin.": "Join request sent. Awaiting an admin's approval.",
  "Cerere de prietenie trimisă!": "Friend request sent!",
  "Cerere respinsă.": "Request rejected.",
  "Chat exportat!": "Chat exported!",
  "Chat șters complet!": "Chat fully cleared!",
  "Chat-ul este gol!": "The chat is empty!",
  "Clubul este deja activ.": "The club is already active.",
  "Colecția este goală sau nu a putut fi citită.": "The collection is empty or could not be read.",
  "Completează data și jocul!": "Fill in the date and the game!",
  "Completează email-ul și parola!": "Fill in the email and password!",
  "Completează numele și numărul de jucători!": "Fill in the name and number of players!",
  "Completează titlul și conținutul articolului!": "Fill in the article title and content!",
  "Completează titlul, data și ora!": "Fill in the title, date and time!",
  "Completează toate câmpurile!": "Fill in all fields!",
  "Comut clubul…": "Switching club…",
  "Cont creat! Verifică-ți emailul pentru confirmare, apoi autentifică-te.": "Account created! Check your email for confirmation, then sign in.",
  "Cont dezactivat. Te poți reconecta în 30 de zile pentru a-l reactiva.": "Account deactivated. You can sign back in within 30 days to reactivate it.",
  "Cont reactivat. Bine ai revenit!": "Account reactivated. Welcome back!",
  "Contul tău nu are rol de administrator!": "Your account doesn't have the administrator role!",
  "Conținutul nu poate fi gol!": "The content cannot be empty!",
  "Copiat! Lipește în WhatsApp.": "Copied! Paste it in WhatsApp.",
  "Crearea de cluburi e disponibilă doar la invitație. Contactează administratorul platformei (alex.24ps@gmail.com).": "Creating clubs is invitation-only. Contact the platform administrator (alex.24ps@gmail.com).",
  "Creez clubul…": "Creating the club…",
  "Dacă adresa există, vei primi un email cu instrucțiuni de resetare a parolei.": "If the address exists, you'll receive an email with password reset instructions.",
  "Dificultate invalidă! Introduce un număr între 1 și 5.": "Invalid difficulty! Enter a number between 1 and 5.",
  "Doar adminii pot adăuga articole!": "Only admins can add articles!",
  "Doar adminii pot arhiva sezoane!": "Only admins can archive seasons!",
  "Doar adminii pot crea invitații.": "Only admins can create invitations.",
  "Doar adminii pot edita jucători!": "Only admins can edit players!",
  "Doar adminii pot edita regulamentul!": "Only admins can edit the rulebook!",
  "Doar adminii pot edita rolurile.": "Only admins can edit roles.",
  "Doar adminii pot edita scoresheet-uri.": "Only admins can edit scoresheets.",
  "Doar adminii pot edita sesiuni!": "Only admins can edit sessions!",
  "Doar adminii pot exporta rapoarte de sezon!": "Only admins can export season reports!",
  "Doar adminii pot face asta.": "Only admins can do that.",
  "Doar adminii pot face reset complet!": "Only admins can do a full reset!",
  "Doar adminii pot gestiona sezoanele!": "Only admins can manage seasons!",
  "Doar adminii pot regla perioada!": "Only admins can adjust the period!",
  "Doar adminii pot reseta sezoanele!": "Only admins can reset seasons!",
  "Doar adminii pot restaura backup-uri!": "Only admins can restore backups!",
  "Doar adminii pot schimba modul competitiv!": "Only admins can change competitive mode!",
  "Doar adminii pot schimba setările clubului.": "Only admins can change club settings.",
  "Doar adminii pot seta eticheta sezonului!": "Only admins can set the season label!",
  "Doar adminii pot vedea cererile.": "Only admins can see the requests.",
  "Doar adminii pot șterge articole!": "Only admins can delete articles!",
  "Doar adminii pot șterge chat-ul!": "Only admins can clear the chat!",
  "Doar adminii pot șterge din arhivă!": "Only admins can delete from the archive!",
  "Doar adminii pot șterge jocuri!": "Only admins can delete games!",
  "Doar adminii pot șterge sesiuni!": "Only admins can delete sessions!",
  "Doar adminii pot șterge în masă!": "Only admins can bulk delete!",
  "Doar adminii sau creatorul poll-ului pot să-l închidă!": "Only admins or the poll creator can close it!",
  "Doar adminul principal poate reactiva clubul.": "Only the principal admin can reactivate the club.",
  "Doar adminul principal poate închide clubul.": "Only the principal admin can close the club.",
  "Echipe copiate în clipboard!": "Teams copied to clipboard!",
  "Email actualizat (verifică inbox-ul dacă ți se cere confirmarea).": "Email updated (check your inbox if confirmation is required).",
  "Eroare la copiere!": "Copy error!",
  "Eroare la generarea PDF-ului!": "Error generating the PDF!",
  "Eroare la generarea imaginii.": "Error generating the image.",
  "Eroare la printarea regulamentului!": "Error printing the rulebook!",
  "Eroare la restaurarea backup-ului! Fișierul poate fi corupt.": "Error restoring the backup! The file may be corrupt.",
  "Eroare la salvare! Datele nu au fost salvate.": "Save error! Data was not saved.",
  "Eroare la salvarea datelor!": "Error saving data!",
  "Eroare la salvarea etichetei.": "Error saving the label.",
  "Eroare la salvarea perioadei.": "Error saving the period.",
  "Eroare la încărcarea datelor. Se folosesc date demo.": "Error loading data. Using demo data.",
  "Eveniment creat!": "Event created!",
  "Eveniment șters!": "Event deleted!",
  "Evenimentul nu a fost găsit!": "Event not found!",
  "Evenimentul nu a fost găsit.": "Event not found.",
  "Există deja alt membru cu cont pe acest nume. Alege altul.": "Another member with an account already uses this name. Choose another.",
  "Ești offline. Unele funcții pot fi limitate.": "You're offline. Some features may be limited.",
  "Ești în mod vizualizare (mut) în acest club. Poți vedea tot, dar nu poți face modificări până când un admin te dezmuțește.": "You're in view-only (muted) mode in this club. You can see everything but can't make changes until an admin unmutes you.",
  "Imaginea a fost descărcată — o poți trimite pe WhatsApp.": "The image was downloaded — you can send it on WhatsApp.",
  "Importul automat BGG a fost blocat de browser (CORS). Poți adăuga jocurile manual sau folosi „Import JSON\".": "Automatic BGG import was blocked by the browser (CORS). You can add games manually or use “Import JSON”.",
  "Indisponibil în demo.": "Unavailable in demo.",
  "Indisponibil în modul demo.": "Unavailable in demo mode.",
  "Introdu email-ul!": "Enter the email!",
  "Introdu numele invitatului!": "Enter the guest's name!",
  "Introdu numele jucătorului!": "Enter the player's name!",
  "Introdu întrebarea poll-ului!": "Enter the poll question!",
  "Invitatul este deja adăugat!": "The guest is already added!",
  "Invitație invalidă sau expirată.": "Invalid or expired invitation.",
  "Istoric exportat cu succes!": "History exported successfully!",
  "Istoric exportat în PDF!": "History exported to PDF!",
  "Jocul e deja în listă.": "The game is already in the list.",
  "Jocul există deja în catalog!": "The game already exists in the catalog!",
  "Jucători exportați cu succes!": "Players exported successfully!",
  "Jucătorul există deja!": "The player already exists!",
  "Jucătorul nu a fost găsit.": "Player not found.",
  "Link BGG invalid. Ex: https://boardgamegeek.com/boardgame/169786/scythe": "Invalid BGG link. E.g. https://boardgamegeek.com/boardgame/169786/scythe",
  "Link copiat!": "Link copied!",
  "Linkul de resetare nu mai este activ. Cere unul nou din „Am uitat parola\" și deschide-l imediat.": "The reset link is no longer active. Request a new one from “Forgot password” and open it right away.",
  "Lista ta de jocuri a fost ștearsă!": "Your game list was cleared!",
  "Lista ta este deja goală!": "Your list is already empty!",
  "Mod demo activat! Datele sunt resetate la ieșire.": "Demo mode enabled! Data is reset on exit.",
  "Mod demo cu date fictive!": "Demo mode with fake data!",
  "Niciun joc potrivit pentru vot. Adaugă jocuri sau schimbă numărul.": "No suitable game for voting. Add games or change the number.",
  "Nimic de partajat.": "Nothing to share.",
  "Nimic nou de importat (totul există deja).": "Nothing new to import (everything already exists).",
  "Nu ai introdus niciun jucător!": "You didn't enter any player!",
  "Nu ai selectat niciun joc!": "You didn't select any game!",
  "Nu ai selectat niciun jucător!": "You didn't select any player!",
  "Nu am putut genera imaginea.": "Could not generate the image.",
  "Nu există evenimente de exportat!": "No events to export!",
  "Nu există istoric de backup-uri!": "No backup history!",
  "Nu există istoric de exportat!": "No history to export!",
  "Nu există jucători de exportat!": "No players to export!",
  "Nu există jucători de șters!": "No players to delete!",
  "Nu există poll-uri închise!": "No closed polls!",
  "Nu poți închide singurul tău club. Creează altul mai întâi.": "You can't close your only club. Create another one first.",
  "Nu s-a putut încărca librăria Supabase. Verifică conexiunea la internet.": "Could not load the Supabase library. Check your internet connection.",
  "Nu s-au găsit jocuri care să îndeplinească criteriile!": "No games matching the criteria were found!",
  "Nu te poți aplica ție însuți această acțiune.": "You can't apply this action to yourself.",
  "Nu te poți șterge pe tine însuți!": "You can't delete yourself!",
  "Numele clubului nu poate fi gol.": "The club name cannot be empty.",
  "Numele nu poate fi gol.": "The name cannot be empty.",
  "Numele și avatarul s-au salvat. Pentru restul câmpurilor rulează scriptul „profile_fields.sql\".": "Name and avatar were saved. For the remaining fields run the “profile_fields.sql” script.",
  "Opțiunea nu a fost găsită!": "Option not found!",
  "Ordine copiată în clipboard!": "Order copied to clipboard!",
  "Parola a fost actualizată cu succes! Acum te poți autentifica.": "Password updated successfully! You can now sign in.",
  "Parola a fost schimbată.": "Password changed.",
  "Parola nouă trebuie să aibă minim 8 caractere.": "The new password must be at least 8 characters.",
  "Parola nu e suficient de puternică: minim 8 caractere, literă mare, literă mică, cifră și un caracter special.": "Password not strong enough: at least 8 characters, uppercase, lowercase, a digit and a special character.",
  "Parola trebuie să aibă minim 8 caractere!": "The password must be at least 8 characters!",
  "Parolele noi nu coincid.": "The new passwords don't match.",
  "Parolele nu coincid!": "Passwords don't match!",
  "Pentru instalare folosește meniul browserului → „Adaugă la ecranul principal\".": "To install, use the browser menu → “Add to Home Screen”.",
  "Pentru programarea ștergerii rulează „turnorder_account.sql\". Te-am deconectat oricum.": "To schedule deletion run “turnorder_account.sql”. You've been signed out anyway.",
  "Permite ferestrele pop-up pentru a printa!": "Allow pop-ups to print!",
  "Poll creat cu succes!": "Poll created successfully!",
  "Poll închis!": "Poll closed!",
  "Poll-ul a expirat!": "The poll has expired!",
  "Poll-ul nu a fost găsit!": "Poll not found!",
  "Poll-ul nu este activ!": "The poll is not active!",
  "Poză pregătită. Apasă „Salvează profilul\".": "Photo ready. Press “Save profile”.",
  "Poți avea maximum 3 jocuri în lista ta!": "You can have at most 3 games in your list!",
  "Poți șterge doar evenimentele tale (sau ca admin).": "You can only delete your own events (or as an admin).",
  "Prietenie eliminată.": "Friendship removed.",
  "Profil actualizat!": "Profile updated!",
  "Profil șters! (Contul de autentificare se șterge separat din panoul Supabase.)": "Profile deleted! (The auth account is deleted separately from the Supabase panel.)",
  "Pune un nume campaniei.": "Give the campaign a name.",
  "Pune un nume scenariului.": "Give the scenario a name.",
  "Raport sezon exportat în PDF!": "Season report exported to PDF!",
  "Rating invalid! Introduce un număr între 1 și 10.": "Invalid rating! Enter a number between 1 and 10.",
  "Regulament exportat în PDF!": "Rulebook exported to PDF!",
  "Regulament resetat la versiunea originală!": "Rulebook reset to the original version!",
  "Reset complet efectuat! Aplicația a fost resetată la setările inițiale.": "Full reset done! The app was reset to its initial settings.",
  "Restaurarea a deconectat utilizatorul curent.": "The restore signed out the current user.",
  "Scenariu adăugat.": "Scenario added.",
  "Scor invalid!": "Invalid score!",
  "Se arhivează sezonul...": "Archiving the season...",
  "Se conectează...": "Connecting...",
  "Se creează contul...": "Creating the account...",
  "Se deschide dialogul de printare...": "Opening the print dialog...",
  "Se generează imaginea…": "Generating the image…",
  "Se mută istoricul pe noul nume...": "Moving history to the new name...",
  "Se salvează sesiunea...": "Saving the session...",
  "Se trimite linkul de resetare...": "Sending the reset link...",
  "Se șterge chat-ul...": "Clearing the chat...",
  "Selectează un joc!": "Select a game!",
  "Selectează întâi un joc.": "Select a game first.",
  "Sesiune actualizată!": "Session updated!",
  "Sesiune salvată cu succes!": "Session saved successfully!",
  "Sesiune salvată. Pentru „înregistrat de\" rulează scriptul „matches_recorded_by.sql\".": "Session saved. For “recorded by” run the “matches_recorded_by.sql” script.",
  "Sesiune ștearsă!": "Session deleted!",
  "Sesiunea nu a fost găsită!": "Session not found!",
  "Sesiunea nu mai există!": "The session no longer exists!",
  "Setează o parolă nouă mai jos.": "Set a new password below.",
  "Setările clubului au fost salvate.": "Club settings were saved.",
  "Sezon arhivat!": "Season archived!",
  "Sezon nou! Clasamentul a fost arhivat, punctele resetate. ELO și istoricul rămân neatinse.": "New season! The leaderboard was archived, points reset. ELO and history stay untouched.",
  "Sezon resetat complet!": "Season fully reset!",
  "Sezon șters din arhivă.": "Season deleted from the archive.",
  "Sunteți acum prieteni!": "You are now friends!",
  "Te-ai alăturat clubului prin invitație!": "You joined the club via invitation!",
  "Te-ai alăturat clubului!": "You joined the club!",
  "Trebuie să accepți termenii și condițiile!": "You must accept the terms and conditions!",
  "Trebuie să fii autentificat pentru a adăuga jocuri în listă!": "You must be signed in to add games to your list!",
  "Username BGG invalid sau colecție privată.": "Invalid BGG username or private collection.",
  "Utilizator șters!": "User deleted!",
  "Vot pornit! Toți membrii pot vota acum.": "Voting started! All members can vote now.",
  "Vot retras!": "Vote withdrawn!",
  "Vot închis.": "Voting closed.",
  "Vot înregistrat!": "Vote recorded!",
  "În modul demo importul nu se salvează în Supabase.": "In demo mode the import is not saved to Supabase.",
  "În modul demo, modificările nu se salvează.": "In demo mode, changes are not saved."
};

window.NOTIF_PREFIX = [
  ["Bun venit, ", "Welcome, "],
  ["Cont creat cu succes! Bun venit, ", "Account created successfully! Welcome, "],
  ["Scor actualizat pentru ", "Score updated for "],
  ["🎉 Realizare deblocată: ", "🎉 Achievement unlocked: "],
  ["Ai atins limita de membri a planului (", "You've reached the plan's member limit ("],
  ["Autentificare eșuată: ", "Authentication failed: "],
  ["Club activ: ", "Active club: "],
  ["Club creat, dar nu te-am putut adăuga ca admin: ", "Club created, but we couldn't add you as admin: "],
  ["Club creat: ", "Club created: "],
  ["Clubul „", "The club „"],
  ["Cronometru oprit. Durata sesiunii: ", "Timer stopped. Session duration: "],
  ["Email: ", "Email: "],
  ["Eroare import catalog: ", "Catalog import error: "],
  ["Eroare import sesiuni: ", "Sessions import error: "],
  ["Eroare la actualizare: ", "Update error: "],
  ["Eroare la adăugarea jocului: ", "Error adding the game: "],
  ["Eroare la aprobare: ", "Approval error: "],
  ["Eroare la ban: ", "Ban error: "],
  ["Eroare la creare club: ", "Club creation error: "],
  ["Eroare la crearea evenimentului: ", "Event creation error: "],
  ["Eroare la crearea invitației: ", "Invitation creation error: "],
  ["Eroare la invitație: ", "Invitation error: "],
  ["Eroare la mute: ", "Mute error: "],
  ["Eroare la reactivare: ", "Reactivation error: "],
  ["Eroare la salvare: ", "Save error: "],
  ["Eroare la salvarea sesiunii: ", "Session save error: "],
  ["Eroare la salvarea setării: ", "Setting save error: "],
  ["Eroare la salvarea votului: ", "Vote save error: "],
  ["Eroare la scoaterea din club: ", "Error removing from club: "],
  ["Eroare la trimiterea mesajului: ", "Message send error: "],
  ["Eroare la unban: ", "Unban error: "],
  ["Eroare la unmute: ", "Unmute error: "],
  ["Eroare la închidere: ", "Close error: "],
  ["Eroare la înregistrare: ", "Registration error: "],
  ["Eroare la ștergere: ", "Delete error: "],
  ["Eroare la ștergerea chat-ului: ", "Chat delete error: "],
  ["Eroare: ", "Error: "],
  ["Fișier invalid sau format neașteptat: ", "Invalid file or unexpected format: "],
  ["Jucător adăugat, dar nu l-am putut lega de club: ", "Player added, but couldn't be linked to the club: "],
  ["Jucătorul a fost adăugat local, dar nu în Supabase: ", "The player was added locally, but not in Supabase: "],
  ["Nu am putut trimite cererea: ", "Could not send the request: "],
  ["Nu te-am putut alătura: ", "Could not join you: "],
  ["Parolă: ", "Password: "],
  ["Pentru prietenii rulează „turnorder_friends.sql\". (", "For friends run „turnorder_friends.sql”. ("],
  ["Roluri salvate pentru „", "Roles saved for „"],
  ["Scoresheet salvat pentru „", "Scoresheet saved for „"],
  ["💬 ", "💬 "]
];

window.tn = function (msg) {
    try {
        if (typeof msg !== 'string') return msg;
        if (window.currentLang === 'ro') return msg;
        if (window.NOTIF_EXACT && Object.prototype.hasOwnProperty.call(window.NOTIF_EXACT, msg)) {
            return window.NOTIF_EXACT[msg];
        }
        if (window.NOTIF_PREFIX) {
            for (var i = 0; i < window.NOTIF_PREFIX.length; i++) {
                var p = window.NOTIF_PREFIX[i];
                if (msg.indexOf(p[0]) === 0) return p[1] + msg.slice(p[0].length);
            }
        }
    } catch (e) {}
    return msg;
};

/* ============================================================
   Traducerea conținutului de planuri/funcții (date) RO -> EN.
   ptr(s): întoarce EN dacă limba e EN și există mapare, altfel s.
   ============================================================ */
window.PLANS_TR = {
    /* Feature nou (iulie 2026): sesiunile live au propria cheie de plan,
       separată de cronometru. */
    'Sesiuni live': 'Live sessions',
  "în așteptare plată": "Awaiting payment",
  "Start!": "Start!",
  "Prima sesiune jucată": "First session played",
  "Ritm bun": "Good rhythm",
  "10 sesiuni jucate": "10 sessions played",
  "Obișnuiții mesei": "Table regulars",
  "50 de sesiuni": "50 sessions",
  "Sută!": "Hundred!",
  "100 de sesiuni": "100 sessions",
  "Curioși": "Curious",
  "10 jocuri diferite jucate": "10 different games played",
  "Exploratori": "Explorers",
  "50 de jocuri diferite jucate": "50 different games played",
  "Maeștri ai variației": "Masters of variety",
  "200 de jocuri diferite jucate": "200 different games played",
  "Club adevărat": "A real club",
  "10 membri în club": "10 club members",
  "Raft plin": "Full shelf",
  "25 de jocuri în catalog": "25 games in catalog",
  "Ludotecă": "Game library",
  "100 de jocuri în catalog": "100 games in catalog",
  "Organizați": "Organized",
  "10 evenimente programate": "10 scheduled events",
  "Gălăgioși": "Noisy",
  "100 de mesaje în chat": "100 chat messages",
  "Gratuit": "Free",
  "≈ 4€/lună": "≈ €4/mo",
  "≈ 9€/lună": "≈ €9/mo",
  "≈ 19€/lună": "≈ €19/mo",
  "La cerere": "On request",
  "Pentru un grup mic de prieteni": "For a small group of friends",
  "Pentru un club care crește": "For a growing club",
  "Pentru cluburi active": "For active clubs",
  "Pentru rețele de cluburi": "For club networks",
  "Pentru organizații & federații": "For organizations & federations",
  "Sesiuni, scoruri & clasament": "Sessions, scores & leaderboard",
  "Chat de club": "Club chat",
  "Calendar & evenimente (RSVP)": "Calendar & events (RSVP)",
  "Poll-uri": "Polls",
  "Randomizere & vot de joc": "Randomizers & game vote",
  "Catalog cu integrare BoardGameGeek": "Catalog with BoardGameGeek integration",
  "Import istoric (BG Stats / ScorePal / CSV)": "History import (BG Stats / ScorePal / CSV)",
  "Sincronizare în cloud": "Cloud sync",
  "PWA instalabilă": "Installable PWA",
  "Tot din Starter": "Everything in Starter",
  "Export rapoarte": "Reports export",
  "Regulament de club": "Club rulebook",
  "Fotografii sesiune": "Session photos",
  "Tot din Basic": "Everything in Basic",
  "Mod competitiv ELO": "Competitive ELO mode",
  "Scoresheets custom": "Custom scoresheets",
  "Statistici avansate (H-Index, win-rate/rol)": "Advanced stats (H-Index, win-rate/role)",
  "Cronometru sesiune & per jucător": "Session & per-player timer",
  "Cooperativ": "Cooperative",
  "Campanii / Legacy": "Campaigns / Legacy",
  "Tot din Pro": "Everything in Pro",
  "Turnee": "Tournaments",
  "Realizări de club": "Club achievements",
  "Statistici inter-club": "Cross-club statistics",
  "Tot din Elite": "Everything in Elite",
  "SLA & suport dedicat": "SLA & dedicated support",
  "Onboarding asistat": "Assisted onboarding",
  "Facturare/contract la cerere": "Billing/contract on request",
  "Regulament": "Rulebook",
  "Mod competitiv (ELO)": "Competitive mode (ELO)",
  "Statistici avansate (H-Index, win rate per rol)": "Advanced stats (H-Index, win rate per role)",
  "API": "API",
  "activ": "active",
  "blocat": "blocked",
  "doar-citire": "read-only",
  "arhivat": "archived",
  "închis": "closed",
  "Sesiuni live": "Live sessions"
};
window.ptr = function (s) {
  try {
    if (window.currentLang === 'ro' || typeof s !== 'string') return s;
    if (window.PLANS_TR && Object.prototype.hasOwnProperty.call(window.PLANS_TR, s)) return window.PLANS_TR[s];
  } catch (e) {}
  return s;
};
